// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23212529%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23052c65%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.1 (https://getbootstrap.com/)
 * Copyright 2011-2023 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #f27a43;
  --bs-secondary: #afafaf;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #ff0000;
  --bs-light: #f8f9fa;
  --bs-dark: #000000;
  --bs-primary-rgb: 242, 122, 67;
  --bs-secondary-rgb: 175, 175, 175;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 255, 0, 0;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 0, 0, 0;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit;
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2;
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

.g-5-px,
.gx-5-px {
  --bs-gutter-x: 5px;
}

.g-5-px,
.gy-5-px {
  --bs-gutter-y: 5px;
}

.g-10-px,
.gx-10-px {
  --bs-gutter-x: 10px;
}

.g-10-px,
.gy-10-px {
  --bs-gutter-y: 10px;
}

.g-20-px,
.gx-20-px {
  --bs-gutter-x: 20px;
}

.g-20-px,
.gy-20-px {
  --bs-gutter-y: 20px;
}

.g-30-px,
.gx-30-px {
  --bs-gutter-x: 30px;
}

.g-30-px,
.gy-30-px {
  --bs-gutter-y: 30px;
}

.g-35-px,
.gx-35-px {
  --bs-gutter-x: 35px;
}

.g-35-px,
.gy-35-px {
  --bs-gutter-y: 35px;
}

.g-40-px,
.gx-40-px {
  --bs-gutter-x: 40px;
}

.g-40-px,
.gy-40-px {
  --bs-gutter-y: 40px;
}

.g-45-px,
.gx-45-px {
  --bs-gutter-x: 45px;
}

.g-45-px,
.gy-45-px {
  --bs-gutter-y: 45px;
}

.g-50-px,
.gx-50-px {
  --bs-gutter-x: 50px;
}

.g-50-px,
.gy-50-px {
  --bs-gutter-y: 50px;
}

.g-60-px,
.gx-60-px {
  --bs-gutter-x: 60px;
}

.g-60-px,
.gy-60-px {
  --bs-gutter-y: 60px;
}

.g-70-px,
.gx-70-px {
  --bs-gutter-x: 70px;
}

.g-70-px,
.gy-70-px {
  --bs-gutter-y: 70px;
}

.g-80-px,
.gx-80-px {
  --bs-gutter-x: 80px;
}

.g-80-px,
.gy-80-px {
  --bs-gutter-y: 80px;
}

.g-90-px,
.gx-90-px {
  --bs-gutter-x: 90px;
}

.g-90-px,
.gy-90-px {
  --bs-gutter-y: 90px;
}

.g-100-px,
.gx-100-px {
  --bs-gutter-x: 100px;
}

.g-100-px,
.gy-100-px {
  --bs-gutter-y: 100px;
}

.g-120-px,
.gx-120-px {
  --bs-gutter-x: 120px;
}

.g-120-px,
.gy-120-px {
  --bs-gutter-y: 120px;
}

.g-125-px,
.gx-125-px {
  --bs-gutter-x: 125px;
}

.g-125-px,
.gy-125-px {
  --bs-gutter-y: 125px;
}

.g-130-px,
.gx-130-px {
  --bs-gutter-x: 130px;
}

.g-130-px,
.gy-130-px {
  --bs-gutter-y: 130px;
}

.g-150-px,
.gx-150-px {
  --bs-gutter-x: 150px;
}

.g-150-px,
.gy-150-px {
  --bs-gutter-y: 150px;
}

.g-200-px,
.gx-200-px {
  --bs-gutter-x: 200px;
}

.g-200-px,
.gy-200-px {
  --bs-gutter-y: 200px;
}

.g-250-px,
.gx-250-px {
  --bs-gutter-x: 250px;
}

.g-250-px,
.gy-250-px {
  --bs-gutter-y: 250px;
}

.g-300-px,
.gx-300-px {
  --bs-gutter-x: 300px;
}

.g-300-px,
.gy-300-px {
  --bs-gutter-y: 300px;
}

.g-350-px,
.gx-350-px {
  --bs-gutter-x: 350px;
}

.g-350-px,
.gy-350-px {
  --bs-gutter-y: 350px;
}

.g-400-px,
.gx-400-px {
  --bs-gutter-x: 400px;
}

.g-400-px,
.gy-400-px {
  --bs-gutter-y: 400px;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
  .g-sm-5-px,
  .gx-sm-5-px {
    --bs-gutter-x: 5px;
  }
  .g-sm-5-px,
  .gy-sm-5-px {
    --bs-gutter-y: 5px;
  }
  .g-sm-10-px,
  .gx-sm-10-px {
    --bs-gutter-x: 10px;
  }
  .g-sm-10-px,
  .gy-sm-10-px {
    --bs-gutter-y: 10px;
  }
  .g-sm-20-px,
  .gx-sm-20-px {
    --bs-gutter-x: 20px;
  }
  .g-sm-20-px,
  .gy-sm-20-px {
    --bs-gutter-y: 20px;
  }
  .g-sm-30-px,
  .gx-sm-30-px {
    --bs-gutter-x: 30px;
  }
  .g-sm-30-px,
  .gy-sm-30-px {
    --bs-gutter-y: 30px;
  }
  .g-sm-35-px,
  .gx-sm-35-px {
    --bs-gutter-x: 35px;
  }
  .g-sm-35-px,
  .gy-sm-35-px {
    --bs-gutter-y: 35px;
  }
  .g-sm-40-px,
  .gx-sm-40-px {
    --bs-gutter-x: 40px;
  }
  .g-sm-40-px,
  .gy-sm-40-px {
    --bs-gutter-y: 40px;
  }
  .g-sm-45-px,
  .gx-sm-45-px {
    --bs-gutter-x: 45px;
  }
  .g-sm-45-px,
  .gy-sm-45-px {
    --bs-gutter-y: 45px;
  }
  .g-sm-50-px,
  .gx-sm-50-px {
    --bs-gutter-x: 50px;
  }
  .g-sm-50-px,
  .gy-sm-50-px {
    --bs-gutter-y: 50px;
  }
  .g-sm-60-px,
  .gx-sm-60-px {
    --bs-gutter-x: 60px;
  }
  .g-sm-60-px,
  .gy-sm-60-px {
    --bs-gutter-y: 60px;
  }
  .g-sm-70-px,
  .gx-sm-70-px {
    --bs-gutter-x: 70px;
  }
  .g-sm-70-px,
  .gy-sm-70-px {
    --bs-gutter-y: 70px;
  }
  .g-sm-80-px,
  .gx-sm-80-px {
    --bs-gutter-x: 80px;
  }
  .g-sm-80-px,
  .gy-sm-80-px {
    --bs-gutter-y: 80px;
  }
  .g-sm-90-px,
  .gx-sm-90-px {
    --bs-gutter-x: 90px;
  }
  .g-sm-90-px,
  .gy-sm-90-px {
    --bs-gutter-y: 90px;
  }
  .g-sm-100-px,
  .gx-sm-100-px {
    --bs-gutter-x: 100px;
  }
  .g-sm-100-px,
  .gy-sm-100-px {
    --bs-gutter-y: 100px;
  }
  .g-sm-120-px,
  .gx-sm-120-px {
    --bs-gutter-x: 120px;
  }
  .g-sm-120-px,
  .gy-sm-120-px {
    --bs-gutter-y: 120px;
  }
  .g-sm-125-px,
  .gx-sm-125-px {
    --bs-gutter-x: 125px;
  }
  .g-sm-125-px,
  .gy-sm-125-px {
    --bs-gutter-y: 125px;
  }
  .g-sm-130-px,
  .gx-sm-130-px {
    --bs-gutter-x: 130px;
  }
  .g-sm-130-px,
  .gy-sm-130-px {
    --bs-gutter-y: 130px;
  }
  .g-sm-150-px,
  .gx-sm-150-px {
    --bs-gutter-x: 150px;
  }
  .g-sm-150-px,
  .gy-sm-150-px {
    --bs-gutter-y: 150px;
  }
  .g-sm-200-px,
  .gx-sm-200-px {
    --bs-gutter-x: 200px;
  }
  .g-sm-200-px,
  .gy-sm-200-px {
    --bs-gutter-y: 200px;
  }
  .g-sm-250-px,
  .gx-sm-250-px {
    --bs-gutter-x: 250px;
  }
  .g-sm-250-px,
  .gy-sm-250-px {
    --bs-gutter-y: 250px;
  }
  .g-sm-300-px,
  .gx-sm-300-px {
    --bs-gutter-x: 300px;
  }
  .g-sm-300-px,
  .gy-sm-300-px {
    --bs-gutter-y: 300px;
  }
  .g-sm-350-px,
  .gx-sm-350-px {
    --bs-gutter-x: 350px;
  }
  .g-sm-350-px,
  .gy-sm-350-px {
    --bs-gutter-y: 350px;
  }
  .g-sm-400-px,
  .gx-sm-400-px {
    --bs-gutter-x: 400px;
  }
  .g-sm-400-px,
  .gy-sm-400-px {
    --bs-gutter-y: 400px;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
  .g-md-5-px,
  .gx-md-5-px {
    --bs-gutter-x: 5px;
  }
  .g-md-5-px,
  .gy-md-5-px {
    --bs-gutter-y: 5px;
  }
  .g-md-10-px,
  .gx-md-10-px {
    --bs-gutter-x: 10px;
  }
  .g-md-10-px,
  .gy-md-10-px {
    --bs-gutter-y: 10px;
  }
  .g-md-20-px,
  .gx-md-20-px {
    --bs-gutter-x: 20px;
  }
  .g-md-20-px,
  .gy-md-20-px {
    --bs-gutter-y: 20px;
  }
  .g-md-30-px,
  .gx-md-30-px {
    --bs-gutter-x: 30px;
  }
  .g-md-30-px,
  .gy-md-30-px {
    --bs-gutter-y: 30px;
  }
  .g-md-35-px,
  .gx-md-35-px {
    --bs-gutter-x: 35px;
  }
  .g-md-35-px,
  .gy-md-35-px {
    --bs-gutter-y: 35px;
  }
  .g-md-40-px,
  .gx-md-40-px {
    --bs-gutter-x: 40px;
  }
  .g-md-40-px,
  .gy-md-40-px {
    --bs-gutter-y: 40px;
  }
  .g-md-45-px,
  .gx-md-45-px {
    --bs-gutter-x: 45px;
  }
  .g-md-45-px,
  .gy-md-45-px {
    --bs-gutter-y: 45px;
  }
  .g-md-50-px,
  .gx-md-50-px {
    --bs-gutter-x: 50px;
  }
  .g-md-50-px,
  .gy-md-50-px {
    --bs-gutter-y: 50px;
  }
  .g-md-60-px,
  .gx-md-60-px {
    --bs-gutter-x: 60px;
  }
  .g-md-60-px,
  .gy-md-60-px {
    --bs-gutter-y: 60px;
  }
  .g-md-70-px,
  .gx-md-70-px {
    --bs-gutter-x: 70px;
  }
  .g-md-70-px,
  .gy-md-70-px {
    --bs-gutter-y: 70px;
  }
  .g-md-80-px,
  .gx-md-80-px {
    --bs-gutter-x: 80px;
  }
  .g-md-80-px,
  .gy-md-80-px {
    --bs-gutter-y: 80px;
  }
  .g-md-90-px,
  .gx-md-90-px {
    --bs-gutter-x: 90px;
  }
  .g-md-90-px,
  .gy-md-90-px {
    --bs-gutter-y: 90px;
  }
  .g-md-100-px,
  .gx-md-100-px {
    --bs-gutter-x: 100px;
  }
  .g-md-100-px,
  .gy-md-100-px {
    --bs-gutter-y: 100px;
  }
  .g-md-120-px,
  .gx-md-120-px {
    --bs-gutter-x: 120px;
  }
  .g-md-120-px,
  .gy-md-120-px {
    --bs-gutter-y: 120px;
  }
  .g-md-125-px,
  .gx-md-125-px {
    --bs-gutter-x: 125px;
  }
  .g-md-125-px,
  .gy-md-125-px {
    --bs-gutter-y: 125px;
  }
  .g-md-130-px,
  .gx-md-130-px {
    --bs-gutter-x: 130px;
  }
  .g-md-130-px,
  .gy-md-130-px {
    --bs-gutter-y: 130px;
  }
  .g-md-150-px,
  .gx-md-150-px {
    --bs-gutter-x: 150px;
  }
  .g-md-150-px,
  .gy-md-150-px {
    --bs-gutter-y: 150px;
  }
  .g-md-200-px,
  .gx-md-200-px {
    --bs-gutter-x: 200px;
  }
  .g-md-200-px,
  .gy-md-200-px {
    --bs-gutter-y: 200px;
  }
  .g-md-250-px,
  .gx-md-250-px {
    --bs-gutter-x: 250px;
  }
  .g-md-250-px,
  .gy-md-250-px {
    --bs-gutter-y: 250px;
  }
  .g-md-300-px,
  .gx-md-300-px {
    --bs-gutter-x: 300px;
  }
  .g-md-300-px,
  .gy-md-300-px {
    --bs-gutter-y: 300px;
  }
  .g-md-350-px,
  .gx-md-350-px {
    --bs-gutter-x: 350px;
  }
  .g-md-350-px,
  .gy-md-350-px {
    --bs-gutter-y: 350px;
  }
  .g-md-400-px,
  .gx-md-400-px {
    --bs-gutter-x: 400px;
  }
  .g-md-400-px,
  .gy-md-400-px {
    --bs-gutter-y: 400px;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
  .g-lg-5-px,
  .gx-lg-5-px {
    --bs-gutter-x: 5px;
  }
  .g-lg-5-px,
  .gy-lg-5-px {
    --bs-gutter-y: 5px;
  }
  .g-lg-10-px,
  .gx-lg-10-px {
    --bs-gutter-x: 10px;
  }
  .g-lg-10-px,
  .gy-lg-10-px {
    --bs-gutter-y: 10px;
  }
  .g-lg-20-px,
  .gx-lg-20-px {
    --bs-gutter-x: 20px;
  }
  .g-lg-20-px,
  .gy-lg-20-px {
    --bs-gutter-y: 20px;
  }
  .g-lg-30-px,
  .gx-lg-30-px {
    --bs-gutter-x: 30px;
  }
  .g-lg-30-px,
  .gy-lg-30-px {
    --bs-gutter-y: 30px;
  }
  .g-lg-35-px,
  .gx-lg-35-px {
    --bs-gutter-x: 35px;
  }
  .g-lg-35-px,
  .gy-lg-35-px {
    --bs-gutter-y: 35px;
  }
  .g-lg-40-px,
  .gx-lg-40-px {
    --bs-gutter-x: 40px;
  }
  .g-lg-40-px,
  .gy-lg-40-px {
    --bs-gutter-y: 40px;
  }
  .g-lg-45-px,
  .gx-lg-45-px {
    --bs-gutter-x: 45px;
  }
  .g-lg-45-px,
  .gy-lg-45-px {
    --bs-gutter-y: 45px;
  }
  .g-lg-50-px,
  .gx-lg-50-px {
    --bs-gutter-x: 50px;
  }
  .g-lg-50-px,
  .gy-lg-50-px {
    --bs-gutter-y: 50px;
  }
  .g-lg-60-px,
  .gx-lg-60-px {
    --bs-gutter-x: 60px;
  }
  .g-lg-60-px,
  .gy-lg-60-px {
    --bs-gutter-y: 60px;
  }
  .g-lg-70-px,
  .gx-lg-70-px {
    --bs-gutter-x: 70px;
  }
  .g-lg-70-px,
  .gy-lg-70-px {
    --bs-gutter-y: 70px;
  }
  .g-lg-80-px,
  .gx-lg-80-px {
    --bs-gutter-x: 80px;
  }
  .g-lg-80-px,
  .gy-lg-80-px {
    --bs-gutter-y: 80px;
  }
  .g-lg-90-px,
  .gx-lg-90-px {
    --bs-gutter-x: 90px;
  }
  .g-lg-90-px,
  .gy-lg-90-px {
    --bs-gutter-y: 90px;
  }
  .g-lg-100-px,
  .gx-lg-100-px {
    --bs-gutter-x: 100px;
  }
  .g-lg-100-px,
  .gy-lg-100-px {
    --bs-gutter-y: 100px;
  }
  .g-lg-120-px,
  .gx-lg-120-px {
    --bs-gutter-x: 120px;
  }
  .g-lg-120-px,
  .gy-lg-120-px {
    --bs-gutter-y: 120px;
  }
  .g-lg-125-px,
  .gx-lg-125-px {
    --bs-gutter-x: 125px;
  }
  .g-lg-125-px,
  .gy-lg-125-px {
    --bs-gutter-y: 125px;
  }
  .g-lg-130-px,
  .gx-lg-130-px {
    --bs-gutter-x: 130px;
  }
  .g-lg-130-px,
  .gy-lg-130-px {
    --bs-gutter-y: 130px;
  }
  .g-lg-150-px,
  .gx-lg-150-px {
    --bs-gutter-x: 150px;
  }
  .g-lg-150-px,
  .gy-lg-150-px {
    --bs-gutter-y: 150px;
  }
  .g-lg-200-px,
  .gx-lg-200-px {
    --bs-gutter-x: 200px;
  }
  .g-lg-200-px,
  .gy-lg-200-px {
    --bs-gutter-y: 200px;
  }
  .g-lg-250-px,
  .gx-lg-250-px {
    --bs-gutter-x: 250px;
  }
  .g-lg-250-px,
  .gy-lg-250-px {
    --bs-gutter-y: 250px;
  }
  .g-lg-300-px,
  .gx-lg-300-px {
    --bs-gutter-x: 300px;
  }
  .g-lg-300-px,
  .gy-lg-300-px {
    --bs-gutter-y: 300px;
  }
  .g-lg-350-px,
  .gx-lg-350-px {
    --bs-gutter-x: 350px;
  }
  .g-lg-350-px,
  .gy-lg-350-px {
    --bs-gutter-y: 350px;
  }
  .g-lg-400-px,
  .gx-lg-400-px {
    --bs-gutter-x: 400px;
  }
  .g-lg-400-px,
  .gy-lg-400-px {
    --bs-gutter-y: 400px;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
  .g-xl-5-px,
  .gx-xl-5-px {
    --bs-gutter-x: 5px;
  }
  .g-xl-5-px,
  .gy-xl-5-px {
    --bs-gutter-y: 5px;
  }
  .g-xl-10-px,
  .gx-xl-10-px {
    --bs-gutter-x: 10px;
  }
  .g-xl-10-px,
  .gy-xl-10-px {
    --bs-gutter-y: 10px;
  }
  .g-xl-20-px,
  .gx-xl-20-px {
    --bs-gutter-x: 20px;
  }
  .g-xl-20-px,
  .gy-xl-20-px {
    --bs-gutter-y: 20px;
  }
  .g-xl-30-px,
  .gx-xl-30-px {
    --bs-gutter-x: 30px;
  }
  .g-xl-30-px,
  .gy-xl-30-px {
    --bs-gutter-y: 30px;
  }
  .g-xl-35-px,
  .gx-xl-35-px {
    --bs-gutter-x: 35px;
  }
  .g-xl-35-px,
  .gy-xl-35-px {
    --bs-gutter-y: 35px;
  }
  .g-xl-40-px,
  .gx-xl-40-px {
    --bs-gutter-x: 40px;
  }
  .g-xl-40-px,
  .gy-xl-40-px {
    --bs-gutter-y: 40px;
  }
  .g-xl-45-px,
  .gx-xl-45-px {
    --bs-gutter-x: 45px;
  }
  .g-xl-45-px,
  .gy-xl-45-px {
    --bs-gutter-y: 45px;
  }
  .g-xl-50-px,
  .gx-xl-50-px {
    --bs-gutter-x: 50px;
  }
  .g-xl-50-px,
  .gy-xl-50-px {
    --bs-gutter-y: 50px;
  }
  .g-xl-60-px,
  .gx-xl-60-px {
    --bs-gutter-x: 60px;
  }
  .g-xl-60-px,
  .gy-xl-60-px {
    --bs-gutter-y: 60px;
  }
  .g-xl-70-px,
  .gx-xl-70-px {
    --bs-gutter-x: 70px;
  }
  .g-xl-70-px,
  .gy-xl-70-px {
    --bs-gutter-y: 70px;
  }
  .g-xl-80-px,
  .gx-xl-80-px {
    --bs-gutter-x: 80px;
  }
  .g-xl-80-px,
  .gy-xl-80-px {
    --bs-gutter-y: 80px;
  }
  .g-xl-90-px,
  .gx-xl-90-px {
    --bs-gutter-x: 90px;
  }
  .g-xl-90-px,
  .gy-xl-90-px {
    --bs-gutter-y: 90px;
  }
  .g-xl-100-px,
  .gx-xl-100-px {
    --bs-gutter-x: 100px;
  }
  .g-xl-100-px,
  .gy-xl-100-px {
    --bs-gutter-y: 100px;
  }
  .g-xl-120-px,
  .gx-xl-120-px {
    --bs-gutter-x: 120px;
  }
  .g-xl-120-px,
  .gy-xl-120-px {
    --bs-gutter-y: 120px;
  }
  .g-xl-125-px,
  .gx-xl-125-px {
    --bs-gutter-x: 125px;
  }
  .g-xl-125-px,
  .gy-xl-125-px {
    --bs-gutter-y: 125px;
  }
  .g-xl-130-px,
  .gx-xl-130-px {
    --bs-gutter-x: 130px;
  }
  .g-xl-130-px,
  .gy-xl-130-px {
    --bs-gutter-y: 130px;
  }
  .g-xl-150-px,
  .gx-xl-150-px {
    --bs-gutter-x: 150px;
  }
  .g-xl-150-px,
  .gy-xl-150-px {
    --bs-gutter-y: 150px;
  }
  .g-xl-200-px,
  .gx-xl-200-px {
    --bs-gutter-x: 200px;
  }
  .g-xl-200-px,
  .gy-xl-200-px {
    --bs-gutter-y: 200px;
  }
  .g-xl-250-px,
  .gx-xl-250-px {
    --bs-gutter-x: 250px;
  }
  .g-xl-250-px,
  .gy-xl-250-px {
    --bs-gutter-y: 250px;
  }
  .g-xl-300-px,
  .gx-xl-300-px {
    --bs-gutter-x: 300px;
  }
  .g-xl-300-px,
  .gy-xl-300-px {
    --bs-gutter-y: 300px;
  }
  .g-xl-350-px,
  .gx-xl-350-px {
    --bs-gutter-x: 350px;
  }
  .g-xl-350-px,
  .gy-xl-350-px {
    --bs-gutter-y: 350px;
  }
  .g-xl-400-px,
  .gx-xl-400-px {
    --bs-gutter-x: 400px;
  }
  .g-xl-400-px,
  .gy-xl-400-px {
    --bs-gutter-y: 400px;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
  .g-xxl-5-px,
  .gx-xxl-5-px {
    --bs-gutter-x: 5px;
  }
  .g-xxl-5-px,
  .gy-xxl-5-px {
    --bs-gutter-y: 5px;
  }
  .g-xxl-10-px,
  .gx-xxl-10-px {
    --bs-gutter-x: 10px;
  }
  .g-xxl-10-px,
  .gy-xxl-10-px {
    --bs-gutter-y: 10px;
  }
  .g-xxl-20-px,
  .gx-xxl-20-px {
    --bs-gutter-x: 20px;
  }
  .g-xxl-20-px,
  .gy-xxl-20-px {
    --bs-gutter-y: 20px;
  }
  .g-xxl-30-px,
  .gx-xxl-30-px {
    --bs-gutter-x: 30px;
  }
  .g-xxl-30-px,
  .gy-xxl-30-px {
    --bs-gutter-y: 30px;
  }
  .g-xxl-35-px,
  .gx-xxl-35-px {
    --bs-gutter-x: 35px;
  }
  .g-xxl-35-px,
  .gy-xxl-35-px {
    --bs-gutter-y: 35px;
  }
  .g-xxl-40-px,
  .gx-xxl-40-px {
    --bs-gutter-x: 40px;
  }
  .g-xxl-40-px,
  .gy-xxl-40-px {
    --bs-gutter-y: 40px;
  }
  .g-xxl-45-px,
  .gx-xxl-45-px {
    --bs-gutter-x: 45px;
  }
  .g-xxl-45-px,
  .gy-xxl-45-px {
    --bs-gutter-y: 45px;
  }
  .g-xxl-50-px,
  .gx-xxl-50-px {
    --bs-gutter-x: 50px;
  }
  .g-xxl-50-px,
  .gy-xxl-50-px {
    --bs-gutter-y: 50px;
  }
  .g-xxl-60-px,
  .gx-xxl-60-px {
    --bs-gutter-x: 60px;
  }
  .g-xxl-60-px,
  .gy-xxl-60-px {
    --bs-gutter-y: 60px;
  }
  .g-xxl-70-px,
  .gx-xxl-70-px {
    --bs-gutter-x: 70px;
  }
  .g-xxl-70-px,
  .gy-xxl-70-px {
    --bs-gutter-y: 70px;
  }
  .g-xxl-80-px,
  .gx-xxl-80-px {
    --bs-gutter-x: 80px;
  }
  .g-xxl-80-px,
  .gy-xxl-80-px {
    --bs-gutter-y: 80px;
  }
  .g-xxl-90-px,
  .gx-xxl-90-px {
    --bs-gutter-x: 90px;
  }
  .g-xxl-90-px,
  .gy-xxl-90-px {
    --bs-gutter-y: 90px;
  }
  .g-xxl-100-px,
  .gx-xxl-100-px {
    --bs-gutter-x: 100px;
  }
  .g-xxl-100-px,
  .gy-xxl-100-px {
    --bs-gutter-y: 100px;
  }
  .g-xxl-120-px,
  .gx-xxl-120-px {
    --bs-gutter-x: 120px;
  }
  .g-xxl-120-px,
  .gy-xxl-120-px {
    --bs-gutter-y: 120px;
  }
  .g-xxl-125-px,
  .gx-xxl-125-px {
    --bs-gutter-x: 125px;
  }
  .g-xxl-125-px,
  .gy-xxl-125-px {
    --bs-gutter-y: 125px;
  }
  .g-xxl-130-px,
  .gx-xxl-130-px {
    --bs-gutter-x: 130px;
  }
  .g-xxl-130-px,
  .gy-xxl-130-px {
    --bs-gutter-y: 130px;
  }
  .g-xxl-150-px,
  .gx-xxl-150-px {
    --bs-gutter-x: 150px;
  }
  .g-xxl-150-px,
  .gy-xxl-150-px {
    --bs-gutter-y: 150px;
  }
  .g-xxl-200-px,
  .gx-xxl-200-px {
    --bs-gutter-x: 200px;
  }
  .g-xxl-200-px,
  .gy-xxl-200-px {
    --bs-gutter-y: 200px;
  }
  .g-xxl-250-px,
  .gx-xxl-250-px {
    --bs-gutter-x: 250px;
  }
  .g-xxl-250-px,
  .gy-xxl-250-px {
    --bs-gutter-y: 250px;
  }
  .g-xxl-300-px,
  .gx-xxl-300-px {
    --bs-gutter-x: 300px;
  }
  .g-xxl-300-px,
  .gy-xxl-300-px {
    --bs-gutter-y: 300px;
  }
  .g-xxl-350-px,
  .gx-xxl-350-px {
    --bs-gutter-x: 350px;
  }
  .g-xxl-350-px,
  .gy-xxl-350-px {
    --bs-gutter-y: 350px;
  }
  .g-xxl-400-px,
  .gx-xxl-400-px {
    --bs-gutter-x: 400px;
  }
  .g-xxl-400-px,
  .gy-xxl-400-px {
    --bs-gutter-y: 400px;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #bacbe6;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #cbccce;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #bcd0c7;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #badce3;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #e6dbb9;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #dfc2c4;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #dfe0e1;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #373b3e;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: #86b7fe;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-tertiary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: #b6d4fe;
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-tertiary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-select ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  color: rgba(var(--bs-body-color-rgb), 0.65);
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}
.form-floating > :disabled ~ label::after,
.form-floating > .form-control:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(var(--bs-border-width) * -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #000;
  --bs-btn-bg: #f27a43;
  --bs-btn-border-color: #f27a43;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f48e5f;
  --bs-btn-hover-border-color: #f38756;
  --bs-btn-focus-shadow-rgb: 206, 104, 57;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f59569;
  --bs-btn-active-border-color: #f38756;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f27a43;
  --bs-btn-disabled-border-color: #f27a43;
}

.btn-secondary {
  --bs-btn-color: #000;
  --bs-btn-bg: #afafaf;
  --bs-btn-border-color: #afafaf;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #bbbbbb;
  --bs-btn-hover-border-color: #b7b7b7;
  --bs-btn-focus-shadow-rgb: 149, 149, 149;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #bfbfbf;
  --bs-btn-active-border-color: #b7b7b7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #afafaf;
  --bs-btn-disabled-border-color: #afafaf;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #000;
  --bs-btn-bg: #ff0000;
  --bs-btn-border-color: #ff0000;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ff2626;
  --bs-btn-hover-border-color: #ff1a1a;
  --bs-btn-focus-shadow-rgb: 217, 0, 0;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ff3333;
  --bs-btn-active-border-color: #ff1a1a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ff0000;
  --bs-btn-disabled-border-color: #ff0000;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #262626;
  --bs-btn-hover-border-color: #1a1a1a;
  --bs-btn-focus-shadow-rgb: 38, 38, 38;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #333333;
  --bs-btn-active-border-color: #1a1a1a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #000000;
  --bs-btn-disabled-border-color: #000000;
}

.btn-outline-primary {
  --bs-btn-color: #f27a43;
  --bs-btn-border-color: #f27a43;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f27a43;
  --bs-btn-hover-border-color: #f27a43;
  --bs-btn-focus-shadow-rgb: 242, 122, 67;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f27a43;
  --bs-btn-active-border-color: #f27a43;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f27a43;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f27a43;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #afafaf;
  --bs-btn-border-color: #afafaf;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #afafaf;
  --bs-btn-hover-border-color: #afafaf;
  --bs-btn-focus-shadow-rgb: 175, 175, 175;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #afafaf;
  --bs-btn-active-border-color: #afafaf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #afafaf;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #afafaf;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #ff0000;
  --bs-btn-border-color: #ff0000;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ff0000;
  --bs-btn-hover-border-color: #ff0000;
  --bs-btn-focus-shadow-rgb: 255, 0, 0;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ff0000;
  --bs-btn-active-border-color: #ff0000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ff0000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ff0000;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #000000;
  --bs-btn-border-color: #000000;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #000000;
  --bs-btn-hover-border-color: #000000;
  --bs-btn-focus-shadow-rgb: 0, 0, 0;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #000000;
  --bs-btn-active-border-color: #000000;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000000;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #000000;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(var(--bs-border-width) * -1);
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(var(--bs-border-width) * -1);
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-border-color: #86b7fe;
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--bs-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(var(--bs-border-width) * -1);
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 1rem;
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  --bs-btn-close-white-filter: invert(1) grayscale(100%) brightness(200%);
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  filter: var(--bs-btn-close-white-filter);
}

[data-bs-theme=dark] .btn-close {
  filter: var(--bs-btn-close-white-filter);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--bs-modal-header-padding-y)) calc(-0.5 * var(--bs-modal-header-padding-x)) calc(-0.5 * var(--bs-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

[data-bs-theme=dark] .carousel .carousel-control-prev-icon,
[data-bs-theme=dark] .carousel .carousel-control-next-icon, [data-bs-theme=dark].carousel .carousel-control-prev-icon,
[data-bs-theme=dark].carousel .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
[data-bs-theme=dark] .carousel .carousel-indicators [data-bs-target], [data-bs-theme=dark].carousel .carousel-indicators [data-bs-target] {
  background-color: #000;
}
[data-bs-theme=dark] .carousel .carousel-caption, [data-bs-theme=dark].carousel .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000 !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #000 !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(245, 149, 105, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(245, 149, 105, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(191, 191, 191, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(191, 191, 191, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(255, 51, 51, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 51, 51, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(0, 0, 0, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 0, 0, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.top--8 {
  top: -8% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.bottom--8 {
  bottom: -8% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.start--8 {
  left: -8% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.end--8 {
  right: -8% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-5 {
  width: 5% !important;
}

.w-10 {
  width: 10% !important;
}

.w-15 {
  width: 15% !important;
}

.w-20 {
  width: 20% !important;
}

.w-25 {
  width: 25% !important;
}

.w-30 {
  width: 30% !important;
}

.w-35 {
  width: 35% !important;
}

.w-40 {
  width: 40% !important;
}

.w-50 {
  width: 50% !important;
}

.w-60 {
  width: 60% !important;
}

.w-65 {
  width: 65% !important;
}

.w-70 {
  width: 70% !important;
}

.w-75 {
  width: 75% !important;
}

.w-80 {
  width: 80% !important;
}

.w-85 {
  width: 85% !important;
}

.w-90 {
  width: 90% !important;
}

.w-95 {
  width: 95% !important;
}

.w-100 {
  width: 100% !important;
}

.w-1-px {
  width: 1px !important;
}

.w-2-px {
  width: 2px !important;
}

.w-3-px {
  width: 3px !important;
}

.w-4-px {
  width: 4px !important;
}

.w-5-px {
  width: 5px !important;
}

.w-10-px {
  width: 10px !important;
}

.w-15-px {
  width: 15px !important;
}

.w-20-px {
  width: 20px !important;
}

.w-30-px {
  width: 30px !important;
}

.w-35-px {
  width: 35px !important;
}

.w-40-px {
  width: 40px !important;
}

.w-50-px {
  width: 50px !important;
}

.w-60-px {
  width: 60px !important;
}

.w-65-px {
  width: 65px !important;
}

.w-70-px {
  width: 70px !important;
}

.w-75-px {
  width: 75px !important;
}

.w-80-px {
  width: 80px !important;
}

.w-85-px {
  width: 85px !important;
}

.w-90-px {
  width: 90px !important;
}

.w-95-px {
  width: 95px !important;
}

.w-100-px {
  width: 100px !important;
}

.w-125-px {
  width: 125px !important;
}

.w-140-px {
  width: 140px !important;
}

.w-150-px {
  width: 150px !important;
}

.w-175-px {
  width: 175px !important;
}

.w-180-px {
  width: 180px !important;
}

.w-190-px {
  width: 190px !important;
}

.w-200-px {
  width: 200px !important;
}

.w-220-px {
  width: 220px !important;
}

.w-225-px {
  width: 225px !important;
}

.w-230-px {
  width: 230px !important;
}

.w-250-px {
  width: 250px !important;
}

.w-300-px {
  width: 300px !important;
}

.w-320-px {
  width: 320px !important;
}

.w-330-px {
  width: 330px !important;
}

.w-350-px {
  width: 350px !important;
}

.w-400-px {
  width: 400px !important;
}

.w-450-px {
  width: 450px !important;
}

.w-500-px {
  width: 500px !important;
}

.w-550-px {
  width: 550px !important;
}

.w-600-px {
  width: 600px !important;
}

.w-610-px {
  width: 610px !important;
}

.w-620-px {
  width: 620px !important;
}

.w-630-px {
  width: 630px !important;
}

.w-640-px {
  width: 640px !important;
}

.w-650-px {
  width: 650px !important;
}

.w-700-px {
  width: 700px !important;
}

.w-100-vh {
  width: 100vh !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-5 {
  height: 5% !important;
}

.h-10 {
  height: 10% !important;
}

.h-15 {
  height: 15% !important;
}

.h-20 {
  height: 20% !important;
}

.h-25 {
  height: 25% !important;
}

.h-30 {
  height: 30% !important;
}

.h-35 {
  height: 35% !important;
}

.h-40 {
  height: 40% !important;
}

.h-50 {
  height: 50% !important;
}

.h-60 {
  height: 60% !important;
}

.h-70 {
  height: 70% !important;
}

.h-75 {
  height: 75% !important;
}

.h-80 {
  height: 80% !important;
}

.h-90 {
  height: 90% !important;
}

.h-95 {
  height: 95% !important;
}

.h-100 {
  height: 100% !important;
}

.h-1-px {
  height: 1px !important;
}

.h-2-px {
  height: 2px !important;
}

.h-3-px {
  height: 3px !important;
}

.h-4-px {
  height: 4px !important;
}

.h-5-px {
  height: 5px !important;
}

.h-10-px {
  height: 10px !important;
}

.h-15-px {
  height: 15px !important;
}

.h-20-px {
  height: 20px !important;
}

.h-30-px {
  height: 30px !important;
}

.h-40-px {
  height: 40px !important;
}

.h-41-px {
  height: 41px !important;
}

.h-42-px {
  height: 42px !important;
}

.h-43-px {
  height: 43px !important;
}

.h-44-px {
  height: 44px !important;
}

.h-45-px {
  height: 45px !important;
}

.h-46-px {
  height: 46px !important;
}

.h-47-px {
  height: 47px !important;
}

.h-48-px {
  height: 48px !important;
}

.h-49-px {
  height: 49px !important;
}

.h-50-px {
  height: 50px !important;
}

.h-60-px {
  height: 60px !important;
}

.h-65-px {
  height: 65px !important;
}

.h-70-px {
  height: 70px !important;
}

.h-80-px {
  height: 80px !important;
}

.h-90-px {
  height: 90px !important;
}

.h-100-px {
  height: 100px !important;
}

.h-125-px {
  height: 125px !important;
}

.h-150-px {
  height: 150px !important;
}

.h-175-px {
  height: 175px !important;
}

.h-200-px {
  height: 200px !important;
}

.h-220-px {
  height: 220px !important;
}

.h-225-px {
  height: 225px !important;
}

.h-230-px {
  height: 230px !important;
}

.h-250-px {
  height: 250px !important;
}

.h-300-px {
  height: 300px !important;
}

.h-310-px {
  height: 310px !important;
}

.h-320-px {
  height: 320px !important;
}

.h-330-px {
  height: 330px !important;
}

.h-340-px {
  height: 340px !important;
}

.h-350-px {
  height: 350px !important;
}

.h-360-px {
  height: 360px !important;
}

.h-370-px {
  height: 370px !important;
}

.h-380-px {
  height: 380px !important;
}

.h-390-px {
  height: 390px !important;
}

.h-400-px {
  height: 400px !important;
}

.h-450-px {
  height: 450px !important;
}

.h-500-px {
  height: 500px !important;
}

.h-550-px {
  height: 550px !important;
}

.h-560-px {
  height: 560px !important;
}

.h-570-px {
  height: 570px !important;
}

.h-580-px {
  height: 580px !important;
}

.h-590-px {
  height: 590px !important;
}

.h-600-px {
  height: 600px !important;
}

.h-20-vh {
  height: 20vh !important;
}

.h-40-vh {
  height: 40vh !important;
}

.h-50-vh {
  height: 50vh !important;
}

.h-60-vh {
  height: 60vh !important;
}

.h-70-vh {
  height: 70vh !important;
}

.h-75-vh {
  height: 75vh !important;
}

.h-80-vh {
  height: 80vh !important;
}

.h-100-vh {
  height: 100vh !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-5-px {
  margin: 5px !important;
}

.m-10-px {
  margin: 10px !important;
}

.m-20-px {
  margin: 20px !important;
}

.m-30-px {
  margin: 30px !important;
}

.m-35-px {
  margin: 35px !important;
}

.m-40-px {
  margin: 40px !important;
}

.m-45-px {
  margin: 45px !important;
}

.m-50-px {
  margin: 50px !important;
}

.m-60-px {
  margin: 60px !important;
}

.m-70-px {
  margin: 70px !important;
}

.m-80-px {
  margin: 80px !important;
}

.m-90-px {
  margin: 90px !important;
}

.m-100-px {
  margin: 100px !important;
}

.m-120-px {
  margin: 120px !important;
}

.m-125-px {
  margin: 125px !important;
}

.m-130-px {
  margin: 130px !important;
}

.m-150-px {
  margin: 150px !important;
}

.m-200-px {
  margin: 200px !important;
}

.m-250-px {
  margin: 250px !important;
}

.m-300-px {
  margin: 300px !important;
}

.m-350-px {
  margin: 350px !important;
}

.m-400-px {
  margin: 400px !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-5-px {
  margin-right: 5px !important;
  margin-left: 5px !important;
}

.mx-10-px {
  margin-right: 10px !important;
  margin-left: 10px !important;
}

.mx-20-px {
  margin-right: 20px !important;
  margin-left: 20px !important;
}

.mx-30-px {
  margin-right: 30px !important;
  margin-left: 30px !important;
}

.mx-35-px {
  margin-right: 35px !important;
  margin-left: 35px !important;
}

.mx-40-px {
  margin-right: 40px !important;
  margin-left: 40px !important;
}

.mx-45-px {
  margin-right: 45px !important;
  margin-left: 45px !important;
}

.mx-50-px {
  margin-right: 50px !important;
  margin-left: 50px !important;
}

.mx-60-px {
  margin-right: 60px !important;
  margin-left: 60px !important;
}

.mx-70-px {
  margin-right: 70px !important;
  margin-left: 70px !important;
}

.mx-80-px {
  margin-right: 80px !important;
  margin-left: 80px !important;
}

.mx-90-px {
  margin-right: 90px !important;
  margin-left: 90px !important;
}

.mx-100-px {
  margin-right: 100px !important;
  margin-left: 100px !important;
}

.mx-120-px {
  margin-right: 120px !important;
  margin-left: 120px !important;
}

.mx-125-px {
  margin-right: 125px !important;
  margin-left: 125px !important;
}

.mx-130-px {
  margin-right: 130px !important;
  margin-left: 130px !important;
}

.mx-150-px {
  margin-right: 150px !important;
  margin-left: 150px !important;
}

.mx-200-px {
  margin-right: 200px !important;
  margin-left: 200px !important;
}

.mx-250-px {
  margin-right: 250px !important;
  margin-left: 250px !important;
}

.mx-300-px {
  margin-right: 300px !important;
  margin-left: 300px !important;
}

.mx-350-px {
  margin-right: 350px !important;
  margin-left: 350px !important;
}

.mx-400-px {
  margin-right: 400px !important;
  margin-left: 400px !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-5-px {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}

.my-10-px {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.my-20-px {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.my-30-px {
  margin-top: 30px !important;
  margin-bottom: 30px !important;
}

.my-35-px {
  margin-top: 35px !important;
  margin-bottom: 35px !important;
}

.my-40-px {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.my-45-px {
  margin-top: 45px !important;
  margin-bottom: 45px !important;
}

.my-50-px {
  margin-top: 50px !important;
  margin-bottom: 50px !important;
}

.my-60-px {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

.my-70-px {
  margin-top: 70px !important;
  margin-bottom: 70px !important;
}

.my-80-px {
  margin-top: 80px !important;
  margin-bottom: 80px !important;
}

.my-90-px {
  margin-top: 90px !important;
  margin-bottom: 90px !important;
}

.my-100-px {
  margin-top: 100px !important;
  margin-bottom: 100px !important;
}

.my-120-px {
  margin-top: 120px !important;
  margin-bottom: 120px !important;
}

.my-125-px {
  margin-top: 125px !important;
  margin-bottom: 125px !important;
}

.my-130-px {
  margin-top: 130px !important;
  margin-bottom: 130px !important;
}

.my-150-px {
  margin-top: 150px !important;
  margin-bottom: 150px !important;
}

.my-200-px {
  margin-top: 200px !important;
  margin-bottom: 200px !important;
}

.my-250-px {
  margin-top: 250px !important;
  margin-bottom: 250px !important;
}

.my-300-px {
  margin-top: 300px !important;
  margin-bottom: 300px !important;
}

.my-350-px {
  margin-top: 350px !important;
  margin-bottom: 350px !important;
}

.my-400-px {
  margin-top: 400px !important;
  margin-bottom: 400px !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-5-px {
  margin-top: 5px !important;
}

.mt-10-px {
  margin-top: 10px !important;
}

.mt-20-px {
  margin-top: 20px !important;
}

.mt-30-px {
  margin-top: 30px !important;
}

.mt-35-px {
  margin-top: 35px !important;
}

.mt-40-px {
  margin-top: 40px !important;
}

.mt-45-px {
  margin-top: 45px !important;
}

.mt-50-px {
  margin-top: 50px !important;
}

.mt-60-px {
  margin-top: 60px !important;
}

.mt-70-px {
  margin-top: 70px !important;
}

.mt-80-px {
  margin-top: 80px !important;
}

.mt-90-px {
  margin-top: 90px !important;
}

.mt-100-px {
  margin-top: 100px !important;
}

.mt-120-px {
  margin-top: 120px !important;
}

.mt-125-px {
  margin-top: 125px !important;
}

.mt-130-px {
  margin-top: 130px !important;
}

.mt-150-px {
  margin-top: 150px !important;
}

.mt-200-px {
  margin-top: 200px !important;
}

.mt-250-px {
  margin-top: 250px !important;
}

.mt-300-px {
  margin-top: 300px !important;
}

.mt-350-px {
  margin-top: 350px !important;
}

.mt-400-px {
  margin-top: 400px !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-5-px {
  margin-right: 5px !important;
}

.me-10-px {
  margin-right: 10px !important;
}

.me-20-px {
  margin-right: 20px !important;
}

.me-30-px {
  margin-right: 30px !important;
}

.me-35-px {
  margin-right: 35px !important;
}

.me-40-px {
  margin-right: 40px !important;
}

.me-45-px {
  margin-right: 45px !important;
}

.me-50-px {
  margin-right: 50px !important;
}

.me-60-px {
  margin-right: 60px !important;
}

.me-70-px {
  margin-right: 70px !important;
}

.me-80-px {
  margin-right: 80px !important;
}

.me-90-px {
  margin-right: 90px !important;
}

.me-100-px {
  margin-right: 100px !important;
}

.me-120-px {
  margin-right: 120px !important;
}

.me-125-px {
  margin-right: 125px !important;
}

.me-130-px {
  margin-right: 130px !important;
}

.me-150-px {
  margin-right: 150px !important;
}

.me-200-px {
  margin-right: 200px !important;
}

.me-250-px {
  margin-right: 250px !important;
}

.me-300-px {
  margin-right: 300px !important;
}

.me-350-px {
  margin-right: 350px !important;
}

.me-400-px {
  margin-right: 400px !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-5-px {
  margin-bottom: 5px !important;
}

.mb-10-px {
  margin-bottom: 10px !important;
}

.mb-20-px {
  margin-bottom: 20px !important;
}

.mb-30-px {
  margin-bottom: 30px !important;
}

.mb-35-px {
  margin-bottom: 35px !important;
}

.mb-40-px {
  margin-bottom: 40px !important;
}

.mb-45-px {
  margin-bottom: 45px !important;
}

.mb-50-px {
  margin-bottom: 50px !important;
}

.mb-60-px {
  margin-bottom: 60px !important;
}

.mb-70-px {
  margin-bottom: 70px !important;
}

.mb-80-px {
  margin-bottom: 80px !important;
}

.mb-90-px {
  margin-bottom: 90px !important;
}

.mb-100-px {
  margin-bottom: 100px !important;
}

.mb-120-px {
  margin-bottom: 120px !important;
}

.mb-125-px {
  margin-bottom: 125px !important;
}

.mb-130-px {
  margin-bottom: 130px !important;
}

.mb-150-px {
  margin-bottom: 150px !important;
}

.mb-200-px {
  margin-bottom: 200px !important;
}

.mb-250-px {
  margin-bottom: 250px !important;
}

.mb-300-px {
  margin-bottom: 300px !important;
}

.mb-350-px {
  margin-bottom: 350px !important;
}

.mb-400-px {
  margin-bottom: 400px !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-5-px {
  margin-left: 5px !important;
}

.ms-10-px {
  margin-left: 10px !important;
}

.ms-20-px {
  margin-left: 20px !important;
}

.ms-30-px {
  margin-left: 30px !important;
}

.ms-35-px {
  margin-left: 35px !important;
}

.ms-40-px {
  margin-left: 40px !important;
}

.ms-45-px {
  margin-left: 45px !important;
}

.ms-50-px {
  margin-left: 50px !important;
}

.ms-60-px {
  margin-left: 60px !important;
}

.ms-70-px {
  margin-left: 70px !important;
}

.ms-80-px {
  margin-left: 80px !important;
}

.ms-90-px {
  margin-left: 90px !important;
}

.ms-100-px {
  margin-left: 100px !important;
}

.ms-120-px {
  margin-left: 120px !important;
}

.ms-125-px {
  margin-left: 125px !important;
}

.ms-130-px {
  margin-left: 130px !important;
}

.ms-150-px {
  margin-left: 150px !important;
}

.ms-200-px {
  margin-left: 200px !important;
}

.ms-250-px {
  margin-left: 250px !important;
}

.ms-300-px {
  margin-left: 300px !important;
}

.ms-350-px {
  margin-left: 350px !important;
}

.ms-400-px {
  margin-left: 400px !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.m-n5-px {
  margin: -5px !important;
}

.m-n10-px {
  margin: -10px !important;
}

.m-n20-px {
  margin: -20px !important;
}

.m-n30-px {
  margin: -30px !important;
}

.m-n35-px {
  margin: -35px !important;
}

.m-n40-px {
  margin: -40px !important;
}

.m-n45-px {
  margin: -45px !important;
}

.m-n50-px {
  margin: -50px !important;
}

.m-n60-px {
  margin: -60px !important;
}

.m-n70-px {
  margin: -70px !important;
}

.m-n80-px {
  margin: -80px !important;
}

.m-n90-px {
  margin: -90px !important;
}

.m-n100-px {
  margin: -100px !important;
}

.m-n120-px {
  margin: -120px !important;
}

.m-n125-px {
  margin: -125px !important;
}

.m-n130-px {
  margin: -130px !important;
}

.m-n150-px {
  margin: -150px !important;
}

.m-n200-px {
  margin: -200px !important;
}

.m-n250-px {
  margin: -250px !important;
}

.m-n300-px {
  margin: -300px !important;
}

.m-n350-px {
  margin: -350px !important;
}

.m-n400-px {
  margin: -400px !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.mx-n5-px {
  margin-right: -5px !important;
  margin-left: -5px !important;
}

.mx-n10-px {
  margin-right: -10px !important;
  margin-left: -10px !important;
}

.mx-n20-px {
  margin-right: -20px !important;
  margin-left: -20px !important;
}

.mx-n30-px {
  margin-right: -30px !important;
  margin-left: -30px !important;
}

.mx-n35-px {
  margin-right: -35px !important;
  margin-left: -35px !important;
}

.mx-n40-px {
  margin-right: -40px !important;
  margin-left: -40px !important;
}

.mx-n45-px {
  margin-right: -45px !important;
  margin-left: -45px !important;
}

.mx-n50-px {
  margin-right: -50px !important;
  margin-left: -50px !important;
}

.mx-n60-px {
  margin-right: -60px !important;
  margin-left: -60px !important;
}

.mx-n70-px {
  margin-right: -70px !important;
  margin-left: -70px !important;
}

.mx-n80-px {
  margin-right: -80px !important;
  margin-left: -80px !important;
}

.mx-n90-px {
  margin-right: -90px !important;
  margin-left: -90px !important;
}

.mx-n100-px {
  margin-right: -100px !important;
  margin-left: -100px !important;
}

.mx-n120-px {
  margin-right: -120px !important;
  margin-left: -120px !important;
}

.mx-n125-px {
  margin-right: -125px !important;
  margin-left: -125px !important;
}

.mx-n130-px {
  margin-right: -130px !important;
  margin-left: -130px !important;
}

.mx-n150-px {
  margin-right: -150px !important;
  margin-left: -150px !important;
}

.mx-n200-px {
  margin-right: -200px !important;
  margin-left: -200px !important;
}

.mx-n250-px {
  margin-right: -250px !important;
  margin-left: -250px !important;
}

.mx-n300-px {
  margin-right: -300px !important;
  margin-left: -300px !important;
}

.mx-n350-px {
  margin-right: -350px !important;
  margin-left: -350px !important;
}

.mx-n400-px {
  margin-right: -400px !important;
  margin-left: -400px !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.my-n5-px {
  margin-top: -5px !important;
  margin-bottom: -5px !important;
}

.my-n10-px {
  margin-top: -10px !important;
  margin-bottom: -10px !important;
}

.my-n20-px {
  margin-top: -20px !important;
  margin-bottom: -20px !important;
}

.my-n30-px {
  margin-top: -30px !important;
  margin-bottom: -30px !important;
}

.my-n35-px {
  margin-top: -35px !important;
  margin-bottom: -35px !important;
}

.my-n40-px {
  margin-top: -40px !important;
  margin-bottom: -40px !important;
}

.my-n45-px {
  margin-top: -45px !important;
  margin-bottom: -45px !important;
}

.my-n50-px {
  margin-top: -50px !important;
  margin-bottom: -50px !important;
}

.my-n60-px {
  margin-top: -60px !important;
  margin-bottom: -60px !important;
}

.my-n70-px {
  margin-top: -70px !important;
  margin-bottom: -70px !important;
}

.my-n80-px {
  margin-top: -80px !important;
  margin-bottom: -80px !important;
}

.my-n90-px {
  margin-top: -90px !important;
  margin-bottom: -90px !important;
}

.my-n100-px {
  margin-top: -100px !important;
  margin-bottom: -100px !important;
}

.my-n120-px {
  margin-top: -120px !important;
  margin-bottom: -120px !important;
}

.my-n125-px {
  margin-top: -125px !important;
  margin-bottom: -125px !important;
}

.my-n130-px {
  margin-top: -130px !important;
  margin-bottom: -130px !important;
}

.my-n150-px {
  margin-top: -150px !important;
  margin-bottom: -150px !important;
}

.my-n200-px {
  margin-top: -200px !important;
  margin-bottom: -200px !important;
}

.my-n250-px {
  margin-top: -250px !important;
  margin-bottom: -250px !important;
}

.my-n300-px {
  margin-top: -300px !important;
  margin-bottom: -300px !important;
}

.my-n350-px {
  margin-top: -350px !important;
  margin-bottom: -350px !important;
}

.my-n400-px {
  margin-top: -400px !important;
  margin-bottom: -400px !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.mt-n5-px {
  margin-top: -5px !important;
}

.mt-n10-px {
  margin-top: -10px !important;
}

.mt-n20-px {
  margin-top: -20px !important;
}

.mt-n30-px {
  margin-top: -30px !important;
}

.mt-n35-px {
  margin-top: -35px !important;
}

.mt-n40-px {
  margin-top: -40px !important;
}

.mt-n45-px {
  margin-top: -45px !important;
}

.mt-n50-px {
  margin-top: -50px !important;
}

.mt-n60-px {
  margin-top: -60px !important;
}

.mt-n70-px {
  margin-top: -70px !important;
}

.mt-n80-px {
  margin-top: -80px !important;
}

.mt-n90-px {
  margin-top: -90px !important;
}

.mt-n100-px {
  margin-top: -100px !important;
}

.mt-n120-px {
  margin-top: -120px !important;
}

.mt-n125-px {
  margin-top: -125px !important;
}

.mt-n130-px {
  margin-top: -130px !important;
}

.mt-n150-px {
  margin-top: -150px !important;
}

.mt-n200-px {
  margin-top: -200px !important;
}

.mt-n250-px {
  margin-top: -250px !important;
}

.mt-n300-px {
  margin-top: -300px !important;
}

.mt-n350-px {
  margin-top: -350px !important;
}

.mt-n400-px {
  margin-top: -400px !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.me-n5-px {
  margin-right: -5px !important;
}

.me-n10-px {
  margin-right: -10px !important;
}

.me-n20-px {
  margin-right: -20px !important;
}

.me-n30-px {
  margin-right: -30px !important;
}

.me-n35-px {
  margin-right: -35px !important;
}

.me-n40-px {
  margin-right: -40px !important;
}

.me-n45-px {
  margin-right: -45px !important;
}

.me-n50-px {
  margin-right: -50px !important;
}

.me-n60-px {
  margin-right: -60px !important;
}

.me-n70-px {
  margin-right: -70px !important;
}

.me-n80-px {
  margin-right: -80px !important;
}

.me-n90-px {
  margin-right: -90px !important;
}

.me-n100-px {
  margin-right: -100px !important;
}

.me-n120-px {
  margin-right: -120px !important;
}

.me-n125-px {
  margin-right: -125px !important;
}

.me-n130-px {
  margin-right: -130px !important;
}

.me-n150-px {
  margin-right: -150px !important;
}

.me-n200-px {
  margin-right: -200px !important;
}

.me-n250-px {
  margin-right: -250px !important;
}

.me-n300-px {
  margin-right: -300px !important;
}

.me-n350-px {
  margin-right: -350px !important;
}

.me-n400-px {
  margin-right: -400px !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.mb-n5-px {
  margin-bottom: -5px !important;
}

.mb-n10-px {
  margin-bottom: -10px !important;
}

.mb-n20-px {
  margin-bottom: -20px !important;
}

.mb-n30-px {
  margin-bottom: -30px !important;
}

.mb-n35-px {
  margin-bottom: -35px !important;
}

.mb-n40-px {
  margin-bottom: -40px !important;
}

.mb-n45-px {
  margin-bottom: -45px !important;
}

.mb-n50-px {
  margin-bottom: -50px !important;
}

.mb-n60-px {
  margin-bottom: -60px !important;
}

.mb-n70-px {
  margin-bottom: -70px !important;
}

.mb-n80-px {
  margin-bottom: -80px !important;
}

.mb-n90-px {
  margin-bottom: -90px !important;
}

.mb-n100-px {
  margin-bottom: -100px !important;
}

.mb-n120-px {
  margin-bottom: -120px !important;
}

.mb-n125-px {
  margin-bottom: -125px !important;
}

.mb-n130-px {
  margin-bottom: -130px !important;
}

.mb-n150-px {
  margin-bottom: -150px !important;
}

.mb-n200-px {
  margin-bottom: -200px !important;
}

.mb-n250-px {
  margin-bottom: -250px !important;
}

.mb-n300-px {
  margin-bottom: -300px !important;
}

.mb-n350-px {
  margin-bottom: -350px !important;
}

.mb-n400-px {
  margin-bottom: -400px !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.ms-n5-px {
  margin-left: -5px !important;
}

.ms-n10-px {
  margin-left: -10px !important;
}

.ms-n20-px {
  margin-left: -20px !important;
}

.ms-n30-px {
  margin-left: -30px !important;
}

.ms-n35-px {
  margin-left: -35px !important;
}

.ms-n40-px {
  margin-left: -40px !important;
}

.ms-n45-px {
  margin-left: -45px !important;
}

.ms-n50-px {
  margin-left: -50px !important;
}

.ms-n60-px {
  margin-left: -60px !important;
}

.ms-n70-px {
  margin-left: -70px !important;
}

.ms-n80-px {
  margin-left: -80px !important;
}

.ms-n90-px {
  margin-left: -90px !important;
}

.ms-n100-px {
  margin-left: -100px !important;
}

.ms-n120-px {
  margin-left: -120px !important;
}

.ms-n125-px {
  margin-left: -125px !important;
}

.ms-n130-px {
  margin-left: -130px !important;
}

.ms-n150-px {
  margin-left: -150px !important;
}

.ms-n200-px {
  margin-left: -200px !important;
}

.ms-n250-px {
  margin-left: -250px !important;
}

.ms-n300-px {
  margin-left: -300px !important;
}

.ms-n350-px {
  margin-left: -350px !important;
}

.ms-n400-px {
  margin-left: -400px !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.p-5-px {
  padding: 5px !important;
}

.p-10-px {
  padding: 10px !important;
}

.p-20-px {
  padding: 20px !important;
}

.p-30-px {
  padding: 30px !important;
}

.p-35-px {
  padding: 35px !important;
}

.p-40-px {
  padding: 40px !important;
}

.p-45-px {
  padding: 45px !important;
}

.p-50-px {
  padding: 50px !important;
}

.p-60-px {
  padding: 60px !important;
}

.p-70-px {
  padding: 70px !important;
}

.p-80-px {
  padding: 80px !important;
}

.p-90-px {
  padding: 90px !important;
}

.p-100-px {
  padding: 100px !important;
}

.p-120-px {
  padding: 120px !important;
}

.p-125-px {
  padding: 125px !important;
}

.p-130-px {
  padding: 130px !important;
}

.p-150-px {
  padding: 150px !important;
}

.p-200-px {
  padding: 200px !important;
}

.p-250-px {
  padding: 250px !important;
}

.p-300-px {
  padding: 300px !important;
}

.p-350-px {
  padding: 350px !important;
}

.p-400-px {
  padding: 400px !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.px-5-px {
  padding-right: 5px !important;
  padding-left: 5px !important;
}

.px-10-px {
  padding-right: 10px !important;
  padding-left: 10px !important;
}

.px-20-px {
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.px-30-px {
  padding-right: 30px !important;
  padding-left: 30px !important;
}

.px-35-px {
  padding-right: 35px !important;
  padding-left: 35px !important;
}

.px-40-px {
  padding-right: 40px !important;
  padding-left: 40px !important;
}

.px-45-px {
  padding-right: 45px !important;
  padding-left: 45px !important;
}

.px-50-px {
  padding-right: 50px !important;
  padding-left: 50px !important;
}

.px-60-px {
  padding-right: 60px !important;
  padding-left: 60px !important;
}

.px-70-px {
  padding-right: 70px !important;
  padding-left: 70px !important;
}

.px-80-px {
  padding-right: 80px !important;
  padding-left: 80px !important;
}

.px-90-px {
  padding-right: 90px !important;
  padding-left: 90px !important;
}

.px-100-px {
  padding-right: 100px !important;
  padding-left: 100px !important;
}

.px-120-px {
  padding-right: 120px !important;
  padding-left: 120px !important;
}

.px-125-px {
  padding-right: 125px !important;
  padding-left: 125px !important;
}

.px-130-px {
  padding-right: 130px !important;
  padding-left: 130px !important;
}

.px-150-px {
  padding-right: 150px !important;
  padding-left: 150px !important;
}

.px-200-px {
  padding-right: 200px !important;
  padding-left: 200px !important;
}

.px-250-px {
  padding-right: 250px !important;
  padding-left: 250px !important;
}

.px-300-px {
  padding-right: 300px !important;
  padding-left: 300px !important;
}

.px-350-px {
  padding-right: 350px !important;
  padding-left: 350px !important;
}

.px-400-px {
  padding-right: 400px !important;
  padding-left: 400px !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.py-5-px {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.py-10-px {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}

.py-20-px {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.py-30-px {
  padding-top: 30px !important;
  padding-bottom: 30px !important;
}

.py-35-px {
  padding-top: 35px !important;
  padding-bottom: 35px !important;
}

.py-40-px {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.py-45-px {
  padding-top: 45px !important;
  padding-bottom: 45px !important;
}

.py-50-px {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}

.py-60-px {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.py-70-px {
  padding-top: 70px !important;
  padding-bottom: 70px !important;
}

.py-80-px {
  padding-top: 80px !important;
  padding-bottom: 80px !important;
}

.py-90-px {
  padding-top: 90px !important;
  padding-bottom: 90px !important;
}

.py-100-px {
  padding-top: 100px !important;
  padding-bottom: 100px !important;
}

.py-120-px {
  padding-top: 120px !important;
  padding-bottom: 120px !important;
}

.py-125-px {
  padding-top: 125px !important;
  padding-bottom: 125px !important;
}

.py-130-px {
  padding-top: 130px !important;
  padding-bottom: 130px !important;
}

.py-150-px {
  padding-top: 150px !important;
  padding-bottom: 150px !important;
}

.py-200-px {
  padding-top: 200px !important;
  padding-bottom: 200px !important;
}

.py-250-px {
  padding-top: 250px !important;
  padding-bottom: 250px !important;
}

.py-300-px {
  padding-top: 300px !important;
  padding-bottom: 300px !important;
}

.py-350-px {
  padding-top: 350px !important;
  padding-bottom: 350px !important;
}

.py-400-px {
  padding-top: 400px !important;
  padding-bottom: 400px !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pt-5-px {
  padding-top: 5px !important;
}

.pt-10-px {
  padding-top: 10px !important;
}

.pt-20-px {
  padding-top: 20px !important;
}

.pt-30-px {
  padding-top: 30px !important;
}

.pt-35-px {
  padding-top: 35px !important;
}

.pt-40-px {
  padding-top: 40px !important;
}

.pt-45-px {
  padding-top: 45px !important;
}

.pt-50-px {
  padding-top: 50px !important;
}

.pt-60-px {
  padding-top: 60px !important;
}

.pt-70-px {
  padding-top: 70px !important;
}

.pt-80-px {
  padding-top: 80px !important;
}

.pt-90-px {
  padding-top: 90px !important;
}

.pt-100-px {
  padding-top: 100px !important;
}

.pt-120-px {
  padding-top: 120px !important;
}

.pt-125-px {
  padding-top: 125px !important;
}

.pt-130-px {
  padding-top: 130px !important;
}

.pt-150-px {
  padding-top: 150px !important;
}

.pt-200-px {
  padding-top: 200px !important;
}

.pt-250-px {
  padding-top: 250px !important;
}

.pt-300-px {
  padding-top: 300px !important;
}

.pt-350-px {
  padding-top: 350px !important;
}

.pt-400-px {
  padding-top: 400px !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pe-5-px {
  padding-right: 5px !important;
}

.pe-10-px {
  padding-right: 10px !important;
}

.pe-20-px {
  padding-right: 20px !important;
}

.pe-30-px {
  padding-right: 30px !important;
}

.pe-35-px {
  padding-right: 35px !important;
}

.pe-40-px {
  padding-right: 40px !important;
}

.pe-45-px {
  padding-right: 45px !important;
}

.pe-50-px {
  padding-right: 50px !important;
}

.pe-60-px {
  padding-right: 60px !important;
}

.pe-70-px {
  padding-right: 70px !important;
}

.pe-80-px {
  padding-right: 80px !important;
}

.pe-90-px {
  padding-right: 90px !important;
}

.pe-100-px {
  padding-right: 100px !important;
}

.pe-120-px {
  padding-right: 120px !important;
}

.pe-125-px {
  padding-right: 125px !important;
}

.pe-130-px {
  padding-right: 130px !important;
}

.pe-150-px {
  padding-right: 150px !important;
}

.pe-200-px {
  padding-right: 200px !important;
}

.pe-250-px {
  padding-right: 250px !important;
}

.pe-300-px {
  padding-right: 300px !important;
}

.pe-350-px {
  padding-right: 350px !important;
}

.pe-400-px {
  padding-right: 400px !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.pb-5-px {
  padding-bottom: 5px !important;
}

.pb-10-px {
  padding-bottom: 10px !important;
}

.pb-20-px {
  padding-bottom: 20px !important;
}

.pb-30-px {
  padding-bottom: 30px !important;
}

.pb-35-px {
  padding-bottom: 35px !important;
}

.pb-40-px {
  padding-bottom: 40px !important;
}

.pb-45-px {
  padding-bottom: 45px !important;
}

.pb-50-px {
  padding-bottom: 50px !important;
}

.pb-60-px {
  padding-bottom: 60px !important;
}

.pb-70-px {
  padding-bottom: 70px !important;
}

.pb-80-px {
  padding-bottom: 80px !important;
}

.pb-90-px {
  padding-bottom: 90px !important;
}

.pb-100-px {
  padding-bottom: 100px !important;
}

.pb-120-px {
  padding-bottom: 120px !important;
}

.pb-125-px {
  padding-bottom: 125px !important;
}

.pb-130-px {
  padding-bottom: 130px !important;
}

.pb-150-px {
  padding-bottom: 150px !important;
}

.pb-200-px {
  padding-bottom: 200px !important;
}

.pb-250-px {
  padding-bottom: 250px !important;
}

.pb-300-px {
  padding-bottom: 300px !important;
}

.pb-350-px {
  padding-bottom: 350px !important;
}

.pb-400-px {
  padding-bottom: 400px !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.ps-5-px {
  padding-left: 5px !important;
}

.ps-10-px {
  padding-left: 10px !important;
}

.ps-20-px {
  padding-left: 20px !important;
}

.ps-30-px {
  padding-left: 30px !important;
}

.ps-35-px {
  padding-left: 35px !important;
}

.ps-40-px {
  padding-left: 40px !important;
}

.ps-45-px {
  padding-left: 45px !important;
}

.ps-50-px {
  padding-left: 50px !important;
}

.ps-60-px {
  padding-left: 60px !important;
}

.ps-70-px {
  padding-left: 70px !important;
}

.ps-80-px {
  padding-left: 80px !important;
}

.ps-90-px {
  padding-left: 90px !important;
}

.ps-100-px {
  padding-left: 100px !important;
}

.ps-120-px {
  padding-left: 120px !important;
}

.ps-125-px {
  padding-left: 125px !important;
}

.ps-130-px {
  padding-left: 130px !important;
}

.ps-150-px {
  padding-left: 150px !important;
}

.ps-200-px {
  padding-left: 200px !important;
}

.ps-250-px {
  padding-left: 250px !important;
}

.ps-300-px {
  padding-left: 300px !important;
}

.ps-350-px {
  padding-left: 350px !important;
}

.ps-400-px {
  padding-left: 400px !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.gap-5-px {
  gap: 5px !important;
}

.gap-10-px {
  gap: 10px !important;
}

.gap-20-px {
  gap: 20px !important;
}

.gap-30-px {
  gap: 30px !important;
}

.gap-35-px {
  gap: 35px !important;
}

.gap-40-px {
  gap: 40px !important;
}

.gap-45-px {
  gap: 45px !important;
}

.gap-50-px {
  gap: 50px !important;
}

.gap-60-px {
  gap: 60px !important;
}

.gap-70-px {
  gap: 70px !important;
}

.gap-80-px {
  gap: 80px !important;
}

.gap-90-px {
  gap: 90px !important;
}

.gap-100-px {
  gap: 100px !important;
}

.gap-120-px {
  gap: 120px !important;
}

.gap-125-px {
  gap: 125px !important;
}

.gap-130-px {
  gap: 130px !important;
}

.gap-150-px {
  gap: 150px !important;
}

.gap-200-px {
  gap: 200px !important;
}

.gap-250-px {
  gap: 250px !important;
}

.gap-300-px {
  gap: 300px !important;
}

.gap-350-px {
  gap: 350px !important;
}

.gap-400-px {
  gap: 400px !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.row-gap-5-px {
  row-gap: 5px !important;
}

.row-gap-10-px {
  row-gap: 10px !important;
}

.row-gap-20-px {
  row-gap: 20px !important;
}

.row-gap-30-px {
  row-gap: 30px !important;
}

.row-gap-35-px {
  row-gap: 35px !important;
}

.row-gap-40-px {
  row-gap: 40px !important;
}

.row-gap-45-px {
  row-gap: 45px !important;
}

.row-gap-50-px {
  row-gap: 50px !important;
}

.row-gap-60-px {
  row-gap: 60px !important;
}

.row-gap-70-px {
  row-gap: 70px !important;
}

.row-gap-80-px {
  row-gap: 80px !important;
}

.row-gap-90-px {
  row-gap: 90px !important;
}

.row-gap-100-px {
  row-gap: 100px !important;
}

.row-gap-120-px {
  row-gap: 120px !important;
}

.row-gap-125-px {
  row-gap: 125px !important;
}

.row-gap-130-px {
  row-gap: 130px !important;
}

.row-gap-150-px {
  row-gap: 150px !important;
}

.row-gap-200-px {
  row-gap: 200px !important;
}

.row-gap-250-px {
  row-gap: 250px !important;
}

.row-gap-300-px {
  row-gap: 300px !important;
}

.row-gap-350-px {
  row-gap: 350px !important;
}

.row-gap-400-px {
  row-gap: 400px !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.column-gap-5-px {
  column-gap: 5px !important;
}

.column-gap-10-px {
  column-gap: 10px !important;
}

.column-gap-20-px {
  column-gap: 20px !important;
}

.column-gap-30-px {
  column-gap: 30px !important;
}

.column-gap-35-px {
  column-gap: 35px !important;
}

.column-gap-40-px {
  column-gap: 40px !important;
}

.column-gap-45-px {
  column-gap: 45px !important;
}

.column-gap-50-px {
  column-gap: 50px !important;
}

.column-gap-60-px {
  column-gap: 60px !important;
}

.column-gap-70-px {
  column-gap: 70px !important;
}

.column-gap-80-px {
  column-gap: 80px !important;
}

.column-gap-90-px {
  column-gap: 90px !important;
}

.column-gap-100-px {
  column-gap: 100px !important;
}

.column-gap-120-px {
  column-gap: 120px !important;
}

.column-gap-125-px {
  column-gap: 125px !important;
}

.column-gap-130-px {
  column-gap: 130px !important;
}

.column-gap-150-px {
  column-gap: 150px !important;
}

.column-gap-200-px {
  column-gap: 200px !important;
}

.column-gap-250-px {
  column-gap: 250px !important;
}

.column-gap-300-px {
  column-gap: 300px !important;
}

.column-gap-350-px {
  column-gap: 350px !important;
}

.column-gap-400-px {
  column-gap: 400px !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-5-px {
    margin: 5px !important;
  }
  .m-sm-10-px {
    margin: 10px !important;
  }
  .m-sm-20-px {
    margin: 20px !important;
  }
  .m-sm-30-px {
    margin: 30px !important;
  }
  .m-sm-35-px {
    margin: 35px !important;
  }
  .m-sm-40-px {
    margin: 40px !important;
  }
  .m-sm-45-px {
    margin: 45px !important;
  }
  .m-sm-50-px {
    margin: 50px !important;
  }
  .m-sm-60-px {
    margin: 60px !important;
  }
  .m-sm-70-px {
    margin: 70px !important;
  }
  .m-sm-80-px {
    margin: 80px !important;
  }
  .m-sm-90-px {
    margin: 90px !important;
  }
  .m-sm-100-px {
    margin: 100px !important;
  }
  .m-sm-120-px {
    margin: 120px !important;
  }
  .m-sm-125-px {
    margin: 125px !important;
  }
  .m-sm-130-px {
    margin: 130px !important;
  }
  .m-sm-150-px {
    margin: 150px !important;
  }
  .m-sm-200-px {
    margin: 200px !important;
  }
  .m-sm-250-px {
    margin: 250px !important;
  }
  .m-sm-300-px {
    margin: 300px !important;
  }
  .m-sm-350-px {
    margin: 350px !important;
  }
  .m-sm-400-px {
    margin: 400px !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-5-px {
    margin-right: 5px !important;
    margin-left: 5px !important;
  }
  .mx-sm-10-px {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }
  .mx-sm-20-px {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  .mx-sm-30-px {
    margin-right: 30px !important;
    margin-left: 30px !important;
  }
  .mx-sm-35-px {
    margin-right: 35px !important;
    margin-left: 35px !important;
  }
  .mx-sm-40-px {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  .mx-sm-45-px {
    margin-right: 45px !important;
    margin-left: 45px !important;
  }
  .mx-sm-50-px {
    margin-right: 50px !important;
    margin-left: 50px !important;
  }
  .mx-sm-60-px {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  .mx-sm-70-px {
    margin-right: 70px !important;
    margin-left: 70px !important;
  }
  .mx-sm-80-px {
    margin-right: 80px !important;
    margin-left: 80px !important;
  }
  .mx-sm-90-px {
    margin-right: 90px !important;
    margin-left: 90px !important;
  }
  .mx-sm-100-px {
    margin-right: 100px !important;
    margin-left: 100px !important;
  }
  .mx-sm-120-px {
    margin-right: 120px !important;
    margin-left: 120px !important;
  }
  .mx-sm-125-px {
    margin-right: 125px !important;
    margin-left: 125px !important;
  }
  .mx-sm-130-px {
    margin-right: 130px !important;
    margin-left: 130px !important;
  }
  .mx-sm-150-px {
    margin-right: 150px !important;
    margin-left: 150px !important;
  }
  .mx-sm-200-px {
    margin-right: 200px !important;
    margin-left: 200px !important;
  }
  .mx-sm-250-px {
    margin-right: 250px !important;
    margin-left: 250px !important;
  }
  .mx-sm-300-px {
    margin-right: 300px !important;
    margin-left: 300px !important;
  }
  .mx-sm-350-px {
    margin-right: 350px !important;
    margin-left: 350px !important;
  }
  .mx-sm-400-px {
    margin-right: 400px !important;
    margin-left: 400px !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-5-px {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }
  .my-sm-10-px {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .my-sm-20-px {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .my-sm-30-px {
    margin-top: 30px !important;
    margin-bottom: 30px !important;
  }
  .my-sm-35-px {
    margin-top: 35px !important;
    margin-bottom: 35px !important;
  }
  .my-sm-40-px {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .my-sm-45-px {
    margin-top: 45px !important;
    margin-bottom: 45px !important;
  }
  .my-sm-50-px {
    margin-top: 50px !important;
    margin-bottom: 50px !important;
  }
  .my-sm-60-px {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  .my-sm-70-px {
    margin-top: 70px !important;
    margin-bottom: 70px !important;
  }
  .my-sm-80-px {
    margin-top: 80px !important;
    margin-bottom: 80px !important;
  }
  .my-sm-90-px {
    margin-top: 90px !important;
    margin-bottom: 90px !important;
  }
  .my-sm-100-px {
    margin-top: 100px !important;
    margin-bottom: 100px !important;
  }
  .my-sm-120-px {
    margin-top: 120px !important;
    margin-bottom: 120px !important;
  }
  .my-sm-125-px {
    margin-top: 125px !important;
    margin-bottom: 125px !important;
  }
  .my-sm-130-px {
    margin-top: 130px !important;
    margin-bottom: 130px !important;
  }
  .my-sm-150-px {
    margin-top: 150px !important;
    margin-bottom: 150px !important;
  }
  .my-sm-200-px {
    margin-top: 200px !important;
    margin-bottom: 200px !important;
  }
  .my-sm-250-px {
    margin-top: 250px !important;
    margin-bottom: 250px !important;
  }
  .my-sm-300-px {
    margin-top: 300px !important;
    margin-bottom: 300px !important;
  }
  .my-sm-350-px {
    margin-top: 350px !important;
    margin-bottom: 350px !important;
  }
  .my-sm-400-px {
    margin-top: 400px !important;
    margin-bottom: 400px !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-5-px {
    margin-top: 5px !important;
  }
  .mt-sm-10-px {
    margin-top: 10px !important;
  }
  .mt-sm-20-px {
    margin-top: 20px !important;
  }
  .mt-sm-30-px {
    margin-top: 30px !important;
  }
  .mt-sm-35-px {
    margin-top: 35px !important;
  }
  .mt-sm-40-px {
    margin-top: 40px !important;
  }
  .mt-sm-45-px {
    margin-top: 45px !important;
  }
  .mt-sm-50-px {
    margin-top: 50px !important;
  }
  .mt-sm-60-px {
    margin-top: 60px !important;
  }
  .mt-sm-70-px {
    margin-top: 70px !important;
  }
  .mt-sm-80-px {
    margin-top: 80px !important;
  }
  .mt-sm-90-px {
    margin-top: 90px !important;
  }
  .mt-sm-100-px {
    margin-top: 100px !important;
  }
  .mt-sm-120-px {
    margin-top: 120px !important;
  }
  .mt-sm-125-px {
    margin-top: 125px !important;
  }
  .mt-sm-130-px {
    margin-top: 130px !important;
  }
  .mt-sm-150-px {
    margin-top: 150px !important;
  }
  .mt-sm-200-px {
    margin-top: 200px !important;
  }
  .mt-sm-250-px {
    margin-top: 250px !important;
  }
  .mt-sm-300-px {
    margin-top: 300px !important;
  }
  .mt-sm-350-px {
    margin-top: 350px !important;
  }
  .mt-sm-400-px {
    margin-top: 400px !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-5-px {
    margin-right: 5px !important;
  }
  .me-sm-10-px {
    margin-right: 10px !important;
  }
  .me-sm-20-px {
    margin-right: 20px !important;
  }
  .me-sm-30-px {
    margin-right: 30px !important;
  }
  .me-sm-35-px {
    margin-right: 35px !important;
  }
  .me-sm-40-px {
    margin-right: 40px !important;
  }
  .me-sm-45-px {
    margin-right: 45px !important;
  }
  .me-sm-50-px {
    margin-right: 50px !important;
  }
  .me-sm-60-px {
    margin-right: 60px !important;
  }
  .me-sm-70-px {
    margin-right: 70px !important;
  }
  .me-sm-80-px {
    margin-right: 80px !important;
  }
  .me-sm-90-px {
    margin-right: 90px !important;
  }
  .me-sm-100-px {
    margin-right: 100px !important;
  }
  .me-sm-120-px {
    margin-right: 120px !important;
  }
  .me-sm-125-px {
    margin-right: 125px !important;
  }
  .me-sm-130-px {
    margin-right: 130px !important;
  }
  .me-sm-150-px {
    margin-right: 150px !important;
  }
  .me-sm-200-px {
    margin-right: 200px !important;
  }
  .me-sm-250-px {
    margin-right: 250px !important;
  }
  .me-sm-300-px {
    margin-right: 300px !important;
  }
  .me-sm-350-px {
    margin-right: 350px !important;
  }
  .me-sm-400-px {
    margin-right: 400px !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-5-px {
    margin-bottom: 5px !important;
  }
  .mb-sm-10-px {
    margin-bottom: 10px !important;
  }
  .mb-sm-20-px {
    margin-bottom: 20px !important;
  }
  .mb-sm-30-px {
    margin-bottom: 30px !important;
  }
  .mb-sm-35-px {
    margin-bottom: 35px !important;
  }
  .mb-sm-40-px {
    margin-bottom: 40px !important;
  }
  .mb-sm-45-px {
    margin-bottom: 45px !important;
  }
  .mb-sm-50-px {
    margin-bottom: 50px !important;
  }
  .mb-sm-60-px {
    margin-bottom: 60px !important;
  }
  .mb-sm-70-px {
    margin-bottom: 70px !important;
  }
  .mb-sm-80-px {
    margin-bottom: 80px !important;
  }
  .mb-sm-90-px {
    margin-bottom: 90px !important;
  }
  .mb-sm-100-px {
    margin-bottom: 100px !important;
  }
  .mb-sm-120-px {
    margin-bottom: 120px !important;
  }
  .mb-sm-125-px {
    margin-bottom: 125px !important;
  }
  .mb-sm-130-px {
    margin-bottom: 130px !important;
  }
  .mb-sm-150-px {
    margin-bottom: 150px !important;
  }
  .mb-sm-200-px {
    margin-bottom: 200px !important;
  }
  .mb-sm-250-px {
    margin-bottom: 250px !important;
  }
  .mb-sm-300-px {
    margin-bottom: 300px !important;
  }
  .mb-sm-350-px {
    margin-bottom: 350px !important;
  }
  .mb-sm-400-px {
    margin-bottom: 400px !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-5-px {
    margin-left: 5px !important;
  }
  .ms-sm-10-px {
    margin-left: 10px !important;
  }
  .ms-sm-20-px {
    margin-left: 20px !important;
  }
  .ms-sm-30-px {
    margin-left: 30px !important;
  }
  .ms-sm-35-px {
    margin-left: 35px !important;
  }
  .ms-sm-40-px {
    margin-left: 40px !important;
  }
  .ms-sm-45-px {
    margin-left: 45px !important;
  }
  .ms-sm-50-px {
    margin-left: 50px !important;
  }
  .ms-sm-60-px {
    margin-left: 60px !important;
  }
  .ms-sm-70-px {
    margin-left: 70px !important;
  }
  .ms-sm-80-px {
    margin-left: 80px !important;
  }
  .ms-sm-90-px {
    margin-left: 90px !important;
  }
  .ms-sm-100-px {
    margin-left: 100px !important;
  }
  .ms-sm-120-px {
    margin-left: 120px !important;
  }
  .ms-sm-125-px {
    margin-left: 125px !important;
  }
  .ms-sm-130-px {
    margin-left: 130px !important;
  }
  .ms-sm-150-px {
    margin-left: 150px !important;
  }
  .ms-sm-200-px {
    margin-left: 200px !important;
  }
  .ms-sm-250-px {
    margin-left: 250px !important;
  }
  .ms-sm-300-px {
    margin-left: 300px !important;
  }
  .ms-sm-350-px {
    margin-left: 350px !important;
  }
  .ms-sm-400-px {
    margin-left: 400px !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .m-sm-n5-px {
    margin: -5px !important;
  }
  .m-sm-n10-px {
    margin: -10px !important;
  }
  .m-sm-n20-px {
    margin: -20px !important;
  }
  .m-sm-n30-px {
    margin: -30px !important;
  }
  .m-sm-n35-px {
    margin: -35px !important;
  }
  .m-sm-n40-px {
    margin: -40px !important;
  }
  .m-sm-n45-px {
    margin: -45px !important;
  }
  .m-sm-n50-px {
    margin: -50px !important;
  }
  .m-sm-n60-px {
    margin: -60px !important;
  }
  .m-sm-n70-px {
    margin: -70px !important;
  }
  .m-sm-n80-px {
    margin: -80px !important;
  }
  .m-sm-n90-px {
    margin: -90px !important;
  }
  .m-sm-n100-px {
    margin: -100px !important;
  }
  .m-sm-n120-px {
    margin: -120px !important;
  }
  .m-sm-n125-px {
    margin: -125px !important;
  }
  .m-sm-n130-px {
    margin: -130px !important;
  }
  .m-sm-n150-px {
    margin: -150px !important;
  }
  .m-sm-n200-px {
    margin: -200px !important;
  }
  .m-sm-n250-px {
    margin: -250px !important;
  }
  .m-sm-n300-px {
    margin: -300px !important;
  }
  .m-sm-n350-px {
    margin: -350px !important;
  }
  .m-sm-n400-px {
    margin: -400px !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-sm-n5-px {
    margin-right: -5px !important;
    margin-left: -5px !important;
  }
  .mx-sm-n10-px {
    margin-right: -10px !important;
    margin-left: -10px !important;
  }
  .mx-sm-n20-px {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  .mx-sm-n30-px {
    margin-right: -30px !important;
    margin-left: -30px !important;
  }
  .mx-sm-n35-px {
    margin-right: -35px !important;
    margin-left: -35px !important;
  }
  .mx-sm-n40-px {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  .mx-sm-n45-px {
    margin-right: -45px !important;
    margin-left: -45px !important;
  }
  .mx-sm-n50-px {
    margin-right: -50px !important;
    margin-left: -50px !important;
  }
  .mx-sm-n60-px {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  .mx-sm-n70-px {
    margin-right: -70px !important;
    margin-left: -70px !important;
  }
  .mx-sm-n80-px {
    margin-right: -80px !important;
    margin-left: -80px !important;
  }
  .mx-sm-n90-px {
    margin-right: -90px !important;
    margin-left: -90px !important;
  }
  .mx-sm-n100-px {
    margin-right: -100px !important;
    margin-left: -100px !important;
  }
  .mx-sm-n120-px {
    margin-right: -120px !important;
    margin-left: -120px !important;
  }
  .mx-sm-n125-px {
    margin-right: -125px !important;
    margin-left: -125px !important;
  }
  .mx-sm-n130-px {
    margin-right: -130px !important;
    margin-left: -130px !important;
  }
  .mx-sm-n150-px {
    margin-right: -150px !important;
    margin-left: -150px !important;
  }
  .mx-sm-n200-px {
    margin-right: -200px !important;
    margin-left: -200px !important;
  }
  .mx-sm-n250-px {
    margin-right: -250px !important;
    margin-left: -250px !important;
  }
  .mx-sm-n300-px {
    margin-right: -300px !important;
    margin-left: -300px !important;
  }
  .mx-sm-n350-px {
    margin-right: -350px !important;
    margin-left: -350px !important;
  }
  .mx-sm-n400-px {
    margin-right: -400px !important;
    margin-left: -400px !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-sm-n5-px {
    margin-top: -5px !important;
    margin-bottom: -5px !important;
  }
  .my-sm-n10-px {
    margin-top: -10px !important;
    margin-bottom: -10px !important;
  }
  .my-sm-n20-px {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  .my-sm-n30-px {
    margin-top: -30px !important;
    margin-bottom: -30px !important;
  }
  .my-sm-n35-px {
    margin-top: -35px !important;
    margin-bottom: -35px !important;
  }
  .my-sm-n40-px {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  .my-sm-n45-px {
    margin-top: -45px !important;
    margin-bottom: -45px !important;
  }
  .my-sm-n50-px {
    margin-top: -50px !important;
    margin-bottom: -50px !important;
  }
  .my-sm-n60-px {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  .my-sm-n70-px {
    margin-top: -70px !important;
    margin-bottom: -70px !important;
  }
  .my-sm-n80-px {
    margin-top: -80px !important;
    margin-bottom: -80px !important;
  }
  .my-sm-n90-px {
    margin-top: -90px !important;
    margin-bottom: -90px !important;
  }
  .my-sm-n100-px {
    margin-top: -100px !important;
    margin-bottom: -100px !important;
  }
  .my-sm-n120-px {
    margin-top: -120px !important;
    margin-bottom: -120px !important;
  }
  .my-sm-n125-px {
    margin-top: -125px !important;
    margin-bottom: -125px !important;
  }
  .my-sm-n130-px {
    margin-top: -130px !important;
    margin-bottom: -130px !important;
  }
  .my-sm-n150-px {
    margin-top: -150px !important;
    margin-bottom: -150px !important;
  }
  .my-sm-n200-px {
    margin-top: -200px !important;
    margin-bottom: -200px !important;
  }
  .my-sm-n250-px {
    margin-top: -250px !important;
    margin-bottom: -250px !important;
  }
  .my-sm-n300-px {
    margin-top: -300px !important;
    margin-bottom: -300px !important;
  }
  .my-sm-n350-px {
    margin-top: -350px !important;
    margin-bottom: -350px !important;
  }
  .my-sm-n400-px {
    margin-top: -400px !important;
    margin-bottom: -400px !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .mt-sm-n5-px {
    margin-top: -5px !important;
  }
  .mt-sm-n10-px {
    margin-top: -10px !important;
  }
  .mt-sm-n20-px {
    margin-top: -20px !important;
  }
  .mt-sm-n30-px {
    margin-top: -30px !important;
  }
  .mt-sm-n35-px {
    margin-top: -35px !important;
  }
  .mt-sm-n40-px {
    margin-top: -40px !important;
  }
  .mt-sm-n45-px {
    margin-top: -45px !important;
  }
  .mt-sm-n50-px {
    margin-top: -50px !important;
  }
  .mt-sm-n60-px {
    margin-top: -60px !important;
  }
  .mt-sm-n70-px {
    margin-top: -70px !important;
  }
  .mt-sm-n80-px {
    margin-top: -80px !important;
  }
  .mt-sm-n90-px {
    margin-top: -90px !important;
  }
  .mt-sm-n100-px {
    margin-top: -100px !important;
  }
  .mt-sm-n120-px {
    margin-top: -120px !important;
  }
  .mt-sm-n125-px {
    margin-top: -125px !important;
  }
  .mt-sm-n130-px {
    margin-top: -130px !important;
  }
  .mt-sm-n150-px {
    margin-top: -150px !important;
  }
  .mt-sm-n200-px {
    margin-top: -200px !important;
  }
  .mt-sm-n250-px {
    margin-top: -250px !important;
  }
  .mt-sm-n300-px {
    margin-top: -300px !important;
  }
  .mt-sm-n350-px {
    margin-top: -350px !important;
  }
  .mt-sm-n400-px {
    margin-top: -400px !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .me-sm-n5-px {
    margin-right: -5px !important;
  }
  .me-sm-n10-px {
    margin-right: -10px !important;
  }
  .me-sm-n20-px {
    margin-right: -20px !important;
  }
  .me-sm-n30-px {
    margin-right: -30px !important;
  }
  .me-sm-n35-px {
    margin-right: -35px !important;
  }
  .me-sm-n40-px {
    margin-right: -40px !important;
  }
  .me-sm-n45-px {
    margin-right: -45px !important;
  }
  .me-sm-n50-px {
    margin-right: -50px !important;
  }
  .me-sm-n60-px {
    margin-right: -60px !important;
  }
  .me-sm-n70-px {
    margin-right: -70px !important;
  }
  .me-sm-n80-px {
    margin-right: -80px !important;
  }
  .me-sm-n90-px {
    margin-right: -90px !important;
  }
  .me-sm-n100-px {
    margin-right: -100px !important;
  }
  .me-sm-n120-px {
    margin-right: -120px !important;
  }
  .me-sm-n125-px {
    margin-right: -125px !important;
  }
  .me-sm-n130-px {
    margin-right: -130px !important;
  }
  .me-sm-n150-px {
    margin-right: -150px !important;
  }
  .me-sm-n200-px {
    margin-right: -200px !important;
  }
  .me-sm-n250-px {
    margin-right: -250px !important;
  }
  .me-sm-n300-px {
    margin-right: -300px !important;
  }
  .me-sm-n350-px {
    margin-right: -350px !important;
  }
  .me-sm-n400-px {
    margin-right: -400px !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-sm-n5-px {
    margin-bottom: -5px !important;
  }
  .mb-sm-n10-px {
    margin-bottom: -10px !important;
  }
  .mb-sm-n20-px {
    margin-bottom: -20px !important;
  }
  .mb-sm-n30-px {
    margin-bottom: -30px !important;
  }
  .mb-sm-n35-px {
    margin-bottom: -35px !important;
  }
  .mb-sm-n40-px {
    margin-bottom: -40px !important;
  }
  .mb-sm-n45-px {
    margin-bottom: -45px !important;
  }
  .mb-sm-n50-px {
    margin-bottom: -50px !important;
  }
  .mb-sm-n60-px {
    margin-bottom: -60px !important;
  }
  .mb-sm-n70-px {
    margin-bottom: -70px !important;
  }
  .mb-sm-n80-px {
    margin-bottom: -80px !important;
  }
  .mb-sm-n90-px {
    margin-bottom: -90px !important;
  }
  .mb-sm-n100-px {
    margin-bottom: -100px !important;
  }
  .mb-sm-n120-px {
    margin-bottom: -120px !important;
  }
  .mb-sm-n125-px {
    margin-bottom: -125px !important;
  }
  .mb-sm-n130-px {
    margin-bottom: -130px !important;
  }
  .mb-sm-n150-px {
    margin-bottom: -150px !important;
  }
  .mb-sm-n200-px {
    margin-bottom: -200px !important;
  }
  .mb-sm-n250-px {
    margin-bottom: -250px !important;
  }
  .mb-sm-n300-px {
    margin-bottom: -300px !important;
  }
  .mb-sm-n350-px {
    margin-bottom: -350px !important;
  }
  .mb-sm-n400-px {
    margin-bottom: -400px !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .ms-sm-n5-px {
    margin-left: -5px !important;
  }
  .ms-sm-n10-px {
    margin-left: -10px !important;
  }
  .ms-sm-n20-px {
    margin-left: -20px !important;
  }
  .ms-sm-n30-px {
    margin-left: -30px !important;
  }
  .ms-sm-n35-px {
    margin-left: -35px !important;
  }
  .ms-sm-n40-px {
    margin-left: -40px !important;
  }
  .ms-sm-n45-px {
    margin-left: -45px !important;
  }
  .ms-sm-n50-px {
    margin-left: -50px !important;
  }
  .ms-sm-n60-px {
    margin-left: -60px !important;
  }
  .ms-sm-n70-px {
    margin-left: -70px !important;
  }
  .ms-sm-n80-px {
    margin-left: -80px !important;
  }
  .ms-sm-n90-px {
    margin-left: -90px !important;
  }
  .ms-sm-n100-px {
    margin-left: -100px !important;
  }
  .ms-sm-n120-px {
    margin-left: -120px !important;
  }
  .ms-sm-n125-px {
    margin-left: -125px !important;
  }
  .ms-sm-n130-px {
    margin-left: -130px !important;
  }
  .ms-sm-n150-px {
    margin-left: -150px !important;
  }
  .ms-sm-n200-px {
    margin-left: -200px !important;
  }
  .ms-sm-n250-px {
    margin-left: -250px !important;
  }
  .ms-sm-n300-px {
    margin-left: -300px !important;
  }
  .ms-sm-n350-px {
    margin-left: -350px !important;
  }
  .ms-sm-n400-px {
    margin-left: -400px !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .p-sm-5-px {
    padding: 5px !important;
  }
  .p-sm-10-px {
    padding: 10px !important;
  }
  .p-sm-20-px {
    padding: 20px !important;
  }
  .p-sm-30-px {
    padding: 30px !important;
  }
  .p-sm-35-px {
    padding: 35px !important;
  }
  .p-sm-40-px {
    padding: 40px !important;
  }
  .p-sm-45-px {
    padding: 45px !important;
  }
  .p-sm-50-px {
    padding: 50px !important;
  }
  .p-sm-60-px {
    padding: 60px !important;
  }
  .p-sm-70-px {
    padding: 70px !important;
  }
  .p-sm-80-px {
    padding: 80px !important;
  }
  .p-sm-90-px {
    padding: 90px !important;
  }
  .p-sm-100-px {
    padding: 100px !important;
  }
  .p-sm-120-px {
    padding: 120px !important;
  }
  .p-sm-125-px {
    padding: 125px !important;
  }
  .p-sm-130-px {
    padding: 130px !important;
  }
  .p-sm-150-px {
    padding: 150px !important;
  }
  .p-sm-200-px {
    padding: 200px !important;
  }
  .p-sm-250-px {
    padding: 250px !important;
  }
  .p-sm-300-px {
    padding: 300px !important;
  }
  .p-sm-350-px {
    padding: 350px !important;
  }
  .p-sm-400-px {
    padding: 400px !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-sm-5-px {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }
  .px-sm-10-px {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .px-sm-20-px {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  .px-sm-30-px {
    padding-right: 30px !important;
    padding-left: 30px !important;
  }
  .px-sm-35-px {
    padding-right: 35px !important;
    padding-left: 35px !important;
  }
  .px-sm-40-px {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  .px-sm-45-px {
    padding-right: 45px !important;
    padding-left: 45px !important;
  }
  .px-sm-50-px {
    padding-right: 50px !important;
    padding-left: 50px !important;
  }
  .px-sm-60-px {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  .px-sm-70-px {
    padding-right: 70px !important;
    padding-left: 70px !important;
  }
  .px-sm-80-px {
    padding-right: 80px !important;
    padding-left: 80px !important;
  }
  .px-sm-90-px {
    padding-right: 90px !important;
    padding-left: 90px !important;
  }
  .px-sm-100-px {
    padding-right: 100px !important;
    padding-left: 100px !important;
  }
  .px-sm-120-px {
    padding-right: 120px !important;
    padding-left: 120px !important;
  }
  .px-sm-125-px {
    padding-right: 125px !important;
    padding-left: 125px !important;
  }
  .px-sm-130-px {
    padding-right: 130px !important;
    padding-left: 130px !important;
  }
  .px-sm-150-px {
    padding-right: 150px !important;
    padding-left: 150px !important;
  }
  .px-sm-200-px {
    padding-right: 200px !important;
    padding-left: 200px !important;
  }
  .px-sm-250-px {
    padding-right: 250px !important;
    padding-left: 250px !important;
  }
  .px-sm-300-px {
    padding-right: 300px !important;
    padding-left: 300px !important;
  }
  .px-sm-350-px {
    padding-right: 350px !important;
    padding-left: 350px !important;
  }
  .px-sm-400-px {
    padding-right: 400px !important;
    padding-left: 400px !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-sm-5-px {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }
  .py-sm-10-px {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .py-sm-20-px {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .py-sm-30-px {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
  .py-sm-35-px {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .py-sm-40-px {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .py-sm-45-px {
    padding-top: 45px !important;
    padding-bottom: 45px !important;
  }
  .py-sm-50-px {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }
  .py-sm-60-px {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  .py-sm-70-px {
    padding-top: 70px !important;
    padding-bottom: 70px !important;
  }
  .py-sm-80-px {
    padding-top: 80px !important;
    padding-bottom: 80px !important;
  }
  .py-sm-90-px {
    padding-top: 90px !important;
    padding-bottom: 90px !important;
  }
  .py-sm-100-px {
    padding-top: 100px !important;
    padding-bottom: 100px !important;
  }
  .py-sm-120-px {
    padding-top: 120px !important;
    padding-bottom: 120px !important;
  }
  .py-sm-125-px {
    padding-top: 125px !important;
    padding-bottom: 125px !important;
  }
  .py-sm-130-px {
    padding-top: 130px !important;
    padding-bottom: 130px !important;
  }
  .py-sm-150-px {
    padding-top: 150px !important;
    padding-bottom: 150px !important;
  }
  .py-sm-200-px {
    padding-top: 200px !important;
    padding-bottom: 200px !important;
  }
  .py-sm-250-px {
    padding-top: 250px !important;
    padding-bottom: 250px !important;
  }
  .py-sm-300-px {
    padding-top: 300px !important;
    padding-bottom: 300px !important;
  }
  .py-sm-350-px {
    padding-top: 350px !important;
    padding-bottom: 350px !important;
  }
  .py-sm-400-px {
    padding-top: 400px !important;
    padding-bottom: 400px !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pt-sm-5-px {
    padding-top: 5px !important;
  }
  .pt-sm-10-px {
    padding-top: 10px !important;
  }
  .pt-sm-20-px {
    padding-top: 20px !important;
  }
  .pt-sm-30-px {
    padding-top: 30px !important;
  }
  .pt-sm-35-px {
    padding-top: 35px !important;
  }
  .pt-sm-40-px {
    padding-top: 40px !important;
  }
  .pt-sm-45-px {
    padding-top: 45px !important;
  }
  .pt-sm-50-px {
    padding-top: 50px !important;
  }
  .pt-sm-60-px {
    padding-top: 60px !important;
  }
  .pt-sm-70-px {
    padding-top: 70px !important;
  }
  .pt-sm-80-px {
    padding-top: 80px !important;
  }
  .pt-sm-90-px {
    padding-top: 90px !important;
  }
  .pt-sm-100-px {
    padding-top: 100px !important;
  }
  .pt-sm-120-px {
    padding-top: 120px !important;
  }
  .pt-sm-125-px {
    padding-top: 125px !important;
  }
  .pt-sm-130-px {
    padding-top: 130px !important;
  }
  .pt-sm-150-px {
    padding-top: 150px !important;
  }
  .pt-sm-200-px {
    padding-top: 200px !important;
  }
  .pt-sm-250-px {
    padding-top: 250px !important;
  }
  .pt-sm-300-px {
    padding-top: 300px !important;
  }
  .pt-sm-350-px {
    padding-top: 350px !important;
  }
  .pt-sm-400-px {
    padding-top: 400px !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pe-sm-5-px {
    padding-right: 5px !important;
  }
  .pe-sm-10-px {
    padding-right: 10px !important;
  }
  .pe-sm-20-px {
    padding-right: 20px !important;
  }
  .pe-sm-30-px {
    padding-right: 30px !important;
  }
  .pe-sm-35-px {
    padding-right: 35px !important;
  }
  .pe-sm-40-px {
    padding-right: 40px !important;
  }
  .pe-sm-45-px {
    padding-right: 45px !important;
  }
  .pe-sm-50-px {
    padding-right: 50px !important;
  }
  .pe-sm-60-px {
    padding-right: 60px !important;
  }
  .pe-sm-70-px {
    padding-right: 70px !important;
  }
  .pe-sm-80-px {
    padding-right: 80px !important;
  }
  .pe-sm-90-px {
    padding-right: 90px !important;
  }
  .pe-sm-100-px {
    padding-right: 100px !important;
  }
  .pe-sm-120-px {
    padding-right: 120px !important;
  }
  .pe-sm-125-px {
    padding-right: 125px !important;
  }
  .pe-sm-130-px {
    padding-right: 130px !important;
  }
  .pe-sm-150-px {
    padding-right: 150px !important;
  }
  .pe-sm-200-px {
    padding-right: 200px !important;
  }
  .pe-sm-250-px {
    padding-right: 250px !important;
  }
  .pe-sm-300-px {
    padding-right: 300px !important;
  }
  .pe-sm-350-px {
    padding-right: 350px !important;
  }
  .pe-sm-400-px {
    padding-right: 400px !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pb-sm-5-px {
    padding-bottom: 5px !important;
  }
  .pb-sm-10-px {
    padding-bottom: 10px !important;
  }
  .pb-sm-20-px {
    padding-bottom: 20px !important;
  }
  .pb-sm-30-px {
    padding-bottom: 30px !important;
  }
  .pb-sm-35-px {
    padding-bottom: 35px !important;
  }
  .pb-sm-40-px {
    padding-bottom: 40px !important;
  }
  .pb-sm-45-px {
    padding-bottom: 45px !important;
  }
  .pb-sm-50-px {
    padding-bottom: 50px !important;
  }
  .pb-sm-60-px {
    padding-bottom: 60px !important;
  }
  .pb-sm-70-px {
    padding-bottom: 70px !important;
  }
  .pb-sm-80-px {
    padding-bottom: 80px !important;
  }
  .pb-sm-90-px {
    padding-bottom: 90px !important;
  }
  .pb-sm-100-px {
    padding-bottom: 100px !important;
  }
  .pb-sm-120-px {
    padding-bottom: 120px !important;
  }
  .pb-sm-125-px {
    padding-bottom: 125px !important;
  }
  .pb-sm-130-px {
    padding-bottom: 130px !important;
  }
  .pb-sm-150-px {
    padding-bottom: 150px !important;
  }
  .pb-sm-200-px {
    padding-bottom: 200px !important;
  }
  .pb-sm-250-px {
    padding-bottom: 250px !important;
  }
  .pb-sm-300-px {
    padding-bottom: 300px !important;
  }
  .pb-sm-350-px {
    padding-bottom: 350px !important;
  }
  .pb-sm-400-px {
    padding-bottom: 400px !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .ps-sm-5-px {
    padding-left: 5px !important;
  }
  .ps-sm-10-px {
    padding-left: 10px !important;
  }
  .ps-sm-20-px {
    padding-left: 20px !important;
  }
  .ps-sm-30-px {
    padding-left: 30px !important;
  }
  .ps-sm-35-px {
    padding-left: 35px !important;
  }
  .ps-sm-40-px {
    padding-left: 40px !important;
  }
  .ps-sm-45-px {
    padding-left: 45px !important;
  }
  .ps-sm-50-px {
    padding-left: 50px !important;
  }
  .ps-sm-60-px {
    padding-left: 60px !important;
  }
  .ps-sm-70-px {
    padding-left: 70px !important;
  }
  .ps-sm-80-px {
    padding-left: 80px !important;
  }
  .ps-sm-90-px {
    padding-left: 90px !important;
  }
  .ps-sm-100-px {
    padding-left: 100px !important;
  }
  .ps-sm-120-px {
    padding-left: 120px !important;
  }
  .ps-sm-125-px {
    padding-left: 125px !important;
  }
  .ps-sm-130-px {
    padding-left: 130px !important;
  }
  .ps-sm-150-px {
    padding-left: 150px !important;
  }
  .ps-sm-200-px {
    padding-left: 200px !important;
  }
  .ps-sm-250-px {
    padding-left: 250px !important;
  }
  .ps-sm-300-px {
    padding-left: 300px !important;
  }
  .ps-sm-350-px {
    padding-left: 350px !important;
  }
  .ps-sm-400-px {
    padding-left: 400px !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .gap-sm-5-px {
    gap: 5px !important;
  }
  .gap-sm-10-px {
    gap: 10px !important;
  }
  .gap-sm-20-px {
    gap: 20px !important;
  }
  .gap-sm-30-px {
    gap: 30px !important;
  }
  .gap-sm-35-px {
    gap: 35px !important;
  }
  .gap-sm-40-px {
    gap: 40px !important;
  }
  .gap-sm-45-px {
    gap: 45px !important;
  }
  .gap-sm-50-px {
    gap: 50px !important;
  }
  .gap-sm-60-px {
    gap: 60px !important;
  }
  .gap-sm-70-px {
    gap: 70px !important;
  }
  .gap-sm-80-px {
    gap: 80px !important;
  }
  .gap-sm-90-px {
    gap: 90px !important;
  }
  .gap-sm-100-px {
    gap: 100px !important;
  }
  .gap-sm-120-px {
    gap: 120px !important;
  }
  .gap-sm-125-px {
    gap: 125px !important;
  }
  .gap-sm-130-px {
    gap: 130px !important;
  }
  .gap-sm-150-px {
    gap: 150px !important;
  }
  .gap-sm-200-px {
    gap: 200px !important;
  }
  .gap-sm-250-px {
    gap: 250px !important;
  }
  .gap-sm-300-px {
    gap: 300px !important;
  }
  .gap-sm-350-px {
    gap: 350px !important;
  }
  .gap-sm-400-px {
    gap: 400px !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .row-gap-sm-5-px {
    row-gap: 5px !important;
  }
  .row-gap-sm-10-px {
    row-gap: 10px !important;
  }
  .row-gap-sm-20-px {
    row-gap: 20px !important;
  }
  .row-gap-sm-30-px {
    row-gap: 30px !important;
  }
  .row-gap-sm-35-px {
    row-gap: 35px !important;
  }
  .row-gap-sm-40-px {
    row-gap: 40px !important;
  }
  .row-gap-sm-45-px {
    row-gap: 45px !important;
  }
  .row-gap-sm-50-px {
    row-gap: 50px !important;
  }
  .row-gap-sm-60-px {
    row-gap: 60px !important;
  }
  .row-gap-sm-70-px {
    row-gap: 70px !important;
  }
  .row-gap-sm-80-px {
    row-gap: 80px !important;
  }
  .row-gap-sm-90-px {
    row-gap: 90px !important;
  }
  .row-gap-sm-100-px {
    row-gap: 100px !important;
  }
  .row-gap-sm-120-px {
    row-gap: 120px !important;
  }
  .row-gap-sm-125-px {
    row-gap: 125px !important;
  }
  .row-gap-sm-130-px {
    row-gap: 130px !important;
  }
  .row-gap-sm-150-px {
    row-gap: 150px !important;
  }
  .row-gap-sm-200-px {
    row-gap: 200px !important;
  }
  .row-gap-sm-250-px {
    row-gap: 250px !important;
  }
  .row-gap-sm-300-px {
    row-gap: 300px !important;
  }
  .row-gap-sm-350-px {
    row-gap: 350px !important;
  }
  .row-gap-sm-400-px {
    row-gap: 400px !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .column-gap-sm-5-px {
    column-gap: 5px !important;
  }
  .column-gap-sm-10-px {
    column-gap: 10px !important;
  }
  .column-gap-sm-20-px {
    column-gap: 20px !important;
  }
  .column-gap-sm-30-px {
    column-gap: 30px !important;
  }
  .column-gap-sm-35-px {
    column-gap: 35px !important;
  }
  .column-gap-sm-40-px {
    column-gap: 40px !important;
  }
  .column-gap-sm-45-px {
    column-gap: 45px !important;
  }
  .column-gap-sm-50-px {
    column-gap: 50px !important;
  }
  .column-gap-sm-60-px {
    column-gap: 60px !important;
  }
  .column-gap-sm-70-px {
    column-gap: 70px !important;
  }
  .column-gap-sm-80-px {
    column-gap: 80px !important;
  }
  .column-gap-sm-90-px {
    column-gap: 90px !important;
  }
  .column-gap-sm-100-px {
    column-gap: 100px !important;
  }
  .column-gap-sm-120-px {
    column-gap: 120px !important;
  }
  .column-gap-sm-125-px {
    column-gap: 125px !important;
  }
  .column-gap-sm-130-px {
    column-gap: 130px !important;
  }
  .column-gap-sm-150-px {
    column-gap: 150px !important;
  }
  .column-gap-sm-200-px {
    column-gap: 200px !important;
  }
  .column-gap-sm-250-px {
    column-gap: 250px !important;
  }
  .column-gap-sm-300-px {
    column-gap: 300px !important;
  }
  .column-gap-sm-350-px {
    column-gap: 350px !important;
  }
  .column-gap-sm-400-px {
    column-gap: 400px !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-5-px {
    margin: 5px !important;
  }
  .m-md-10-px {
    margin: 10px !important;
  }
  .m-md-20-px {
    margin: 20px !important;
  }
  .m-md-30-px {
    margin: 30px !important;
  }
  .m-md-35-px {
    margin: 35px !important;
  }
  .m-md-40-px {
    margin: 40px !important;
  }
  .m-md-45-px {
    margin: 45px !important;
  }
  .m-md-50-px {
    margin: 50px !important;
  }
  .m-md-60-px {
    margin: 60px !important;
  }
  .m-md-70-px {
    margin: 70px !important;
  }
  .m-md-80-px {
    margin: 80px !important;
  }
  .m-md-90-px {
    margin: 90px !important;
  }
  .m-md-100-px {
    margin: 100px !important;
  }
  .m-md-120-px {
    margin: 120px !important;
  }
  .m-md-125-px {
    margin: 125px !important;
  }
  .m-md-130-px {
    margin: 130px !important;
  }
  .m-md-150-px {
    margin: 150px !important;
  }
  .m-md-200-px {
    margin: 200px !important;
  }
  .m-md-250-px {
    margin: 250px !important;
  }
  .m-md-300-px {
    margin: 300px !important;
  }
  .m-md-350-px {
    margin: 350px !important;
  }
  .m-md-400-px {
    margin: 400px !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-5-px {
    margin-right: 5px !important;
    margin-left: 5px !important;
  }
  .mx-md-10-px {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }
  .mx-md-20-px {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  .mx-md-30-px {
    margin-right: 30px !important;
    margin-left: 30px !important;
  }
  .mx-md-35-px {
    margin-right: 35px !important;
    margin-left: 35px !important;
  }
  .mx-md-40-px {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  .mx-md-45-px {
    margin-right: 45px !important;
    margin-left: 45px !important;
  }
  .mx-md-50-px {
    margin-right: 50px !important;
    margin-left: 50px !important;
  }
  .mx-md-60-px {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  .mx-md-70-px {
    margin-right: 70px !important;
    margin-left: 70px !important;
  }
  .mx-md-80-px {
    margin-right: 80px !important;
    margin-left: 80px !important;
  }
  .mx-md-90-px {
    margin-right: 90px !important;
    margin-left: 90px !important;
  }
  .mx-md-100-px {
    margin-right: 100px !important;
    margin-left: 100px !important;
  }
  .mx-md-120-px {
    margin-right: 120px !important;
    margin-left: 120px !important;
  }
  .mx-md-125-px {
    margin-right: 125px !important;
    margin-left: 125px !important;
  }
  .mx-md-130-px {
    margin-right: 130px !important;
    margin-left: 130px !important;
  }
  .mx-md-150-px {
    margin-right: 150px !important;
    margin-left: 150px !important;
  }
  .mx-md-200-px {
    margin-right: 200px !important;
    margin-left: 200px !important;
  }
  .mx-md-250-px {
    margin-right: 250px !important;
    margin-left: 250px !important;
  }
  .mx-md-300-px {
    margin-right: 300px !important;
    margin-left: 300px !important;
  }
  .mx-md-350-px {
    margin-right: 350px !important;
    margin-left: 350px !important;
  }
  .mx-md-400-px {
    margin-right: 400px !important;
    margin-left: 400px !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-5-px {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }
  .my-md-10-px {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .my-md-20-px {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .my-md-30-px {
    margin-top: 30px !important;
    margin-bottom: 30px !important;
  }
  .my-md-35-px {
    margin-top: 35px !important;
    margin-bottom: 35px !important;
  }
  .my-md-40-px {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .my-md-45-px {
    margin-top: 45px !important;
    margin-bottom: 45px !important;
  }
  .my-md-50-px {
    margin-top: 50px !important;
    margin-bottom: 50px !important;
  }
  .my-md-60-px {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  .my-md-70-px {
    margin-top: 70px !important;
    margin-bottom: 70px !important;
  }
  .my-md-80-px {
    margin-top: 80px !important;
    margin-bottom: 80px !important;
  }
  .my-md-90-px {
    margin-top: 90px !important;
    margin-bottom: 90px !important;
  }
  .my-md-100-px {
    margin-top: 100px !important;
    margin-bottom: 100px !important;
  }
  .my-md-120-px {
    margin-top: 120px !important;
    margin-bottom: 120px !important;
  }
  .my-md-125-px {
    margin-top: 125px !important;
    margin-bottom: 125px !important;
  }
  .my-md-130-px {
    margin-top: 130px !important;
    margin-bottom: 130px !important;
  }
  .my-md-150-px {
    margin-top: 150px !important;
    margin-bottom: 150px !important;
  }
  .my-md-200-px {
    margin-top: 200px !important;
    margin-bottom: 200px !important;
  }
  .my-md-250-px {
    margin-top: 250px !important;
    margin-bottom: 250px !important;
  }
  .my-md-300-px {
    margin-top: 300px !important;
    margin-bottom: 300px !important;
  }
  .my-md-350-px {
    margin-top: 350px !important;
    margin-bottom: 350px !important;
  }
  .my-md-400-px {
    margin-top: 400px !important;
    margin-bottom: 400px !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-5-px {
    margin-top: 5px !important;
  }
  .mt-md-10-px {
    margin-top: 10px !important;
  }
  .mt-md-20-px {
    margin-top: 20px !important;
  }
  .mt-md-30-px {
    margin-top: 30px !important;
  }
  .mt-md-35-px {
    margin-top: 35px !important;
  }
  .mt-md-40-px {
    margin-top: 40px !important;
  }
  .mt-md-45-px {
    margin-top: 45px !important;
  }
  .mt-md-50-px {
    margin-top: 50px !important;
  }
  .mt-md-60-px {
    margin-top: 60px !important;
  }
  .mt-md-70-px {
    margin-top: 70px !important;
  }
  .mt-md-80-px {
    margin-top: 80px !important;
  }
  .mt-md-90-px {
    margin-top: 90px !important;
  }
  .mt-md-100-px {
    margin-top: 100px !important;
  }
  .mt-md-120-px {
    margin-top: 120px !important;
  }
  .mt-md-125-px {
    margin-top: 125px !important;
  }
  .mt-md-130-px {
    margin-top: 130px !important;
  }
  .mt-md-150-px {
    margin-top: 150px !important;
  }
  .mt-md-200-px {
    margin-top: 200px !important;
  }
  .mt-md-250-px {
    margin-top: 250px !important;
  }
  .mt-md-300-px {
    margin-top: 300px !important;
  }
  .mt-md-350-px {
    margin-top: 350px !important;
  }
  .mt-md-400-px {
    margin-top: 400px !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-5-px {
    margin-right: 5px !important;
  }
  .me-md-10-px {
    margin-right: 10px !important;
  }
  .me-md-20-px {
    margin-right: 20px !important;
  }
  .me-md-30-px {
    margin-right: 30px !important;
  }
  .me-md-35-px {
    margin-right: 35px !important;
  }
  .me-md-40-px {
    margin-right: 40px !important;
  }
  .me-md-45-px {
    margin-right: 45px !important;
  }
  .me-md-50-px {
    margin-right: 50px !important;
  }
  .me-md-60-px {
    margin-right: 60px !important;
  }
  .me-md-70-px {
    margin-right: 70px !important;
  }
  .me-md-80-px {
    margin-right: 80px !important;
  }
  .me-md-90-px {
    margin-right: 90px !important;
  }
  .me-md-100-px {
    margin-right: 100px !important;
  }
  .me-md-120-px {
    margin-right: 120px !important;
  }
  .me-md-125-px {
    margin-right: 125px !important;
  }
  .me-md-130-px {
    margin-right: 130px !important;
  }
  .me-md-150-px {
    margin-right: 150px !important;
  }
  .me-md-200-px {
    margin-right: 200px !important;
  }
  .me-md-250-px {
    margin-right: 250px !important;
  }
  .me-md-300-px {
    margin-right: 300px !important;
  }
  .me-md-350-px {
    margin-right: 350px !important;
  }
  .me-md-400-px {
    margin-right: 400px !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-5-px {
    margin-bottom: 5px !important;
  }
  .mb-md-10-px {
    margin-bottom: 10px !important;
  }
  .mb-md-20-px {
    margin-bottom: 20px !important;
  }
  .mb-md-30-px {
    margin-bottom: 30px !important;
  }
  .mb-md-35-px {
    margin-bottom: 35px !important;
  }
  .mb-md-40-px {
    margin-bottom: 40px !important;
  }
  .mb-md-45-px {
    margin-bottom: 45px !important;
  }
  .mb-md-50-px {
    margin-bottom: 50px !important;
  }
  .mb-md-60-px {
    margin-bottom: 60px !important;
  }
  .mb-md-70-px {
    margin-bottom: 70px !important;
  }
  .mb-md-80-px {
    margin-bottom: 80px !important;
  }
  .mb-md-90-px {
    margin-bottom: 90px !important;
  }
  .mb-md-100-px {
    margin-bottom: 100px !important;
  }
  .mb-md-120-px {
    margin-bottom: 120px !important;
  }
  .mb-md-125-px {
    margin-bottom: 125px !important;
  }
  .mb-md-130-px {
    margin-bottom: 130px !important;
  }
  .mb-md-150-px {
    margin-bottom: 150px !important;
  }
  .mb-md-200-px {
    margin-bottom: 200px !important;
  }
  .mb-md-250-px {
    margin-bottom: 250px !important;
  }
  .mb-md-300-px {
    margin-bottom: 300px !important;
  }
  .mb-md-350-px {
    margin-bottom: 350px !important;
  }
  .mb-md-400-px {
    margin-bottom: 400px !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-5-px {
    margin-left: 5px !important;
  }
  .ms-md-10-px {
    margin-left: 10px !important;
  }
  .ms-md-20-px {
    margin-left: 20px !important;
  }
  .ms-md-30-px {
    margin-left: 30px !important;
  }
  .ms-md-35-px {
    margin-left: 35px !important;
  }
  .ms-md-40-px {
    margin-left: 40px !important;
  }
  .ms-md-45-px {
    margin-left: 45px !important;
  }
  .ms-md-50-px {
    margin-left: 50px !important;
  }
  .ms-md-60-px {
    margin-left: 60px !important;
  }
  .ms-md-70-px {
    margin-left: 70px !important;
  }
  .ms-md-80-px {
    margin-left: 80px !important;
  }
  .ms-md-90-px {
    margin-left: 90px !important;
  }
  .ms-md-100-px {
    margin-left: 100px !important;
  }
  .ms-md-120-px {
    margin-left: 120px !important;
  }
  .ms-md-125-px {
    margin-left: 125px !important;
  }
  .ms-md-130-px {
    margin-left: 130px !important;
  }
  .ms-md-150-px {
    margin-left: 150px !important;
  }
  .ms-md-200-px {
    margin-left: 200px !important;
  }
  .ms-md-250-px {
    margin-left: 250px !important;
  }
  .ms-md-300-px {
    margin-left: 300px !important;
  }
  .ms-md-350-px {
    margin-left: 350px !important;
  }
  .ms-md-400-px {
    margin-left: 400px !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .m-md-n5-px {
    margin: -5px !important;
  }
  .m-md-n10-px {
    margin: -10px !important;
  }
  .m-md-n20-px {
    margin: -20px !important;
  }
  .m-md-n30-px {
    margin: -30px !important;
  }
  .m-md-n35-px {
    margin: -35px !important;
  }
  .m-md-n40-px {
    margin: -40px !important;
  }
  .m-md-n45-px {
    margin: -45px !important;
  }
  .m-md-n50-px {
    margin: -50px !important;
  }
  .m-md-n60-px {
    margin: -60px !important;
  }
  .m-md-n70-px {
    margin: -70px !important;
  }
  .m-md-n80-px {
    margin: -80px !important;
  }
  .m-md-n90-px {
    margin: -90px !important;
  }
  .m-md-n100-px {
    margin: -100px !important;
  }
  .m-md-n120-px {
    margin: -120px !important;
  }
  .m-md-n125-px {
    margin: -125px !important;
  }
  .m-md-n130-px {
    margin: -130px !important;
  }
  .m-md-n150-px {
    margin: -150px !important;
  }
  .m-md-n200-px {
    margin: -200px !important;
  }
  .m-md-n250-px {
    margin: -250px !important;
  }
  .m-md-n300-px {
    margin: -300px !important;
  }
  .m-md-n350-px {
    margin: -350px !important;
  }
  .m-md-n400-px {
    margin: -400px !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-md-n5-px {
    margin-right: -5px !important;
    margin-left: -5px !important;
  }
  .mx-md-n10-px {
    margin-right: -10px !important;
    margin-left: -10px !important;
  }
  .mx-md-n20-px {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  .mx-md-n30-px {
    margin-right: -30px !important;
    margin-left: -30px !important;
  }
  .mx-md-n35-px {
    margin-right: -35px !important;
    margin-left: -35px !important;
  }
  .mx-md-n40-px {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  .mx-md-n45-px {
    margin-right: -45px !important;
    margin-left: -45px !important;
  }
  .mx-md-n50-px {
    margin-right: -50px !important;
    margin-left: -50px !important;
  }
  .mx-md-n60-px {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  .mx-md-n70-px {
    margin-right: -70px !important;
    margin-left: -70px !important;
  }
  .mx-md-n80-px {
    margin-right: -80px !important;
    margin-left: -80px !important;
  }
  .mx-md-n90-px {
    margin-right: -90px !important;
    margin-left: -90px !important;
  }
  .mx-md-n100-px {
    margin-right: -100px !important;
    margin-left: -100px !important;
  }
  .mx-md-n120-px {
    margin-right: -120px !important;
    margin-left: -120px !important;
  }
  .mx-md-n125-px {
    margin-right: -125px !important;
    margin-left: -125px !important;
  }
  .mx-md-n130-px {
    margin-right: -130px !important;
    margin-left: -130px !important;
  }
  .mx-md-n150-px {
    margin-right: -150px !important;
    margin-left: -150px !important;
  }
  .mx-md-n200-px {
    margin-right: -200px !important;
    margin-left: -200px !important;
  }
  .mx-md-n250-px {
    margin-right: -250px !important;
    margin-left: -250px !important;
  }
  .mx-md-n300-px {
    margin-right: -300px !important;
    margin-left: -300px !important;
  }
  .mx-md-n350-px {
    margin-right: -350px !important;
    margin-left: -350px !important;
  }
  .mx-md-n400-px {
    margin-right: -400px !important;
    margin-left: -400px !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-md-n5-px {
    margin-top: -5px !important;
    margin-bottom: -5px !important;
  }
  .my-md-n10-px {
    margin-top: -10px !important;
    margin-bottom: -10px !important;
  }
  .my-md-n20-px {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  .my-md-n30-px {
    margin-top: -30px !important;
    margin-bottom: -30px !important;
  }
  .my-md-n35-px {
    margin-top: -35px !important;
    margin-bottom: -35px !important;
  }
  .my-md-n40-px {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  .my-md-n45-px {
    margin-top: -45px !important;
    margin-bottom: -45px !important;
  }
  .my-md-n50-px {
    margin-top: -50px !important;
    margin-bottom: -50px !important;
  }
  .my-md-n60-px {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  .my-md-n70-px {
    margin-top: -70px !important;
    margin-bottom: -70px !important;
  }
  .my-md-n80-px {
    margin-top: -80px !important;
    margin-bottom: -80px !important;
  }
  .my-md-n90-px {
    margin-top: -90px !important;
    margin-bottom: -90px !important;
  }
  .my-md-n100-px {
    margin-top: -100px !important;
    margin-bottom: -100px !important;
  }
  .my-md-n120-px {
    margin-top: -120px !important;
    margin-bottom: -120px !important;
  }
  .my-md-n125-px {
    margin-top: -125px !important;
    margin-bottom: -125px !important;
  }
  .my-md-n130-px {
    margin-top: -130px !important;
    margin-bottom: -130px !important;
  }
  .my-md-n150-px {
    margin-top: -150px !important;
    margin-bottom: -150px !important;
  }
  .my-md-n200-px {
    margin-top: -200px !important;
    margin-bottom: -200px !important;
  }
  .my-md-n250-px {
    margin-top: -250px !important;
    margin-bottom: -250px !important;
  }
  .my-md-n300-px {
    margin-top: -300px !important;
    margin-bottom: -300px !important;
  }
  .my-md-n350-px {
    margin-top: -350px !important;
    margin-bottom: -350px !important;
  }
  .my-md-n400-px {
    margin-top: -400px !important;
    margin-bottom: -400px !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .mt-md-n5-px {
    margin-top: -5px !important;
  }
  .mt-md-n10-px {
    margin-top: -10px !important;
  }
  .mt-md-n20-px {
    margin-top: -20px !important;
  }
  .mt-md-n30-px {
    margin-top: -30px !important;
  }
  .mt-md-n35-px {
    margin-top: -35px !important;
  }
  .mt-md-n40-px {
    margin-top: -40px !important;
  }
  .mt-md-n45-px {
    margin-top: -45px !important;
  }
  .mt-md-n50-px {
    margin-top: -50px !important;
  }
  .mt-md-n60-px {
    margin-top: -60px !important;
  }
  .mt-md-n70-px {
    margin-top: -70px !important;
  }
  .mt-md-n80-px {
    margin-top: -80px !important;
  }
  .mt-md-n90-px {
    margin-top: -90px !important;
  }
  .mt-md-n100-px {
    margin-top: -100px !important;
  }
  .mt-md-n120-px {
    margin-top: -120px !important;
  }
  .mt-md-n125-px {
    margin-top: -125px !important;
  }
  .mt-md-n130-px {
    margin-top: -130px !important;
  }
  .mt-md-n150-px {
    margin-top: -150px !important;
  }
  .mt-md-n200-px {
    margin-top: -200px !important;
  }
  .mt-md-n250-px {
    margin-top: -250px !important;
  }
  .mt-md-n300-px {
    margin-top: -300px !important;
  }
  .mt-md-n350-px {
    margin-top: -350px !important;
  }
  .mt-md-n400-px {
    margin-top: -400px !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .me-md-n5-px {
    margin-right: -5px !important;
  }
  .me-md-n10-px {
    margin-right: -10px !important;
  }
  .me-md-n20-px {
    margin-right: -20px !important;
  }
  .me-md-n30-px {
    margin-right: -30px !important;
  }
  .me-md-n35-px {
    margin-right: -35px !important;
  }
  .me-md-n40-px {
    margin-right: -40px !important;
  }
  .me-md-n45-px {
    margin-right: -45px !important;
  }
  .me-md-n50-px {
    margin-right: -50px !important;
  }
  .me-md-n60-px {
    margin-right: -60px !important;
  }
  .me-md-n70-px {
    margin-right: -70px !important;
  }
  .me-md-n80-px {
    margin-right: -80px !important;
  }
  .me-md-n90-px {
    margin-right: -90px !important;
  }
  .me-md-n100-px {
    margin-right: -100px !important;
  }
  .me-md-n120-px {
    margin-right: -120px !important;
  }
  .me-md-n125-px {
    margin-right: -125px !important;
  }
  .me-md-n130-px {
    margin-right: -130px !important;
  }
  .me-md-n150-px {
    margin-right: -150px !important;
  }
  .me-md-n200-px {
    margin-right: -200px !important;
  }
  .me-md-n250-px {
    margin-right: -250px !important;
  }
  .me-md-n300-px {
    margin-right: -300px !important;
  }
  .me-md-n350-px {
    margin-right: -350px !important;
  }
  .me-md-n400-px {
    margin-right: -400px !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-md-n5-px {
    margin-bottom: -5px !important;
  }
  .mb-md-n10-px {
    margin-bottom: -10px !important;
  }
  .mb-md-n20-px {
    margin-bottom: -20px !important;
  }
  .mb-md-n30-px {
    margin-bottom: -30px !important;
  }
  .mb-md-n35-px {
    margin-bottom: -35px !important;
  }
  .mb-md-n40-px {
    margin-bottom: -40px !important;
  }
  .mb-md-n45-px {
    margin-bottom: -45px !important;
  }
  .mb-md-n50-px {
    margin-bottom: -50px !important;
  }
  .mb-md-n60-px {
    margin-bottom: -60px !important;
  }
  .mb-md-n70-px {
    margin-bottom: -70px !important;
  }
  .mb-md-n80-px {
    margin-bottom: -80px !important;
  }
  .mb-md-n90-px {
    margin-bottom: -90px !important;
  }
  .mb-md-n100-px {
    margin-bottom: -100px !important;
  }
  .mb-md-n120-px {
    margin-bottom: -120px !important;
  }
  .mb-md-n125-px {
    margin-bottom: -125px !important;
  }
  .mb-md-n130-px {
    margin-bottom: -130px !important;
  }
  .mb-md-n150-px {
    margin-bottom: -150px !important;
  }
  .mb-md-n200-px {
    margin-bottom: -200px !important;
  }
  .mb-md-n250-px {
    margin-bottom: -250px !important;
  }
  .mb-md-n300-px {
    margin-bottom: -300px !important;
  }
  .mb-md-n350-px {
    margin-bottom: -350px !important;
  }
  .mb-md-n400-px {
    margin-bottom: -400px !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .ms-md-n5-px {
    margin-left: -5px !important;
  }
  .ms-md-n10-px {
    margin-left: -10px !important;
  }
  .ms-md-n20-px {
    margin-left: -20px !important;
  }
  .ms-md-n30-px {
    margin-left: -30px !important;
  }
  .ms-md-n35-px {
    margin-left: -35px !important;
  }
  .ms-md-n40-px {
    margin-left: -40px !important;
  }
  .ms-md-n45-px {
    margin-left: -45px !important;
  }
  .ms-md-n50-px {
    margin-left: -50px !important;
  }
  .ms-md-n60-px {
    margin-left: -60px !important;
  }
  .ms-md-n70-px {
    margin-left: -70px !important;
  }
  .ms-md-n80-px {
    margin-left: -80px !important;
  }
  .ms-md-n90-px {
    margin-left: -90px !important;
  }
  .ms-md-n100-px {
    margin-left: -100px !important;
  }
  .ms-md-n120-px {
    margin-left: -120px !important;
  }
  .ms-md-n125-px {
    margin-left: -125px !important;
  }
  .ms-md-n130-px {
    margin-left: -130px !important;
  }
  .ms-md-n150-px {
    margin-left: -150px !important;
  }
  .ms-md-n200-px {
    margin-left: -200px !important;
  }
  .ms-md-n250-px {
    margin-left: -250px !important;
  }
  .ms-md-n300-px {
    margin-left: -300px !important;
  }
  .ms-md-n350-px {
    margin-left: -350px !important;
  }
  .ms-md-n400-px {
    margin-left: -400px !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .p-md-5-px {
    padding: 5px !important;
  }
  .p-md-10-px {
    padding: 10px !important;
  }
  .p-md-20-px {
    padding: 20px !important;
  }
  .p-md-30-px {
    padding: 30px !important;
  }
  .p-md-35-px {
    padding: 35px !important;
  }
  .p-md-40-px {
    padding: 40px !important;
  }
  .p-md-45-px {
    padding: 45px !important;
  }
  .p-md-50-px {
    padding: 50px !important;
  }
  .p-md-60-px {
    padding: 60px !important;
  }
  .p-md-70-px {
    padding: 70px !important;
  }
  .p-md-80-px {
    padding: 80px !important;
  }
  .p-md-90-px {
    padding: 90px !important;
  }
  .p-md-100-px {
    padding: 100px !important;
  }
  .p-md-120-px {
    padding: 120px !important;
  }
  .p-md-125-px {
    padding: 125px !important;
  }
  .p-md-130-px {
    padding: 130px !important;
  }
  .p-md-150-px {
    padding: 150px !important;
  }
  .p-md-200-px {
    padding: 200px !important;
  }
  .p-md-250-px {
    padding: 250px !important;
  }
  .p-md-300-px {
    padding: 300px !important;
  }
  .p-md-350-px {
    padding: 350px !important;
  }
  .p-md-400-px {
    padding: 400px !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-md-5-px {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }
  .px-md-10-px {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .px-md-20-px {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  .px-md-30-px {
    padding-right: 30px !important;
    padding-left: 30px !important;
  }
  .px-md-35-px {
    padding-right: 35px !important;
    padding-left: 35px !important;
  }
  .px-md-40-px {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  .px-md-45-px {
    padding-right: 45px !important;
    padding-left: 45px !important;
  }
  .px-md-50-px {
    padding-right: 50px !important;
    padding-left: 50px !important;
  }
  .px-md-60-px {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  .px-md-70-px {
    padding-right: 70px !important;
    padding-left: 70px !important;
  }
  .px-md-80-px {
    padding-right: 80px !important;
    padding-left: 80px !important;
  }
  .px-md-90-px {
    padding-right: 90px !important;
    padding-left: 90px !important;
  }
  .px-md-100-px {
    padding-right: 100px !important;
    padding-left: 100px !important;
  }
  .px-md-120-px {
    padding-right: 120px !important;
    padding-left: 120px !important;
  }
  .px-md-125-px {
    padding-right: 125px !important;
    padding-left: 125px !important;
  }
  .px-md-130-px {
    padding-right: 130px !important;
    padding-left: 130px !important;
  }
  .px-md-150-px {
    padding-right: 150px !important;
    padding-left: 150px !important;
  }
  .px-md-200-px {
    padding-right: 200px !important;
    padding-left: 200px !important;
  }
  .px-md-250-px {
    padding-right: 250px !important;
    padding-left: 250px !important;
  }
  .px-md-300-px {
    padding-right: 300px !important;
    padding-left: 300px !important;
  }
  .px-md-350-px {
    padding-right: 350px !important;
    padding-left: 350px !important;
  }
  .px-md-400-px {
    padding-right: 400px !important;
    padding-left: 400px !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-md-5-px {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }
  .py-md-10-px {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .py-md-20-px {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .py-md-30-px {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
  .py-md-35-px {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .py-md-40-px {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .py-md-45-px {
    padding-top: 45px !important;
    padding-bottom: 45px !important;
  }
  .py-md-50-px {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }
  .py-md-60-px {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  .py-md-70-px {
    padding-top: 70px !important;
    padding-bottom: 70px !important;
  }
  .py-md-80-px {
    padding-top: 80px !important;
    padding-bottom: 80px !important;
  }
  .py-md-90-px {
    padding-top: 90px !important;
    padding-bottom: 90px !important;
  }
  .py-md-100-px {
    padding-top: 100px !important;
    padding-bottom: 100px !important;
  }
  .py-md-120-px {
    padding-top: 120px !important;
    padding-bottom: 120px !important;
  }
  .py-md-125-px {
    padding-top: 125px !important;
    padding-bottom: 125px !important;
  }
  .py-md-130-px {
    padding-top: 130px !important;
    padding-bottom: 130px !important;
  }
  .py-md-150-px {
    padding-top: 150px !important;
    padding-bottom: 150px !important;
  }
  .py-md-200-px {
    padding-top: 200px !important;
    padding-bottom: 200px !important;
  }
  .py-md-250-px {
    padding-top: 250px !important;
    padding-bottom: 250px !important;
  }
  .py-md-300-px {
    padding-top: 300px !important;
    padding-bottom: 300px !important;
  }
  .py-md-350-px {
    padding-top: 350px !important;
    padding-bottom: 350px !important;
  }
  .py-md-400-px {
    padding-top: 400px !important;
    padding-bottom: 400px !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pt-md-5-px {
    padding-top: 5px !important;
  }
  .pt-md-10-px {
    padding-top: 10px !important;
  }
  .pt-md-20-px {
    padding-top: 20px !important;
  }
  .pt-md-30-px {
    padding-top: 30px !important;
  }
  .pt-md-35-px {
    padding-top: 35px !important;
  }
  .pt-md-40-px {
    padding-top: 40px !important;
  }
  .pt-md-45-px {
    padding-top: 45px !important;
  }
  .pt-md-50-px {
    padding-top: 50px !important;
  }
  .pt-md-60-px {
    padding-top: 60px !important;
  }
  .pt-md-70-px {
    padding-top: 70px !important;
  }
  .pt-md-80-px {
    padding-top: 80px !important;
  }
  .pt-md-90-px {
    padding-top: 90px !important;
  }
  .pt-md-100-px {
    padding-top: 100px !important;
  }
  .pt-md-120-px {
    padding-top: 120px !important;
  }
  .pt-md-125-px {
    padding-top: 125px !important;
  }
  .pt-md-130-px {
    padding-top: 130px !important;
  }
  .pt-md-150-px {
    padding-top: 150px !important;
  }
  .pt-md-200-px {
    padding-top: 200px !important;
  }
  .pt-md-250-px {
    padding-top: 250px !important;
  }
  .pt-md-300-px {
    padding-top: 300px !important;
  }
  .pt-md-350-px {
    padding-top: 350px !important;
  }
  .pt-md-400-px {
    padding-top: 400px !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pe-md-5-px {
    padding-right: 5px !important;
  }
  .pe-md-10-px {
    padding-right: 10px !important;
  }
  .pe-md-20-px {
    padding-right: 20px !important;
  }
  .pe-md-30-px {
    padding-right: 30px !important;
  }
  .pe-md-35-px {
    padding-right: 35px !important;
  }
  .pe-md-40-px {
    padding-right: 40px !important;
  }
  .pe-md-45-px {
    padding-right: 45px !important;
  }
  .pe-md-50-px {
    padding-right: 50px !important;
  }
  .pe-md-60-px {
    padding-right: 60px !important;
  }
  .pe-md-70-px {
    padding-right: 70px !important;
  }
  .pe-md-80-px {
    padding-right: 80px !important;
  }
  .pe-md-90-px {
    padding-right: 90px !important;
  }
  .pe-md-100-px {
    padding-right: 100px !important;
  }
  .pe-md-120-px {
    padding-right: 120px !important;
  }
  .pe-md-125-px {
    padding-right: 125px !important;
  }
  .pe-md-130-px {
    padding-right: 130px !important;
  }
  .pe-md-150-px {
    padding-right: 150px !important;
  }
  .pe-md-200-px {
    padding-right: 200px !important;
  }
  .pe-md-250-px {
    padding-right: 250px !important;
  }
  .pe-md-300-px {
    padding-right: 300px !important;
  }
  .pe-md-350-px {
    padding-right: 350px !important;
  }
  .pe-md-400-px {
    padding-right: 400px !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .pb-md-5-px {
    padding-bottom: 5px !important;
  }
  .pb-md-10-px {
    padding-bottom: 10px !important;
  }
  .pb-md-20-px {
    padding-bottom: 20px !important;
  }
  .pb-md-30-px {
    padding-bottom: 30px !important;
  }
  .pb-md-35-px {
    padding-bottom: 35px !important;
  }
  .pb-md-40-px {
    padding-bottom: 40px !important;
  }
  .pb-md-45-px {
    padding-bottom: 45px !important;
  }
  .pb-md-50-px {
    padding-bottom: 50px !important;
  }
  .pb-md-60-px {
    padding-bottom: 60px !important;
  }
  .pb-md-70-px {
    padding-bottom: 70px !important;
  }
  .pb-md-80-px {
    padding-bottom: 80px !important;
  }
  .pb-md-90-px {
    padding-bottom: 90px !important;
  }
  .pb-md-100-px {
    padding-bottom: 100px !important;
  }
  .pb-md-120-px {
    padding-bottom: 120px !important;
  }
  .pb-md-125-px {
    padding-bottom: 125px !important;
  }
  .pb-md-130-px {
    padding-bottom: 130px !important;
  }
  .pb-md-150-px {
    padding-bottom: 150px !important;
  }
  .pb-md-200-px {
    padding-bottom: 200px !important;
  }
  .pb-md-250-px {
    padding-bottom: 250px !important;
  }
  .pb-md-300-px {
    padding-bottom: 300px !important;
  }
  .pb-md-350-px {
    padding-bottom: 350px !important;
  }
  .pb-md-400-px {
    padding-bottom: 400px !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .ps-md-5-px {
    padding-left: 5px !important;
  }
  .ps-md-10-px {
    padding-left: 10px !important;
  }
  .ps-md-20-px {
    padding-left: 20px !important;
  }
  .ps-md-30-px {
    padding-left: 30px !important;
  }
  .ps-md-35-px {
    padding-left: 35px !important;
  }
  .ps-md-40-px {
    padding-left: 40px !important;
  }
  .ps-md-45-px {
    padding-left: 45px !important;
  }
  .ps-md-50-px {
    padding-left: 50px !important;
  }
  .ps-md-60-px {
    padding-left: 60px !important;
  }
  .ps-md-70-px {
    padding-left: 70px !important;
  }
  .ps-md-80-px {
    padding-left: 80px !important;
  }
  .ps-md-90-px {
    padding-left: 90px !important;
  }
  .ps-md-100-px {
    padding-left: 100px !important;
  }
  .ps-md-120-px {
    padding-left: 120px !important;
  }
  .ps-md-125-px {
    padding-left: 125px !important;
  }
  .ps-md-130-px {
    padding-left: 130px !important;
  }
  .ps-md-150-px {
    padding-left: 150px !important;
  }
  .ps-md-200-px {
    padding-left: 200px !important;
  }
  .ps-md-250-px {
    padding-left: 250px !important;
  }
  .ps-md-300-px {
    padding-left: 300px !important;
  }
  .ps-md-350-px {
    padding-left: 350px !important;
  }
  .ps-md-400-px {
    padding-left: 400px !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .gap-md-5-px {
    gap: 5px !important;
  }
  .gap-md-10-px {
    gap: 10px !important;
  }
  .gap-md-20-px {
    gap: 20px !important;
  }
  .gap-md-30-px {
    gap: 30px !important;
  }
  .gap-md-35-px {
    gap: 35px !important;
  }
  .gap-md-40-px {
    gap: 40px !important;
  }
  .gap-md-45-px {
    gap: 45px !important;
  }
  .gap-md-50-px {
    gap: 50px !important;
  }
  .gap-md-60-px {
    gap: 60px !important;
  }
  .gap-md-70-px {
    gap: 70px !important;
  }
  .gap-md-80-px {
    gap: 80px !important;
  }
  .gap-md-90-px {
    gap: 90px !important;
  }
  .gap-md-100-px {
    gap: 100px !important;
  }
  .gap-md-120-px {
    gap: 120px !important;
  }
  .gap-md-125-px {
    gap: 125px !important;
  }
  .gap-md-130-px {
    gap: 130px !important;
  }
  .gap-md-150-px {
    gap: 150px !important;
  }
  .gap-md-200-px {
    gap: 200px !important;
  }
  .gap-md-250-px {
    gap: 250px !important;
  }
  .gap-md-300-px {
    gap: 300px !important;
  }
  .gap-md-350-px {
    gap: 350px !important;
  }
  .gap-md-400-px {
    gap: 400px !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .row-gap-md-5-px {
    row-gap: 5px !important;
  }
  .row-gap-md-10-px {
    row-gap: 10px !important;
  }
  .row-gap-md-20-px {
    row-gap: 20px !important;
  }
  .row-gap-md-30-px {
    row-gap: 30px !important;
  }
  .row-gap-md-35-px {
    row-gap: 35px !important;
  }
  .row-gap-md-40-px {
    row-gap: 40px !important;
  }
  .row-gap-md-45-px {
    row-gap: 45px !important;
  }
  .row-gap-md-50-px {
    row-gap: 50px !important;
  }
  .row-gap-md-60-px {
    row-gap: 60px !important;
  }
  .row-gap-md-70-px {
    row-gap: 70px !important;
  }
  .row-gap-md-80-px {
    row-gap: 80px !important;
  }
  .row-gap-md-90-px {
    row-gap: 90px !important;
  }
  .row-gap-md-100-px {
    row-gap: 100px !important;
  }
  .row-gap-md-120-px {
    row-gap: 120px !important;
  }
  .row-gap-md-125-px {
    row-gap: 125px !important;
  }
  .row-gap-md-130-px {
    row-gap: 130px !important;
  }
  .row-gap-md-150-px {
    row-gap: 150px !important;
  }
  .row-gap-md-200-px {
    row-gap: 200px !important;
  }
  .row-gap-md-250-px {
    row-gap: 250px !important;
  }
  .row-gap-md-300-px {
    row-gap: 300px !important;
  }
  .row-gap-md-350-px {
    row-gap: 350px !important;
  }
  .row-gap-md-400-px {
    row-gap: 400px !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .column-gap-md-5-px {
    column-gap: 5px !important;
  }
  .column-gap-md-10-px {
    column-gap: 10px !important;
  }
  .column-gap-md-20-px {
    column-gap: 20px !important;
  }
  .column-gap-md-30-px {
    column-gap: 30px !important;
  }
  .column-gap-md-35-px {
    column-gap: 35px !important;
  }
  .column-gap-md-40-px {
    column-gap: 40px !important;
  }
  .column-gap-md-45-px {
    column-gap: 45px !important;
  }
  .column-gap-md-50-px {
    column-gap: 50px !important;
  }
  .column-gap-md-60-px {
    column-gap: 60px !important;
  }
  .column-gap-md-70-px {
    column-gap: 70px !important;
  }
  .column-gap-md-80-px {
    column-gap: 80px !important;
  }
  .column-gap-md-90-px {
    column-gap: 90px !important;
  }
  .column-gap-md-100-px {
    column-gap: 100px !important;
  }
  .column-gap-md-120-px {
    column-gap: 120px !important;
  }
  .column-gap-md-125-px {
    column-gap: 125px !important;
  }
  .column-gap-md-130-px {
    column-gap: 130px !important;
  }
  .column-gap-md-150-px {
    column-gap: 150px !important;
  }
  .column-gap-md-200-px {
    column-gap: 200px !important;
  }
  .column-gap-md-250-px {
    column-gap: 250px !important;
  }
  .column-gap-md-300-px {
    column-gap: 300px !important;
  }
  .column-gap-md-350-px {
    column-gap: 350px !important;
  }
  .column-gap-md-400-px {
    column-gap: 400px !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-5-px {
    margin: 5px !important;
  }
  .m-lg-10-px {
    margin: 10px !important;
  }
  .m-lg-20-px {
    margin: 20px !important;
  }
  .m-lg-30-px {
    margin: 30px !important;
  }
  .m-lg-35-px {
    margin: 35px !important;
  }
  .m-lg-40-px {
    margin: 40px !important;
  }
  .m-lg-45-px {
    margin: 45px !important;
  }
  .m-lg-50-px {
    margin: 50px !important;
  }
  .m-lg-60-px {
    margin: 60px !important;
  }
  .m-lg-70-px {
    margin: 70px !important;
  }
  .m-lg-80-px {
    margin: 80px !important;
  }
  .m-lg-90-px {
    margin: 90px !important;
  }
  .m-lg-100-px {
    margin: 100px !important;
  }
  .m-lg-120-px {
    margin: 120px !important;
  }
  .m-lg-125-px {
    margin: 125px !important;
  }
  .m-lg-130-px {
    margin: 130px !important;
  }
  .m-lg-150-px {
    margin: 150px !important;
  }
  .m-lg-200-px {
    margin: 200px !important;
  }
  .m-lg-250-px {
    margin: 250px !important;
  }
  .m-lg-300-px {
    margin: 300px !important;
  }
  .m-lg-350-px {
    margin: 350px !important;
  }
  .m-lg-400-px {
    margin: 400px !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-5-px {
    margin-right: 5px !important;
    margin-left: 5px !important;
  }
  .mx-lg-10-px {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }
  .mx-lg-20-px {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  .mx-lg-30-px {
    margin-right: 30px !important;
    margin-left: 30px !important;
  }
  .mx-lg-35-px {
    margin-right: 35px !important;
    margin-left: 35px !important;
  }
  .mx-lg-40-px {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  .mx-lg-45-px {
    margin-right: 45px !important;
    margin-left: 45px !important;
  }
  .mx-lg-50-px {
    margin-right: 50px !important;
    margin-left: 50px !important;
  }
  .mx-lg-60-px {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  .mx-lg-70-px {
    margin-right: 70px !important;
    margin-left: 70px !important;
  }
  .mx-lg-80-px {
    margin-right: 80px !important;
    margin-left: 80px !important;
  }
  .mx-lg-90-px {
    margin-right: 90px !important;
    margin-left: 90px !important;
  }
  .mx-lg-100-px {
    margin-right: 100px !important;
    margin-left: 100px !important;
  }
  .mx-lg-120-px {
    margin-right: 120px !important;
    margin-left: 120px !important;
  }
  .mx-lg-125-px {
    margin-right: 125px !important;
    margin-left: 125px !important;
  }
  .mx-lg-130-px {
    margin-right: 130px !important;
    margin-left: 130px !important;
  }
  .mx-lg-150-px {
    margin-right: 150px !important;
    margin-left: 150px !important;
  }
  .mx-lg-200-px {
    margin-right: 200px !important;
    margin-left: 200px !important;
  }
  .mx-lg-250-px {
    margin-right: 250px !important;
    margin-left: 250px !important;
  }
  .mx-lg-300-px {
    margin-right: 300px !important;
    margin-left: 300px !important;
  }
  .mx-lg-350-px {
    margin-right: 350px !important;
    margin-left: 350px !important;
  }
  .mx-lg-400-px {
    margin-right: 400px !important;
    margin-left: 400px !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-5-px {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }
  .my-lg-10-px {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .my-lg-20-px {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .my-lg-30-px {
    margin-top: 30px !important;
    margin-bottom: 30px !important;
  }
  .my-lg-35-px {
    margin-top: 35px !important;
    margin-bottom: 35px !important;
  }
  .my-lg-40-px {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .my-lg-45-px {
    margin-top: 45px !important;
    margin-bottom: 45px !important;
  }
  .my-lg-50-px {
    margin-top: 50px !important;
    margin-bottom: 50px !important;
  }
  .my-lg-60-px {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  .my-lg-70-px {
    margin-top: 70px !important;
    margin-bottom: 70px !important;
  }
  .my-lg-80-px {
    margin-top: 80px !important;
    margin-bottom: 80px !important;
  }
  .my-lg-90-px {
    margin-top: 90px !important;
    margin-bottom: 90px !important;
  }
  .my-lg-100-px {
    margin-top: 100px !important;
    margin-bottom: 100px !important;
  }
  .my-lg-120-px {
    margin-top: 120px !important;
    margin-bottom: 120px !important;
  }
  .my-lg-125-px {
    margin-top: 125px !important;
    margin-bottom: 125px !important;
  }
  .my-lg-130-px {
    margin-top: 130px !important;
    margin-bottom: 130px !important;
  }
  .my-lg-150-px {
    margin-top: 150px !important;
    margin-bottom: 150px !important;
  }
  .my-lg-200-px {
    margin-top: 200px !important;
    margin-bottom: 200px !important;
  }
  .my-lg-250-px {
    margin-top: 250px !important;
    margin-bottom: 250px !important;
  }
  .my-lg-300-px {
    margin-top: 300px !important;
    margin-bottom: 300px !important;
  }
  .my-lg-350-px {
    margin-top: 350px !important;
    margin-bottom: 350px !important;
  }
  .my-lg-400-px {
    margin-top: 400px !important;
    margin-bottom: 400px !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-5-px {
    margin-top: 5px !important;
  }
  .mt-lg-10-px {
    margin-top: 10px !important;
  }
  .mt-lg-20-px {
    margin-top: 20px !important;
  }
  .mt-lg-30-px {
    margin-top: 30px !important;
  }
  .mt-lg-35-px {
    margin-top: 35px !important;
  }
  .mt-lg-40-px {
    margin-top: 40px !important;
  }
  .mt-lg-45-px {
    margin-top: 45px !important;
  }
  .mt-lg-50-px {
    margin-top: 50px !important;
  }
  .mt-lg-60-px {
    margin-top: 60px !important;
  }
  .mt-lg-70-px {
    margin-top: 70px !important;
  }
  .mt-lg-80-px {
    margin-top: 80px !important;
  }
  .mt-lg-90-px {
    margin-top: 90px !important;
  }
  .mt-lg-100-px {
    margin-top: 100px !important;
  }
  .mt-lg-120-px {
    margin-top: 120px !important;
  }
  .mt-lg-125-px {
    margin-top: 125px !important;
  }
  .mt-lg-130-px {
    margin-top: 130px !important;
  }
  .mt-lg-150-px {
    margin-top: 150px !important;
  }
  .mt-lg-200-px {
    margin-top: 200px !important;
  }
  .mt-lg-250-px {
    margin-top: 250px !important;
  }
  .mt-lg-300-px {
    margin-top: 300px !important;
  }
  .mt-lg-350-px {
    margin-top: 350px !important;
  }
  .mt-lg-400-px {
    margin-top: 400px !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-5-px {
    margin-right: 5px !important;
  }
  .me-lg-10-px {
    margin-right: 10px !important;
  }
  .me-lg-20-px {
    margin-right: 20px !important;
  }
  .me-lg-30-px {
    margin-right: 30px !important;
  }
  .me-lg-35-px {
    margin-right: 35px !important;
  }
  .me-lg-40-px {
    margin-right: 40px !important;
  }
  .me-lg-45-px {
    margin-right: 45px !important;
  }
  .me-lg-50-px {
    margin-right: 50px !important;
  }
  .me-lg-60-px {
    margin-right: 60px !important;
  }
  .me-lg-70-px {
    margin-right: 70px !important;
  }
  .me-lg-80-px {
    margin-right: 80px !important;
  }
  .me-lg-90-px {
    margin-right: 90px !important;
  }
  .me-lg-100-px {
    margin-right: 100px !important;
  }
  .me-lg-120-px {
    margin-right: 120px !important;
  }
  .me-lg-125-px {
    margin-right: 125px !important;
  }
  .me-lg-130-px {
    margin-right: 130px !important;
  }
  .me-lg-150-px {
    margin-right: 150px !important;
  }
  .me-lg-200-px {
    margin-right: 200px !important;
  }
  .me-lg-250-px {
    margin-right: 250px !important;
  }
  .me-lg-300-px {
    margin-right: 300px !important;
  }
  .me-lg-350-px {
    margin-right: 350px !important;
  }
  .me-lg-400-px {
    margin-right: 400px !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-5-px {
    margin-bottom: 5px !important;
  }
  .mb-lg-10-px {
    margin-bottom: 10px !important;
  }
  .mb-lg-20-px {
    margin-bottom: 20px !important;
  }
  .mb-lg-30-px {
    margin-bottom: 30px !important;
  }
  .mb-lg-35-px {
    margin-bottom: 35px !important;
  }
  .mb-lg-40-px {
    margin-bottom: 40px !important;
  }
  .mb-lg-45-px {
    margin-bottom: 45px !important;
  }
  .mb-lg-50-px {
    margin-bottom: 50px !important;
  }
  .mb-lg-60-px {
    margin-bottom: 60px !important;
  }
  .mb-lg-70-px {
    margin-bottom: 70px !important;
  }
  .mb-lg-80-px {
    margin-bottom: 80px !important;
  }
  .mb-lg-90-px {
    margin-bottom: 90px !important;
  }
  .mb-lg-100-px {
    margin-bottom: 100px !important;
  }
  .mb-lg-120-px {
    margin-bottom: 120px !important;
  }
  .mb-lg-125-px {
    margin-bottom: 125px !important;
  }
  .mb-lg-130-px {
    margin-bottom: 130px !important;
  }
  .mb-lg-150-px {
    margin-bottom: 150px !important;
  }
  .mb-lg-200-px {
    margin-bottom: 200px !important;
  }
  .mb-lg-250-px {
    margin-bottom: 250px !important;
  }
  .mb-lg-300-px {
    margin-bottom: 300px !important;
  }
  .mb-lg-350-px {
    margin-bottom: 350px !important;
  }
  .mb-lg-400-px {
    margin-bottom: 400px !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-5-px {
    margin-left: 5px !important;
  }
  .ms-lg-10-px {
    margin-left: 10px !important;
  }
  .ms-lg-20-px {
    margin-left: 20px !important;
  }
  .ms-lg-30-px {
    margin-left: 30px !important;
  }
  .ms-lg-35-px {
    margin-left: 35px !important;
  }
  .ms-lg-40-px {
    margin-left: 40px !important;
  }
  .ms-lg-45-px {
    margin-left: 45px !important;
  }
  .ms-lg-50-px {
    margin-left: 50px !important;
  }
  .ms-lg-60-px {
    margin-left: 60px !important;
  }
  .ms-lg-70-px {
    margin-left: 70px !important;
  }
  .ms-lg-80-px {
    margin-left: 80px !important;
  }
  .ms-lg-90-px {
    margin-left: 90px !important;
  }
  .ms-lg-100-px {
    margin-left: 100px !important;
  }
  .ms-lg-120-px {
    margin-left: 120px !important;
  }
  .ms-lg-125-px {
    margin-left: 125px !important;
  }
  .ms-lg-130-px {
    margin-left: 130px !important;
  }
  .ms-lg-150-px {
    margin-left: 150px !important;
  }
  .ms-lg-200-px {
    margin-left: 200px !important;
  }
  .ms-lg-250-px {
    margin-left: 250px !important;
  }
  .ms-lg-300-px {
    margin-left: 300px !important;
  }
  .ms-lg-350-px {
    margin-left: 350px !important;
  }
  .ms-lg-400-px {
    margin-left: 400px !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .m-lg-n5-px {
    margin: -5px !important;
  }
  .m-lg-n10-px {
    margin: -10px !important;
  }
  .m-lg-n20-px {
    margin: -20px !important;
  }
  .m-lg-n30-px {
    margin: -30px !important;
  }
  .m-lg-n35-px {
    margin: -35px !important;
  }
  .m-lg-n40-px {
    margin: -40px !important;
  }
  .m-lg-n45-px {
    margin: -45px !important;
  }
  .m-lg-n50-px {
    margin: -50px !important;
  }
  .m-lg-n60-px {
    margin: -60px !important;
  }
  .m-lg-n70-px {
    margin: -70px !important;
  }
  .m-lg-n80-px {
    margin: -80px !important;
  }
  .m-lg-n90-px {
    margin: -90px !important;
  }
  .m-lg-n100-px {
    margin: -100px !important;
  }
  .m-lg-n120-px {
    margin: -120px !important;
  }
  .m-lg-n125-px {
    margin: -125px !important;
  }
  .m-lg-n130-px {
    margin: -130px !important;
  }
  .m-lg-n150-px {
    margin: -150px !important;
  }
  .m-lg-n200-px {
    margin: -200px !important;
  }
  .m-lg-n250-px {
    margin: -250px !important;
  }
  .m-lg-n300-px {
    margin: -300px !important;
  }
  .m-lg-n350-px {
    margin: -350px !important;
  }
  .m-lg-n400-px {
    margin: -400px !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-lg-n5-px {
    margin-right: -5px !important;
    margin-left: -5px !important;
  }
  .mx-lg-n10-px {
    margin-right: -10px !important;
    margin-left: -10px !important;
  }
  .mx-lg-n20-px {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  .mx-lg-n30-px {
    margin-right: -30px !important;
    margin-left: -30px !important;
  }
  .mx-lg-n35-px {
    margin-right: -35px !important;
    margin-left: -35px !important;
  }
  .mx-lg-n40-px {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  .mx-lg-n45-px {
    margin-right: -45px !important;
    margin-left: -45px !important;
  }
  .mx-lg-n50-px {
    margin-right: -50px !important;
    margin-left: -50px !important;
  }
  .mx-lg-n60-px {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  .mx-lg-n70-px {
    margin-right: -70px !important;
    margin-left: -70px !important;
  }
  .mx-lg-n80-px {
    margin-right: -80px !important;
    margin-left: -80px !important;
  }
  .mx-lg-n90-px {
    margin-right: -90px !important;
    margin-left: -90px !important;
  }
  .mx-lg-n100-px {
    margin-right: -100px !important;
    margin-left: -100px !important;
  }
  .mx-lg-n120-px {
    margin-right: -120px !important;
    margin-left: -120px !important;
  }
  .mx-lg-n125-px {
    margin-right: -125px !important;
    margin-left: -125px !important;
  }
  .mx-lg-n130-px {
    margin-right: -130px !important;
    margin-left: -130px !important;
  }
  .mx-lg-n150-px {
    margin-right: -150px !important;
    margin-left: -150px !important;
  }
  .mx-lg-n200-px {
    margin-right: -200px !important;
    margin-left: -200px !important;
  }
  .mx-lg-n250-px {
    margin-right: -250px !important;
    margin-left: -250px !important;
  }
  .mx-lg-n300-px {
    margin-right: -300px !important;
    margin-left: -300px !important;
  }
  .mx-lg-n350-px {
    margin-right: -350px !important;
    margin-left: -350px !important;
  }
  .mx-lg-n400-px {
    margin-right: -400px !important;
    margin-left: -400px !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-lg-n5-px {
    margin-top: -5px !important;
    margin-bottom: -5px !important;
  }
  .my-lg-n10-px {
    margin-top: -10px !important;
    margin-bottom: -10px !important;
  }
  .my-lg-n20-px {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  .my-lg-n30-px {
    margin-top: -30px !important;
    margin-bottom: -30px !important;
  }
  .my-lg-n35-px {
    margin-top: -35px !important;
    margin-bottom: -35px !important;
  }
  .my-lg-n40-px {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  .my-lg-n45-px {
    margin-top: -45px !important;
    margin-bottom: -45px !important;
  }
  .my-lg-n50-px {
    margin-top: -50px !important;
    margin-bottom: -50px !important;
  }
  .my-lg-n60-px {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  .my-lg-n70-px {
    margin-top: -70px !important;
    margin-bottom: -70px !important;
  }
  .my-lg-n80-px {
    margin-top: -80px !important;
    margin-bottom: -80px !important;
  }
  .my-lg-n90-px {
    margin-top: -90px !important;
    margin-bottom: -90px !important;
  }
  .my-lg-n100-px {
    margin-top: -100px !important;
    margin-bottom: -100px !important;
  }
  .my-lg-n120-px {
    margin-top: -120px !important;
    margin-bottom: -120px !important;
  }
  .my-lg-n125-px {
    margin-top: -125px !important;
    margin-bottom: -125px !important;
  }
  .my-lg-n130-px {
    margin-top: -130px !important;
    margin-bottom: -130px !important;
  }
  .my-lg-n150-px {
    margin-top: -150px !important;
    margin-bottom: -150px !important;
  }
  .my-lg-n200-px {
    margin-top: -200px !important;
    margin-bottom: -200px !important;
  }
  .my-lg-n250-px {
    margin-top: -250px !important;
    margin-bottom: -250px !important;
  }
  .my-lg-n300-px {
    margin-top: -300px !important;
    margin-bottom: -300px !important;
  }
  .my-lg-n350-px {
    margin-top: -350px !important;
    margin-bottom: -350px !important;
  }
  .my-lg-n400-px {
    margin-top: -400px !important;
    margin-bottom: -400px !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .mt-lg-n5-px {
    margin-top: -5px !important;
  }
  .mt-lg-n10-px {
    margin-top: -10px !important;
  }
  .mt-lg-n20-px {
    margin-top: -20px !important;
  }
  .mt-lg-n30-px {
    margin-top: -30px !important;
  }
  .mt-lg-n35-px {
    margin-top: -35px !important;
  }
  .mt-lg-n40-px {
    margin-top: -40px !important;
  }
  .mt-lg-n45-px {
    margin-top: -45px !important;
  }
  .mt-lg-n50-px {
    margin-top: -50px !important;
  }
  .mt-lg-n60-px {
    margin-top: -60px !important;
  }
  .mt-lg-n70-px {
    margin-top: -70px !important;
  }
  .mt-lg-n80-px {
    margin-top: -80px !important;
  }
  .mt-lg-n90-px {
    margin-top: -90px !important;
  }
  .mt-lg-n100-px {
    margin-top: -100px !important;
  }
  .mt-lg-n120-px {
    margin-top: -120px !important;
  }
  .mt-lg-n125-px {
    margin-top: -125px !important;
  }
  .mt-lg-n130-px {
    margin-top: -130px !important;
  }
  .mt-lg-n150-px {
    margin-top: -150px !important;
  }
  .mt-lg-n200-px {
    margin-top: -200px !important;
  }
  .mt-lg-n250-px {
    margin-top: -250px !important;
  }
  .mt-lg-n300-px {
    margin-top: -300px !important;
  }
  .mt-lg-n350-px {
    margin-top: -350px !important;
  }
  .mt-lg-n400-px {
    margin-top: -400px !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .me-lg-n5-px {
    margin-right: -5px !important;
  }
  .me-lg-n10-px {
    margin-right: -10px !important;
  }
  .me-lg-n20-px {
    margin-right: -20px !important;
  }
  .me-lg-n30-px {
    margin-right: -30px !important;
  }
  .me-lg-n35-px {
    margin-right: -35px !important;
  }
  .me-lg-n40-px {
    margin-right: -40px !important;
  }
  .me-lg-n45-px {
    margin-right: -45px !important;
  }
  .me-lg-n50-px {
    margin-right: -50px !important;
  }
  .me-lg-n60-px {
    margin-right: -60px !important;
  }
  .me-lg-n70-px {
    margin-right: -70px !important;
  }
  .me-lg-n80-px {
    margin-right: -80px !important;
  }
  .me-lg-n90-px {
    margin-right: -90px !important;
  }
  .me-lg-n100-px {
    margin-right: -100px !important;
  }
  .me-lg-n120-px {
    margin-right: -120px !important;
  }
  .me-lg-n125-px {
    margin-right: -125px !important;
  }
  .me-lg-n130-px {
    margin-right: -130px !important;
  }
  .me-lg-n150-px {
    margin-right: -150px !important;
  }
  .me-lg-n200-px {
    margin-right: -200px !important;
  }
  .me-lg-n250-px {
    margin-right: -250px !important;
  }
  .me-lg-n300-px {
    margin-right: -300px !important;
  }
  .me-lg-n350-px {
    margin-right: -350px !important;
  }
  .me-lg-n400-px {
    margin-right: -400px !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-lg-n5-px {
    margin-bottom: -5px !important;
  }
  .mb-lg-n10-px {
    margin-bottom: -10px !important;
  }
  .mb-lg-n20-px {
    margin-bottom: -20px !important;
  }
  .mb-lg-n30-px {
    margin-bottom: -30px !important;
  }
  .mb-lg-n35-px {
    margin-bottom: -35px !important;
  }
  .mb-lg-n40-px {
    margin-bottom: -40px !important;
  }
  .mb-lg-n45-px {
    margin-bottom: -45px !important;
  }
  .mb-lg-n50-px {
    margin-bottom: -50px !important;
  }
  .mb-lg-n60-px {
    margin-bottom: -60px !important;
  }
  .mb-lg-n70-px {
    margin-bottom: -70px !important;
  }
  .mb-lg-n80-px {
    margin-bottom: -80px !important;
  }
  .mb-lg-n90-px {
    margin-bottom: -90px !important;
  }
  .mb-lg-n100-px {
    margin-bottom: -100px !important;
  }
  .mb-lg-n120-px {
    margin-bottom: -120px !important;
  }
  .mb-lg-n125-px {
    margin-bottom: -125px !important;
  }
  .mb-lg-n130-px {
    margin-bottom: -130px !important;
  }
  .mb-lg-n150-px {
    margin-bottom: -150px !important;
  }
  .mb-lg-n200-px {
    margin-bottom: -200px !important;
  }
  .mb-lg-n250-px {
    margin-bottom: -250px !important;
  }
  .mb-lg-n300-px {
    margin-bottom: -300px !important;
  }
  .mb-lg-n350-px {
    margin-bottom: -350px !important;
  }
  .mb-lg-n400-px {
    margin-bottom: -400px !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .ms-lg-n5-px {
    margin-left: -5px !important;
  }
  .ms-lg-n10-px {
    margin-left: -10px !important;
  }
  .ms-lg-n20-px {
    margin-left: -20px !important;
  }
  .ms-lg-n30-px {
    margin-left: -30px !important;
  }
  .ms-lg-n35-px {
    margin-left: -35px !important;
  }
  .ms-lg-n40-px {
    margin-left: -40px !important;
  }
  .ms-lg-n45-px {
    margin-left: -45px !important;
  }
  .ms-lg-n50-px {
    margin-left: -50px !important;
  }
  .ms-lg-n60-px {
    margin-left: -60px !important;
  }
  .ms-lg-n70-px {
    margin-left: -70px !important;
  }
  .ms-lg-n80-px {
    margin-left: -80px !important;
  }
  .ms-lg-n90-px {
    margin-left: -90px !important;
  }
  .ms-lg-n100-px {
    margin-left: -100px !important;
  }
  .ms-lg-n120-px {
    margin-left: -120px !important;
  }
  .ms-lg-n125-px {
    margin-left: -125px !important;
  }
  .ms-lg-n130-px {
    margin-left: -130px !important;
  }
  .ms-lg-n150-px {
    margin-left: -150px !important;
  }
  .ms-lg-n200-px {
    margin-left: -200px !important;
  }
  .ms-lg-n250-px {
    margin-left: -250px !important;
  }
  .ms-lg-n300-px {
    margin-left: -300px !important;
  }
  .ms-lg-n350-px {
    margin-left: -350px !important;
  }
  .ms-lg-n400-px {
    margin-left: -400px !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .p-lg-5-px {
    padding: 5px !important;
  }
  .p-lg-10-px {
    padding: 10px !important;
  }
  .p-lg-20-px {
    padding: 20px !important;
  }
  .p-lg-30-px {
    padding: 30px !important;
  }
  .p-lg-35-px {
    padding: 35px !important;
  }
  .p-lg-40-px {
    padding: 40px !important;
  }
  .p-lg-45-px {
    padding: 45px !important;
  }
  .p-lg-50-px {
    padding: 50px !important;
  }
  .p-lg-60-px {
    padding: 60px !important;
  }
  .p-lg-70-px {
    padding: 70px !important;
  }
  .p-lg-80-px {
    padding: 80px !important;
  }
  .p-lg-90-px {
    padding: 90px !important;
  }
  .p-lg-100-px {
    padding: 100px !important;
  }
  .p-lg-120-px {
    padding: 120px !important;
  }
  .p-lg-125-px {
    padding: 125px !important;
  }
  .p-lg-130-px {
    padding: 130px !important;
  }
  .p-lg-150-px {
    padding: 150px !important;
  }
  .p-lg-200-px {
    padding: 200px !important;
  }
  .p-lg-250-px {
    padding: 250px !important;
  }
  .p-lg-300-px {
    padding: 300px !important;
  }
  .p-lg-350-px {
    padding: 350px !important;
  }
  .p-lg-400-px {
    padding: 400px !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-lg-5-px {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }
  .px-lg-10-px {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .px-lg-20-px {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  .px-lg-30-px {
    padding-right: 30px !important;
    padding-left: 30px !important;
  }
  .px-lg-35-px {
    padding-right: 35px !important;
    padding-left: 35px !important;
  }
  .px-lg-40-px {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  .px-lg-45-px {
    padding-right: 45px !important;
    padding-left: 45px !important;
  }
  .px-lg-50-px {
    padding-right: 50px !important;
    padding-left: 50px !important;
  }
  .px-lg-60-px {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  .px-lg-70-px {
    padding-right: 70px !important;
    padding-left: 70px !important;
  }
  .px-lg-80-px {
    padding-right: 80px !important;
    padding-left: 80px !important;
  }
  .px-lg-90-px {
    padding-right: 90px !important;
    padding-left: 90px !important;
  }
  .px-lg-100-px {
    padding-right: 100px !important;
    padding-left: 100px !important;
  }
  .px-lg-120-px {
    padding-right: 120px !important;
    padding-left: 120px !important;
  }
  .px-lg-125-px {
    padding-right: 125px !important;
    padding-left: 125px !important;
  }
  .px-lg-130-px {
    padding-right: 130px !important;
    padding-left: 130px !important;
  }
  .px-lg-150-px {
    padding-right: 150px !important;
    padding-left: 150px !important;
  }
  .px-lg-200-px {
    padding-right: 200px !important;
    padding-left: 200px !important;
  }
  .px-lg-250-px {
    padding-right: 250px !important;
    padding-left: 250px !important;
  }
  .px-lg-300-px {
    padding-right: 300px !important;
    padding-left: 300px !important;
  }
  .px-lg-350-px {
    padding-right: 350px !important;
    padding-left: 350px !important;
  }
  .px-lg-400-px {
    padding-right: 400px !important;
    padding-left: 400px !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-lg-5-px {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }
  .py-lg-10-px {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .py-lg-20-px {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .py-lg-30-px {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
  .py-lg-35-px {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .py-lg-40-px {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .py-lg-45-px {
    padding-top: 45px !important;
    padding-bottom: 45px !important;
  }
  .py-lg-50-px {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }
  .py-lg-60-px {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  .py-lg-70-px {
    padding-top: 70px !important;
    padding-bottom: 70px !important;
  }
  .py-lg-80-px {
    padding-top: 80px !important;
    padding-bottom: 80px !important;
  }
  .py-lg-90-px {
    padding-top: 90px !important;
    padding-bottom: 90px !important;
  }
  .py-lg-100-px {
    padding-top: 100px !important;
    padding-bottom: 100px !important;
  }
  .py-lg-120-px {
    padding-top: 120px !important;
    padding-bottom: 120px !important;
  }
  .py-lg-125-px {
    padding-top: 125px !important;
    padding-bottom: 125px !important;
  }
  .py-lg-130-px {
    padding-top: 130px !important;
    padding-bottom: 130px !important;
  }
  .py-lg-150-px {
    padding-top: 150px !important;
    padding-bottom: 150px !important;
  }
  .py-lg-200-px {
    padding-top: 200px !important;
    padding-bottom: 200px !important;
  }
  .py-lg-250-px {
    padding-top: 250px !important;
    padding-bottom: 250px !important;
  }
  .py-lg-300-px {
    padding-top: 300px !important;
    padding-bottom: 300px !important;
  }
  .py-lg-350-px {
    padding-top: 350px !important;
    padding-bottom: 350px !important;
  }
  .py-lg-400-px {
    padding-top: 400px !important;
    padding-bottom: 400px !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pt-lg-5-px {
    padding-top: 5px !important;
  }
  .pt-lg-10-px {
    padding-top: 10px !important;
  }
  .pt-lg-20-px {
    padding-top: 20px !important;
  }
  .pt-lg-30-px {
    padding-top: 30px !important;
  }
  .pt-lg-35-px {
    padding-top: 35px !important;
  }
  .pt-lg-40-px {
    padding-top: 40px !important;
  }
  .pt-lg-45-px {
    padding-top: 45px !important;
  }
  .pt-lg-50-px {
    padding-top: 50px !important;
  }
  .pt-lg-60-px {
    padding-top: 60px !important;
  }
  .pt-lg-70-px {
    padding-top: 70px !important;
  }
  .pt-lg-80-px {
    padding-top: 80px !important;
  }
  .pt-lg-90-px {
    padding-top: 90px !important;
  }
  .pt-lg-100-px {
    padding-top: 100px !important;
  }
  .pt-lg-120-px {
    padding-top: 120px !important;
  }
  .pt-lg-125-px {
    padding-top: 125px !important;
  }
  .pt-lg-130-px {
    padding-top: 130px !important;
  }
  .pt-lg-150-px {
    padding-top: 150px !important;
  }
  .pt-lg-200-px {
    padding-top: 200px !important;
  }
  .pt-lg-250-px {
    padding-top: 250px !important;
  }
  .pt-lg-300-px {
    padding-top: 300px !important;
  }
  .pt-lg-350-px {
    padding-top: 350px !important;
  }
  .pt-lg-400-px {
    padding-top: 400px !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pe-lg-5-px {
    padding-right: 5px !important;
  }
  .pe-lg-10-px {
    padding-right: 10px !important;
  }
  .pe-lg-20-px {
    padding-right: 20px !important;
  }
  .pe-lg-30-px {
    padding-right: 30px !important;
  }
  .pe-lg-35-px {
    padding-right: 35px !important;
  }
  .pe-lg-40-px {
    padding-right: 40px !important;
  }
  .pe-lg-45-px {
    padding-right: 45px !important;
  }
  .pe-lg-50-px {
    padding-right: 50px !important;
  }
  .pe-lg-60-px {
    padding-right: 60px !important;
  }
  .pe-lg-70-px {
    padding-right: 70px !important;
  }
  .pe-lg-80-px {
    padding-right: 80px !important;
  }
  .pe-lg-90-px {
    padding-right: 90px !important;
  }
  .pe-lg-100-px {
    padding-right: 100px !important;
  }
  .pe-lg-120-px {
    padding-right: 120px !important;
  }
  .pe-lg-125-px {
    padding-right: 125px !important;
  }
  .pe-lg-130-px {
    padding-right: 130px !important;
  }
  .pe-lg-150-px {
    padding-right: 150px !important;
  }
  .pe-lg-200-px {
    padding-right: 200px !important;
  }
  .pe-lg-250-px {
    padding-right: 250px !important;
  }
  .pe-lg-300-px {
    padding-right: 300px !important;
  }
  .pe-lg-350-px {
    padding-right: 350px !important;
  }
  .pe-lg-400-px {
    padding-right: 400px !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pb-lg-5-px {
    padding-bottom: 5px !important;
  }
  .pb-lg-10-px {
    padding-bottom: 10px !important;
  }
  .pb-lg-20-px {
    padding-bottom: 20px !important;
  }
  .pb-lg-30-px {
    padding-bottom: 30px !important;
  }
  .pb-lg-35-px {
    padding-bottom: 35px !important;
  }
  .pb-lg-40-px {
    padding-bottom: 40px !important;
  }
  .pb-lg-45-px {
    padding-bottom: 45px !important;
  }
  .pb-lg-50-px {
    padding-bottom: 50px !important;
  }
  .pb-lg-60-px {
    padding-bottom: 60px !important;
  }
  .pb-lg-70-px {
    padding-bottom: 70px !important;
  }
  .pb-lg-80-px {
    padding-bottom: 80px !important;
  }
  .pb-lg-90-px {
    padding-bottom: 90px !important;
  }
  .pb-lg-100-px {
    padding-bottom: 100px !important;
  }
  .pb-lg-120-px {
    padding-bottom: 120px !important;
  }
  .pb-lg-125-px {
    padding-bottom: 125px !important;
  }
  .pb-lg-130-px {
    padding-bottom: 130px !important;
  }
  .pb-lg-150-px {
    padding-bottom: 150px !important;
  }
  .pb-lg-200-px {
    padding-bottom: 200px !important;
  }
  .pb-lg-250-px {
    padding-bottom: 250px !important;
  }
  .pb-lg-300-px {
    padding-bottom: 300px !important;
  }
  .pb-lg-350-px {
    padding-bottom: 350px !important;
  }
  .pb-lg-400-px {
    padding-bottom: 400px !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .ps-lg-5-px {
    padding-left: 5px !important;
  }
  .ps-lg-10-px {
    padding-left: 10px !important;
  }
  .ps-lg-20-px {
    padding-left: 20px !important;
  }
  .ps-lg-30-px {
    padding-left: 30px !important;
  }
  .ps-lg-35-px {
    padding-left: 35px !important;
  }
  .ps-lg-40-px {
    padding-left: 40px !important;
  }
  .ps-lg-45-px {
    padding-left: 45px !important;
  }
  .ps-lg-50-px {
    padding-left: 50px !important;
  }
  .ps-lg-60-px {
    padding-left: 60px !important;
  }
  .ps-lg-70-px {
    padding-left: 70px !important;
  }
  .ps-lg-80-px {
    padding-left: 80px !important;
  }
  .ps-lg-90-px {
    padding-left: 90px !important;
  }
  .ps-lg-100-px {
    padding-left: 100px !important;
  }
  .ps-lg-120-px {
    padding-left: 120px !important;
  }
  .ps-lg-125-px {
    padding-left: 125px !important;
  }
  .ps-lg-130-px {
    padding-left: 130px !important;
  }
  .ps-lg-150-px {
    padding-left: 150px !important;
  }
  .ps-lg-200-px {
    padding-left: 200px !important;
  }
  .ps-lg-250-px {
    padding-left: 250px !important;
  }
  .ps-lg-300-px {
    padding-left: 300px !important;
  }
  .ps-lg-350-px {
    padding-left: 350px !important;
  }
  .ps-lg-400-px {
    padding-left: 400px !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .gap-lg-5-px {
    gap: 5px !important;
  }
  .gap-lg-10-px {
    gap: 10px !important;
  }
  .gap-lg-20-px {
    gap: 20px !important;
  }
  .gap-lg-30-px {
    gap: 30px !important;
  }
  .gap-lg-35-px {
    gap: 35px !important;
  }
  .gap-lg-40-px {
    gap: 40px !important;
  }
  .gap-lg-45-px {
    gap: 45px !important;
  }
  .gap-lg-50-px {
    gap: 50px !important;
  }
  .gap-lg-60-px {
    gap: 60px !important;
  }
  .gap-lg-70-px {
    gap: 70px !important;
  }
  .gap-lg-80-px {
    gap: 80px !important;
  }
  .gap-lg-90-px {
    gap: 90px !important;
  }
  .gap-lg-100-px {
    gap: 100px !important;
  }
  .gap-lg-120-px {
    gap: 120px !important;
  }
  .gap-lg-125-px {
    gap: 125px !important;
  }
  .gap-lg-130-px {
    gap: 130px !important;
  }
  .gap-lg-150-px {
    gap: 150px !important;
  }
  .gap-lg-200-px {
    gap: 200px !important;
  }
  .gap-lg-250-px {
    gap: 250px !important;
  }
  .gap-lg-300-px {
    gap: 300px !important;
  }
  .gap-lg-350-px {
    gap: 350px !important;
  }
  .gap-lg-400-px {
    gap: 400px !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .row-gap-lg-5-px {
    row-gap: 5px !important;
  }
  .row-gap-lg-10-px {
    row-gap: 10px !important;
  }
  .row-gap-lg-20-px {
    row-gap: 20px !important;
  }
  .row-gap-lg-30-px {
    row-gap: 30px !important;
  }
  .row-gap-lg-35-px {
    row-gap: 35px !important;
  }
  .row-gap-lg-40-px {
    row-gap: 40px !important;
  }
  .row-gap-lg-45-px {
    row-gap: 45px !important;
  }
  .row-gap-lg-50-px {
    row-gap: 50px !important;
  }
  .row-gap-lg-60-px {
    row-gap: 60px !important;
  }
  .row-gap-lg-70-px {
    row-gap: 70px !important;
  }
  .row-gap-lg-80-px {
    row-gap: 80px !important;
  }
  .row-gap-lg-90-px {
    row-gap: 90px !important;
  }
  .row-gap-lg-100-px {
    row-gap: 100px !important;
  }
  .row-gap-lg-120-px {
    row-gap: 120px !important;
  }
  .row-gap-lg-125-px {
    row-gap: 125px !important;
  }
  .row-gap-lg-130-px {
    row-gap: 130px !important;
  }
  .row-gap-lg-150-px {
    row-gap: 150px !important;
  }
  .row-gap-lg-200-px {
    row-gap: 200px !important;
  }
  .row-gap-lg-250-px {
    row-gap: 250px !important;
  }
  .row-gap-lg-300-px {
    row-gap: 300px !important;
  }
  .row-gap-lg-350-px {
    row-gap: 350px !important;
  }
  .row-gap-lg-400-px {
    row-gap: 400px !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .column-gap-lg-5-px {
    column-gap: 5px !important;
  }
  .column-gap-lg-10-px {
    column-gap: 10px !important;
  }
  .column-gap-lg-20-px {
    column-gap: 20px !important;
  }
  .column-gap-lg-30-px {
    column-gap: 30px !important;
  }
  .column-gap-lg-35-px {
    column-gap: 35px !important;
  }
  .column-gap-lg-40-px {
    column-gap: 40px !important;
  }
  .column-gap-lg-45-px {
    column-gap: 45px !important;
  }
  .column-gap-lg-50-px {
    column-gap: 50px !important;
  }
  .column-gap-lg-60-px {
    column-gap: 60px !important;
  }
  .column-gap-lg-70-px {
    column-gap: 70px !important;
  }
  .column-gap-lg-80-px {
    column-gap: 80px !important;
  }
  .column-gap-lg-90-px {
    column-gap: 90px !important;
  }
  .column-gap-lg-100-px {
    column-gap: 100px !important;
  }
  .column-gap-lg-120-px {
    column-gap: 120px !important;
  }
  .column-gap-lg-125-px {
    column-gap: 125px !important;
  }
  .column-gap-lg-130-px {
    column-gap: 130px !important;
  }
  .column-gap-lg-150-px {
    column-gap: 150px !important;
  }
  .column-gap-lg-200-px {
    column-gap: 200px !important;
  }
  .column-gap-lg-250-px {
    column-gap: 250px !important;
  }
  .column-gap-lg-300-px {
    column-gap: 300px !important;
  }
  .column-gap-lg-350-px {
    column-gap: 350px !important;
  }
  .column-gap-lg-400-px {
    column-gap: 400px !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-5-px {
    margin: 5px !important;
  }
  .m-xl-10-px {
    margin: 10px !important;
  }
  .m-xl-20-px {
    margin: 20px !important;
  }
  .m-xl-30-px {
    margin: 30px !important;
  }
  .m-xl-35-px {
    margin: 35px !important;
  }
  .m-xl-40-px {
    margin: 40px !important;
  }
  .m-xl-45-px {
    margin: 45px !important;
  }
  .m-xl-50-px {
    margin: 50px !important;
  }
  .m-xl-60-px {
    margin: 60px !important;
  }
  .m-xl-70-px {
    margin: 70px !important;
  }
  .m-xl-80-px {
    margin: 80px !important;
  }
  .m-xl-90-px {
    margin: 90px !important;
  }
  .m-xl-100-px {
    margin: 100px !important;
  }
  .m-xl-120-px {
    margin: 120px !important;
  }
  .m-xl-125-px {
    margin: 125px !important;
  }
  .m-xl-130-px {
    margin: 130px !important;
  }
  .m-xl-150-px {
    margin: 150px !important;
  }
  .m-xl-200-px {
    margin: 200px !important;
  }
  .m-xl-250-px {
    margin: 250px !important;
  }
  .m-xl-300-px {
    margin: 300px !important;
  }
  .m-xl-350-px {
    margin: 350px !important;
  }
  .m-xl-400-px {
    margin: 400px !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-5-px {
    margin-right: 5px !important;
    margin-left: 5px !important;
  }
  .mx-xl-10-px {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }
  .mx-xl-20-px {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  .mx-xl-30-px {
    margin-right: 30px !important;
    margin-left: 30px !important;
  }
  .mx-xl-35-px {
    margin-right: 35px !important;
    margin-left: 35px !important;
  }
  .mx-xl-40-px {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  .mx-xl-45-px {
    margin-right: 45px !important;
    margin-left: 45px !important;
  }
  .mx-xl-50-px {
    margin-right: 50px !important;
    margin-left: 50px !important;
  }
  .mx-xl-60-px {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  .mx-xl-70-px {
    margin-right: 70px !important;
    margin-left: 70px !important;
  }
  .mx-xl-80-px {
    margin-right: 80px !important;
    margin-left: 80px !important;
  }
  .mx-xl-90-px {
    margin-right: 90px !important;
    margin-left: 90px !important;
  }
  .mx-xl-100-px {
    margin-right: 100px !important;
    margin-left: 100px !important;
  }
  .mx-xl-120-px {
    margin-right: 120px !important;
    margin-left: 120px !important;
  }
  .mx-xl-125-px {
    margin-right: 125px !important;
    margin-left: 125px !important;
  }
  .mx-xl-130-px {
    margin-right: 130px !important;
    margin-left: 130px !important;
  }
  .mx-xl-150-px {
    margin-right: 150px !important;
    margin-left: 150px !important;
  }
  .mx-xl-200-px {
    margin-right: 200px !important;
    margin-left: 200px !important;
  }
  .mx-xl-250-px {
    margin-right: 250px !important;
    margin-left: 250px !important;
  }
  .mx-xl-300-px {
    margin-right: 300px !important;
    margin-left: 300px !important;
  }
  .mx-xl-350-px {
    margin-right: 350px !important;
    margin-left: 350px !important;
  }
  .mx-xl-400-px {
    margin-right: 400px !important;
    margin-left: 400px !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-5-px {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }
  .my-xl-10-px {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .my-xl-20-px {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .my-xl-30-px {
    margin-top: 30px !important;
    margin-bottom: 30px !important;
  }
  .my-xl-35-px {
    margin-top: 35px !important;
    margin-bottom: 35px !important;
  }
  .my-xl-40-px {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .my-xl-45-px {
    margin-top: 45px !important;
    margin-bottom: 45px !important;
  }
  .my-xl-50-px {
    margin-top: 50px !important;
    margin-bottom: 50px !important;
  }
  .my-xl-60-px {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  .my-xl-70-px {
    margin-top: 70px !important;
    margin-bottom: 70px !important;
  }
  .my-xl-80-px {
    margin-top: 80px !important;
    margin-bottom: 80px !important;
  }
  .my-xl-90-px {
    margin-top: 90px !important;
    margin-bottom: 90px !important;
  }
  .my-xl-100-px {
    margin-top: 100px !important;
    margin-bottom: 100px !important;
  }
  .my-xl-120-px {
    margin-top: 120px !important;
    margin-bottom: 120px !important;
  }
  .my-xl-125-px {
    margin-top: 125px !important;
    margin-bottom: 125px !important;
  }
  .my-xl-130-px {
    margin-top: 130px !important;
    margin-bottom: 130px !important;
  }
  .my-xl-150-px {
    margin-top: 150px !important;
    margin-bottom: 150px !important;
  }
  .my-xl-200-px {
    margin-top: 200px !important;
    margin-bottom: 200px !important;
  }
  .my-xl-250-px {
    margin-top: 250px !important;
    margin-bottom: 250px !important;
  }
  .my-xl-300-px {
    margin-top: 300px !important;
    margin-bottom: 300px !important;
  }
  .my-xl-350-px {
    margin-top: 350px !important;
    margin-bottom: 350px !important;
  }
  .my-xl-400-px {
    margin-top: 400px !important;
    margin-bottom: 400px !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-5-px {
    margin-top: 5px !important;
  }
  .mt-xl-10-px {
    margin-top: 10px !important;
  }
  .mt-xl-20-px {
    margin-top: 20px !important;
  }
  .mt-xl-30-px {
    margin-top: 30px !important;
  }
  .mt-xl-35-px {
    margin-top: 35px !important;
  }
  .mt-xl-40-px {
    margin-top: 40px !important;
  }
  .mt-xl-45-px {
    margin-top: 45px !important;
  }
  .mt-xl-50-px {
    margin-top: 50px !important;
  }
  .mt-xl-60-px {
    margin-top: 60px !important;
  }
  .mt-xl-70-px {
    margin-top: 70px !important;
  }
  .mt-xl-80-px {
    margin-top: 80px !important;
  }
  .mt-xl-90-px {
    margin-top: 90px !important;
  }
  .mt-xl-100-px {
    margin-top: 100px !important;
  }
  .mt-xl-120-px {
    margin-top: 120px !important;
  }
  .mt-xl-125-px {
    margin-top: 125px !important;
  }
  .mt-xl-130-px {
    margin-top: 130px !important;
  }
  .mt-xl-150-px {
    margin-top: 150px !important;
  }
  .mt-xl-200-px {
    margin-top: 200px !important;
  }
  .mt-xl-250-px {
    margin-top: 250px !important;
  }
  .mt-xl-300-px {
    margin-top: 300px !important;
  }
  .mt-xl-350-px {
    margin-top: 350px !important;
  }
  .mt-xl-400-px {
    margin-top: 400px !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-5-px {
    margin-right: 5px !important;
  }
  .me-xl-10-px {
    margin-right: 10px !important;
  }
  .me-xl-20-px {
    margin-right: 20px !important;
  }
  .me-xl-30-px {
    margin-right: 30px !important;
  }
  .me-xl-35-px {
    margin-right: 35px !important;
  }
  .me-xl-40-px {
    margin-right: 40px !important;
  }
  .me-xl-45-px {
    margin-right: 45px !important;
  }
  .me-xl-50-px {
    margin-right: 50px !important;
  }
  .me-xl-60-px {
    margin-right: 60px !important;
  }
  .me-xl-70-px {
    margin-right: 70px !important;
  }
  .me-xl-80-px {
    margin-right: 80px !important;
  }
  .me-xl-90-px {
    margin-right: 90px !important;
  }
  .me-xl-100-px {
    margin-right: 100px !important;
  }
  .me-xl-120-px {
    margin-right: 120px !important;
  }
  .me-xl-125-px {
    margin-right: 125px !important;
  }
  .me-xl-130-px {
    margin-right: 130px !important;
  }
  .me-xl-150-px {
    margin-right: 150px !important;
  }
  .me-xl-200-px {
    margin-right: 200px !important;
  }
  .me-xl-250-px {
    margin-right: 250px !important;
  }
  .me-xl-300-px {
    margin-right: 300px !important;
  }
  .me-xl-350-px {
    margin-right: 350px !important;
  }
  .me-xl-400-px {
    margin-right: 400px !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-5-px {
    margin-bottom: 5px !important;
  }
  .mb-xl-10-px {
    margin-bottom: 10px !important;
  }
  .mb-xl-20-px {
    margin-bottom: 20px !important;
  }
  .mb-xl-30-px {
    margin-bottom: 30px !important;
  }
  .mb-xl-35-px {
    margin-bottom: 35px !important;
  }
  .mb-xl-40-px {
    margin-bottom: 40px !important;
  }
  .mb-xl-45-px {
    margin-bottom: 45px !important;
  }
  .mb-xl-50-px {
    margin-bottom: 50px !important;
  }
  .mb-xl-60-px {
    margin-bottom: 60px !important;
  }
  .mb-xl-70-px {
    margin-bottom: 70px !important;
  }
  .mb-xl-80-px {
    margin-bottom: 80px !important;
  }
  .mb-xl-90-px {
    margin-bottom: 90px !important;
  }
  .mb-xl-100-px {
    margin-bottom: 100px !important;
  }
  .mb-xl-120-px {
    margin-bottom: 120px !important;
  }
  .mb-xl-125-px {
    margin-bottom: 125px !important;
  }
  .mb-xl-130-px {
    margin-bottom: 130px !important;
  }
  .mb-xl-150-px {
    margin-bottom: 150px !important;
  }
  .mb-xl-200-px {
    margin-bottom: 200px !important;
  }
  .mb-xl-250-px {
    margin-bottom: 250px !important;
  }
  .mb-xl-300-px {
    margin-bottom: 300px !important;
  }
  .mb-xl-350-px {
    margin-bottom: 350px !important;
  }
  .mb-xl-400-px {
    margin-bottom: 400px !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-5-px {
    margin-left: 5px !important;
  }
  .ms-xl-10-px {
    margin-left: 10px !important;
  }
  .ms-xl-20-px {
    margin-left: 20px !important;
  }
  .ms-xl-30-px {
    margin-left: 30px !important;
  }
  .ms-xl-35-px {
    margin-left: 35px !important;
  }
  .ms-xl-40-px {
    margin-left: 40px !important;
  }
  .ms-xl-45-px {
    margin-left: 45px !important;
  }
  .ms-xl-50-px {
    margin-left: 50px !important;
  }
  .ms-xl-60-px {
    margin-left: 60px !important;
  }
  .ms-xl-70-px {
    margin-left: 70px !important;
  }
  .ms-xl-80-px {
    margin-left: 80px !important;
  }
  .ms-xl-90-px {
    margin-left: 90px !important;
  }
  .ms-xl-100-px {
    margin-left: 100px !important;
  }
  .ms-xl-120-px {
    margin-left: 120px !important;
  }
  .ms-xl-125-px {
    margin-left: 125px !important;
  }
  .ms-xl-130-px {
    margin-left: 130px !important;
  }
  .ms-xl-150-px {
    margin-left: 150px !important;
  }
  .ms-xl-200-px {
    margin-left: 200px !important;
  }
  .ms-xl-250-px {
    margin-left: 250px !important;
  }
  .ms-xl-300-px {
    margin-left: 300px !important;
  }
  .ms-xl-350-px {
    margin-left: 350px !important;
  }
  .ms-xl-400-px {
    margin-left: 400px !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .m-xl-n5-px {
    margin: -5px !important;
  }
  .m-xl-n10-px {
    margin: -10px !important;
  }
  .m-xl-n20-px {
    margin: -20px !important;
  }
  .m-xl-n30-px {
    margin: -30px !important;
  }
  .m-xl-n35-px {
    margin: -35px !important;
  }
  .m-xl-n40-px {
    margin: -40px !important;
  }
  .m-xl-n45-px {
    margin: -45px !important;
  }
  .m-xl-n50-px {
    margin: -50px !important;
  }
  .m-xl-n60-px {
    margin: -60px !important;
  }
  .m-xl-n70-px {
    margin: -70px !important;
  }
  .m-xl-n80-px {
    margin: -80px !important;
  }
  .m-xl-n90-px {
    margin: -90px !important;
  }
  .m-xl-n100-px {
    margin: -100px !important;
  }
  .m-xl-n120-px {
    margin: -120px !important;
  }
  .m-xl-n125-px {
    margin: -125px !important;
  }
  .m-xl-n130-px {
    margin: -130px !important;
  }
  .m-xl-n150-px {
    margin: -150px !important;
  }
  .m-xl-n200-px {
    margin: -200px !important;
  }
  .m-xl-n250-px {
    margin: -250px !important;
  }
  .m-xl-n300-px {
    margin: -300px !important;
  }
  .m-xl-n350-px {
    margin: -350px !important;
  }
  .m-xl-n400-px {
    margin: -400px !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xl-n5-px {
    margin-right: -5px !important;
    margin-left: -5px !important;
  }
  .mx-xl-n10-px {
    margin-right: -10px !important;
    margin-left: -10px !important;
  }
  .mx-xl-n20-px {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  .mx-xl-n30-px {
    margin-right: -30px !important;
    margin-left: -30px !important;
  }
  .mx-xl-n35-px {
    margin-right: -35px !important;
    margin-left: -35px !important;
  }
  .mx-xl-n40-px {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  .mx-xl-n45-px {
    margin-right: -45px !important;
    margin-left: -45px !important;
  }
  .mx-xl-n50-px {
    margin-right: -50px !important;
    margin-left: -50px !important;
  }
  .mx-xl-n60-px {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  .mx-xl-n70-px {
    margin-right: -70px !important;
    margin-left: -70px !important;
  }
  .mx-xl-n80-px {
    margin-right: -80px !important;
    margin-left: -80px !important;
  }
  .mx-xl-n90-px {
    margin-right: -90px !important;
    margin-left: -90px !important;
  }
  .mx-xl-n100-px {
    margin-right: -100px !important;
    margin-left: -100px !important;
  }
  .mx-xl-n120-px {
    margin-right: -120px !important;
    margin-left: -120px !important;
  }
  .mx-xl-n125-px {
    margin-right: -125px !important;
    margin-left: -125px !important;
  }
  .mx-xl-n130-px {
    margin-right: -130px !important;
    margin-left: -130px !important;
  }
  .mx-xl-n150-px {
    margin-right: -150px !important;
    margin-left: -150px !important;
  }
  .mx-xl-n200-px {
    margin-right: -200px !important;
    margin-left: -200px !important;
  }
  .mx-xl-n250-px {
    margin-right: -250px !important;
    margin-left: -250px !important;
  }
  .mx-xl-n300-px {
    margin-right: -300px !important;
    margin-left: -300px !important;
  }
  .mx-xl-n350-px {
    margin-right: -350px !important;
    margin-left: -350px !important;
  }
  .mx-xl-n400-px {
    margin-right: -400px !important;
    margin-left: -400px !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xl-n5-px {
    margin-top: -5px !important;
    margin-bottom: -5px !important;
  }
  .my-xl-n10-px {
    margin-top: -10px !important;
    margin-bottom: -10px !important;
  }
  .my-xl-n20-px {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  .my-xl-n30-px {
    margin-top: -30px !important;
    margin-bottom: -30px !important;
  }
  .my-xl-n35-px {
    margin-top: -35px !important;
    margin-bottom: -35px !important;
  }
  .my-xl-n40-px {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  .my-xl-n45-px {
    margin-top: -45px !important;
    margin-bottom: -45px !important;
  }
  .my-xl-n50-px {
    margin-top: -50px !important;
    margin-bottom: -50px !important;
  }
  .my-xl-n60-px {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  .my-xl-n70-px {
    margin-top: -70px !important;
    margin-bottom: -70px !important;
  }
  .my-xl-n80-px {
    margin-top: -80px !important;
    margin-bottom: -80px !important;
  }
  .my-xl-n90-px {
    margin-top: -90px !important;
    margin-bottom: -90px !important;
  }
  .my-xl-n100-px {
    margin-top: -100px !important;
    margin-bottom: -100px !important;
  }
  .my-xl-n120-px {
    margin-top: -120px !important;
    margin-bottom: -120px !important;
  }
  .my-xl-n125-px {
    margin-top: -125px !important;
    margin-bottom: -125px !important;
  }
  .my-xl-n130-px {
    margin-top: -130px !important;
    margin-bottom: -130px !important;
  }
  .my-xl-n150-px {
    margin-top: -150px !important;
    margin-bottom: -150px !important;
  }
  .my-xl-n200-px {
    margin-top: -200px !important;
    margin-bottom: -200px !important;
  }
  .my-xl-n250-px {
    margin-top: -250px !important;
    margin-bottom: -250px !important;
  }
  .my-xl-n300-px {
    margin-top: -300px !important;
    margin-bottom: -300px !important;
  }
  .my-xl-n350-px {
    margin-top: -350px !important;
    margin-bottom: -350px !important;
  }
  .my-xl-n400-px {
    margin-top: -400px !important;
    margin-bottom: -400px !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .mt-xl-n5-px {
    margin-top: -5px !important;
  }
  .mt-xl-n10-px {
    margin-top: -10px !important;
  }
  .mt-xl-n20-px {
    margin-top: -20px !important;
  }
  .mt-xl-n30-px {
    margin-top: -30px !important;
  }
  .mt-xl-n35-px {
    margin-top: -35px !important;
  }
  .mt-xl-n40-px {
    margin-top: -40px !important;
  }
  .mt-xl-n45-px {
    margin-top: -45px !important;
  }
  .mt-xl-n50-px {
    margin-top: -50px !important;
  }
  .mt-xl-n60-px {
    margin-top: -60px !important;
  }
  .mt-xl-n70-px {
    margin-top: -70px !important;
  }
  .mt-xl-n80-px {
    margin-top: -80px !important;
  }
  .mt-xl-n90-px {
    margin-top: -90px !important;
  }
  .mt-xl-n100-px {
    margin-top: -100px !important;
  }
  .mt-xl-n120-px {
    margin-top: -120px !important;
  }
  .mt-xl-n125-px {
    margin-top: -125px !important;
  }
  .mt-xl-n130-px {
    margin-top: -130px !important;
  }
  .mt-xl-n150-px {
    margin-top: -150px !important;
  }
  .mt-xl-n200-px {
    margin-top: -200px !important;
  }
  .mt-xl-n250-px {
    margin-top: -250px !important;
  }
  .mt-xl-n300-px {
    margin-top: -300px !important;
  }
  .mt-xl-n350-px {
    margin-top: -350px !important;
  }
  .mt-xl-n400-px {
    margin-top: -400px !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .me-xl-n5-px {
    margin-right: -5px !important;
  }
  .me-xl-n10-px {
    margin-right: -10px !important;
  }
  .me-xl-n20-px {
    margin-right: -20px !important;
  }
  .me-xl-n30-px {
    margin-right: -30px !important;
  }
  .me-xl-n35-px {
    margin-right: -35px !important;
  }
  .me-xl-n40-px {
    margin-right: -40px !important;
  }
  .me-xl-n45-px {
    margin-right: -45px !important;
  }
  .me-xl-n50-px {
    margin-right: -50px !important;
  }
  .me-xl-n60-px {
    margin-right: -60px !important;
  }
  .me-xl-n70-px {
    margin-right: -70px !important;
  }
  .me-xl-n80-px {
    margin-right: -80px !important;
  }
  .me-xl-n90-px {
    margin-right: -90px !important;
  }
  .me-xl-n100-px {
    margin-right: -100px !important;
  }
  .me-xl-n120-px {
    margin-right: -120px !important;
  }
  .me-xl-n125-px {
    margin-right: -125px !important;
  }
  .me-xl-n130-px {
    margin-right: -130px !important;
  }
  .me-xl-n150-px {
    margin-right: -150px !important;
  }
  .me-xl-n200-px {
    margin-right: -200px !important;
  }
  .me-xl-n250-px {
    margin-right: -250px !important;
  }
  .me-xl-n300-px {
    margin-right: -300px !important;
  }
  .me-xl-n350-px {
    margin-right: -350px !important;
  }
  .me-xl-n400-px {
    margin-right: -400px !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-xl-n5-px {
    margin-bottom: -5px !important;
  }
  .mb-xl-n10-px {
    margin-bottom: -10px !important;
  }
  .mb-xl-n20-px {
    margin-bottom: -20px !important;
  }
  .mb-xl-n30-px {
    margin-bottom: -30px !important;
  }
  .mb-xl-n35-px {
    margin-bottom: -35px !important;
  }
  .mb-xl-n40-px {
    margin-bottom: -40px !important;
  }
  .mb-xl-n45-px {
    margin-bottom: -45px !important;
  }
  .mb-xl-n50-px {
    margin-bottom: -50px !important;
  }
  .mb-xl-n60-px {
    margin-bottom: -60px !important;
  }
  .mb-xl-n70-px {
    margin-bottom: -70px !important;
  }
  .mb-xl-n80-px {
    margin-bottom: -80px !important;
  }
  .mb-xl-n90-px {
    margin-bottom: -90px !important;
  }
  .mb-xl-n100-px {
    margin-bottom: -100px !important;
  }
  .mb-xl-n120-px {
    margin-bottom: -120px !important;
  }
  .mb-xl-n125-px {
    margin-bottom: -125px !important;
  }
  .mb-xl-n130-px {
    margin-bottom: -130px !important;
  }
  .mb-xl-n150-px {
    margin-bottom: -150px !important;
  }
  .mb-xl-n200-px {
    margin-bottom: -200px !important;
  }
  .mb-xl-n250-px {
    margin-bottom: -250px !important;
  }
  .mb-xl-n300-px {
    margin-bottom: -300px !important;
  }
  .mb-xl-n350-px {
    margin-bottom: -350px !important;
  }
  .mb-xl-n400-px {
    margin-bottom: -400px !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .ms-xl-n5-px {
    margin-left: -5px !important;
  }
  .ms-xl-n10-px {
    margin-left: -10px !important;
  }
  .ms-xl-n20-px {
    margin-left: -20px !important;
  }
  .ms-xl-n30-px {
    margin-left: -30px !important;
  }
  .ms-xl-n35-px {
    margin-left: -35px !important;
  }
  .ms-xl-n40-px {
    margin-left: -40px !important;
  }
  .ms-xl-n45-px {
    margin-left: -45px !important;
  }
  .ms-xl-n50-px {
    margin-left: -50px !important;
  }
  .ms-xl-n60-px {
    margin-left: -60px !important;
  }
  .ms-xl-n70-px {
    margin-left: -70px !important;
  }
  .ms-xl-n80-px {
    margin-left: -80px !important;
  }
  .ms-xl-n90-px {
    margin-left: -90px !important;
  }
  .ms-xl-n100-px {
    margin-left: -100px !important;
  }
  .ms-xl-n120-px {
    margin-left: -120px !important;
  }
  .ms-xl-n125-px {
    margin-left: -125px !important;
  }
  .ms-xl-n130-px {
    margin-left: -130px !important;
  }
  .ms-xl-n150-px {
    margin-left: -150px !important;
  }
  .ms-xl-n200-px {
    margin-left: -200px !important;
  }
  .ms-xl-n250-px {
    margin-left: -250px !important;
  }
  .ms-xl-n300-px {
    margin-left: -300px !important;
  }
  .ms-xl-n350-px {
    margin-left: -350px !important;
  }
  .ms-xl-n400-px {
    margin-left: -400px !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .p-xl-5-px {
    padding: 5px !important;
  }
  .p-xl-10-px {
    padding: 10px !important;
  }
  .p-xl-20-px {
    padding: 20px !important;
  }
  .p-xl-30-px {
    padding: 30px !important;
  }
  .p-xl-35-px {
    padding: 35px !important;
  }
  .p-xl-40-px {
    padding: 40px !important;
  }
  .p-xl-45-px {
    padding: 45px !important;
  }
  .p-xl-50-px {
    padding: 50px !important;
  }
  .p-xl-60-px {
    padding: 60px !important;
  }
  .p-xl-70-px {
    padding: 70px !important;
  }
  .p-xl-80-px {
    padding: 80px !important;
  }
  .p-xl-90-px {
    padding: 90px !important;
  }
  .p-xl-100-px {
    padding: 100px !important;
  }
  .p-xl-120-px {
    padding: 120px !important;
  }
  .p-xl-125-px {
    padding: 125px !important;
  }
  .p-xl-130-px {
    padding: 130px !important;
  }
  .p-xl-150-px {
    padding: 150px !important;
  }
  .p-xl-200-px {
    padding: 200px !important;
  }
  .p-xl-250-px {
    padding: 250px !important;
  }
  .p-xl-300-px {
    padding: 300px !important;
  }
  .p-xl-350-px {
    padding: 350px !important;
  }
  .p-xl-400-px {
    padding: 400px !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xl-5-px {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }
  .px-xl-10-px {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .px-xl-20-px {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  .px-xl-30-px {
    padding-right: 30px !important;
    padding-left: 30px !important;
  }
  .px-xl-35-px {
    padding-right: 35px !important;
    padding-left: 35px !important;
  }
  .px-xl-40-px {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  .px-xl-45-px {
    padding-right: 45px !important;
    padding-left: 45px !important;
  }
  .px-xl-50-px {
    padding-right: 50px !important;
    padding-left: 50px !important;
  }
  .px-xl-60-px {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  .px-xl-70-px {
    padding-right: 70px !important;
    padding-left: 70px !important;
  }
  .px-xl-80-px {
    padding-right: 80px !important;
    padding-left: 80px !important;
  }
  .px-xl-90-px {
    padding-right: 90px !important;
    padding-left: 90px !important;
  }
  .px-xl-100-px {
    padding-right: 100px !important;
    padding-left: 100px !important;
  }
  .px-xl-120-px {
    padding-right: 120px !important;
    padding-left: 120px !important;
  }
  .px-xl-125-px {
    padding-right: 125px !important;
    padding-left: 125px !important;
  }
  .px-xl-130-px {
    padding-right: 130px !important;
    padding-left: 130px !important;
  }
  .px-xl-150-px {
    padding-right: 150px !important;
    padding-left: 150px !important;
  }
  .px-xl-200-px {
    padding-right: 200px !important;
    padding-left: 200px !important;
  }
  .px-xl-250-px {
    padding-right: 250px !important;
    padding-left: 250px !important;
  }
  .px-xl-300-px {
    padding-right: 300px !important;
    padding-left: 300px !important;
  }
  .px-xl-350-px {
    padding-right: 350px !important;
    padding-left: 350px !important;
  }
  .px-xl-400-px {
    padding-right: 400px !important;
    padding-left: 400px !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xl-5-px {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }
  .py-xl-10-px {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .py-xl-20-px {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .py-xl-30-px {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
  .py-xl-35-px {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .py-xl-40-px {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .py-xl-45-px {
    padding-top: 45px !important;
    padding-bottom: 45px !important;
  }
  .py-xl-50-px {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }
  .py-xl-60-px {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  .py-xl-70-px {
    padding-top: 70px !important;
    padding-bottom: 70px !important;
  }
  .py-xl-80-px {
    padding-top: 80px !important;
    padding-bottom: 80px !important;
  }
  .py-xl-90-px {
    padding-top: 90px !important;
    padding-bottom: 90px !important;
  }
  .py-xl-100-px {
    padding-top: 100px !important;
    padding-bottom: 100px !important;
  }
  .py-xl-120-px {
    padding-top: 120px !important;
    padding-bottom: 120px !important;
  }
  .py-xl-125-px {
    padding-top: 125px !important;
    padding-bottom: 125px !important;
  }
  .py-xl-130-px {
    padding-top: 130px !important;
    padding-bottom: 130px !important;
  }
  .py-xl-150-px {
    padding-top: 150px !important;
    padding-bottom: 150px !important;
  }
  .py-xl-200-px {
    padding-top: 200px !important;
    padding-bottom: 200px !important;
  }
  .py-xl-250-px {
    padding-top: 250px !important;
    padding-bottom: 250px !important;
  }
  .py-xl-300-px {
    padding-top: 300px !important;
    padding-bottom: 300px !important;
  }
  .py-xl-350-px {
    padding-top: 350px !important;
    padding-bottom: 350px !important;
  }
  .py-xl-400-px {
    padding-top: 400px !important;
    padding-bottom: 400px !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pt-xl-5-px {
    padding-top: 5px !important;
  }
  .pt-xl-10-px {
    padding-top: 10px !important;
  }
  .pt-xl-20-px {
    padding-top: 20px !important;
  }
  .pt-xl-30-px {
    padding-top: 30px !important;
  }
  .pt-xl-35-px {
    padding-top: 35px !important;
  }
  .pt-xl-40-px {
    padding-top: 40px !important;
  }
  .pt-xl-45-px {
    padding-top: 45px !important;
  }
  .pt-xl-50-px {
    padding-top: 50px !important;
  }
  .pt-xl-60-px {
    padding-top: 60px !important;
  }
  .pt-xl-70-px {
    padding-top: 70px !important;
  }
  .pt-xl-80-px {
    padding-top: 80px !important;
  }
  .pt-xl-90-px {
    padding-top: 90px !important;
  }
  .pt-xl-100-px {
    padding-top: 100px !important;
  }
  .pt-xl-120-px {
    padding-top: 120px !important;
  }
  .pt-xl-125-px {
    padding-top: 125px !important;
  }
  .pt-xl-130-px {
    padding-top: 130px !important;
  }
  .pt-xl-150-px {
    padding-top: 150px !important;
  }
  .pt-xl-200-px {
    padding-top: 200px !important;
  }
  .pt-xl-250-px {
    padding-top: 250px !important;
  }
  .pt-xl-300-px {
    padding-top: 300px !important;
  }
  .pt-xl-350-px {
    padding-top: 350px !important;
  }
  .pt-xl-400-px {
    padding-top: 400px !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pe-xl-5-px {
    padding-right: 5px !important;
  }
  .pe-xl-10-px {
    padding-right: 10px !important;
  }
  .pe-xl-20-px {
    padding-right: 20px !important;
  }
  .pe-xl-30-px {
    padding-right: 30px !important;
  }
  .pe-xl-35-px {
    padding-right: 35px !important;
  }
  .pe-xl-40-px {
    padding-right: 40px !important;
  }
  .pe-xl-45-px {
    padding-right: 45px !important;
  }
  .pe-xl-50-px {
    padding-right: 50px !important;
  }
  .pe-xl-60-px {
    padding-right: 60px !important;
  }
  .pe-xl-70-px {
    padding-right: 70px !important;
  }
  .pe-xl-80-px {
    padding-right: 80px !important;
  }
  .pe-xl-90-px {
    padding-right: 90px !important;
  }
  .pe-xl-100-px {
    padding-right: 100px !important;
  }
  .pe-xl-120-px {
    padding-right: 120px !important;
  }
  .pe-xl-125-px {
    padding-right: 125px !important;
  }
  .pe-xl-130-px {
    padding-right: 130px !important;
  }
  .pe-xl-150-px {
    padding-right: 150px !important;
  }
  .pe-xl-200-px {
    padding-right: 200px !important;
  }
  .pe-xl-250-px {
    padding-right: 250px !important;
  }
  .pe-xl-300-px {
    padding-right: 300px !important;
  }
  .pe-xl-350-px {
    padding-right: 350px !important;
  }
  .pe-xl-400-px {
    padding-right: 400px !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pb-xl-5-px {
    padding-bottom: 5px !important;
  }
  .pb-xl-10-px {
    padding-bottom: 10px !important;
  }
  .pb-xl-20-px {
    padding-bottom: 20px !important;
  }
  .pb-xl-30-px {
    padding-bottom: 30px !important;
  }
  .pb-xl-35-px {
    padding-bottom: 35px !important;
  }
  .pb-xl-40-px {
    padding-bottom: 40px !important;
  }
  .pb-xl-45-px {
    padding-bottom: 45px !important;
  }
  .pb-xl-50-px {
    padding-bottom: 50px !important;
  }
  .pb-xl-60-px {
    padding-bottom: 60px !important;
  }
  .pb-xl-70-px {
    padding-bottom: 70px !important;
  }
  .pb-xl-80-px {
    padding-bottom: 80px !important;
  }
  .pb-xl-90-px {
    padding-bottom: 90px !important;
  }
  .pb-xl-100-px {
    padding-bottom: 100px !important;
  }
  .pb-xl-120-px {
    padding-bottom: 120px !important;
  }
  .pb-xl-125-px {
    padding-bottom: 125px !important;
  }
  .pb-xl-130-px {
    padding-bottom: 130px !important;
  }
  .pb-xl-150-px {
    padding-bottom: 150px !important;
  }
  .pb-xl-200-px {
    padding-bottom: 200px !important;
  }
  .pb-xl-250-px {
    padding-bottom: 250px !important;
  }
  .pb-xl-300-px {
    padding-bottom: 300px !important;
  }
  .pb-xl-350-px {
    padding-bottom: 350px !important;
  }
  .pb-xl-400-px {
    padding-bottom: 400px !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .ps-xl-5-px {
    padding-left: 5px !important;
  }
  .ps-xl-10-px {
    padding-left: 10px !important;
  }
  .ps-xl-20-px {
    padding-left: 20px !important;
  }
  .ps-xl-30-px {
    padding-left: 30px !important;
  }
  .ps-xl-35-px {
    padding-left: 35px !important;
  }
  .ps-xl-40-px {
    padding-left: 40px !important;
  }
  .ps-xl-45-px {
    padding-left: 45px !important;
  }
  .ps-xl-50-px {
    padding-left: 50px !important;
  }
  .ps-xl-60-px {
    padding-left: 60px !important;
  }
  .ps-xl-70-px {
    padding-left: 70px !important;
  }
  .ps-xl-80-px {
    padding-left: 80px !important;
  }
  .ps-xl-90-px {
    padding-left: 90px !important;
  }
  .ps-xl-100-px {
    padding-left: 100px !important;
  }
  .ps-xl-120-px {
    padding-left: 120px !important;
  }
  .ps-xl-125-px {
    padding-left: 125px !important;
  }
  .ps-xl-130-px {
    padding-left: 130px !important;
  }
  .ps-xl-150-px {
    padding-left: 150px !important;
  }
  .ps-xl-200-px {
    padding-left: 200px !important;
  }
  .ps-xl-250-px {
    padding-left: 250px !important;
  }
  .ps-xl-300-px {
    padding-left: 300px !important;
  }
  .ps-xl-350-px {
    padding-left: 350px !important;
  }
  .ps-xl-400-px {
    padding-left: 400px !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .gap-xl-5-px {
    gap: 5px !important;
  }
  .gap-xl-10-px {
    gap: 10px !important;
  }
  .gap-xl-20-px {
    gap: 20px !important;
  }
  .gap-xl-30-px {
    gap: 30px !important;
  }
  .gap-xl-35-px {
    gap: 35px !important;
  }
  .gap-xl-40-px {
    gap: 40px !important;
  }
  .gap-xl-45-px {
    gap: 45px !important;
  }
  .gap-xl-50-px {
    gap: 50px !important;
  }
  .gap-xl-60-px {
    gap: 60px !important;
  }
  .gap-xl-70-px {
    gap: 70px !important;
  }
  .gap-xl-80-px {
    gap: 80px !important;
  }
  .gap-xl-90-px {
    gap: 90px !important;
  }
  .gap-xl-100-px {
    gap: 100px !important;
  }
  .gap-xl-120-px {
    gap: 120px !important;
  }
  .gap-xl-125-px {
    gap: 125px !important;
  }
  .gap-xl-130-px {
    gap: 130px !important;
  }
  .gap-xl-150-px {
    gap: 150px !important;
  }
  .gap-xl-200-px {
    gap: 200px !important;
  }
  .gap-xl-250-px {
    gap: 250px !important;
  }
  .gap-xl-300-px {
    gap: 300px !important;
  }
  .gap-xl-350-px {
    gap: 350px !important;
  }
  .gap-xl-400-px {
    gap: 400px !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .row-gap-xl-5-px {
    row-gap: 5px !important;
  }
  .row-gap-xl-10-px {
    row-gap: 10px !important;
  }
  .row-gap-xl-20-px {
    row-gap: 20px !important;
  }
  .row-gap-xl-30-px {
    row-gap: 30px !important;
  }
  .row-gap-xl-35-px {
    row-gap: 35px !important;
  }
  .row-gap-xl-40-px {
    row-gap: 40px !important;
  }
  .row-gap-xl-45-px {
    row-gap: 45px !important;
  }
  .row-gap-xl-50-px {
    row-gap: 50px !important;
  }
  .row-gap-xl-60-px {
    row-gap: 60px !important;
  }
  .row-gap-xl-70-px {
    row-gap: 70px !important;
  }
  .row-gap-xl-80-px {
    row-gap: 80px !important;
  }
  .row-gap-xl-90-px {
    row-gap: 90px !important;
  }
  .row-gap-xl-100-px {
    row-gap: 100px !important;
  }
  .row-gap-xl-120-px {
    row-gap: 120px !important;
  }
  .row-gap-xl-125-px {
    row-gap: 125px !important;
  }
  .row-gap-xl-130-px {
    row-gap: 130px !important;
  }
  .row-gap-xl-150-px {
    row-gap: 150px !important;
  }
  .row-gap-xl-200-px {
    row-gap: 200px !important;
  }
  .row-gap-xl-250-px {
    row-gap: 250px !important;
  }
  .row-gap-xl-300-px {
    row-gap: 300px !important;
  }
  .row-gap-xl-350-px {
    row-gap: 350px !important;
  }
  .row-gap-xl-400-px {
    row-gap: 400px !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .column-gap-xl-5-px {
    column-gap: 5px !important;
  }
  .column-gap-xl-10-px {
    column-gap: 10px !important;
  }
  .column-gap-xl-20-px {
    column-gap: 20px !important;
  }
  .column-gap-xl-30-px {
    column-gap: 30px !important;
  }
  .column-gap-xl-35-px {
    column-gap: 35px !important;
  }
  .column-gap-xl-40-px {
    column-gap: 40px !important;
  }
  .column-gap-xl-45-px {
    column-gap: 45px !important;
  }
  .column-gap-xl-50-px {
    column-gap: 50px !important;
  }
  .column-gap-xl-60-px {
    column-gap: 60px !important;
  }
  .column-gap-xl-70-px {
    column-gap: 70px !important;
  }
  .column-gap-xl-80-px {
    column-gap: 80px !important;
  }
  .column-gap-xl-90-px {
    column-gap: 90px !important;
  }
  .column-gap-xl-100-px {
    column-gap: 100px !important;
  }
  .column-gap-xl-120-px {
    column-gap: 120px !important;
  }
  .column-gap-xl-125-px {
    column-gap: 125px !important;
  }
  .column-gap-xl-130-px {
    column-gap: 130px !important;
  }
  .column-gap-xl-150-px {
    column-gap: 150px !important;
  }
  .column-gap-xl-200-px {
    column-gap: 200px !important;
  }
  .column-gap-xl-250-px {
    column-gap: 250px !important;
  }
  .column-gap-xl-300-px {
    column-gap: 300px !important;
  }
  .column-gap-xl-350-px {
    column-gap: 350px !important;
  }
  .column-gap-xl-400-px {
    column-gap: 400px !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-5-px {
    margin: 5px !important;
  }
  .m-xxl-10-px {
    margin: 10px !important;
  }
  .m-xxl-20-px {
    margin: 20px !important;
  }
  .m-xxl-30-px {
    margin: 30px !important;
  }
  .m-xxl-35-px {
    margin: 35px !important;
  }
  .m-xxl-40-px {
    margin: 40px !important;
  }
  .m-xxl-45-px {
    margin: 45px !important;
  }
  .m-xxl-50-px {
    margin: 50px !important;
  }
  .m-xxl-60-px {
    margin: 60px !important;
  }
  .m-xxl-70-px {
    margin: 70px !important;
  }
  .m-xxl-80-px {
    margin: 80px !important;
  }
  .m-xxl-90-px {
    margin: 90px !important;
  }
  .m-xxl-100-px {
    margin: 100px !important;
  }
  .m-xxl-120-px {
    margin: 120px !important;
  }
  .m-xxl-125-px {
    margin: 125px !important;
  }
  .m-xxl-130-px {
    margin: 130px !important;
  }
  .m-xxl-150-px {
    margin: 150px !important;
  }
  .m-xxl-200-px {
    margin: 200px !important;
  }
  .m-xxl-250-px {
    margin: 250px !important;
  }
  .m-xxl-300-px {
    margin: 300px !important;
  }
  .m-xxl-350-px {
    margin: 350px !important;
  }
  .m-xxl-400-px {
    margin: 400px !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-5-px {
    margin-right: 5px !important;
    margin-left: 5px !important;
  }
  .mx-xxl-10-px {
    margin-right: 10px !important;
    margin-left: 10px !important;
  }
  .mx-xxl-20-px {
    margin-right: 20px !important;
    margin-left: 20px !important;
  }
  .mx-xxl-30-px {
    margin-right: 30px !important;
    margin-left: 30px !important;
  }
  .mx-xxl-35-px {
    margin-right: 35px !important;
    margin-left: 35px !important;
  }
  .mx-xxl-40-px {
    margin-right: 40px !important;
    margin-left: 40px !important;
  }
  .mx-xxl-45-px {
    margin-right: 45px !important;
    margin-left: 45px !important;
  }
  .mx-xxl-50-px {
    margin-right: 50px !important;
    margin-left: 50px !important;
  }
  .mx-xxl-60-px {
    margin-right: 60px !important;
    margin-left: 60px !important;
  }
  .mx-xxl-70-px {
    margin-right: 70px !important;
    margin-left: 70px !important;
  }
  .mx-xxl-80-px {
    margin-right: 80px !important;
    margin-left: 80px !important;
  }
  .mx-xxl-90-px {
    margin-right: 90px !important;
    margin-left: 90px !important;
  }
  .mx-xxl-100-px {
    margin-right: 100px !important;
    margin-left: 100px !important;
  }
  .mx-xxl-120-px {
    margin-right: 120px !important;
    margin-left: 120px !important;
  }
  .mx-xxl-125-px {
    margin-right: 125px !important;
    margin-left: 125px !important;
  }
  .mx-xxl-130-px {
    margin-right: 130px !important;
    margin-left: 130px !important;
  }
  .mx-xxl-150-px {
    margin-right: 150px !important;
    margin-left: 150px !important;
  }
  .mx-xxl-200-px {
    margin-right: 200px !important;
    margin-left: 200px !important;
  }
  .mx-xxl-250-px {
    margin-right: 250px !important;
    margin-left: 250px !important;
  }
  .mx-xxl-300-px {
    margin-right: 300px !important;
    margin-left: 300px !important;
  }
  .mx-xxl-350-px {
    margin-right: 350px !important;
    margin-left: 350px !important;
  }
  .mx-xxl-400-px {
    margin-right: 400px !important;
    margin-left: 400px !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-5-px {
    margin-top: 5px !important;
    margin-bottom: 5px !important;
  }
  .my-xxl-10-px {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .my-xxl-20-px {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .my-xxl-30-px {
    margin-top: 30px !important;
    margin-bottom: 30px !important;
  }
  .my-xxl-35-px {
    margin-top: 35px !important;
    margin-bottom: 35px !important;
  }
  .my-xxl-40-px {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .my-xxl-45-px {
    margin-top: 45px !important;
    margin-bottom: 45px !important;
  }
  .my-xxl-50-px {
    margin-top: 50px !important;
    margin-bottom: 50px !important;
  }
  .my-xxl-60-px {
    margin-top: 60px !important;
    margin-bottom: 60px !important;
  }
  .my-xxl-70-px {
    margin-top: 70px !important;
    margin-bottom: 70px !important;
  }
  .my-xxl-80-px {
    margin-top: 80px !important;
    margin-bottom: 80px !important;
  }
  .my-xxl-90-px {
    margin-top: 90px !important;
    margin-bottom: 90px !important;
  }
  .my-xxl-100-px {
    margin-top: 100px !important;
    margin-bottom: 100px !important;
  }
  .my-xxl-120-px {
    margin-top: 120px !important;
    margin-bottom: 120px !important;
  }
  .my-xxl-125-px {
    margin-top: 125px !important;
    margin-bottom: 125px !important;
  }
  .my-xxl-130-px {
    margin-top: 130px !important;
    margin-bottom: 130px !important;
  }
  .my-xxl-150-px {
    margin-top: 150px !important;
    margin-bottom: 150px !important;
  }
  .my-xxl-200-px {
    margin-top: 200px !important;
    margin-bottom: 200px !important;
  }
  .my-xxl-250-px {
    margin-top: 250px !important;
    margin-bottom: 250px !important;
  }
  .my-xxl-300-px {
    margin-top: 300px !important;
    margin-bottom: 300px !important;
  }
  .my-xxl-350-px {
    margin-top: 350px !important;
    margin-bottom: 350px !important;
  }
  .my-xxl-400-px {
    margin-top: 400px !important;
    margin-bottom: 400px !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-5-px {
    margin-top: 5px !important;
  }
  .mt-xxl-10-px {
    margin-top: 10px !important;
  }
  .mt-xxl-20-px {
    margin-top: 20px !important;
  }
  .mt-xxl-30-px {
    margin-top: 30px !important;
  }
  .mt-xxl-35-px {
    margin-top: 35px !important;
  }
  .mt-xxl-40-px {
    margin-top: 40px !important;
  }
  .mt-xxl-45-px {
    margin-top: 45px !important;
  }
  .mt-xxl-50-px {
    margin-top: 50px !important;
  }
  .mt-xxl-60-px {
    margin-top: 60px !important;
  }
  .mt-xxl-70-px {
    margin-top: 70px !important;
  }
  .mt-xxl-80-px {
    margin-top: 80px !important;
  }
  .mt-xxl-90-px {
    margin-top: 90px !important;
  }
  .mt-xxl-100-px {
    margin-top: 100px !important;
  }
  .mt-xxl-120-px {
    margin-top: 120px !important;
  }
  .mt-xxl-125-px {
    margin-top: 125px !important;
  }
  .mt-xxl-130-px {
    margin-top: 130px !important;
  }
  .mt-xxl-150-px {
    margin-top: 150px !important;
  }
  .mt-xxl-200-px {
    margin-top: 200px !important;
  }
  .mt-xxl-250-px {
    margin-top: 250px !important;
  }
  .mt-xxl-300-px {
    margin-top: 300px !important;
  }
  .mt-xxl-350-px {
    margin-top: 350px !important;
  }
  .mt-xxl-400-px {
    margin-top: 400px !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-5-px {
    margin-right: 5px !important;
  }
  .me-xxl-10-px {
    margin-right: 10px !important;
  }
  .me-xxl-20-px {
    margin-right: 20px !important;
  }
  .me-xxl-30-px {
    margin-right: 30px !important;
  }
  .me-xxl-35-px {
    margin-right: 35px !important;
  }
  .me-xxl-40-px {
    margin-right: 40px !important;
  }
  .me-xxl-45-px {
    margin-right: 45px !important;
  }
  .me-xxl-50-px {
    margin-right: 50px !important;
  }
  .me-xxl-60-px {
    margin-right: 60px !important;
  }
  .me-xxl-70-px {
    margin-right: 70px !important;
  }
  .me-xxl-80-px {
    margin-right: 80px !important;
  }
  .me-xxl-90-px {
    margin-right: 90px !important;
  }
  .me-xxl-100-px {
    margin-right: 100px !important;
  }
  .me-xxl-120-px {
    margin-right: 120px !important;
  }
  .me-xxl-125-px {
    margin-right: 125px !important;
  }
  .me-xxl-130-px {
    margin-right: 130px !important;
  }
  .me-xxl-150-px {
    margin-right: 150px !important;
  }
  .me-xxl-200-px {
    margin-right: 200px !important;
  }
  .me-xxl-250-px {
    margin-right: 250px !important;
  }
  .me-xxl-300-px {
    margin-right: 300px !important;
  }
  .me-xxl-350-px {
    margin-right: 350px !important;
  }
  .me-xxl-400-px {
    margin-right: 400px !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-5-px {
    margin-bottom: 5px !important;
  }
  .mb-xxl-10-px {
    margin-bottom: 10px !important;
  }
  .mb-xxl-20-px {
    margin-bottom: 20px !important;
  }
  .mb-xxl-30-px {
    margin-bottom: 30px !important;
  }
  .mb-xxl-35-px {
    margin-bottom: 35px !important;
  }
  .mb-xxl-40-px {
    margin-bottom: 40px !important;
  }
  .mb-xxl-45-px {
    margin-bottom: 45px !important;
  }
  .mb-xxl-50-px {
    margin-bottom: 50px !important;
  }
  .mb-xxl-60-px {
    margin-bottom: 60px !important;
  }
  .mb-xxl-70-px {
    margin-bottom: 70px !important;
  }
  .mb-xxl-80-px {
    margin-bottom: 80px !important;
  }
  .mb-xxl-90-px {
    margin-bottom: 90px !important;
  }
  .mb-xxl-100-px {
    margin-bottom: 100px !important;
  }
  .mb-xxl-120-px {
    margin-bottom: 120px !important;
  }
  .mb-xxl-125-px {
    margin-bottom: 125px !important;
  }
  .mb-xxl-130-px {
    margin-bottom: 130px !important;
  }
  .mb-xxl-150-px {
    margin-bottom: 150px !important;
  }
  .mb-xxl-200-px {
    margin-bottom: 200px !important;
  }
  .mb-xxl-250-px {
    margin-bottom: 250px !important;
  }
  .mb-xxl-300-px {
    margin-bottom: 300px !important;
  }
  .mb-xxl-350-px {
    margin-bottom: 350px !important;
  }
  .mb-xxl-400-px {
    margin-bottom: 400px !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-5-px {
    margin-left: 5px !important;
  }
  .ms-xxl-10-px {
    margin-left: 10px !important;
  }
  .ms-xxl-20-px {
    margin-left: 20px !important;
  }
  .ms-xxl-30-px {
    margin-left: 30px !important;
  }
  .ms-xxl-35-px {
    margin-left: 35px !important;
  }
  .ms-xxl-40-px {
    margin-left: 40px !important;
  }
  .ms-xxl-45-px {
    margin-left: 45px !important;
  }
  .ms-xxl-50-px {
    margin-left: 50px !important;
  }
  .ms-xxl-60-px {
    margin-left: 60px !important;
  }
  .ms-xxl-70-px {
    margin-left: 70px !important;
  }
  .ms-xxl-80-px {
    margin-left: 80px !important;
  }
  .ms-xxl-90-px {
    margin-left: 90px !important;
  }
  .ms-xxl-100-px {
    margin-left: 100px !important;
  }
  .ms-xxl-120-px {
    margin-left: 120px !important;
  }
  .ms-xxl-125-px {
    margin-left: 125px !important;
  }
  .ms-xxl-130-px {
    margin-left: 130px !important;
  }
  .ms-xxl-150-px {
    margin-left: 150px !important;
  }
  .ms-xxl-200-px {
    margin-left: 200px !important;
  }
  .ms-xxl-250-px {
    margin-left: 250px !important;
  }
  .ms-xxl-300-px {
    margin-left: 300px !important;
  }
  .ms-xxl-350-px {
    margin-left: 350px !important;
  }
  .ms-xxl-400-px {
    margin-left: 400px !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .m-xxl-n5-px {
    margin: -5px !important;
  }
  .m-xxl-n10-px {
    margin: -10px !important;
  }
  .m-xxl-n20-px {
    margin: -20px !important;
  }
  .m-xxl-n30-px {
    margin: -30px !important;
  }
  .m-xxl-n35-px {
    margin: -35px !important;
  }
  .m-xxl-n40-px {
    margin: -40px !important;
  }
  .m-xxl-n45-px {
    margin: -45px !important;
  }
  .m-xxl-n50-px {
    margin: -50px !important;
  }
  .m-xxl-n60-px {
    margin: -60px !important;
  }
  .m-xxl-n70-px {
    margin: -70px !important;
  }
  .m-xxl-n80-px {
    margin: -80px !important;
  }
  .m-xxl-n90-px {
    margin: -90px !important;
  }
  .m-xxl-n100-px {
    margin: -100px !important;
  }
  .m-xxl-n120-px {
    margin: -120px !important;
  }
  .m-xxl-n125-px {
    margin: -125px !important;
  }
  .m-xxl-n130-px {
    margin: -130px !important;
  }
  .m-xxl-n150-px {
    margin: -150px !important;
  }
  .m-xxl-n200-px {
    margin: -200px !important;
  }
  .m-xxl-n250-px {
    margin: -250px !important;
  }
  .m-xxl-n300-px {
    margin: -300px !important;
  }
  .m-xxl-n350-px {
    margin: -350px !important;
  }
  .m-xxl-n400-px {
    margin: -400px !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .mx-xxl-n5-px {
    margin-right: -5px !important;
    margin-left: -5px !important;
  }
  .mx-xxl-n10-px {
    margin-right: -10px !important;
    margin-left: -10px !important;
  }
  .mx-xxl-n20-px {
    margin-right: -20px !important;
    margin-left: -20px !important;
  }
  .mx-xxl-n30-px {
    margin-right: -30px !important;
    margin-left: -30px !important;
  }
  .mx-xxl-n35-px {
    margin-right: -35px !important;
    margin-left: -35px !important;
  }
  .mx-xxl-n40-px {
    margin-right: -40px !important;
    margin-left: -40px !important;
  }
  .mx-xxl-n45-px {
    margin-right: -45px !important;
    margin-left: -45px !important;
  }
  .mx-xxl-n50-px {
    margin-right: -50px !important;
    margin-left: -50px !important;
  }
  .mx-xxl-n60-px {
    margin-right: -60px !important;
    margin-left: -60px !important;
  }
  .mx-xxl-n70-px {
    margin-right: -70px !important;
    margin-left: -70px !important;
  }
  .mx-xxl-n80-px {
    margin-right: -80px !important;
    margin-left: -80px !important;
  }
  .mx-xxl-n90-px {
    margin-right: -90px !important;
    margin-left: -90px !important;
  }
  .mx-xxl-n100-px {
    margin-right: -100px !important;
    margin-left: -100px !important;
  }
  .mx-xxl-n120-px {
    margin-right: -120px !important;
    margin-left: -120px !important;
  }
  .mx-xxl-n125-px {
    margin-right: -125px !important;
    margin-left: -125px !important;
  }
  .mx-xxl-n130-px {
    margin-right: -130px !important;
    margin-left: -130px !important;
  }
  .mx-xxl-n150-px {
    margin-right: -150px !important;
    margin-left: -150px !important;
  }
  .mx-xxl-n200-px {
    margin-right: -200px !important;
    margin-left: -200px !important;
  }
  .mx-xxl-n250-px {
    margin-right: -250px !important;
    margin-left: -250px !important;
  }
  .mx-xxl-n300-px {
    margin-right: -300px !important;
    margin-left: -300px !important;
  }
  .mx-xxl-n350-px {
    margin-right: -350px !important;
    margin-left: -350px !important;
  }
  .mx-xxl-n400-px {
    margin-right: -400px !important;
    margin-left: -400px !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .my-xxl-n5-px {
    margin-top: -5px !important;
    margin-bottom: -5px !important;
  }
  .my-xxl-n10-px {
    margin-top: -10px !important;
    margin-bottom: -10px !important;
  }
  .my-xxl-n20-px {
    margin-top: -20px !important;
    margin-bottom: -20px !important;
  }
  .my-xxl-n30-px {
    margin-top: -30px !important;
    margin-bottom: -30px !important;
  }
  .my-xxl-n35-px {
    margin-top: -35px !important;
    margin-bottom: -35px !important;
  }
  .my-xxl-n40-px {
    margin-top: -40px !important;
    margin-bottom: -40px !important;
  }
  .my-xxl-n45-px {
    margin-top: -45px !important;
    margin-bottom: -45px !important;
  }
  .my-xxl-n50-px {
    margin-top: -50px !important;
    margin-bottom: -50px !important;
  }
  .my-xxl-n60-px {
    margin-top: -60px !important;
    margin-bottom: -60px !important;
  }
  .my-xxl-n70-px {
    margin-top: -70px !important;
    margin-bottom: -70px !important;
  }
  .my-xxl-n80-px {
    margin-top: -80px !important;
    margin-bottom: -80px !important;
  }
  .my-xxl-n90-px {
    margin-top: -90px !important;
    margin-bottom: -90px !important;
  }
  .my-xxl-n100-px {
    margin-top: -100px !important;
    margin-bottom: -100px !important;
  }
  .my-xxl-n120-px {
    margin-top: -120px !important;
    margin-bottom: -120px !important;
  }
  .my-xxl-n125-px {
    margin-top: -125px !important;
    margin-bottom: -125px !important;
  }
  .my-xxl-n130-px {
    margin-top: -130px !important;
    margin-bottom: -130px !important;
  }
  .my-xxl-n150-px {
    margin-top: -150px !important;
    margin-bottom: -150px !important;
  }
  .my-xxl-n200-px {
    margin-top: -200px !important;
    margin-bottom: -200px !important;
  }
  .my-xxl-n250-px {
    margin-top: -250px !important;
    margin-bottom: -250px !important;
  }
  .my-xxl-n300-px {
    margin-top: -300px !important;
    margin-bottom: -300px !important;
  }
  .my-xxl-n350-px {
    margin-top: -350px !important;
    margin-bottom: -350px !important;
  }
  .my-xxl-n400-px {
    margin-top: -400px !important;
    margin-bottom: -400px !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .mt-xxl-n5-px {
    margin-top: -5px !important;
  }
  .mt-xxl-n10-px {
    margin-top: -10px !important;
  }
  .mt-xxl-n20-px {
    margin-top: -20px !important;
  }
  .mt-xxl-n30-px {
    margin-top: -30px !important;
  }
  .mt-xxl-n35-px {
    margin-top: -35px !important;
  }
  .mt-xxl-n40-px {
    margin-top: -40px !important;
  }
  .mt-xxl-n45-px {
    margin-top: -45px !important;
  }
  .mt-xxl-n50-px {
    margin-top: -50px !important;
  }
  .mt-xxl-n60-px {
    margin-top: -60px !important;
  }
  .mt-xxl-n70-px {
    margin-top: -70px !important;
  }
  .mt-xxl-n80-px {
    margin-top: -80px !important;
  }
  .mt-xxl-n90-px {
    margin-top: -90px !important;
  }
  .mt-xxl-n100-px {
    margin-top: -100px !important;
  }
  .mt-xxl-n120-px {
    margin-top: -120px !important;
  }
  .mt-xxl-n125-px {
    margin-top: -125px !important;
  }
  .mt-xxl-n130-px {
    margin-top: -130px !important;
  }
  .mt-xxl-n150-px {
    margin-top: -150px !important;
  }
  .mt-xxl-n200-px {
    margin-top: -200px !important;
  }
  .mt-xxl-n250-px {
    margin-top: -250px !important;
  }
  .mt-xxl-n300-px {
    margin-top: -300px !important;
  }
  .mt-xxl-n350-px {
    margin-top: -350px !important;
  }
  .mt-xxl-n400-px {
    margin-top: -400px !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .me-xxl-n5-px {
    margin-right: -5px !important;
  }
  .me-xxl-n10-px {
    margin-right: -10px !important;
  }
  .me-xxl-n20-px {
    margin-right: -20px !important;
  }
  .me-xxl-n30-px {
    margin-right: -30px !important;
  }
  .me-xxl-n35-px {
    margin-right: -35px !important;
  }
  .me-xxl-n40-px {
    margin-right: -40px !important;
  }
  .me-xxl-n45-px {
    margin-right: -45px !important;
  }
  .me-xxl-n50-px {
    margin-right: -50px !important;
  }
  .me-xxl-n60-px {
    margin-right: -60px !important;
  }
  .me-xxl-n70-px {
    margin-right: -70px !important;
  }
  .me-xxl-n80-px {
    margin-right: -80px !important;
  }
  .me-xxl-n90-px {
    margin-right: -90px !important;
  }
  .me-xxl-n100-px {
    margin-right: -100px !important;
  }
  .me-xxl-n120-px {
    margin-right: -120px !important;
  }
  .me-xxl-n125-px {
    margin-right: -125px !important;
  }
  .me-xxl-n130-px {
    margin-right: -130px !important;
  }
  .me-xxl-n150-px {
    margin-right: -150px !important;
  }
  .me-xxl-n200-px {
    margin-right: -200px !important;
  }
  .me-xxl-n250-px {
    margin-right: -250px !important;
  }
  .me-xxl-n300-px {
    margin-right: -300px !important;
  }
  .me-xxl-n350-px {
    margin-right: -350px !important;
  }
  .me-xxl-n400-px {
    margin-right: -400px !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .mb-xxl-n5-px {
    margin-bottom: -5px !important;
  }
  .mb-xxl-n10-px {
    margin-bottom: -10px !important;
  }
  .mb-xxl-n20-px {
    margin-bottom: -20px !important;
  }
  .mb-xxl-n30-px {
    margin-bottom: -30px !important;
  }
  .mb-xxl-n35-px {
    margin-bottom: -35px !important;
  }
  .mb-xxl-n40-px {
    margin-bottom: -40px !important;
  }
  .mb-xxl-n45-px {
    margin-bottom: -45px !important;
  }
  .mb-xxl-n50-px {
    margin-bottom: -50px !important;
  }
  .mb-xxl-n60-px {
    margin-bottom: -60px !important;
  }
  .mb-xxl-n70-px {
    margin-bottom: -70px !important;
  }
  .mb-xxl-n80-px {
    margin-bottom: -80px !important;
  }
  .mb-xxl-n90-px {
    margin-bottom: -90px !important;
  }
  .mb-xxl-n100-px {
    margin-bottom: -100px !important;
  }
  .mb-xxl-n120-px {
    margin-bottom: -120px !important;
  }
  .mb-xxl-n125-px {
    margin-bottom: -125px !important;
  }
  .mb-xxl-n130-px {
    margin-bottom: -130px !important;
  }
  .mb-xxl-n150-px {
    margin-bottom: -150px !important;
  }
  .mb-xxl-n200-px {
    margin-bottom: -200px !important;
  }
  .mb-xxl-n250-px {
    margin-bottom: -250px !important;
  }
  .mb-xxl-n300-px {
    margin-bottom: -300px !important;
  }
  .mb-xxl-n350-px {
    margin-bottom: -350px !important;
  }
  .mb-xxl-n400-px {
    margin-bottom: -400px !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .ms-xxl-n5-px {
    margin-left: -5px !important;
  }
  .ms-xxl-n10-px {
    margin-left: -10px !important;
  }
  .ms-xxl-n20-px {
    margin-left: -20px !important;
  }
  .ms-xxl-n30-px {
    margin-left: -30px !important;
  }
  .ms-xxl-n35-px {
    margin-left: -35px !important;
  }
  .ms-xxl-n40-px {
    margin-left: -40px !important;
  }
  .ms-xxl-n45-px {
    margin-left: -45px !important;
  }
  .ms-xxl-n50-px {
    margin-left: -50px !important;
  }
  .ms-xxl-n60-px {
    margin-left: -60px !important;
  }
  .ms-xxl-n70-px {
    margin-left: -70px !important;
  }
  .ms-xxl-n80-px {
    margin-left: -80px !important;
  }
  .ms-xxl-n90-px {
    margin-left: -90px !important;
  }
  .ms-xxl-n100-px {
    margin-left: -100px !important;
  }
  .ms-xxl-n120-px {
    margin-left: -120px !important;
  }
  .ms-xxl-n125-px {
    margin-left: -125px !important;
  }
  .ms-xxl-n130-px {
    margin-left: -130px !important;
  }
  .ms-xxl-n150-px {
    margin-left: -150px !important;
  }
  .ms-xxl-n200-px {
    margin-left: -200px !important;
  }
  .ms-xxl-n250-px {
    margin-left: -250px !important;
  }
  .ms-xxl-n300-px {
    margin-left: -300px !important;
  }
  .ms-xxl-n350-px {
    margin-left: -350px !important;
  }
  .ms-xxl-n400-px {
    margin-left: -400px !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .p-xxl-5-px {
    padding: 5px !important;
  }
  .p-xxl-10-px {
    padding: 10px !important;
  }
  .p-xxl-20-px {
    padding: 20px !important;
  }
  .p-xxl-30-px {
    padding: 30px !important;
  }
  .p-xxl-35-px {
    padding: 35px !important;
  }
  .p-xxl-40-px {
    padding: 40px !important;
  }
  .p-xxl-45-px {
    padding: 45px !important;
  }
  .p-xxl-50-px {
    padding: 50px !important;
  }
  .p-xxl-60-px {
    padding: 60px !important;
  }
  .p-xxl-70-px {
    padding: 70px !important;
  }
  .p-xxl-80-px {
    padding: 80px !important;
  }
  .p-xxl-90-px {
    padding: 90px !important;
  }
  .p-xxl-100-px {
    padding: 100px !important;
  }
  .p-xxl-120-px {
    padding: 120px !important;
  }
  .p-xxl-125-px {
    padding: 125px !important;
  }
  .p-xxl-130-px {
    padding: 130px !important;
  }
  .p-xxl-150-px {
    padding: 150px !important;
  }
  .p-xxl-200-px {
    padding: 200px !important;
  }
  .p-xxl-250-px {
    padding: 250px !important;
  }
  .p-xxl-300-px {
    padding: 300px !important;
  }
  .p-xxl-350-px {
    padding: 350px !important;
  }
  .p-xxl-400-px {
    padding: 400px !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .px-xxl-5-px {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }
  .px-xxl-10-px {
    padding-right: 10px !important;
    padding-left: 10px !important;
  }
  .px-xxl-20-px {
    padding-right: 20px !important;
    padding-left: 20px !important;
  }
  .px-xxl-30-px {
    padding-right: 30px !important;
    padding-left: 30px !important;
  }
  .px-xxl-35-px {
    padding-right: 35px !important;
    padding-left: 35px !important;
  }
  .px-xxl-40-px {
    padding-right: 40px !important;
    padding-left: 40px !important;
  }
  .px-xxl-45-px {
    padding-right: 45px !important;
    padding-left: 45px !important;
  }
  .px-xxl-50-px {
    padding-right: 50px !important;
    padding-left: 50px !important;
  }
  .px-xxl-60-px {
    padding-right: 60px !important;
    padding-left: 60px !important;
  }
  .px-xxl-70-px {
    padding-right: 70px !important;
    padding-left: 70px !important;
  }
  .px-xxl-80-px {
    padding-right: 80px !important;
    padding-left: 80px !important;
  }
  .px-xxl-90-px {
    padding-right: 90px !important;
    padding-left: 90px !important;
  }
  .px-xxl-100-px {
    padding-right: 100px !important;
    padding-left: 100px !important;
  }
  .px-xxl-120-px {
    padding-right: 120px !important;
    padding-left: 120px !important;
  }
  .px-xxl-125-px {
    padding-right: 125px !important;
    padding-left: 125px !important;
  }
  .px-xxl-130-px {
    padding-right: 130px !important;
    padding-left: 130px !important;
  }
  .px-xxl-150-px {
    padding-right: 150px !important;
    padding-left: 150px !important;
  }
  .px-xxl-200-px {
    padding-right: 200px !important;
    padding-left: 200px !important;
  }
  .px-xxl-250-px {
    padding-right: 250px !important;
    padding-left: 250px !important;
  }
  .px-xxl-300-px {
    padding-right: 300px !important;
    padding-left: 300px !important;
  }
  .px-xxl-350-px {
    padding-right: 350px !important;
    padding-left: 350px !important;
  }
  .px-xxl-400-px {
    padding-right: 400px !important;
    padding-left: 400px !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .py-xxl-5-px {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
  }
  .py-xxl-10-px {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .py-xxl-20-px {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .py-xxl-30-px {
    padding-top: 30px !important;
    padding-bottom: 30px !important;
  }
  .py-xxl-35-px {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .py-xxl-40-px {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .py-xxl-45-px {
    padding-top: 45px !important;
    padding-bottom: 45px !important;
  }
  .py-xxl-50-px {
    padding-top: 50px !important;
    padding-bottom: 50px !important;
  }
  .py-xxl-60-px {
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
  .py-xxl-70-px {
    padding-top: 70px !important;
    padding-bottom: 70px !important;
  }
  .py-xxl-80-px {
    padding-top: 80px !important;
    padding-bottom: 80px !important;
  }
  .py-xxl-90-px {
    padding-top: 90px !important;
    padding-bottom: 90px !important;
  }
  .py-xxl-100-px {
    padding-top: 100px !important;
    padding-bottom: 100px !important;
  }
  .py-xxl-120-px {
    padding-top: 120px !important;
    padding-bottom: 120px !important;
  }
  .py-xxl-125-px {
    padding-top: 125px !important;
    padding-bottom: 125px !important;
  }
  .py-xxl-130-px {
    padding-top: 130px !important;
    padding-bottom: 130px !important;
  }
  .py-xxl-150-px {
    padding-top: 150px !important;
    padding-bottom: 150px !important;
  }
  .py-xxl-200-px {
    padding-top: 200px !important;
    padding-bottom: 200px !important;
  }
  .py-xxl-250-px {
    padding-top: 250px !important;
    padding-bottom: 250px !important;
  }
  .py-xxl-300-px {
    padding-top: 300px !important;
    padding-bottom: 300px !important;
  }
  .py-xxl-350-px {
    padding-top: 350px !important;
    padding-bottom: 350px !important;
  }
  .py-xxl-400-px {
    padding-top: 400px !important;
    padding-bottom: 400px !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pt-xxl-5-px {
    padding-top: 5px !important;
  }
  .pt-xxl-10-px {
    padding-top: 10px !important;
  }
  .pt-xxl-20-px {
    padding-top: 20px !important;
  }
  .pt-xxl-30-px {
    padding-top: 30px !important;
  }
  .pt-xxl-35-px {
    padding-top: 35px !important;
  }
  .pt-xxl-40-px {
    padding-top: 40px !important;
  }
  .pt-xxl-45-px {
    padding-top: 45px !important;
  }
  .pt-xxl-50-px {
    padding-top: 50px !important;
  }
  .pt-xxl-60-px {
    padding-top: 60px !important;
  }
  .pt-xxl-70-px {
    padding-top: 70px !important;
  }
  .pt-xxl-80-px {
    padding-top: 80px !important;
  }
  .pt-xxl-90-px {
    padding-top: 90px !important;
  }
  .pt-xxl-100-px {
    padding-top: 100px !important;
  }
  .pt-xxl-120-px {
    padding-top: 120px !important;
  }
  .pt-xxl-125-px {
    padding-top: 125px !important;
  }
  .pt-xxl-130-px {
    padding-top: 130px !important;
  }
  .pt-xxl-150-px {
    padding-top: 150px !important;
  }
  .pt-xxl-200-px {
    padding-top: 200px !important;
  }
  .pt-xxl-250-px {
    padding-top: 250px !important;
  }
  .pt-xxl-300-px {
    padding-top: 300px !important;
  }
  .pt-xxl-350-px {
    padding-top: 350px !important;
  }
  .pt-xxl-400-px {
    padding-top: 400px !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pe-xxl-5-px {
    padding-right: 5px !important;
  }
  .pe-xxl-10-px {
    padding-right: 10px !important;
  }
  .pe-xxl-20-px {
    padding-right: 20px !important;
  }
  .pe-xxl-30-px {
    padding-right: 30px !important;
  }
  .pe-xxl-35-px {
    padding-right: 35px !important;
  }
  .pe-xxl-40-px {
    padding-right: 40px !important;
  }
  .pe-xxl-45-px {
    padding-right: 45px !important;
  }
  .pe-xxl-50-px {
    padding-right: 50px !important;
  }
  .pe-xxl-60-px {
    padding-right: 60px !important;
  }
  .pe-xxl-70-px {
    padding-right: 70px !important;
  }
  .pe-xxl-80-px {
    padding-right: 80px !important;
  }
  .pe-xxl-90-px {
    padding-right: 90px !important;
  }
  .pe-xxl-100-px {
    padding-right: 100px !important;
  }
  .pe-xxl-120-px {
    padding-right: 120px !important;
  }
  .pe-xxl-125-px {
    padding-right: 125px !important;
  }
  .pe-xxl-130-px {
    padding-right: 130px !important;
  }
  .pe-xxl-150-px {
    padding-right: 150px !important;
  }
  .pe-xxl-200-px {
    padding-right: 200px !important;
  }
  .pe-xxl-250-px {
    padding-right: 250px !important;
  }
  .pe-xxl-300-px {
    padding-right: 300px !important;
  }
  .pe-xxl-350-px {
    padding-right: 350px !important;
  }
  .pe-xxl-400-px {
    padding-right: 400px !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .pb-xxl-5-px {
    padding-bottom: 5px !important;
  }
  .pb-xxl-10-px {
    padding-bottom: 10px !important;
  }
  .pb-xxl-20-px {
    padding-bottom: 20px !important;
  }
  .pb-xxl-30-px {
    padding-bottom: 30px !important;
  }
  .pb-xxl-35-px {
    padding-bottom: 35px !important;
  }
  .pb-xxl-40-px {
    padding-bottom: 40px !important;
  }
  .pb-xxl-45-px {
    padding-bottom: 45px !important;
  }
  .pb-xxl-50-px {
    padding-bottom: 50px !important;
  }
  .pb-xxl-60-px {
    padding-bottom: 60px !important;
  }
  .pb-xxl-70-px {
    padding-bottom: 70px !important;
  }
  .pb-xxl-80-px {
    padding-bottom: 80px !important;
  }
  .pb-xxl-90-px {
    padding-bottom: 90px !important;
  }
  .pb-xxl-100-px {
    padding-bottom: 100px !important;
  }
  .pb-xxl-120-px {
    padding-bottom: 120px !important;
  }
  .pb-xxl-125-px {
    padding-bottom: 125px !important;
  }
  .pb-xxl-130-px {
    padding-bottom: 130px !important;
  }
  .pb-xxl-150-px {
    padding-bottom: 150px !important;
  }
  .pb-xxl-200-px {
    padding-bottom: 200px !important;
  }
  .pb-xxl-250-px {
    padding-bottom: 250px !important;
  }
  .pb-xxl-300-px {
    padding-bottom: 300px !important;
  }
  .pb-xxl-350-px {
    padding-bottom: 350px !important;
  }
  .pb-xxl-400-px {
    padding-bottom: 400px !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .ps-xxl-5-px {
    padding-left: 5px !important;
  }
  .ps-xxl-10-px {
    padding-left: 10px !important;
  }
  .ps-xxl-20-px {
    padding-left: 20px !important;
  }
  .ps-xxl-30-px {
    padding-left: 30px !important;
  }
  .ps-xxl-35-px {
    padding-left: 35px !important;
  }
  .ps-xxl-40-px {
    padding-left: 40px !important;
  }
  .ps-xxl-45-px {
    padding-left: 45px !important;
  }
  .ps-xxl-50-px {
    padding-left: 50px !important;
  }
  .ps-xxl-60-px {
    padding-left: 60px !important;
  }
  .ps-xxl-70-px {
    padding-left: 70px !important;
  }
  .ps-xxl-80-px {
    padding-left: 80px !important;
  }
  .ps-xxl-90-px {
    padding-left: 90px !important;
  }
  .ps-xxl-100-px {
    padding-left: 100px !important;
  }
  .ps-xxl-120-px {
    padding-left: 120px !important;
  }
  .ps-xxl-125-px {
    padding-left: 125px !important;
  }
  .ps-xxl-130-px {
    padding-left: 130px !important;
  }
  .ps-xxl-150-px {
    padding-left: 150px !important;
  }
  .ps-xxl-200-px {
    padding-left: 200px !important;
  }
  .ps-xxl-250-px {
    padding-left: 250px !important;
  }
  .ps-xxl-300-px {
    padding-left: 300px !important;
  }
  .ps-xxl-350-px {
    padding-left: 350px !important;
  }
  .ps-xxl-400-px {
    padding-left: 400px !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .gap-xxl-5-px {
    gap: 5px !important;
  }
  .gap-xxl-10-px {
    gap: 10px !important;
  }
  .gap-xxl-20-px {
    gap: 20px !important;
  }
  .gap-xxl-30-px {
    gap: 30px !important;
  }
  .gap-xxl-35-px {
    gap: 35px !important;
  }
  .gap-xxl-40-px {
    gap: 40px !important;
  }
  .gap-xxl-45-px {
    gap: 45px !important;
  }
  .gap-xxl-50-px {
    gap: 50px !important;
  }
  .gap-xxl-60-px {
    gap: 60px !important;
  }
  .gap-xxl-70-px {
    gap: 70px !important;
  }
  .gap-xxl-80-px {
    gap: 80px !important;
  }
  .gap-xxl-90-px {
    gap: 90px !important;
  }
  .gap-xxl-100-px {
    gap: 100px !important;
  }
  .gap-xxl-120-px {
    gap: 120px !important;
  }
  .gap-xxl-125-px {
    gap: 125px !important;
  }
  .gap-xxl-130-px {
    gap: 130px !important;
  }
  .gap-xxl-150-px {
    gap: 150px !important;
  }
  .gap-xxl-200-px {
    gap: 200px !important;
  }
  .gap-xxl-250-px {
    gap: 250px !important;
  }
  .gap-xxl-300-px {
    gap: 300px !important;
  }
  .gap-xxl-350-px {
    gap: 350px !important;
  }
  .gap-xxl-400-px {
    gap: 400px !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .row-gap-xxl-5-px {
    row-gap: 5px !important;
  }
  .row-gap-xxl-10-px {
    row-gap: 10px !important;
  }
  .row-gap-xxl-20-px {
    row-gap: 20px !important;
  }
  .row-gap-xxl-30-px {
    row-gap: 30px !important;
  }
  .row-gap-xxl-35-px {
    row-gap: 35px !important;
  }
  .row-gap-xxl-40-px {
    row-gap: 40px !important;
  }
  .row-gap-xxl-45-px {
    row-gap: 45px !important;
  }
  .row-gap-xxl-50-px {
    row-gap: 50px !important;
  }
  .row-gap-xxl-60-px {
    row-gap: 60px !important;
  }
  .row-gap-xxl-70-px {
    row-gap: 70px !important;
  }
  .row-gap-xxl-80-px {
    row-gap: 80px !important;
  }
  .row-gap-xxl-90-px {
    row-gap: 90px !important;
  }
  .row-gap-xxl-100-px {
    row-gap: 100px !important;
  }
  .row-gap-xxl-120-px {
    row-gap: 120px !important;
  }
  .row-gap-xxl-125-px {
    row-gap: 125px !important;
  }
  .row-gap-xxl-130-px {
    row-gap: 130px !important;
  }
  .row-gap-xxl-150-px {
    row-gap: 150px !important;
  }
  .row-gap-xxl-200-px {
    row-gap: 200px !important;
  }
  .row-gap-xxl-250-px {
    row-gap: 250px !important;
  }
  .row-gap-xxl-300-px {
    row-gap: 300px !important;
  }
  .row-gap-xxl-350-px {
    row-gap: 350px !important;
  }
  .row-gap-xxl-400-px {
    row-gap: 400px !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .column-gap-xxl-5-px {
    column-gap: 5px !important;
  }
  .column-gap-xxl-10-px {
    column-gap: 10px !important;
  }
  .column-gap-xxl-20-px {
    column-gap: 20px !important;
  }
  .column-gap-xxl-30-px {
    column-gap: 30px !important;
  }
  .column-gap-xxl-35-px {
    column-gap: 35px !important;
  }
  .column-gap-xxl-40-px {
    column-gap: 40px !important;
  }
  .column-gap-xxl-45-px {
    column-gap: 45px !important;
  }
  .column-gap-xxl-50-px {
    column-gap: 50px !important;
  }
  .column-gap-xxl-60-px {
    column-gap: 60px !important;
  }
  .column-gap-xxl-70-px {
    column-gap: 70px !important;
  }
  .column-gap-xxl-80-px {
    column-gap: 80px !important;
  }
  .column-gap-xxl-90-px {
    column-gap: 90px !important;
  }
  .column-gap-xxl-100-px {
    column-gap: 100px !important;
  }
  .column-gap-xxl-120-px {
    column-gap: 120px !important;
  }
  .column-gap-xxl-125-px {
    column-gap: 125px !important;
  }
  .column-gap-xxl-130-px {
    column-gap: 130px !important;
  }
  .column-gap-xxl-150-px {
    column-gap: 150px !important;
  }
  .column-gap-xxl-200-px {
    column-gap: 200px !important;
  }
  .column-gap-xxl-250-px {
    column-gap: 250px !important;
  }
  .column-gap-xxl-300-px {
    column-gap: 300px !important;
  }
  .column-gap-xxl-350-px {
    column-gap: 350px !important;
  }
  .column-gap-xxl-400-px {
    column-gap: 400px !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
p {
  margin: 0;
}

.w-29 {
  width: 29%;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/bootstrap/index.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./src/assets/scss/bootstrap/spacer.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,0BAAA;EAAA,6BAAA;EAAA,sBAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,8BAAA;EACA,sCAAA;EAMA,wBAAA;EACA,0BAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFFF;;AI7GI;EFqHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,yBAAA;EACA,gCAAA;EAGE,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,+BAAA;EAAA,iCAAA;EAAA,+BAAA;EAAA,4BAAA;EAAA,+BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,mCAAA;EAAA,qCAAA;EAAA,mCAAA;EAAA,gCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,wCAAA;EAEA,wBAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFFJ;;AKnKA;;;EAGE,sBAAA;ALsKF;;AKvJI;EANJ;IAOM,uBAAA;EL2JJ;AACF;;AK9IA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ALiJF;;AKxIA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AN9e9B;;AKjIA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ALkIF;;AK/HA;EFuMQ,iCAAA;AHpER;AGxFI;EE3CJ;IF8MQ,iBAAA;EHvEN;AACF;;AKnIA;EFkMQ,iCAAA;AH3DR;AGjGI;EEtCJ;IFyMQ,eAAA;EH9DN;AACF;;AKvIA;EF6LQ,+BAAA;AHlDR;AG1GI;EEjCJ;IFoMQ,kBAAA;EHrDN;AACF;;AK3IA;EFwLQ,iCAAA;AHzCR;AGnHI;EE5BJ;IF+LQ,iBAAA;EH5CN;AACF;;AK/IA;EF+KM,kBALI;AHvBV;;AK9IA;EF0KM,eALI;AHnBV;;AKvIA;EACE,aAAA;EACA,mBCwV0B;AN9M5B;;AKhIA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;ALmIF;;AK7HA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALgIF;;AK1HA;;EAEE,kBAAA;AL6HF;;AK1HA;;;EAGE,aAAA;EACA,mBAAA;AL6HF;;AK1HA;;;;EAIE,gBAAA;AL6HF;;AK1HA;EACE,gBC6b4B;ANhU9B;;AKxHA;EACE,qBAAA;EACA,cAAA;AL2HF;;AKrHA;EACE,gBAAA;ALwHF;;AKhHA;;EAEE,mBCsa4B;ANnT9B;;AK3GA;EF6EM,kBALI;AHuCV;;AKxGA;EACE,iBCqf4B;EDpf5B,wCAAA;AL2GF;;AKlGA;;EAEE,kBAAA;EFyDI,iBALI;EElDR,cAAA;EACA,wBAAA;ALqGF;;AKlGA;EAAM,eAAA;ALsGN;;AKrGA;EAAM,WAAA;ALyGN;;AKpGA;EACE,gEAAA;EACA,0BCiNwC;AN1G1C;AKrGE;EACE,mDAAA;ALuGJ;;AK5FE;EAEE,cAAA;EACA,qBAAA;AL8FJ;;AKvFA;;;;EAIE,qCCiV4B;EHlUxB,cALI;AHiFV;;AKnFA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFGI,kBALI;AHyFV;AKlFE;EFFI,kBALI;EESN,cAAA;EACA,kBAAA;ALoFJ;;AKhFA;EFTM,kBALI;EEgBR,2BAAA;EACA,qBAAA;ALmFF;AKhFE;EACE,cAAA;ALkFJ;;AK9EA;EACE,2BAAA;EFrBI,kBALI;EE4BR,wBCs5CkC;EDr5ClC,sCCs5CkC;EC1rDhC,sBAAA;APsXJ;AK/EE;EACE,UAAA;EF5BE,cALI;AHmHV;;AKvEA;EACE,gBAAA;AL0EF;;AKpEA;;EAEE,sBAAA;ALuEF;;AK/DA;EACE,oBAAA;EACA,yBAAA;ALkEF;;AK/DA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ALkEF;;AK3DA;EAEE,mBAAA;EACA,gCAAA;AL6DF;;AK1DA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AL6DF;;AKrDA;EACE,qBAAA;ALwDF;;AKlDA;EAEE,gBAAA;ALoDF;;AK5CA;EACE,UAAA;AL+CF;;AK1CA;;;;;EAKE,SAAA;EACA,oBAAA;EF3HI,kBALI;EEkIR,oBAAA;AL6CF;;AKzCA;;EAEE,oBAAA;AL4CF;;AKvCA;EACE,eAAA;AL0CF;;AKvCA;EAGE,iBAAA;ALwCF;AKrCE;EACE,UAAA;ALuCJ;;AKhCA;EACE,wBAAA;ALmCF;;AK3BA;;;;EAIE,0BAAA;AL8BF;AK3BI;;;;EACE,eAAA;ALgCN;;AKzBA;EACE,UAAA;EACA,kBAAA;AL4BF;;AKvBA;EACE,gBAAA;AL0BF;;AKhBA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALmBF;;AKXA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCoN4B;EHpatB,iCAAA;EEmNN,oBAAA;ALaF;AG5XI;EEwWJ;IFrMQ,iBAAA;EH6NN;AACF;AKhBE;EACE,WAAA;ALkBJ;;AKXA;;;;;;;EAOE,UAAA;ALcF;;AKXA;EACE,YAAA;ALcF;;AKLA;EACE,6BAAA;EACA,oBAAA;ALQF;;AKAA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALAF;;AKKA;EACE,UAAA;ALFF;;AKSA;EACE,aAAA;EACA,0BAAA;ALNF;;AKWA;EACE,qBAAA;ALRF;;AKaA;EACE,SAAA;ALVF;;AKiBA;EACE,kBAAA;EACA,eAAA;ALdF;;AKsBA;EACE,wBAAA;ALnBF;;AK2BA;EACE,wBAAA;ALxBF;;AQ5iBA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANzF9B;;AQ1iBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AN7D9B;AG5cI;EKpGF;ILuQM,eAAA;EH6SN;AACF;;AQrjBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANlD9B;AGvdI;EKpGF;ILuQM,iBAAA;EHwTN;AACF;;AQhkBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANvC9B;AGleI;EKpGF;ILuQM,eAAA;EHmUN;AACF;;AQ3kBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;AN5B9B;AG7eI;EKpGF;ILuQM,iBAAA;EH8UN;AACF;;AQtlBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANjB9B;AGxfI;EKpGF;ILuQM,eAAA;EHyVN;AACF;;AQjmBE;ELgQM,iCAAA;EK5PJ,gBFynBkB;EExnBlB,gBFwmB0B;ANN9B;AGngBI;EKpGF;ILuQM,iBAAA;EHoWN;AACF;;AQplBA;ECvDE,eAAA;EACA,gBAAA;AT+oBF;;AQplBA;EC5DE,eAAA;EACA,gBAAA;ATopBF;;AQtlBA;EACE,qBAAA;ARylBF;AQvlBE;EACE,oBFsoB0B;AN7C9B;;AQ/kBA;EL8MM,kBALI;EKvMR,yBAAA;ARklBF;;AQ9kBA;EACE,mBFiUO;EH1HH,kBALI;AHgZV;AQ/kBE;EACE,gBAAA;ARilBJ;;AQ7kBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;ANsqBX;AQ9kBE;EACE,aAAA;ARglBJ;;AUhrBA;ECIE,eAAA;EAGA,YAAA;AX8qBF;;AU/qBA;EACE,gBJ2jDkC;EI1jDlC,mCJ2jDkC;EI1jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AXurBF;;AUzqBA;EAEE,qBAAA;AV2qBF;;AUxqBA;EACE,qBAAA;EACA,cAAA;AV2qBF;;AUxqBA;EPyPM,kBALI;EOlPR,gCJ8iDkC;ANn4BpC;;AY7sBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Ab0tBF;;AcpqBI;EF5CE;IACE,gBNkee;ENkPrB;AACF;Ac1qBI;EF5CE;IACE,gBNkee;ENuPrB;AACF;Ac/qBI;EF5CE;IACE,gBNkee;EN4PrB;AACF;AcprBI;EF5CE;IACE,iBNkee;ENiQrB;AACF;AczrBI;EF5CE;IACE,iBNkee;ENsQrB;AACF;AezvBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;Af+vBJ;;Ae1vBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhBmwBF;AejwBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhB6vBF;;AgB9sBM;EACE,SAAA;AhBitBR;;AgB9sBM;EApCJ,cAAA;EACA,WAAA;AhBsvBF;;AgBxuBE;EACE,cAAA;EACA,WAAA;AhB2uBJ;;AgB7uBE;EACE,cAAA;EACA,UAAA;AhBgvBJ;;AgBlvBE;EACE,cAAA;EACA,qBAAA;AhBqvBJ;;AgBvvBE;EACE,cAAA;EACA,UAAA;AhB0vBJ;;AgB5vBE;EACE,cAAA;EACA,UAAA;AhB+vBJ;;AgBjwBE;EACE,cAAA;EACA,qBAAA;AhBowBJ;;AgBruBM;EAhDJ,cAAA;EACA,WAAA;AhByxBF;;AgBpuBU;EAhEN,cAAA;EACA,kBAAA;AhBwyBJ;;AgBzuBU;EAhEN,cAAA;EACA,mBAAA;AhB6yBJ;;AgB9uBU;EAhEN,cAAA;EACA,UAAA;AhBkzBJ;;AgBnvBU;EAhEN,cAAA;EACA,mBAAA;AhBuzBJ;;AgBxvBU;EAhEN,cAAA;EACA,mBAAA;AhB4zBJ;;AgB7vBU;EAhEN,cAAA;EACA,UAAA;AhBi0BJ;;AgBlwBU;EAhEN,cAAA;EACA,mBAAA;AhBs0BJ;;AgBvwBU;EAhEN,cAAA;EACA,mBAAA;AhB20BJ;;AgB5wBU;EAhEN,cAAA;EACA,UAAA;AhBg1BJ;;AgBjxBU;EAhEN,cAAA;EACA,mBAAA;AhBq1BJ;;AgBtxBU;EAhEN,cAAA;EACA,mBAAA;AhB01BJ;;AgB3xBU;EAhEN,cAAA;EACA,WAAA;AhB+1BJ;;AgBxxBY;EAxDV,wBAAA;AhBo1BF;;AgB5xBY;EAxDV,yBAAA;AhBw1BF;;AgBhyBY;EAxDV,gBAAA;AhB41BF;;AgBpyBY;EAxDV,yBAAA;AhBg2BF;;AgBxyBY;EAxDV,yBAAA;AhBo2BF;;AgB5yBY;EAxDV,gBAAA;AhBw2BF;;AgBhzBY;EAxDV,yBAAA;AhB42BF;;AgBpzBY;EAxDV,yBAAA;AhBg3BF;;AgBxzBY;EAxDV,gBAAA;AhBo3BF;;AgB5zBY;EAxDV,yBAAA;AhBw3BF;;AgBh0BY;EAxDV,yBAAA;AhB43BF;;AgBzzBQ;;EAEE,gBAAA;AhB4zBV;;AgBzzBQ;;EAEE,gBAAA;AhB4zBV;;AgBn0BQ;;EAEE,sBAAA;AhBs0BV;;AgBn0BQ;;EAEE,sBAAA;AhBs0BV;;AgB70BQ;;EAEE,qBAAA;AhBg1BV;;AgB70BQ;;EAEE,qBAAA;AhBg1BV;;AgBv1BQ;;EAEE,mBAAA;AhB01BV;;AgBv1BQ;;EAEE,mBAAA;AhB01BV;;AgBj2BQ;;EAEE,qBAAA;AhBo2BV;;AgBj2BQ;;EAEE,qBAAA;AhBo2BV;;AgB32BQ;;EAEE,mBAAA;AhB82BV;;AgB32BQ;;EAEE,mBAAA;AhB82BV;;AgBr3BQ;;EAEE,kBAAA;AhBw3BV;;AgBr3BQ;;EAEE,kBAAA;AhBw3BV;;AgB/3BQ;;EAEE,mBAAA;AhBk4BV;;AgB/3BQ;;EAEE,mBAAA;AhBk4BV;;AgBz4BQ;;EAEE,mBAAA;AhB44BV;;AgBz4BQ;;EAEE,mBAAA;AhB44BV;;AgBn5BQ;;EAEE,mBAAA;AhBs5BV;;AgBn5BQ;;EAEE,mBAAA;AhBs5BV;;AgB75BQ;;EAEE,mBAAA;AhBg6BV;;AgB75BQ;;EAEE,mBAAA;AhBg6BV;;AgBv6BQ;;EAEE,mBAAA;AhB06BV;;AgBv6BQ;;EAEE,mBAAA;AhB06BV;;AgBj7BQ;;EAEE,mBAAA;AhBo7BV;;AgBj7BQ;;EAEE,mBAAA;AhBo7BV;;AgB37BQ;;EAEE,mBAAA;AhB87BV;;AgB37BQ;;EAEE,mBAAA;AhB87BV;;AgBr8BQ;;EAEE,mBAAA;AhBw8BV;;AgBr8BQ;;EAEE,mBAAA;AhBw8BV;;AgB/8BQ;;EAEE,mBAAA;AhBk9BV;;AgB/8BQ;;EAEE,mBAAA;AhBk9BV;;AgBz9BQ;;EAEE,mBAAA;AhB49BV;;AgBz9BQ;;EAEE,mBAAA;AhB49BV;;AgBn+BQ;;EAEE,mBAAA;AhBs+BV;;AgBn+BQ;;EAEE,mBAAA;AhBs+BV;;AgB7+BQ;;EAEE,oBAAA;AhBg/BV;;AgB7+BQ;;EAEE,oBAAA;AhBg/BV;;AgBv/BQ;;EAEE,oBAAA;AhB0/BV;;AgBv/BQ;;EAEE,oBAAA;AhB0/BV;;AgBjgCQ;;EAEE,oBAAA;AhBogCV;;AgBjgCQ;;EAEE,oBAAA;AhBogCV;;AgB3gCQ;;EAEE,oBAAA;AhB8gCV;;AgB3gCQ;;EAEE,oBAAA;AhB8gCV;;AgBrhCQ;;EAEE,oBAAA;AhBwhCV;;AgBrhCQ;;EAEE,oBAAA;AhBwhCV;;AgB/hCQ;;EAEE,oBAAA;AhBkiCV;;AgB/hCQ;;EAEE,oBAAA;AhBkiCV;;AgBziCQ;;EAEE,oBAAA;AhB4iCV;;AgBziCQ;;EAEE,oBAAA;AhB4iCV;;AgBnjCQ;;EAEE,oBAAA;AhBsjCV;;AgBnjCQ;;EAEE,oBAAA;AhBsjCV;;AgB7jCQ;;EAEE,oBAAA;AhBgkCV;;AgB7jCQ;;EAEE,oBAAA;AhBgkCV;;AgBvkCQ;;EAEE,oBAAA;AhB0kCV;;AgBvkCQ;;EAEE,oBAAA;AhB0kCV;;AcpoCI;EEUE;IACE,SAAA;EhB8nCN;EgB3nCI;IApCJ,cAAA;IACA,WAAA;EhBkqCA;EgBppCA;IACE,cAAA;IACA,WAAA;EhBspCF;EgBxpCA;IACE,cAAA;IACA,UAAA;EhB0pCF;EgB5pCA;IACE,cAAA;IACA,qBAAA;EhB8pCF;EgBhqCA;IACE,cAAA;IACA,UAAA;EhBkqCF;EgBpqCA;IACE,cAAA;IACA,UAAA;EhBsqCF;EgBxqCA;IACE,cAAA;IACA,qBAAA;EhB0qCF;EgB3oCI;IAhDJ,cAAA;IACA,WAAA;EhB8rCA;EgBzoCQ;IAhEN,cAAA;IACA,kBAAA;EhB4sCF;EgB7oCQ;IAhEN,cAAA;IACA,mBAAA;EhBgtCF;EgBjpCQ;IAhEN,cAAA;IACA,UAAA;EhBotCF;EgBrpCQ;IAhEN,cAAA;IACA,mBAAA;EhBwtCF;EgBzpCQ;IAhEN,cAAA;IACA,mBAAA;EhB4tCF;EgB7pCQ;IAhEN,cAAA;IACA,UAAA;EhBguCF;EgBjqCQ;IAhEN,cAAA;IACA,mBAAA;EhBouCF;EgBrqCQ;IAhEN,cAAA;IACA,mBAAA;EhBwuCF;EgBzqCQ;IAhEN,cAAA;IACA,UAAA;EhB4uCF;EgB7qCQ;IAhEN,cAAA;IACA,mBAAA;EhBgvCF;EgBjrCQ;IAhEN,cAAA;IACA,mBAAA;EhBovCF;EgBrrCQ;IAhEN,cAAA;IACA,WAAA;EhBwvCF;EgBjrCU;IAxDV,cAAA;EhB4uCA;EgBprCU;IAxDV,wBAAA;EhB+uCA;EgBvrCU;IAxDV,yBAAA;EhBkvCA;EgB1rCU;IAxDV,gBAAA;EhBqvCA;EgB7rCU;IAxDV,yBAAA;EhBwvCA;EgBhsCU;IAxDV,yBAAA;EhB2vCA;EgBnsCU;IAxDV,gBAAA;EhB8vCA;EgBtsCU;IAxDV,yBAAA;EhBiwCA;EgBzsCU;IAxDV,yBAAA;EhBowCA;EgB5sCU;IAxDV,gBAAA;EhBuwCA;EgB/sCU;IAxDV,yBAAA;EhB0wCA;EgBltCU;IAxDV,yBAAA;EhB6wCA;EgB1sCM;;IAEE,gBAAA;EhB4sCR;EgBzsCM;;IAEE,gBAAA;EhB2sCR;EgBltCM;;IAEE,sBAAA;EhBotCR;EgBjtCM;;IAEE,sBAAA;EhBmtCR;EgB1tCM;;IAEE,qBAAA;EhB4tCR;EgBztCM;;IAEE,qBAAA;EhB2tCR;EgBluCM;;IAEE,mBAAA;EhBouCR;EgBjuCM;;IAEE,mBAAA;EhBmuCR;EgB1uCM;;IAEE,qBAAA;EhB4uCR;EgBzuCM;;IAEE,qBAAA;EhB2uCR;EgBlvCM;;IAEE,mBAAA;EhBovCR;EgBjvCM;;IAEE,mBAAA;EhBmvCR;EgB1vCM;;IAEE,kBAAA;EhB4vCR;EgBzvCM;;IAEE,kBAAA;EhB2vCR;EgBlwCM;;IAEE,mBAAA;EhBowCR;EgBjwCM;;IAEE,mBAAA;EhBmwCR;EgB1wCM;;IAEE,mBAAA;EhB4wCR;EgBzwCM;;IAEE,mBAAA;EhB2wCR;EgBlxCM;;IAEE,mBAAA;EhBoxCR;EgBjxCM;;IAEE,mBAAA;EhBmxCR;EgB1xCM;;IAEE,mBAAA;EhB4xCR;EgBzxCM;;IAEE,mBAAA;EhB2xCR;EgBlyCM;;IAEE,mBAAA;EhBoyCR;EgBjyCM;;IAEE,mBAAA;EhBmyCR;EgB1yCM;;IAEE,mBAAA;EhB4yCR;EgBzyCM;;IAEE,mBAAA;EhB2yCR;EgBlzCM;;IAEE,mBAAA;EhBozCR;EgBjzCM;;IAEE,mBAAA;EhBmzCR;EgB1zCM;;IAEE,mBAAA;EhB4zCR;EgBzzCM;;IAEE,mBAAA;EhB2zCR;EgBl0CM;;IAEE,mBAAA;EhBo0CR;EgBj0CM;;IAEE,mBAAA;EhBm0CR;EgB10CM;;IAEE,mBAAA;EhB40CR;EgBz0CM;;IAEE,mBAAA;EhB20CR;EgBl1CM;;IAEE,mBAAA;EhBo1CR;EgBj1CM;;IAEE,mBAAA;EhBm1CR;EgB11CM;;IAEE,oBAAA;EhB41CR;EgBz1CM;;IAEE,oBAAA;EhB21CR;EgBl2CM;;IAEE,oBAAA;EhBo2CR;EgBj2CM;;IAEE,oBAAA;EhBm2CR;EgB12CM;;IAEE,oBAAA;EhB42CR;EgBz2CM;;IAEE,oBAAA;EhB22CR;EgBl3CM;;IAEE,oBAAA;EhBo3CR;EgBj3CM;;IAEE,oBAAA;EhBm3CR;EgB13CM;;IAEE,oBAAA;EhB43CR;EgBz3CM;;IAEE,oBAAA;EhB23CR;EgBl4CM;;IAEE,oBAAA;EhBo4CR;EgBj4CM;;IAEE,oBAAA;EhBm4CR;EgB14CM;;IAEE,oBAAA;EhB44CR;EgBz4CM;;IAEE,oBAAA;EhB24CR;EgBl5CM;;IAEE,oBAAA;EhBo5CR;EgBj5CM;;IAEE,oBAAA;EhBm5CR;EgB15CM;;IAEE,oBAAA;EhB45CR;EgBz5CM;;IAEE,oBAAA;EhB25CR;EgBl6CM;;IAEE,oBAAA;EhBo6CR;EgBj6CM;;IAEE,oBAAA;EhBm6CR;AACF;Ac99CI;EEUE;IACE,SAAA;EhBu9CN;EgBp9CI;IApCJ,cAAA;IACA,WAAA;EhB2/CA;EgB7+CA;IACE,cAAA;IACA,WAAA;EhB++CF;EgBj/CA;IACE,cAAA;IACA,UAAA;EhBm/CF;EgBr/CA;IACE,cAAA;IACA,qBAAA;EhBu/CF;EgBz/CA;IACE,cAAA;IACA,UAAA;EhB2/CF;EgB7/CA;IACE,cAAA;IACA,UAAA;EhB+/CF;EgBjgDA;IACE,cAAA;IACA,qBAAA;EhBmgDF;EgBp+CI;IAhDJ,cAAA;IACA,WAAA;EhBuhDA;EgBl+CQ;IAhEN,cAAA;IACA,kBAAA;EhBqiDF;EgBt+CQ;IAhEN,cAAA;IACA,mBAAA;EhByiDF;EgB1+CQ;IAhEN,cAAA;IACA,UAAA;EhB6iDF;EgB9+CQ;IAhEN,cAAA;IACA,mBAAA;EhBijDF;EgBl/CQ;IAhEN,cAAA;IACA,mBAAA;EhBqjDF;EgBt/CQ;IAhEN,cAAA;IACA,UAAA;EhByjDF;EgB1/CQ;IAhEN,cAAA;IACA,mBAAA;EhB6jDF;EgB9/CQ;IAhEN,cAAA;IACA,mBAAA;EhBikDF;EgBlgDQ;IAhEN,cAAA;IACA,UAAA;EhBqkDF;EgBtgDQ;IAhEN,cAAA;IACA,mBAAA;EhBykDF;EgB1gDQ;IAhEN,cAAA;IACA,mBAAA;EhB6kDF;EgB9gDQ;IAhEN,cAAA;IACA,WAAA;EhBilDF;EgB1gDU;IAxDV,cAAA;EhBqkDA;EgB7gDU;IAxDV,wBAAA;EhBwkDA;EgBhhDU;IAxDV,yBAAA;EhB2kDA;EgBnhDU;IAxDV,gBAAA;EhB8kDA;EgBthDU;IAxDV,yBAAA;EhBilDA;EgBzhDU;IAxDV,yBAAA;EhBolDA;EgB5hDU;IAxDV,gBAAA;EhBulDA;EgB/hDU;IAxDV,yBAAA;EhB0lDA;EgBliDU;IAxDV,yBAAA;EhB6lDA;EgBriDU;IAxDV,gBAAA;EhBgmDA;EgBxiDU;IAxDV,yBAAA;EhBmmDA;EgB3iDU;IAxDV,yBAAA;EhBsmDA;EgBniDM;;IAEE,gBAAA;EhBqiDR;EgBliDM;;IAEE,gBAAA;EhBoiDR;EgB3iDM;;IAEE,sBAAA;EhB6iDR;EgB1iDM;;IAEE,sBAAA;EhB4iDR;EgBnjDM;;IAEE,qBAAA;EhBqjDR;EgBljDM;;IAEE,qBAAA;EhBojDR;EgB3jDM;;IAEE,mBAAA;EhB6jDR;EgB1jDM;;IAEE,mBAAA;EhB4jDR;EgBnkDM;;IAEE,qBAAA;EhBqkDR;EgBlkDM;;IAEE,qBAAA;EhBokDR;EgB3kDM;;IAEE,mBAAA;EhB6kDR;EgB1kDM;;IAEE,mBAAA;EhB4kDR;EgBnlDM;;IAEE,kBAAA;EhBqlDR;EgBllDM;;IAEE,kBAAA;EhBolDR;EgB3lDM;;IAEE,mBAAA;EhB6lDR;EgB1lDM;;IAEE,mBAAA;EhB4lDR;EgBnmDM;;IAEE,mBAAA;EhBqmDR;EgBlmDM;;IAEE,mBAAA;EhBomDR;EgB3mDM;;IAEE,mBAAA;EhB6mDR;EgB1mDM;;IAEE,mBAAA;EhB4mDR;EgBnnDM;;IAEE,mBAAA;EhBqnDR;EgBlnDM;;IAEE,mBAAA;EhBonDR;EgB3nDM;;IAEE,mBAAA;EhB6nDR;EgB1nDM;;IAEE,mBAAA;EhB4nDR;EgBnoDM;;IAEE,mBAAA;EhBqoDR;EgBloDM;;IAEE,mBAAA;EhBooDR;EgB3oDM;;IAEE,mBAAA;EhB6oDR;EgB1oDM;;IAEE,mBAAA;EhB4oDR;EgBnpDM;;IAEE,mBAAA;EhBqpDR;EgBlpDM;;IAEE,mBAAA;EhBopDR;EgB3pDM;;IAEE,mBAAA;EhB6pDR;EgB1pDM;;IAEE,mBAAA;EhB4pDR;EgBnqDM;;IAEE,mBAAA;EhBqqDR;EgBlqDM;;IAEE,mBAAA;EhBoqDR;EgB3qDM;;IAEE,mBAAA;EhB6qDR;EgB1qDM;;IAEE,mBAAA;EhB4qDR;EgBnrDM;;IAEE,oBAAA;EhBqrDR;EgBlrDM;;IAEE,oBAAA;EhBorDR;EgB3rDM;;IAEE,oBAAA;EhB6rDR;EgB1rDM;;IAEE,oBAAA;EhB4rDR;EgBnsDM;;IAEE,oBAAA;EhBqsDR;EgBlsDM;;IAEE,oBAAA;EhBosDR;EgB3sDM;;IAEE,oBAAA;EhB6sDR;EgB1sDM;;IAEE,oBAAA;EhB4sDR;EgBntDM;;IAEE,oBAAA;EhBqtDR;EgBltDM;;IAEE,oBAAA;EhBotDR;EgB3tDM;;IAEE,oBAAA;EhB6tDR;EgB1tDM;;IAEE,oBAAA;EhB4tDR;EgBnuDM;;IAEE,oBAAA;EhBquDR;EgBluDM;;IAEE,oBAAA;EhBouDR;EgB3uDM;;IAEE,oBAAA;EhB6uDR;EgB1uDM;;IAEE,oBAAA;EhB4uDR;EgBnvDM;;IAEE,oBAAA;EhBqvDR;EgBlvDM;;IAEE,oBAAA;EhBovDR;EgB3vDM;;IAEE,oBAAA;EhB6vDR;EgB1vDM;;IAEE,oBAAA;EhB4vDR;AACF;AcvzDI;EEUE;IACE,SAAA;EhBgzDN;EgB7yDI;IApCJ,cAAA;IACA,WAAA;EhBo1DA;EgBt0DA;IACE,cAAA;IACA,WAAA;EhBw0DF;EgB10DA;IACE,cAAA;IACA,UAAA;EhB40DF;EgB90DA;IACE,cAAA;IACA,qBAAA;EhBg1DF;EgBl1DA;IACE,cAAA;IACA,UAAA;EhBo1DF;EgBt1DA;IACE,cAAA;IACA,UAAA;EhBw1DF;EgB11DA;IACE,cAAA;IACA,qBAAA;EhB41DF;EgB7zDI;IAhDJ,cAAA;IACA,WAAA;EhBg3DA;EgB3zDQ;IAhEN,cAAA;IACA,kBAAA;EhB83DF;EgB/zDQ;IAhEN,cAAA;IACA,mBAAA;EhBk4DF;EgBn0DQ;IAhEN,cAAA;IACA,UAAA;EhBs4DF;EgBv0DQ;IAhEN,cAAA;IACA,mBAAA;EhB04DF;EgB30DQ;IAhEN,cAAA;IACA,mBAAA;EhB84DF;EgB/0DQ;IAhEN,cAAA;IACA,UAAA;EhBk5DF;EgBn1DQ;IAhEN,cAAA;IACA,mBAAA;EhBs5DF;EgBv1DQ;IAhEN,cAAA;IACA,mBAAA;EhB05DF;EgB31DQ;IAhEN,cAAA;IACA,UAAA;EhB85DF;EgB/1DQ;IAhEN,cAAA;IACA,mBAAA;EhBk6DF;EgBn2DQ;IAhEN,cAAA;IACA,mBAAA;EhBs6DF;EgBv2DQ;IAhEN,cAAA;IACA,WAAA;EhB06DF;EgBn2DU;IAxDV,cAAA;EhB85DA;EgBt2DU;IAxDV,wBAAA;EhBi6DA;EgBz2DU;IAxDV,yBAAA;EhBo6DA;EgB52DU;IAxDV,gBAAA;EhBu6DA;EgB/2DU;IAxDV,yBAAA;EhB06DA;EgBl3DU;IAxDV,yBAAA;EhB66DA;EgBr3DU;IAxDV,gBAAA;EhBg7DA;EgBx3DU;IAxDV,yBAAA;EhBm7DA;EgB33DU;IAxDV,yBAAA;EhBs7DA;EgB93DU;IAxDV,gBAAA;EhBy7DA;EgBj4DU;IAxDV,yBAAA;EhB47DA;EgBp4DU;IAxDV,yBAAA;EhB+7DA;EgB53DM;;IAEE,gBAAA;EhB83DR;EgB33DM;;IAEE,gBAAA;EhB63DR;EgBp4DM;;IAEE,sBAAA;EhBs4DR;EgBn4DM;;IAEE,sBAAA;EhBq4DR;EgB54DM;;IAEE,qBAAA;EhB84DR;EgB34DM;;IAEE,qBAAA;EhB64DR;EgBp5DM;;IAEE,mBAAA;EhBs5DR;EgBn5DM;;IAEE,mBAAA;EhBq5DR;EgB55DM;;IAEE,qBAAA;EhB85DR;EgB35DM;;IAEE,qBAAA;EhB65DR;EgBp6DM;;IAEE,mBAAA;EhBs6DR;EgBn6DM;;IAEE,mBAAA;EhBq6DR;EgB56DM;;IAEE,kBAAA;EhB86DR;EgB36DM;;IAEE,kBAAA;EhB66DR;EgBp7DM;;IAEE,mBAAA;EhBs7DR;EgBn7DM;;IAEE,mBAAA;EhBq7DR;EgB57DM;;IAEE,mBAAA;EhB87DR;EgB37DM;;IAEE,mBAAA;EhB67DR;EgBp8DM;;IAEE,mBAAA;EhBs8DR;EgBn8DM;;IAEE,mBAAA;EhBq8DR;EgB58DM;;IAEE,mBAAA;EhB88DR;EgB38DM;;IAEE,mBAAA;EhB68DR;EgBp9DM;;IAEE,mBAAA;EhBs9DR;EgBn9DM;;IAEE,mBAAA;EhBq9DR;EgB59DM;;IAEE,mBAAA;EhB89DR;EgB39DM;;IAEE,mBAAA;EhB69DR;EgBp+DM;;IAEE,mBAAA;EhBs+DR;EgBn+DM;;IAEE,mBAAA;EhBq+DR;EgB5+DM;;IAEE,mBAAA;EhB8+DR;EgB3+DM;;IAEE,mBAAA;EhB6+DR;EgBp/DM;;IAEE,mBAAA;EhBs/DR;EgBn/DM;;IAEE,mBAAA;EhBq/DR;EgB5/DM;;IAEE,mBAAA;EhB8/DR;EgB3/DM;;IAEE,mBAAA;EhB6/DR;EgBpgEM;;IAEE,mBAAA;EhBsgER;EgBngEM;;IAEE,mBAAA;EhBqgER;EgB5gEM;;IAEE,oBAAA;EhB8gER;EgB3gEM;;IAEE,oBAAA;EhB6gER;EgBphEM;;IAEE,oBAAA;EhBshER;EgBnhEM;;IAEE,oBAAA;EhBqhER;EgB5hEM;;IAEE,oBAAA;EhB8hER;EgB3hEM;;IAEE,oBAAA;EhB6hER;EgBpiEM;;IAEE,oBAAA;EhBsiER;EgBniEM;;IAEE,oBAAA;EhBqiER;EgB5iEM;;IAEE,oBAAA;EhB8iER;EgB3iEM;;IAEE,oBAAA;EhB6iER;EgBpjEM;;IAEE,oBAAA;EhBsjER;EgBnjEM;;IAEE,oBAAA;EhBqjER;EgB5jEM;;IAEE,oBAAA;EhB8jER;EgB3jEM;;IAEE,oBAAA;EhB6jER;EgBpkEM;;IAEE,oBAAA;EhBskER;EgBnkEM;;IAEE,oBAAA;EhBqkER;EgB5kEM;;IAEE,oBAAA;EhB8kER;EgB3kEM;;IAEE,oBAAA;EhB6kER;EgBplEM;;IAEE,oBAAA;EhBslER;EgBnlEM;;IAEE,oBAAA;EhBqlER;AACF;AchpEI;EEUE;IACE,SAAA;EhByoEN;EgBtoEI;IApCJ,cAAA;IACA,WAAA;EhB6qEA;EgB/pEA;IACE,cAAA;IACA,WAAA;EhBiqEF;EgBnqEA;IACE,cAAA;IACA,UAAA;EhBqqEF;EgBvqEA;IACE,cAAA;IACA,qBAAA;EhByqEF;EgB3qEA;IACE,cAAA;IACA,UAAA;EhB6qEF;EgB/qEA;IACE,cAAA;IACA,UAAA;EhBirEF;EgBnrEA;IACE,cAAA;IACA,qBAAA;EhBqrEF;EgBtpEI;IAhDJ,cAAA;IACA,WAAA;EhBysEA;EgBppEQ;IAhEN,cAAA;IACA,kBAAA;EhButEF;EgBxpEQ;IAhEN,cAAA;IACA,mBAAA;EhB2tEF;EgB5pEQ;IAhEN,cAAA;IACA,UAAA;EhB+tEF;EgBhqEQ;IAhEN,cAAA;IACA,mBAAA;EhBmuEF;EgBpqEQ;IAhEN,cAAA;IACA,mBAAA;EhBuuEF;EgBxqEQ;IAhEN,cAAA;IACA,UAAA;EhB2uEF;EgB5qEQ;IAhEN,cAAA;IACA,mBAAA;EhB+uEF;EgBhrEQ;IAhEN,cAAA;IACA,mBAAA;EhBmvEF;EgBprEQ;IAhEN,cAAA;IACA,UAAA;EhBuvEF;EgBxrEQ;IAhEN,cAAA;IACA,mBAAA;EhB2vEF;EgB5rEQ;IAhEN,cAAA;IACA,mBAAA;EhB+vEF;EgBhsEQ;IAhEN,cAAA;IACA,WAAA;EhBmwEF;EgB5rEU;IAxDV,cAAA;EhBuvEA;EgB/rEU;IAxDV,wBAAA;EhB0vEA;EgBlsEU;IAxDV,yBAAA;EhB6vEA;EgBrsEU;IAxDV,gBAAA;EhBgwEA;EgBxsEU;IAxDV,yBAAA;EhBmwEA;EgB3sEU;IAxDV,yBAAA;EhBswEA;EgB9sEU;IAxDV,gBAAA;EhBywEA;EgBjtEU;IAxDV,yBAAA;EhB4wEA;EgBptEU;IAxDV,yBAAA;EhB+wEA;EgBvtEU;IAxDV,gBAAA;EhBkxEA;EgB1tEU;IAxDV,yBAAA;EhBqxEA;EgB7tEU;IAxDV,yBAAA;EhBwxEA;EgBrtEM;;IAEE,gBAAA;EhButER;EgBptEM;;IAEE,gBAAA;EhBstER;EgB7tEM;;IAEE,sBAAA;EhB+tER;EgB5tEM;;IAEE,sBAAA;EhB8tER;EgBruEM;;IAEE,qBAAA;EhBuuER;EgBpuEM;;IAEE,qBAAA;EhBsuER;EgB7uEM;;IAEE,mBAAA;EhB+uER;EgB5uEM;;IAEE,mBAAA;EhB8uER;EgBrvEM;;IAEE,qBAAA;EhBuvER;EgBpvEM;;IAEE,qBAAA;EhBsvER;EgB7vEM;;IAEE,mBAAA;EhB+vER;EgB5vEM;;IAEE,mBAAA;EhB8vER;EgBrwEM;;IAEE,kBAAA;EhBuwER;EgBpwEM;;IAEE,kBAAA;EhBswER;EgB7wEM;;IAEE,mBAAA;EhB+wER;EgB5wEM;;IAEE,mBAAA;EhB8wER;EgBrxEM;;IAEE,mBAAA;EhBuxER;EgBpxEM;;IAEE,mBAAA;EhBsxER;EgB7xEM;;IAEE,mBAAA;EhB+xER;EgB5xEM;;IAEE,mBAAA;EhB8xER;EgBryEM;;IAEE,mBAAA;EhBuyER;EgBpyEM;;IAEE,mBAAA;EhBsyER;EgB7yEM;;IAEE,mBAAA;EhB+yER;EgB5yEM;;IAEE,mBAAA;EhB8yER;EgBrzEM;;IAEE,mBAAA;EhBuzER;EgBpzEM;;IAEE,mBAAA;EhBszER;EgB7zEM;;IAEE,mBAAA;EhB+zER;EgB5zEM;;IAEE,mBAAA;EhB8zER;EgBr0EM;;IAEE,mBAAA;EhBu0ER;EgBp0EM;;IAEE,mBAAA;EhBs0ER;EgB70EM;;IAEE,mBAAA;EhB+0ER;EgB50EM;;IAEE,mBAAA;EhB80ER;EgBr1EM;;IAEE,mBAAA;EhBu1ER;EgBp1EM;;IAEE,mBAAA;EhBs1ER;EgB71EM;;IAEE,mBAAA;EhB+1ER;EgB51EM;;IAEE,mBAAA;EhB81ER;EgBr2EM;;IAEE,oBAAA;EhBu2ER;EgBp2EM;;IAEE,oBAAA;EhBs2ER;EgB72EM;;IAEE,oBAAA;EhB+2ER;EgB52EM;;IAEE,oBAAA;EhB82ER;EgBr3EM;;IAEE,oBAAA;EhBu3ER;EgBp3EM;;IAEE,oBAAA;EhBs3ER;EgB73EM;;IAEE,oBAAA;EhB+3ER;EgB53EM;;IAEE,oBAAA;EhB83ER;EgBr4EM;;IAEE,oBAAA;EhBu4ER;EgBp4EM;;IAEE,oBAAA;EhBs4ER;EgB74EM;;IAEE,oBAAA;EhB+4ER;EgB54EM;;IAEE,oBAAA;EhB84ER;EgBr5EM;;IAEE,oBAAA;EhBu5ER;EgBp5EM;;IAEE,oBAAA;EhBs5ER;EgB75EM;;IAEE,oBAAA;EhB+5ER;EgB55EM;;IAEE,oBAAA;EhB85ER;EgBr6EM;;IAEE,oBAAA;EhBu6ER;EgBp6EM;;IAEE,oBAAA;EhBs6ER;EgB76EM;;IAEE,oBAAA;EhB+6ER;EgB56EM;;IAEE,oBAAA;EhB86ER;AACF;Acz+EI;EEUE;IACE,SAAA;EhBk+EN;EgB/9EI;IApCJ,cAAA;IACA,WAAA;EhBsgFA;EgBx/EA;IACE,cAAA;IACA,WAAA;EhB0/EF;EgB5/EA;IACE,cAAA;IACA,UAAA;EhB8/EF;EgBhgFA;IACE,cAAA;IACA,qBAAA;EhBkgFF;EgBpgFA;IACE,cAAA;IACA,UAAA;EhBsgFF;EgBxgFA;IACE,cAAA;IACA,UAAA;EhB0gFF;EgB5gFA;IACE,cAAA;IACA,qBAAA;EhB8gFF;EgB/+EI;IAhDJ,cAAA;IACA,WAAA;EhBkiFA;EgB7+EQ;IAhEN,cAAA;IACA,kBAAA;EhBgjFF;EgBj/EQ;IAhEN,cAAA;IACA,mBAAA;EhBojFF;EgBr/EQ;IAhEN,cAAA;IACA,UAAA;EhBwjFF;EgBz/EQ;IAhEN,cAAA;IACA,mBAAA;EhB4jFF;EgB7/EQ;IAhEN,cAAA;IACA,mBAAA;EhBgkFF;EgBjgFQ;IAhEN,cAAA;IACA,UAAA;EhBokFF;EgBrgFQ;IAhEN,cAAA;IACA,mBAAA;EhBwkFF;EgBzgFQ;IAhEN,cAAA;IACA,mBAAA;EhB4kFF;EgB7gFQ;IAhEN,cAAA;IACA,UAAA;EhBglFF;EgBjhFQ;IAhEN,cAAA;IACA,mBAAA;EhBolFF;EgBrhFQ;IAhEN,cAAA;IACA,mBAAA;EhBwlFF;EgBzhFQ;IAhEN,cAAA;IACA,WAAA;EhB4lFF;EgBrhFU;IAxDV,cAAA;EhBglFA;EgBxhFU;IAxDV,wBAAA;EhBmlFA;EgB3hFU;IAxDV,yBAAA;EhBslFA;EgB9hFU;IAxDV,gBAAA;EhBylFA;EgBjiFU;IAxDV,yBAAA;EhB4lFA;EgBpiFU;IAxDV,yBAAA;EhB+lFA;EgBviFU;IAxDV,gBAAA;EhBkmFA;EgB1iFU;IAxDV,yBAAA;EhBqmFA;EgB7iFU;IAxDV,yBAAA;EhBwmFA;EgBhjFU;IAxDV,gBAAA;EhB2mFA;EgBnjFU;IAxDV,yBAAA;EhB8mFA;EgBtjFU;IAxDV,yBAAA;EhBinFA;EgB9iFM;;IAEE,gBAAA;EhBgjFR;EgB7iFM;;IAEE,gBAAA;EhB+iFR;EgBtjFM;;IAEE,sBAAA;EhBwjFR;EgBrjFM;;IAEE,sBAAA;EhBujFR;EgB9jFM;;IAEE,qBAAA;EhBgkFR;EgB7jFM;;IAEE,qBAAA;EhB+jFR;EgBtkFM;;IAEE,mBAAA;EhBwkFR;EgBrkFM;;IAEE,mBAAA;EhBukFR;EgB9kFM;;IAEE,qBAAA;EhBglFR;EgB7kFM;;IAEE,qBAAA;EhB+kFR;EgBtlFM;;IAEE,mBAAA;EhBwlFR;EgBrlFM;;IAEE,mBAAA;EhBulFR;EgB9lFM;;IAEE,kBAAA;EhBgmFR;EgB7lFM;;IAEE,kBAAA;EhB+lFR;EgBtmFM;;IAEE,mBAAA;EhBwmFR;EgBrmFM;;IAEE,mBAAA;EhBumFR;EgB9mFM;;IAEE,mBAAA;EhBgnFR;EgB7mFM;;IAEE,mBAAA;EhB+mFR;EgBtnFM;;IAEE,mBAAA;EhBwnFR;EgBrnFM;;IAEE,mBAAA;EhBunFR;EgB9nFM;;IAEE,mBAAA;EhBgoFR;EgB7nFM;;IAEE,mBAAA;EhB+nFR;EgBtoFM;;IAEE,mBAAA;EhBwoFR;EgBroFM;;IAEE,mBAAA;EhBuoFR;EgB9oFM;;IAEE,mBAAA;EhBgpFR;EgB7oFM;;IAEE,mBAAA;EhB+oFR;EgBtpFM;;IAEE,mBAAA;EhBwpFR;EgBrpFM;;IAEE,mBAAA;EhBupFR;EgB9pFM;;IAEE,mBAAA;EhBgqFR;EgB7pFM;;IAEE,mBAAA;EhB+pFR;EgBtqFM;;IAEE,mBAAA;EhBwqFR;EgBrqFM;;IAEE,mBAAA;EhBuqFR;EgB9qFM;;IAEE,mBAAA;EhBgrFR;EgB7qFM;;IAEE,mBAAA;EhB+qFR;EgBtrFM;;IAEE,mBAAA;EhBwrFR;EgBrrFM;;IAEE,mBAAA;EhBurFR;EgB9rFM;;IAEE,oBAAA;EhBgsFR;EgB7rFM;;IAEE,oBAAA;EhB+rFR;EgBtsFM;;IAEE,oBAAA;EhBwsFR;EgBrsFM;;IAEE,oBAAA;EhBusFR;EgB9sFM;;IAEE,oBAAA;EhBgtFR;EgB7sFM;;IAEE,oBAAA;EhB+sFR;EgBttFM;;IAEE,oBAAA;EhBwtFR;EgBrtFM;;IAEE,oBAAA;EhButFR;EgB9tFM;;IAEE,oBAAA;EhBguFR;EgB7tFM;;IAEE,oBAAA;EhB+tFR;EgBtuFM;;IAEE,oBAAA;EhBwuFR;EgBruFM;;IAEE,oBAAA;EhBuuFR;EgB9uFM;;IAEE,oBAAA;EhBgvFR;EgB7uFM;;IAEE,oBAAA;EhB+uFR;EgBtvFM;;IAEE,oBAAA;EhBwvFR;EgBrvFM;;IAEE,oBAAA;EhBuvFR;EgB9vFM;;IAEE,oBAAA;EhBgwFR;EgB7vFM;;IAEE,oBAAA;EhB+vFR;EgBtwFM;;IAEE,oBAAA;EhBwwFR;EgBrwFM;;IAEE,oBAAA;EhBuwFR;AACF;AiB73FA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,sCAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,0CAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,yCAAA;EAEA,WAAA;EACA,mBCtBO;EDuBP,mBXssB4B;EWrsB5B,0CAAA;AjB43FF;AiBr3FE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX8sB0B;EW7sB1B,2GAAA;AjBs3FJ;AiBn3FE;EACE,uBAAA;AjBq3FJ;AiBl3FE;EACE,sBAAA;AjBo3FJ;;AiBh3FA;EACE,+DAAA;AjBm3FF;;AiB52FA;EACE,iBAAA;AjB+2FF;;AiBr2FE;EACE,wBAAA;AjBw2FJ;;AiBz1FE;EACE,sCAAA;AjB41FJ;AiBz1FI;EACE,sCAAA;AjB21FN;;AiBp1FE;EACE,sBAAA;AjBu1FJ;AiBp1FE;EACE,mBAAA;AjBs1FJ;;AiB50FE;EACE,oDAAA;EACA,8CAAA;AjB+0FJ;;AiBz0FE;EACE,oDAAA;EACA,8CAAA;AjB40FJ;;AiBp0FA;EACE,oDAAA;EACA,8CAAA;AjBu0FF;;AiB/zFE;EACE,mDAAA;EACA,6CAAA;AjBk0FJ;;AmB98FE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB08FJ;;AmB59FE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBw9FJ;;AmB1+FE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBs+FJ;;AmBx/FE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBo/FJ;;AmBtgGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBkgGJ;;AmBphGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBghGJ;;AmBliGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB8hGJ;;AmBhjGE;EAOE,sBAAA;EACA,sBAAA;EACA,gCAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB4iGJ;;AiB35FI;EACE,gBAAA;EACA,iCAAA;AjB85FN;;Acz/FI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBo6FJ;AACF;AchgGI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB06FJ;AACF;ActgGI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBg7FJ;AACF;Ac5gGI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBs7FJ;AACF;AclhGI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB47FJ;AACF;AoBhmGA;EACE,qBdq2BsC;AN6vExC;;AoBzlGA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EjB8QI,kBALI;EiBrQR,gBd+lB4B;AN2/E9B;;AoBtlGA;EACE,kDAAA;EACA,qDAAA;EjBoQI,kBALI;AH21FV;;AoBtlGA;EACE,mDAAA;EACA,sDAAA;EjB8PI,mBALI;AHi2FV;;AqBvnGA;EACE,mBf61BsC;EHnkBlC,kBALI;EkBjRR,gCf61BsC;AN2xExC;;AsB7nGA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;EnBwRI,eALI;EmBhRR,gBhBkmB4B;EgBjmB5B,gBhBymB4B;EgBxmB5B,2BhB03BsC;EgBz3BtC,gBAAA;EACA,mChBm3BsC;EgBl3BtC,4BAAA;EACA,2DAAA;EfGE,sCAAA;EgBHE,wEDMJ;AtB2nGF;AuB7nGM;EDhBN;ICiBQ,gBAAA;EvBgoGN;AACF;AsB9nGE;EACE,gBAAA;AtBgoGJ;AsB9nGI;EACE,eAAA;AtBgoGN;AsB3nGE;EACE,2BhBo2BoC;EgBn2BpC,mChB81BoC;EgB71BpC,qBhB42BoC;EgB32BpC,UAAA;EAKE,kDhBkhBkB;ANumFxB;AsBrnGE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AtBymGJ;AsBpmGE;EACE,cAAA;EACA,UAAA;AtBsmGJ;AsBlmGE;EACE,gChB00BoC;EgBx0BpC,UAAA;AtBmmGJ;AsB3lGE;EAEE,wChB4yBoC;EgBzyBpC,UAAA;AtB0lGJ;AsBtlGE;EACE,yBAAA;EACA,0BAAA;EACA,0BhBmrB0B;EgBlrB1B,2BhBoyBoC;EkBl4BtC,uClBmiCgC;EgBn8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+ChB+rB0B;EgB9rB1B,gBAAA;ECzFE,qID0FF;AtBwlGJ;AuB9qGM;ED0EJ;ICzEM,gBAAA;EvBirGN;AACF;AsB1lGE;EACE,wChB07B8B;ANkqElC;;AsBnlGA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBhBwf4B;EgBvf5B,2BhByxBsC;EgBxxBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AtBslGF;AsBplGE;EACE,UAAA;AtBslGJ;AsBnlGE;EAEE,gBAAA;EACA,eAAA;AtBolGJ;;AsBzkGA;EACE,mEhB0wBsC;EgBzwBtC,uBAAA;EnByII,mBALI;EIvQN,yCAAA;APitGJ;AsB1kGE;EACE,uBAAA;EACA,wBAAA;EACA,yBhBmoB0B;ANy8E9B;;AsBxkGA;EACE,iEhB8vBsC;EgB7vBtC,oBAAA;EnB4HI,kBALI;EIvQN,yCAAA;AP6tGJ;AsBzkGE;EACE,oBAAA;EACA,qBAAA;EACA,uBhB0nB0B;ANi9E9B;;AsBnkGE;EACE,oEhB2uBoC;AN21ExC;AsBnkGE;EACE,mEhBwuBoC;AN61ExC;AsBlkGE;EACE,iEhBquBoC;AN+1ExC;;AsB/jGA;EACE,WhBmuBsC;EgBluBtC,gEhB4tBsC;EgB3tBtC,iBhBglB4B;ANk/E9B;AsBhkGE;EACE,eAAA;AtBkkGJ;AsB/jGE;EACE,oBAAA;EfvLA,sCAAA;APyvGJ;AsB9jGE;EACE,oBAAA;Ef5LA,sCAAA;AP6vGJ;AsB7jGE;EAAoB,+DhB4sBkB;ANo3ExC;AsB/jGE;EAAoB,6DhB4sBkB;ANs3ExC;;AyBjxGA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;EtBqRI,eALI;EsB7QR,gBnB+lB4B;EmB9lB5B,gBnBsmB4B;EmBrmB5B,2BnBu3BsC;EmBt3BtC,gBAAA;EACA,mCnBg3BsC;EmB/2BtC,mFAAA;EACA,4BAAA;EACA,yCnB69BkC;EmB59BlC,0BnB69BkC;EmB59BlC,2DAAA;ElBHE,sCAAA;EgBHE,wEESJ;AzBixGF;AuBtxGM;EEfN;IFgBQ,gBAAA;EvByxGN;AACF;AyBpxGE;EACE,qBnBo3BoC;EmBn3BpC,UAAA;EAKE,kDnB+9B4B;ANmzElC;AyB9wGE;EAEE,sBnB4uB0B;EmB3uB1B,sBAAA;AzB+wGJ;AyB5wGE;EAEE,wCnBq1BoC;ANw7ExC;AyBxwGE;EACE,kBAAA;EACA,uCAAA;AzB0wGJ;;AyBtwGA;EACE,oBnBquB4B;EmBpuB5B,uBnBouB4B;EmBnuB5B,oBnBouB4B;EHjgBxB,mBALI;EIvQN,yCAAA;APozGJ;;AyBtwGA;EACE,mBnBiuB4B;EmBhuB5B,sBnBguB4B;EmB/tB5B,kBnBguB4B;EHrgBxB,kBALI;EIvQN,yCAAA;AP4zGJ;;AyBpwGI;EACE,gEAAA;AzBuwGN;;A0B/0GA;EACE,cAAA;EACA,kBpBm6BwC;EoBl6BxC,mBpBm6BwC;EoBl6BxC,uBpBm6BwC;AN+6E1C;A0Bh1GE;EACE,WAAA;EACA,mBAAA;A1Bk1GJ;;A0B90GA;EACE,oBpBy5BwC;EoBx5BxC,eAAA;EACA,iBAAA;A1Bi1GF;A0B/0GE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A1Bi1GJ;;A0B70GA;EACE,qCAAA;EAEA,UpBy4BwC;EoBx4BxC,WpBw4BwC;EoBv4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DpB04BwC;EoBz4BxC,iCAAA;UAAA,yBAAA;A1B+0GF;A0B50GE;EnB1BE,qBAAA;APy2GJ;A0B30GE;EAEE,kBpBk4BsC;AN08E1C;A0Bz0GE;EACE,uBpBy3BsC;ANk9E1C;A0Bx0GE;EACE,qBpBq1BoC;EoBp1BpC,UAAA;EACA,kDpB+foB;AN20FxB;A0Bv0GE;EACE,yBpB3BM;EoB4BN,qBpB5BM;ANq2GV;A0Bv0GI;EAII,iEAAA;A1Bs0GR;A0Bl0GI;EAII,iEAAA;A1Bi0GR;A0B5zGE;EACE,yBpBhDM;EoBiDN,qBpBjDM;EoBsDJ,iEAAA;A1B0zGN;A0BtzGE;EACE,oBAAA;EACA,YAAA;EACA,YpBi2BuC;ANu9E3C;A0BjzGI;EACE,eAAA;EACA,YpBw1BqC;AN29E3C;;A0BryGA;EACE,mBpBm1BgC;ANq9ElC;A0BtyGE;EACE,4DAAA;EAEA,UpB60B8B;EoB50B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;EnBhHA,kBAAA;EgBHE,iDGqHF;A1BuyGJ;AuBx5GM;EGyGJ;IHxGM,gBAAA;EvB25GN;AACF;A0B1yGI;EACE,4DAAA;A1B4yGN;A0BzyGI;EACE,iCpB40B4B;EoBv0B1B,4DAAA;A1BuyGR;A0BlyGE;EACE,oBpBuzB8B;EoBtzB9B,eAAA;A1BoyGJ;A0BlyGI;EACE,oBAAA;EACA,cAAA;A1BoyGN;;A0B/xGA;EACE,qBAAA;EACA,kBpBqyBgC;AN6/ElC;;A0B/xGA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1BkyGF;A0B9xGI;EACE,oBAAA;EACA,YAAA;EACA,apBspBwB;AN0oF9B;;A0BzxGI;EACE,4DAAA;A1B4xGN;;A2B98GA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A3Bi9GF;A2B/8GE;EACE,UAAA;A3Bi9GJ;A2B78GI;EAA0B,kErB4gCa;ANo8E3C;A2B/8GI;EAA0B,kErB2gCa;ANu8E3C;A2B/8GE;EACE,SAAA;A3Bi9GJ;A2B98GE;EACE,WrB6/BuC;EqB5/BvC,YrB4/BuC;EqB3/BvC,oBAAA;EACA,gBAAA;EH1BF,yBlBkCQ;EqBNN,SrB2/BuC;ECxgCvC,mBAAA;EgBHE,oHImBF;EJnBE,4GImBF;A3B+8GJ;AuB99GM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EvBi+GN;AACF;A2Bl9GI;EHjCF,yBlB4hCyC;AN09E3C;A2Bh9GE;EACE,WrBs+B8B;EqBr+B9B,crBs+B8B;EqBr+B9B,kBAAA;EACA,erBq+B8B;EqBp+B9B,uCrBq+B8B;EqBp+B9B,yBAAA;EpB7BA,mBAAA;APg/GJ;A2B98GE;EACE,WrBk+BuC;EqBj+BvC,YrBi+BuC;EqBh+BvC,gBAAA;EHpDF,yBlBkCQ;EqBoBN,SrBi+BuC;ECxgCvC,mBAAA;EgBHE,iHI6CF;EJ7CE,4GI6CF;A3B+8GJ;AuBx/GM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EvB2/GN;AACF;A2Bl9GI;EH3DF,yBlB4hCyC;ANo/E3C;A2Bh9GE;EACE,WrB48B8B;EqB38B9B,crB48B8B;EqB38B9B,kBAAA;EACA,erB28B8B;EqB18B9B,uCrB28B8B;EqB18B9B,yBAAA;EpBvDA,mBAAA;AP0gHJ;A2B98GE;EACE,oBAAA;A3Bg9GJ;A2B98GI;EACE,2CrB88BqC;ANkgF3C;A2B78GI;EACE,2CrB08BqC;ANqgF3C;;A4BtiHA;EACE,kBAAA;A5ByiHF;A4BviHE;;;EAGE,uDtBsiCoC;EsBriCpC,2DtBqiCoC;EsBpiCpC,iBtBqiCoC;ANogFxC;A4BtiHE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELRE,gEKSF;A5BwiHJ;AuB7iHM;EKTJ;ILUM,gBAAA;EvBgjHN;AACF;A4B1iHE;;EAEE,qBAAA;A5B4iHJ;A4B1iHI;;EACE,kBAAA;A5B6iHN;A4B1iHI;;;EAEE,qBtB0gCkC;EsBzgClC,wBtB0gCkC;ANmiFxC;A4B1iHI;;EACE,qBtBqgCkC;EsBpgClC,wBtBqgCkC;ANwiFxC;A4BziHE;EACE,qBtB+/BoC;EsB9/BpC,wBtB+/BoC;AN4iFxC;A4BpiHI;;;;EACE,2CAAA;EACA,8DtBy/BkC;ANgjFxC;A4BviHM;;;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,atBi/BgC;EsBh/BhC,WAAA;EACA,mCtB8zBgC;EC92BpC,sCAAA;AP6lHJ;A4BtiHI;EACE,2CAAA;EACA,8DtBw+BkC;ANgkFxC;A4BniHI;EACE,sCAAA;A5BqiHN;A4BjiHE;;EAEE,ctB1EO;AN6mHX;A4BjiHI;;EACE,wCtBwyBkC;AN4vFxC;;A6B3nHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7B8nHF;A6B5nHE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7B8nHJ;A6B1nHE;;;EAGE,UAAA;A7B4nHJ;A6BtnHE;EACE,kBAAA;EACA,UAAA;A7BwnHJ;A6BtnHI;EACE,UAAA;A7BwnHN;;A6B7mHA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;E1B8OI,eALI;E0BvOR,gBvByjB4B;EuBxjB5B,gBvBgkB4B;EuB/jB5B,2BvBi1BsC;EuBh1BtC,kBAAA;EACA,mBAAA;EACA,uCvBw6BsC;EuBv6BtC,2DAAA;EtBtCE,sCAAA;APupHJ;;A6BvmHA;;;;EAIE,oBAAA;E1BwNI,kBALI;EIvQN,yCAAA;APgqHJ;;A6BvmHA;;;;EAIE,uBAAA;E1B+MI,mBALI;EIvQN,yCAAA;APyqHJ;;A6BvmHA;;EAEE,mBAAA;A7B0mHF;;A6B7lHI;;;;EtBjEA,0BAAA;EACA,6BAAA;APqqHJ;A6B5lHI;;;;EtB1EA,0BAAA;EACA,6BAAA;AP4qHJ;A6BtlHE;EACE,8CAAA;EtB1EA,yBAAA;EACA,4BAAA;APmqHJ;A6BtlHE;;EtB9EE,yBAAA;EACA,4BAAA;APwqHJ;;A8BhsHE;EACE,aAAA;EACA,WAAA;EACA,mBxBq0BoC;EHnkBlC,kBALI;E2B1PN,iCxBgjCqB;ANkpFzB;;A8B/rHE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,mBALI;E2B7ON,WxBmiCqB;EwBliCrB,mCxBkiCqB;EC7jCrB,sCAAA;AP6tHJ;;A8B7rHI;;;;EAEE,cAAA;A9BksHN;;A8BjvHI;EAqDE,+CxBqhCmB;EwBlhCjB,oCxB41BgC;EwB31BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9B8rHR;A8B3rHM;EACE,+CxB0gCiB;EwBzgCjB,2DxBygCiB;ANorFzB;;A8B9vHI;EA0EI,oCxB00BgC;EwBz0BhC,kFAAA;A9BwrHR;;A8BnwHI;EAkFE,+CxBw/BmB;AN6rFzB;A8BlrHQ;EAEE,iEAAA;EACA,uBxBw5B8B;EwBv5B9B,+DAAA;EACA,2EAAA;A9BmrHV;A8B/qHM;EACE,+CxB2+BiB;EwB1+BjB,2DxB0+BiB;ANusFzB;;A8BjxHI;EAwGI,yCAAA;A9B6qHR;;A8BrxHI;EA+GE,+CxB29BmB;AN+sFzB;A8BxqHM;EACE,4CxBw9BiB;ANktFzB;A8BvqHM;EACE,2DxBo9BiB;ANqtFzB;A8BtqHM;EACE,iCxBg9BiB;ANwtFzB;;A8BnqHI;EACE,kBAAA;A9BsqHN;;A8BtyHI;;;;;EA0IM,UAAA;A9BoqHV;;A8B1xHE;EACE,aAAA;EACA,WAAA;EACA,mBxBq0BoC;EHnkBlC,kBALI;E2B1PN,mCxBgjCqB;AN4uFzB;;A8BzxHE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E3BqPE,mBALI;E2B7ON,WxBmiCqB;EwBliCrB,kCxBkiCqB;EC7jCrB,sCAAA;APuzHJ;;A8BvxHI;;;;EAEE,cAAA;A9B4xHN;;A8B30HI;EAqDE,iDxBqhCmB;EwBlhCjB,oCxB41BgC;EwB31BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A9BwxHR;A8BrxHM;EACE,iDxB0gCiB;EwBzgCjB,0DxBygCiB;AN8wFzB;;A8Bx1HI;EA0EI,oCxB00BgC;EwBz0BhC,kFAAA;A9BkxHR;;A8B71HI;EAkFE,iDxBw/BmB;ANuxFzB;A8B5wHQ;EAEE,kEAAA;EACA,uBxBw5B8B;EwBv5B9B,+DAAA;EACA,2EAAA;A9B6wHV;A8BzwHM;EACE,iDxB2+BiB;EwB1+BjB,0DxB0+BiB;ANiyFzB;;A8B32HI;EAwGI,yCAAA;A9BuwHR;;A8B/2HI;EA+GE,iDxB29BmB;ANyyFzB;A8BlwHM;EACE,8CxBw9BiB;AN4yFzB;A8BjwHM;EACE,0DxBo9BiB;AN+yFzB;A8BhwHM;EACE,mCxBg9BiB;ANkzFzB;;A8B7vHI;EACE,kBAAA;A9BgwHN;;A8Bh4HI;;;;;EA4IM,UAAA;A9B4vHV;;A+B14HA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E5BuRI,wBALI;E4BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E5BsQI,kCALI;E4B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;ExBjBE,0CAAA;EiBfF,kCOkCqB;ERtBjB,qIQwBJ;A/Bw4HF;AuB55HM;EQhBN;IRiBQ,gBAAA;EvB+5HN;AACF;A+B34HE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A/B44HJ;A+Bz4HE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A/B04HJ;A+Bv4HE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A/Bq4HN;A+Bj4HE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A/B+3HN;A+B33HE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A/Bu3HJ;A+Bp3HI;EAKI,0CAAA;A/Bk3HR;A+B72HE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A/B42HJ;;A+Bh2HE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC08HF;;A+Bj3HE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC29HF;;A+Bl4HE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC4+HF;;A+Bn5HE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC6/HF;;A+Bp6HE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC8gIF;;A+Br7HE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC+hIF;;A+Bt8HE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCgjIF;;A+Bv9HE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCikIF;;A+B98HE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCyjIF;;A+B/9HE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC0kIF;;A+Bh/HE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC2lIF;;A+BjgIE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC4mIF;;A+BlhIE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC6nIF;;A+BniIE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,oCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC8oIF;;A+BpjIE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC+pIF;;A+BrkIE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,kCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCgrIF;;A+B1kIA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BzBuRwC;ANqzH1C;A+BlkIE;EACE,0BAAA;A/BokIJ;A+BjkIE;EACE,gCAAA;A/BmkIJ;;A+BxjIA;ECxIE,0BAAA;EACA,wBAAA;E7B8NI,2BALI;E6BvNR,kDAAA;AhCosIF;;A+B3jIA;EC5IE,2BAAA;EACA,0BAAA;E7B8NI,4BALI;E6BvNR,kDAAA;AhC2sIF;;AiC9wIA;EVgBM,gCUfJ;AjCixIF;AuB9vIM;EUpBN;IVqBQ,gBAAA;EvBiwIN;AACF;AiCpxIE;EACE,UAAA;AjCsxIJ;;AiChxIE;EACE,aAAA;AjCmxIJ;;AiC/wIA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AjCkxIF;AuBhxIM;EULN;IVMQ,gBAAA;EvBmxIN;AACF;AiCrxIE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AjCuxIJ;AuB1xIM;EUAJ;IVCM,gBAAA;EvB6xIN;AACF;;AkClzIA;;;;;;EAME,kBAAA;AlCqzIF;;AkClzIA;EACE,mBAAA;AlCqzIF;AmC7xII;EACE,qBAAA;EACA,oB7B6hBwB;E6B5hBxB,uB7B2hBwB;E6B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AnCq0IF;AmC3wII;EACE,cAAA;AnC6wIN;;AkC3zIA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E/BuQI,6BALI;E+BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,2DAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E/B0OI,uCALI;E+BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E3BzCE,+CAAA;APq2IJ;AkCxzIE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AlC0zIJ;;AkClyII;EACE,oBAAA;AlCqyIN;AkCnyIM;EACE,WAAA;EACA,OAAA;AlCqyIR;;AkCjyII;EACE,kBAAA;AlCoyIN;AkClyIM;EACE,QAAA;EACA,UAAA;AlCoyIR;;Ac90II;EoB4BA;IACE,oBAAA;ElCszIJ;EkCpzII;IACE,WAAA;IACA,OAAA;ElCszIN;EkClzIE;IACE,kBAAA;ElCozIJ;EkClzII;IACE,QAAA;IACA,UAAA;ElCozIN;AACF;Ac/1II;EoB4BA;IACE,oBAAA;ElCs0IJ;EkCp0II;IACE,WAAA;IACA,OAAA;ElCs0IN;EkCl0IE;IACE,kBAAA;ElCo0IJ;EkCl0II;IACE,QAAA;IACA,UAAA;ElCo0IN;AACF;Ac/2II;EoB4BA;IACE,oBAAA;ElCs1IJ;EkCp1II;IACE,WAAA;IACA,OAAA;ElCs1IN;EkCl1IE;IACE,kBAAA;ElCo1IJ;EkCl1II;IACE,QAAA;IACA,UAAA;ElCo1IN;AACF;Ac/3II;EoB4BA;IACE,oBAAA;ElCs2IJ;EkCp2II;IACE,WAAA;IACA,OAAA;ElCs2IN;EkCl2IE;IACE,kBAAA;ElCo2IJ;EkCl2II;IACE,QAAA;IACA,UAAA;ElCo2IN;AACF;Ac/4II;EoB4BA;IACE,oBAAA;ElCs3IJ;EkCp3II;IACE,WAAA;IACA,OAAA;ElCs3IN;EkCl3IE;IACE,kBAAA;ElCo3IJ;EkCl3II;IACE,QAAA;IACA,UAAA;ElCo3IN;AACF;AkC32IE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AlC62IJ;AmCj8II;EACE,qBAAA;EACA,oB7B6hBwB;E6B5hBxB,uB7B2hBwB;E6B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AnCk+IF;AmC/6II;EACE,cAAA;AnCi7IN;;AkCj3IE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AlCo3IJ;AmCt9II;EACE,qBAAA;EACA,oB7B6hBwB;E6B5hBxB,uB7B2hBwB;E6B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AnCg/IF;AmCp8II;EACE,cAAA;AnCs8IN;AkC53II;EACE,iBAAA;AlC83IN;;AkCx3IE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AlC23IJ;AmC9+II;EACE,qBAAA;EACA,oB7B6hBwB;E6B5hBxB,uB7B2hBwB;E6B1hBxB,WAAA;AnCg/IN;AmCr+IM;EACE,aAAA;AnCu+IR;AmCp+IM;EACE,qBAAA;EACA,qB7B0gBsB;E6BzgBtB,uB7BwgBsB;E6BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AnC0gJF;AmCp+II;EACE,cAAA;AnCs+IN;AkC34II;EACE,iBAAA;AlC64IN;;AkCt4IA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AlCy4IF;;AkCn4IA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB5Byb4B;E4Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E3BtKE,uDAAA;AP6iJJ;AkCp4IE;EAEE,0CAAA;EV1LF,kDU4LuB;AlCo4IzB;AkCj4IE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AlCk4IzB;AkC/3IE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AlCg4IJ;;AkC13IA;EACE,cAAA;AlC63IF;;AkCz3IA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E/BmEI,mBALI;E+B5DR,sCAAA;EACA,mBAAA;AlC43IF;;AkCx3IA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AlC23IF;;AkCv3IA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AlCy3IF;;AoC/mJA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApCknJF;AoChnJE;;EACE,kBAAA;EACA,cAAA;ApCmnJJ;AoC9mJE;;;;;;;;;;;;EAME,UAAA;ApCsnJJ;;AoCjnJA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ApConJF;AoClnJE;EACE,WAAA;ApConJJ;;AoChnJA;E7BhBI,sCAAA;APooJJ;AoChnJE;;EAEE,8CAAA;ApCknJJ;AoC9mJE;;;E7BVE,0BAAA;EACA,6BAAA;AP6nJJ;AoC1mJE;;;E7BNE,yBAAA;EACA,4BAAA;APqnJJ;;AoC7lJA;EACE,wBAAA;EACA,uBAAA;ApCgmJF;AoC9lJE;EAGE,cAAA;ApC8lJJ;AoC3lJE;EACE,eAAA;ApC6lJJ;;AoCzlJA;EACE,uBAAA;EACA,sBAAA;ApC4lJF;;AoCzlJA;EACE,sBAAA;EACA,qBAAA;ApC4lJF;;AoCxkJA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ApC2kJF;AoCzkJE;;EAEE,WAAA;ApC2kJJ;AoCxkJE;;EAEE,6CAAA;ApC0kJJ;AoCtkJE;;E7B1FE,6BAAA;EACA,4BAAA;APoqJJ;AoCtkJE;;E7B7GE,yBAAA;EACA,0BAAA;APurJJ;;AqC/sJA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArC8sJF;;AqC3sJA;EACE,cAAA;EACA,kEAAA;ElCsQI,uCALI;EkC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ArC8sJF;AuB1tJM;EcGN;IdFQ,gBAAA;EvB6tJN;AACF;AqCjtJE;EAEE,qCAAA;ArCktJJ;AqC9sJE;EACE,UAAA;EACA,kD/BkhBoB;AN8rIxB;AqC5sJE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ArC6sJJ;;AqCrsJA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ArCqsJF;AqCnsJE;EACE,yDAAA;EACA,yDAAA;E9B7CA,wDAAA;EACA,yDAAA;APmvJJ;AqCpsJI;EAGE,kBAAA;EACA,wDAAA;ArCosJN;AqChsJE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ArCksJJ;AqC/rJE;EAEE,sDAAA;E9BjEA,yBAAA;EACA,0BAAA;APkwJJ;;AqCvrJA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ArCyrJF;AqCtrJE;E9B5FE,gDAAA;APqxJJ;AqCrrJE;;EAEE,4CAAA;EbjHF,oDakHuB;ArCurJzB;;AqC9qJA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ArC8qJF;AqC5qJE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ArC8qJJ;AqC5qJI;EAEE,iCAAA;ArC6qJN;AqCzqJE;;EAEE,gB/B0d0B;E+Bzd1B,gDAAA;EACA,iCAAA;ArC2qJJ;;AqCjqJE;;EAEE,cAAA;EACA,kBAAA;ArCoqJJ;;AqC/pJE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;ArCkqJJ;;AqC5pJE;;EACE,WAAA;ArCgqJJ;;AqCtpJE;EACE,aAAA;ArCypJJ;AqCvpJE;EACE,cAAA;ArCypJJ;;AsCt1JA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AtCs1JF;AsCh1JE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AtCw1JJ;AsCp0JA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EnC4NI,2CALI;EmCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AtCs0JF;AsCp0JE;EAEE,yCAAA;AtCq0JJ;;AsC3zJA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtC0zJF;AsCvzJI;EAEE,oCAAA;AtCwzJN;AsCpzJE;EACE,gBAAA;AtCszJJ;;AsC7yJA;EACE,mBhC4gCkC;EgC3gClC,sBhC2gCkC;EgC1gClC,6BAAA;AtCgzJF;AsC9yJE;;;EAGE,oCAAA;AtCgzJJ;;AsCnyJA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AtCoyJF;;AsChyJA;EACE,8EAAA;EnCyII,6CALI;EmClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E/BxIE,qDAAA;EgBHE,+Ce6IJ;AtCmyJF;AuB56JM;EeiIN;IfhIQ,gBAAA;EvB+6JN;AACF;AsCtyJE;EACE,qBAAA;AtCwyJJ;AsCryJE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AtCuyJJ;;AsCjyJA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AtCoyJF;;AsCjyJA;EACE,yCAAA;EACA,gBAAA;AtCoyJF;;Ac95JI;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EtC2xJN;EsCzxJM;IACE,mBAAA;EtC2xJR;EsCzxJQ;IACE,kBAAA;EtC2xJV;EsCxxJQ;IACE,kDAAA;IACA,iDAAA;EtC0xJV;EsCtxJM;IACE,iBAAA;EtCwxJR;EsCrxJM;IACE,wBAAA;IACA,gBAAA;EtCuxJR;EsCpxJM;IACE,aAAA;EtCsxJR;EsCnxJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCmxJR;EsChxJQ;IACE,aAAA;EtCkxJV;EsC/wJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCixJV;AACF;Ac98JI;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EtC00JN;EsCx0JM;IACE,mBAAA;EtC00JR;EsCx0JQ;IACE,kBAAA;EtC00JV;EsCv0JQ;IACE,kDAAA;IACA,iDAAA;EtCy0JV;EsCr0JM;IACE,iBAAA;EtCu0JR;EsCp0JM;IACE,wBAAA;IACA,gBAAA;EtCs0JR;EsCn0JM;IACE,aAAA;EtCq0JR;EsCl0JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCk0JR;EsC/zJQ;IACE,aAAA;EtCi0JV;EsC9zJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCg0JV;AACF;Ac7/JI;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EtCy3JN;EsCv3JM;IACE,mBAAA;EtCy3JR;EsCv3JQ;IACE,kBAAA;EtCy3JV;EsCt3JQ;IACE,kDAAA;IACA,iDAAA;EtCw3JV;EsCp3JM;IACE,iBAAA;EtCs3JR;EsCn3JM;IACE,wBAAA;IACA,gBAAA;EtCq3JR;EsCl3JM;IACE,aAAA;EtCo3JR;EsCj3JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCi3JR;EsC92JQ;IACE,aAAA;EtCg3JV;EsC72JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC+2JV;AACF;Ac5iKI;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EtCw6JN;EsCt6JM;IACE,mBAAA;EtCw6JR;EsCt6JQ;IACE,kBAAA;EtCw6JV;EsCr6JQ;IACE,kDAAA;IACA,iDAAA;EtCu6JV;EsCn6JM;IACE,iBAAA;EtCq6JR;EsCl6JM;IACE,wBAAA;IACA,gBAAA;EtCo6JR;EsCj6JM;IACE,aAAA;EtCm6JR;EsCh6JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCg6JR;EsC75JQ;IACE,aAAA;EtC+5JV;EsC55JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC85JV;AACF;Ac3lKI;EwBsIA;IAEI,iBAAA;IACA,2BAAA;EtCu9JN;EsCr9JM;IACE,mBAAA;EtCu9JR;EsCr9JQ;IACE,kBAAA;EtCu9JV;EsCp9JQ;IACE,kDAAA;IACA,iDAAA;EtCs9JV;EsCl9JM;IACE,iBAAA;EtCo9JR;EsCj9JM;IACE,wBAAA;IACA,gBAAA;EtCm9JR;EsCh9JM;IACE,aAAA;EtCk9JR;EsC/8JM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtC+8JR;EsC58JQ;IACE,aAAA;EtC88JV;EsC38JQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtC68JV;AACF;AsCpgKI;EAEI,iBAAA;EACA,2BAAA;AtCqgKR;AsCngKQ;EACE,mBAAA;AtCqgKV;AsCngKU;EACE,kBAAA;AtCqgKZ;AsClgKU;EACE,kDAAA;EACA,iDAAA;AtCogKZ;AsChgKQ;EACE,iBAAA;AtCkgKV;AsC//JQ;EACE,wBAAA;EACA,gBAAA;AtCigKV;AsC9/JQ;EACE,aAAA;AtCggKV;AsC7/JQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AtC6/JV;AsC1/JU;EACE,aAAA;AtC4/JZ;AsCz/JU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AtC2/JZ;;AsC1+JA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AtC4+JF;;AsCt+JI;EACE,qEAAA;AtCy+JN;;AuClwKA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;EhCjBE,2CAAA;APoxKJ;AuC/vKE;EACE,eAAA;EACA,cAAA;AvCiwKJ;AuC9vKE;EACE,mBAAA;EACA,sBAAA;AvCgwKJ;AuC9vKI;EACE,mBAAA;EhCtBF,0DAAA;EACA,2DAAA;APuxKJ;AuC9vKI;EACE,sBAAA;EhCbF,8DAAA;EACA,6DAAA;AP8wKJ;AuC3vKE;;EAEE,aAAA;AvC6vKJ;;AuCzvKA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AvC0vKF;;AuCvvKA;EACE,4CAAA;EACA,iCAAA;AvC0vKF;;AuCvvKA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AvC0vKF;;AuCvvKA;EACE,gBAAA;AvC0vKF;;AuClvKE;EACE,oCAAA;AvCqvKJ;;AuC7uKA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AvCgvKF;AuC9uKE;EhC7FE,wFAAA;AP80KJ;;AuC5uKA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AvC+uKF;AuC7uKE;EhCxGE,wFAAA;APw1KJ;;AuCtuKA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AvCyuKF;AuCvuKE;EACE,mCAAA;EACA,sCAAA;AvCyuKJ;;AuCruKA;EACE,uDAAA;EACA,sDAAA;AvCwuKF;;AuCpuKA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;EhC1IE,iDAAA;APk3KJ;;AuCpuKA;;;EAGE,WAAA;AvCuuKF;;AuCpuKA;;EhC3II,0DAAA;EACA,2DAAA;APo3KJ;;AuCruKA;;EhClII,8DAAA;EACA,6DAAA;AP42KJ;;AuC9tKE;EACE,0CAAA;AvCiuKJ;Ac51KI;EyBuHJ;IAQI,aAAA;IACA,mBAAA;EvCiuKF;EuC9tKE;IAEE,SAAA;IACA,gBAAA;EvC+tKJ;EuC7tKI;IACE,cAAA;IACA,cAAA;EvC+tKN;EuC1tKM;IhC3KJ,0BAAA;IACA,6BAAA;EPw4KF;EuC3tKQ;;IAGE,0BAAA;EvC4tKV;EuC1tKQ;;IAGE,6BAAA;EvC2tKV;EuCvtKM;IhC5KJ,yBAAA;IACA,4BAAA;EPs4KF;EuCxtKQ;;IAGE,yBAAA;EvCytKV;EuCvtKQ;;IAGE,4BAAA;EvCwtKV;AACF;;AwC77KA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,8CAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AxC+7KF;;AwC37KA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;ErC2PI,eALI;EqCpPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EjCtBE,gBAAA;EiCwBF,qBAAA;EjB3BI,0CiB4BJ;AxC87KF;AuBt9KM;EiBWN;IjBVQ,gBAAA;EvBy9KN;AACF;AwCj8KE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AxCm8KJ;AwCj8KI;EACE,qDAAA;EACA,iDAAA;AxCm8KN;AwC97KE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBlDE,mDiBmDF;AxCg8KJ;AuB/+KM;EiBsCJ;IjBrCM,gBAAA;EvBk/KN;AACF;AwCl8KE;EACE,UAAA;AxCo8KJ;AwCj8KE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;AxCm8KJ;;AwC/7KA;EACE,gBAAA;AxCk8KF;;AwC/7KA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AxCk8KF;AwCh8KE;EjC/DE,yDAAA;EACA,0DAAA;APkgLJ;AwCj8KI;EjClEA,+DAAA;EACA,gEAAA;APsgLJ;AwCh8KE;EACE,aAAA;AxCk8KJ;AwC97KE;EjC9DE,6DAAA;EACA,4DAAA;AP+/KJ;AwC97KM;EjClEF,mEAAA;EACA,kEAAA;APmgLJ;AwC77KI;EjCvEA,6DAAA;EACA,4DAAA;APugLJ;;AwC37KA;EACE,8EAAA;AxC87KF;;AwCr7KE;EACE,eAAA;AxCw7KJ;AwCr7KE;EACE,eAAA;EACA,cAAA;EjCpHA,gBAAA;AP4iLJ;AwCr7KI;EAAgB,aAAA;AxCw7KpB;AwCv7KI;EAAe,gBAAA;AxC07KnB;AwCv7KM;EjC3HF,gBAAA;APqjLJ;;AwCh7KI;EACE,iEAAA;EACA,wEAAA;AxCm7KN;;AyC7kLA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EtC+QI,yCALI;EsCxQR,gBAAA;EACA,yCAAA;ElCAE,iDAAA;AP6kLJ;;AyCvkLE;EACE,iDAAA;AzC0kLJ;AyCxkLI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AzC0kLN;AyCtkLE;EACE,6CAAA;AzCwkLJ;;A0C7mLA;EAEE,kCAAA;EACA,mCAAA;EvC4RI,+BALI;EuCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EjCpBA,eAAA;EACA,gBAAA;ATkoLF;;A0C3mLA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EvCgQI,yCALI;EuCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A1C8mLF;AuB/nLM;EmBQN;InBPQ,gBAAA;EvBkoLN;AACF;A0CjnLE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A1CknLJ;A0C/mLE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UpCyuCgC;EoCxuChC,iDAAA;A1CinLJ;A0C9mLE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A1C+mLJ;A0C5mLE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A1C6mLJ;;A0CxmLE;EACE,8CpC4sCgC;AN+5IpC;A0CtmLM;EnC9BF,0DAAA;EACA,6DAAA;APuoLJ;A0CpmLM;EnClDF,2DAAA;EACA,8DAAA;APypLJ;;A0CvlLA;EClGE,iCAAA;EACA,kCAAA;ExC0RI,kCALI;EwCnRR,yDAAA;A3C6rLF;;A0C1lLA;ECtGE,iCAAA;EACA,kCAAA;ExC0RI,mCALI;EwCnRR,yDAAA;A3CosLF;;A4CtsLA;EAEE,4BAAA;EACA,4BAAA;EzCuRI,4BALI;EyChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;EzC+QI,oCALI;EyCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;ErCJE,4CAAA;AP2sLJ;A4ClsLE;EACE,aAAA;A5CosLJ;;A4C/rLA;EACE,kBAAA;EACA,SAAA;A5CksLF;;A6CluLA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EtCHE,4CAAA;APsuLJ;;A6C9tLA;EAEE,cAAA;A7CguLF;;A6C5tLA;EACE,gBvC6kB4B;EuC5kB5B,iCAAA;A7C+tLF;;A6CvtLA;EACE,mBvCk+C8B;ANwvIhC;A6CvtLE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A7CytLJ;;A6CjtLE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CotLJ;;A6CxtLE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7C2tLJ;;A6C/tLE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CkuLJ;;A6CtuLE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7CyuLJ;;A6C7uLE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7CgvLJ;;A6CpvLE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A7CuvLJ;;A6C3vLE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A7C8vLJ;;A6ClwLE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7CqwLJ;;A8Cj0LE;EACE;IAAK,2BxCqhD2B;ENgzIlC;AACF;A8Cj0LA;;EAGE,0BAAA;E3CkRI,gCALI;E2C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E3CsQI,uCALI;E2C/PR,uCAAA;EvCRE,+CAAA;APy0LJ;;A8C5zLA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A9C+zLF;AuBp1LM;EuBYN;IvBXQ,gBAAA;EvBu1LN;AACF;;A8Cj0LA;EtBAE,qMAAA;EsBEA,oEAAA;A9Co0LF;;A8Cj0LA;EACE,iBAAA;A9Co0LF;;A8Cj0LA;EACE,WAAA;A9Co0LF;;A8Ch0LE;EACE,kDAAA;A9Cm0LJ;A8Ch0LM;EAJJ;IAKM,eAAA;E9Cm0LN;AACF;;A+C/3LA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ExCXE,iDAAA;APy4LJ;;A+C13LA;EACE,qBAAA;EACA,sBAAA;A/C63LF;A+C33LE;EAEE,oCAAA;EACA,0BAAA;A/C43LJ;;A+Cn3LA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A/Cs3LF;A+Cn3LE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A/Co3LJ;A+Cj3LE;EACE,+CAAA;EACA,uDAAA;A/Cm3LJ;;A+C32LA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A/C82LF;A+C52LE;ExCvDE,+BAAA;EACA,gCAAA;APs6LJ;A+C52LE;ExC7CE,mCAAA;EACA,kCAAA;AP45LJ;A+C52LE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A/C62LJ;A+Cz2LE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A/C22LJ;A+Cv2LE;EACE,mBAAA;A/Cy2LJ;A+Cv2LI;EACE,wDAAA;EACA,mDAAA;A/Cy2LN;;A+C51LI;EACE,mBAAA;A/C+1LN;A+C51LQ;ExCvDJ,6DAAA;EAZA,0BAAA;APm6LJ;A+C31LQ;ExCxEJ,2DAAA;EAYA,4BAAA;AP25LJ;A+C11LQ;EACE,aAAA;A/C41LV;A+Cz1LQ;EACE,mDAAA;EACA,oBAAA;A/C21LV;A+Cz1LU;EACE,yDAAA;EACA,oDAAA;A/C21LZ;;Acj7LI;EiC8DA;IACE,mBAAA;E/Cu3LJ;E+Cp3LM;IxCvDJ,6DAAA;IAZA,0BAAA;EP27LF;E+Cn3LM;IxCxEJ,2DAAA;IAYA,4BAAA;EPm7LF;E+Cl3LM;IACE,aAAA;E/Co3LR;E+Cj3LM;IACE,mDAAA;IACA,oBAAA;E/Cm3LR;E+Cj3LQ;IACE,yDAAA;IACA,oDAAA;E/Cm3LV;AACF;Ac18LI;EiC8DA;IACE,mBAAA;E/C+4LJ;E+C54LM;IxCvDJ,6DAAA;IAZA,0BAAA;EPm9LF;E+C34LM;IxCxEJ,2DAAA;IAYA,4BAAA;EP28LF;E+C14LM;IACE,aAAA;E/C44LR;E+Cz4LM;IACE,mDAAA;IACA,oBAAA;E/C24LR;E+Cz4LQ;IACE,yDAAA;IACA,oDAAA;E/C24LV;AACF;Acl+LI;EiC8DA;IACE,mBAAA;E/Cu6LJ;E+Cp6LM;IxCvDJ,6DAAA;IAZA,0BAAA;EP2+LF;E+Cn6LM;IxCxEJ,2DAAA;IAYA,4BAAA;EPm+LF;E+Cl6LM;IACE,aAAA;E/Co6LR;E+Cj6LM;IACE,mDAAA;IACA,oBAAA;E/Cm6LR;E+Cj6LQ;IACE,yDAAA;IACA,oDAAA;E/Cm6LV;AACF;Ac1/LI;EiC8DA;IACE,mBAAA;E/C+7LJ;E+C57LM;IxCvDJ,6DAAA;IAZA,0BAAA;EPmgMF;E+C37LM;IxCxEJ,2DAAA;IAYA,4BAAA;EP2/LF;E+C17LM;IACE,aAAA;E/C47LR;E+Cz7LM;IACE,mDAAA;IACA,oBAAA;E/C27LR;E+Cz7LQ;IACE,yDAAA;IACA,oDAAA;E/C27LV;AACF;AclhMI;EiC8DA;IACE,mBAAA;E/Cu9LJ;E+Cp9LM;IxCvDJ,6DAAA;IAZA,0BAAA;EP2hMF;E+Cn9LM;IxCxEJ,2DAAA;IAYA,4BAAA;EPmhMF;E+Cl9LM;IACE,aAAA;E/Co9LR;E+Cj9LM;IACE,mDAAA;IACA,oBAAA;E/Cm9LR;E+Cj9LQ;IACE,yDAAA;IACA,oDAAA;E/Cm9LV;AACF;A+Ct8LA;ExChJI,gBAAA;APylMJ;A+Ct8LE;EACE,mDAAA;A/Cw8LJ;A+Ct8LI;EACE,sBAAA;A/Cw8LN;;A+C37LE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/C87LJ;;A+Cx8LE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/C28LJ;;A+Cr9LE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/Cw9LJ;;A+Cl+LE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/Cq+LJ;;A+C/+LE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/Ck/LJ;;A+C5/LE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A/C+/LJ;;A+CzgME;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A/C4gMJ;;A+CthME;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/CyhMJ;;AgDrtMA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EACA,uEAAA;EAGA,uBAAA;EACA,U1CipD2B;E0ChpD3B,W1CgpD2B;E0C/oD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,SAAA;EzCJE,uBAAA;EyCMF,oCAAA;AhDqtMF;AgDltME;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AhDotMJ;AgDjtME;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AhDmtMJ;AgDhtME;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AhDitMJ;;AgDzsMA;EAHE,wCAAA;AhDgtMF;;AgDvsMI;EATF,wCAAA;AhDotMF;;AiDrwMA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E9CyRI,8BALI;E8ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E9C2QI,oCALI;E8CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E1CRE,4CAAA;AP8wMJ;AiDnwME;EACE,UAAA;AjDqwMJ;AiDlwME;EACE,aAAA;AjDowMJ;;AiDhwMA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AjDkwMF;AiDhwME;EACE,sCAAA;AjDkwMJ;;AiD9vMA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E1ChCE,0FAAA;EACA,2FAAA;APkyMJ;AiDhwME;EACE,oDAAA;EACA,sCAAA;AjDkwMJ;;AiD9vMA;EACE,kCAAA;EACA,qBAAA;AjDiwMF;;AkD/zMA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8DAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlD6zMF;;AkDtzMA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AlDwzMF;AkDrzME;E3B5CI,mC2B6CF;EACA,8B5C87CgC;ANy3JpC;AuBj2MM;E2BwCJ;I3BvCM,gBAAA;EvBo2MN;AACF;AkD1zME;EACE,e5C47CgC;ANg4JpC;AkDxzME;EACE,sB5Cy7CgC;ANi4JpC;;AkDtzMA;EACE,+CAAA;AlDyzMF;AkDvzME;EACE,gBAAA;EACA,gBAAA;AlDyzMJ;AkDtzME;EACE,gBAAA;AlDwzMJ;;AkDpzMA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AlDuzMF;;AkDnzMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E3CrFE,4CAAA;E2CyFF,UAAA;AlDmzMF;;AkD/yMA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AlDqzM9D;AmDj6ME;EAAS,UAAA;AnDo6MX;AmDn6ME;EAAS,mCD2GiF;AlD2zM5F;;AkDtzMA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E3CtGE,2DAAA;EACA,4DAAA;APg6MJ;AkDxzME;EACE,kGAAA;EACA,sJAAA;AlD0zMJ;;AkDrzMA;EACE,gBAAA;EACA,8CAAA;AlDwzMF;;AkDnzMA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AlDozMF;;AkDhzMA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E3C1HE,+DAAA;EACA,8DAAA;AP86MJ;AkD/yME;EACE,8CAAA;AlDizMJ;;Ac75MI;EoCkHF;IACE,0BAAA;IACA,wDAAA;ElD+yMF;EkD3yMA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ElD6yMF;EkD1yMA;IACE,uBAAA;ElD4yMF;AACF;Ac56MI;EoCoIF;;IAEE,uBAAA;ElD2yMF;AACF;Acl7MI;EoC2IF;IACE,wBAAA;ElD0yMF;AACF;AkDjyMI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlDmyMN;AkDjyMM;EACE,YAAA;EACA,SAAA;E3C1MJ,gBAAA;AP8+MJ;AkDhyMM;;E3C9MF,gBAAA;APk/MJ;AkD/xMM;EACE,gBAAA;AlDiyMR;;Ac57MI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDuzMJ;EkDrzMI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EPkgNF;EkDpzMI;;I3C9MF,gBAAA;EPsgNF;EkDnzMI;IACE,gBAAA;ElDqzMN;AACF;Acj9MI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD20MJ;EkDz0MI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EPshNF;EkDx0MI;;I3C9MF,gBAAA;EP0hNF;EkDv0MI;IACE,gBAAA;ElDy0MN;AACF;Acr+MI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD+1MJ;EkD71MI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EP0iNF;EkD51MI;;I3C9MF,gBAAA;EP8iNF;EkD31MI;IACE,gBAAA;ElD61MN;AACF;Acz/MI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDm3MJ;EkDj3MI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EP8jNF;EkDh3MI;;I3C9MF,gBAAA;EPkkNF;EkD/2MI;IACE,gBAAA;ElDi3MN;AACF;Ac7gNI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDu4MJ;EkDr4MI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EPklNF;EkDp4MI;;I3C9MF,gBAAA;EPslNF;EkDn4MI;IACE,gBAAA;ElDq4MN;AACF;AoD5mNA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EjDwRI,gCALI;EiDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC/C+lB4B;E+C7lB5B,kBAAA;EACA,gB/CwmB4B;E+CvmB5B,gB/C+mB4B;E+C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ElDgRI,sCALI;EiDhQR,qBAAA;EACA,UAAA;ApDonNF;AoDlnNE;EAAS,kCAAA;ApDqnNX;AoDnnNE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ApDqnNJ;AoDnnNI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDqnNN;;AoDhnNA;EACE,iDAAA;ApDmnNF;AoDjnNE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ApDmnNJ;;AoD/mNA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ApDknNF;AoDhnNE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ApDknNJ;;AoD9mNA,mBAAA;AAEA;EACE,8CAAA;ApDgnNF;AoD9mNE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ApDgnNJ;;AoD5mNA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ApD+mNF;AoD7mNE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ApD+mNJ;;AoD3mNA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E7CjGE,8CAAA;AP+rNJ;;AsDltNA;EAEE,yBAAA;EACA,6BAAA;EnD4RI,gCALI;EmDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,0DAAA;EACA,mCAAA;EACA,qCAAA;EnDmRI,mCALI;EmD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC/C+lB4B;E+C7lB5B,kBAAA;EACA,gB/CwmB4B;E+CvmB5B,gB/C+mB4B;E+C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;ElDgRI,sCALI;EmD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E/ChBE,8CAAA;AP6uNJ;AsDztNE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtD2tNJ;AsDztNI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AtD0tNN;;AsDptNE;EACE,oFAAA;AtDutNJ;AsDrtNI;EAEE,wFAAA;AtDstNN;AsDntNI;EACE,SAAA;EACA,gDAAA;AtDqtNN;AsDltNI;EACE,sCAAA;EACA,sCAAA;AtDotNN;;AsD/sNA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AtDitNJ;AsD/sNI;EAEE,kIAAA;AtDgtNN;AsD7sNI;EACE,OAAA;EACA,kDAAA;AtD+sNN;AsD5sNI;EACE,oCAAA;EACA,wCAAA;AtD8sNN;;AsDzsNA,mBAAA;AAGE;EACE,iFAAA;AtD0sNJ;AsDxsNI;EAEE,wFAAA;AtDysNN;AsDtsNI;EACE,MAAA;EACA,mDAAA;AtDwsNN;AsDrsNI;EACE,mCAAA;EACA,yCAAA;AtDusNN;AsDlsNE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AtDosNJ;;AsDhsNA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AtDksNJ;AsDhsNI;EAEE,kIAAA;AtDisNN;AsD9rNI;EACE,QAAA;EACA,iDAAA;AtDgsNN;AsD7rNI;EACE,qCAAA;EACA,uCAAA;AtD+rNN;;AsD1rNA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;EnD2GI,6CALI;EmDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E/C5JE,6DAAA;EACA,8DAAA;APy0NJ;AsD3qNE;EACE,aAAA;AtD6qNJ;;AsDzqNA;EACE,0EAAA;EACA,mCAAA;AtD4qNF;;AuDj2NA;EACE,kBAAA;AvDo2NF;;AuDj2NA;EACE,mBAAA;AvDo2NF;;AuDj2NA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvDo2NF;AwD13NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxD43NJ;;AuDr2NA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AvDw2NF;AuBv3NM;EgCQN;IhCPQ,gBAAA;EvB03NN;AACF;;AuD12NA;;;EAGE,cAAA;AvD62NF;;AuD12NA;;EAEE,2BAAA;AvD62NF;;AuD12NA;;EAEE,4BAAA;AvD62NF;;AuDp2NE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvDu2NJ;AuDp2NE;;;EAGE,UAAA;EACA,UAAA;AvDs2NJ;AuDn2NE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AvDq2NJ;AuB95NM;EgCqDJ;;IhCpDM,gBAAA;EvBk6NN;AACF;;AuDl2NA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjD8gDmC;EiD7gDnC,UAAA;EACA,WjD1FS;EiD2FT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjDygDmC;EiB/lD/B,8BgCuFJ;AvDo2NF;AuBv7NM;EgCkEN;;IhCjEQ,gBAAA;EvB27NN;AACF;AuDv2NE;;;EAEE,WjDpGO;EiDqGP,qBAAA;EACA,UAAA;EACA,YjDigDiC;ANy2KrC;;AuDv2NA;EACE,OAAA;AvD02NF;;AuDv2NA;EACE,QAAA;AvD02NF;;AuDr2NA;;EAEE,qBAAA;EACA,WjDkgDmC;EiDjgDnC,YjDigDmC;EiDhgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AvDw2NF;;AuDr2NA;;;;;;;GAAA;AAQA;EACE,0DAAA;AvDw2NF;;AuDt2NA;EACE,0DAAA;AvDy2NF;;AuDj2NA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBjD08CmC;EiDz8CnC,mBAAA;EACA,gBjDw8CmC;AN25KrC;AuDj2NE;EACE,uBAAA;EACA,cAAA;EACA,WjDw8CiC;EiDv8CjC,WjDw8CiC;EiDv8CjC,UAAA;EACA,iBjDw8CiC;EiDv8CjC,gBjDu8CiC;EiDt8CjC,mBAAA;EACA,eAAA;EACA,sBjD1KO;EiD2KP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YjD+7CiC;EiBvmD/B,6BgCyKF;AvDk2NJ;AuBvgOM;EgCoJJ;IhCnJM,gBAAA;EvB0gON;AACF;AuDp2NE;EACE,UjD47CiC;AN06KrC;;AuD71NA;EACE,kBAAA;EACA,UAAA;EACA,ejDs7CmC;EiDr7CnC,SAAA;EACA,oBjDm7CmC;EiDl7CnC,uBjDk7CmC;EiDj7CnC,WjDrMS;EiDsMT,kBAAA;AvDg2NF;;AuD11NE;;EAEE,gCjDu7CiC;ANs6KrC;AuD11NE;EACE,sBjDxMO;ANoiOX;AuDz1NE;EACE,WjD5MO;ANuiOX;;AuDr2NE;;;EAEE,gCjDu7CiC;ANk7KrC;AuDt2NE;EACE,sBjDxMO;ANgjOX;AuDr2NE;EACE,WjD5MO;ANmjOX;;AyDjkOA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AzDmkOF;;AyD/jOA;EACE;IAAK,0CAAA;EzDmkOL;AACF;AyDhkOA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AzD+jOF;;AyD5jOA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AzD8jOF;;AyDrjOA;EACE;IACE,mBAAA;EzDwjOF;EyDtjOA;IACE,UAAA;IACA,eAAA;EzDwjOF;AACF;AyDpjOA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AzDmjOF;;AyDhjOA;EACE,wBAAA;EACA,yBAAA;AzDmjOF;;AyD/iOE;EACE;;IAEE,kCAAA;EzDkjOJ;AACF;A0DloOA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kEAAA;EACA,qDAAA;EACA,qCAAA;A1DmoOF;;ActkOI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DonOJ;AACF;AuB/oOM;EmCYJ;InCXM,gBAAA;EvBkpON;AACF;Ac5lOI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1D2nON;E0DxnOI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1D0nON;E0DvnOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DynON;E0DtnOI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DwnON;E0DrnOI;IAEE,eAAA;E1DsnON;E0DnnOI;IAGE,mBAAA;E1DmnON;AACF;AchpOI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DknON;E0DhnOM;IACE,aAAA;E1DknOR;E0D/mOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DgnOR;AACF;;AcppOI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DksOJ;AACF;AuB7tOM;EmCYJ;InCXM,gBAAA;EvBguON;AACF;Ac1qOI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1DysON;E0DtsOI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1DwsON;E0DrsOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DusON;E0DpsOI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DssON;E0DnsOI;IAEE,eAAA;E1DosON;E0DjsOI;IAGE,mBAAA;E1DisON;AACF;Ac9tOI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DgsON;E0D9rOM;IACE,aAAA;E1DgsOR;E0D7rOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D8rOR;AACF;;AcluOI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DgxOJ;AACF;AuB3yOM;EmCYJ;InCXM,gBAAA;EvB8yON;AACF;AcxvOI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1DuxON;E0DpxOI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1DsxON;E0DnxOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DqxON;E0DlxOI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DoxON;E0DjxOI;IAEE,eAAA;E1DkxON;E0D/wOI;IAGE,mBAAA;E1D+wON;AACF;Ac5yOI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1D8wON;E0D5wOM;IACE,aAAA;E1D8wOR;E0D3wOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D4wOR;AACF;;AchzOI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1D81OJ;AACF;AuBz3OM;EmCYJ;InCXM,gBAAA;EvB43ON;AACF;Act0OI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1Dq2ON;E0Dl2OI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1Do2ON;E0Dj2OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1Dm2ON;E0Dh2OI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1Dk2ON;E0D/1OI;IAEE,eAAA;E1Dg2ON;E0D71OI;IAGE,mBAAA;E1D61ON;AACF;Ac13OI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1D41ON;E0D11OM;IACE,aAAA;E1D41OR;E0Dz1OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1D01OR;AACF;;Ac93OI;E4C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1D46OJ;AACF;AuBv8OM;EmCYJ;InCXM,gBAAA;EvB08ON;AACF;Acp5OI;E4C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1Dm7ON;E0Dh7OI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1Dk7ON;E0D/6OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1Di7ON;E0D96OI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1Dg7ON;E0D76OI;IAEE,eAAA;E1D86ON;E0D36OI;IAGE,mBAAA;E1D26ON;AACF;Acx8OI;E4C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1D06ON;E0Dx6OM;IACE,aAAA;E1D06OR;E0Dv6OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Dw6OR;AACF;;A0Dx/OE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A1Dy/ON;AuBnhPM;EmCYJ;InCXM,gBAAA;EvBshPN;AACF;A0D5/OM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A1D8/OR;A0D3/OM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A1D6/OR;A0D1/OM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A1D4/OR;A0Dz/OM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A1D2/OR;A0Dx/OM;EAEE,eAAA;A1Dy/OR;A0Dt/OM;EAGE,mBAAA;A1Ds/OR;;A0D39OA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7CwmCkC;E6CvmClC,YAAA;EACA,aAAA;EACA,sB7CUS;ANykPX;AmDhlPE;EAAS,UAAA;AnDmlPX;AmDllPE;EAAS,Y7C+9CyB;ANsnMpC;;A0Dv+OA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A1D0+OF;A0Dx+OE;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A1D0+OJ;;A0Dt+OA;EACE,gBAAA;EACA,kDAAA;A1Dy+OF;;A0Dt+OA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A1Dy+OF;;A2DznPA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YrD8yCkC;AN80MpC;A2D1nPE;EACE,qBAAA;EACA,WAAA;A3D4nPJ;;A2DvnPA;EACE,iBAAA;A3D0nPF;;A2DvnPA;EACE,iBAAA;A3D0nPF;;A2DvnPA;EACE,iBAAA;A3D0nPF;;A2DrnPE;EACE,mDAAA;A3DwnPJ;;A2DpnPA;EACE;IACE,YrDixCgC;ENs2MlC;AACF;A2DpnPA;EACE,uFAAA;UAAA,+EAAA;EACA,4BAAA;UAAA,oBAAA;EACA,8CAAA;A3DsnPF;;A2DnnPA;EACE;IACE,+BAAA;YAAA,uBAAA;E3DsnPF;AACF;AwDrqPE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxDuqPJ;;A4D1qPE;EACE,sBAAA;EACA,iFAAA;A5D6qPJ;;A4D/qPE;EACE,sBAAA;EACA,mFAAA;A5DkrPJ;;A4DprPE;EACE,sBAAA;EACA,iFAAA;A5DurPJ;;A4DzrPE;EACE,sBAAA;EACA,8EAAA;A5D4rPJ;;A4D9rPE;EACE,sBAAA;EACA,iFAAA;A5DisPJ;;A4DnsPE;EACE,sBAAA;EACA,gFAAA;A5DssPJ;;A4DxsPE;EACE,sBAAA;EACA,+EAAA;A5D2sPJ;;A4D7sPE;EACE,sBAAA;EACA,8EAAA;A5DgtPJ;;A6DltPE;EACE,wEAAA;EACA,kGAAA;A7DqtPJ;A6DltPM;EAGE,gEAAA;EACA,0FAAA;A7DktPR;;A6D3tPE;EACE,0EAAA;EACA,oGAAA;A7D8tPJ;A6D3tPM;EAGE,gEAAA;EACA,0FAAA;A7D2tPR;;A6DpuPE;EACE,wEAAA;EACA,kGAAA;A7DuuPJ;A6DpuPM;EAGE,8DAAA;EACA,wFAAA;A7DouPR;;A6D7uPE;EACE,qEAAA;EACA,+FAAA;A7DgvPJ;A6D7uPM;EAGE,+DAAA;EACA,yFAAA;A7D6uPR;;A6DtvPE;EACE,wEAAA;EACA,kGAAA;A7DyvPJ;A6DtvPM;EAGE,+DAAA;EACA,yFAAA;A7DsvPR;;A6D/vPE;EACE,uEAAA;EACA,iGAAA;A7DkwPJ;A6D/vPM;EAGE,8DAAA;EACA,wFAAA;A7D+vPR;;A6DxwPE;EACE,sEAAA;EACA,gGAAA;A7D2wPJ;A6DxwPM;EAGE,gEAAA;EACA,0FAAA;A7DwwPR;;A6DjxPE;EACE,qEAAA;EACA,+FAAA;A7DoxPJ;A6DjxPM;EAGE,0DAAA;EACA,oFAAA;A7DixPR;;A6D1wPA;EACE,+EAAA;EACA,yGAAA;A7D6wPF;A6D1wPI;EAEE,kFAAA;EACA,4GAAA;A7D2wPN;;A8DryPA;EACE,UAAA;EAEA,kJAAA;A9DuyPF;;A+D1yPA;EACE,oBAAA;EACA,azD6c4B;EyD5c5B,mBAAA;EACA,kFAAA;EACA,6BzD2c4B;EyD1c5B,2BAAA;A/D6yPF;A+D3yPE;EACE,cAAA;EACA,UzDuc0B;EyDtc1B,WzDsc0B;EyDrc1B,kBAAA;ExCIE,sCwCHF;A/D6yPJ;AuBtyPM;EwCZJ;IxCaM,gBAAA;EvByyPN;AACF;;A+D3yPI;EACE,mEAAA;A/D8yPN;;AgEj0PA;EACE,kBAAA;EACA,WAAA;AhEo0PF;AgEl0PE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AhEo0PJ;AgEj0PE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AhEm0PJ;;AgE9zPE;EACE,uBAAA;AhEi0PJ;;AgEl0PE;EACE,sBAAA;AhEq0PJ;;AgEt0PE;EACE,yBAAA;AhEy0PJ;;AgE10PE;EACE,iCAAA;AhE60PJ;;AiEl2PA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a3DqmCkC;ANgwNpC;;AiEl2PA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a3D6lCkC;ANwwNpC;;AiE71PI;EACE,gBAAA;EACA,MAAA;EACA,a3DilC8B;AN+wNpC;;AiE71PI;EACE,gBAAA;EACA,SAAA;EACA,a3D2kC8B;ANqxNpC;;Acj0PI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DilC8B;EN4xNlC;EiE12PE;IACE,gBAAA;IACA,SAAA;IACA,a3D2kC8B;ENiyNlC;AACF;Ac90PI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DilC8B;ENwyNlC;EiEt3PE;IACE,gBAAA;IACA,SAAA;IACA,a3D2kC8B;EN6yNlC;AACF;Ac11PI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DilC8B;ENozNlC;EiEl4PE;IACE,gBAAA;IACA,SAAA;IACA,a3D2kC8B;ENyzNlC;AACF;Act2PI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DilC8B;ENg0NlC;EiE94PE;IACE,gBAAA;IACA,SAAA;IACA,a3D2kC8B;ENq0NlC;AACF;Acl3PI;EmDxCA;IACE,gBAAA;IACA,MAAA;IACA,a3DilC8B;EN40NlC;EiE15PE;IACE,gBAAA;IACA,SAAA;IACA,a3D2kC8B;ENi1NlC;AACF;AkE57PA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlE87PF;;AkE37PA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AlE87PF;;AmEt8PA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ApEu8PF;AoEp8PE;;EACE,6BAAA;ApEu8PJ;;AqEr9PE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U/DgcsC;E+D/btC,WAAA;ArEw9PJ;;AsEh+PA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AvEo+PF;;AwE1+PA;EACE,qBAAA;EACA,mBAAA;EACA,6BlEisB4B;EkEhsB5B,eAAA;EACA,8BAAA;EACA,alE2rB4B;ANkzO9B;;AyEj7PQ;EAOI,mCAAA;AzE86PZ;;AyEr7PQ;EAOI,8BAAA;AzEk7PZ;;AyEz7PQ;EAOI,iCAAA;AzEs7PZ;;AyE77PQ;EAOI,iCAAA;AzE07PZ;;AyEj8PQ;EAOI,sCAAA;AzE87PZ;;AyEr8PQ;EAOI,mCAAA;AzEk8PZ;;AyEz8PQ;EAOI,sBAAA;AzEs8PZ;;AyE78PQ;EAOI,uBAAA;AzE08PZ;;AyEj9PQ;EAOI,sBAAA;AzE88PZ;;AyEr9PQ;EAOI,8BAAA;AzEk9PZ;;AyEz9PQ;EAOI,4BAAA;AzEs9PZ;;AyE79PQ;EAOI,2BAAA;AzE09PZ;;AyEj+PQ;EAOI,iCAAA;AzE89PZ;;AyEr+PQ;EAOI,2BAAA;AzEk+PZ;;AyEz+PQ;EAOI,qBAAA;AzEs+PZ;;AyE7+PQ;EAOI,wBAAA;AzE0+PZ;;AyEj/PQ;EAOI,uBAAA;AzE8+PZ;;AyEr/PQ;EAOI,wBAAA;AzEk/PZ;;AyEz/PQ;EAOI,qBAAA;AzEs/PZ;;AyE7/PQ;EAOI,yBAAA;AzE0/PZ;;AyEjgQQ;EAOI,2BAAA;AzE8/PZ;;AyErgQQ;EAOI,4BAAA;AzEkgQZ;;AyEzgQQ;EAOI,2BAAA;AzEsgQZ;;AyE7gQQ;EAOI,2BAAA;AzE0gQZ;;AyEjhQQ;EAOI,6BAAA;AzE8gQZ;;AyErhQQ;EAOI,8BAAA;AzEkhQZ;;AyEzhQQ;EAOI,6BAAA;AzEshQZ;;AyE7hQQ;EAOI,2BAAA;AzE0hQZ;;AyEjiQQ;EAOI,6BAAA;AzE8hQZ;;AyEriQQ;EAOI,8BAAA;AzEkiQZ;;AyEziQQ;EAOI,6BAAA;AzEsiQZ;;AyE7iQQ;EAOI,0BAAA;AzE0iQZ;;AyEjjQQ;EAOI,gCAAA;AzE8iQZ;;AyErjQQ;EAOI,yBAAA;AzEkjQZ;;AyEzjQQ;EAOI,wBAAA;AzEsjQZ;;AyE7jQQ;EAOI,+BAAA;AzE0jQZ;;AyEjkQQ;EAOI,yBAAA;AzE8jQZ;;AyErkQQ;EAOI,6BAAA;AzEkkQZ;;AyEzkQQ;EAOI,8BAAA;AzEskQZ;;AyE7kQQ;EAOI,wBAAA;AzE0kQZ;;AyEjlQQ;EAOI,+BAAA;AzE8kQZ;;AyErlQQ;EAOI,wBAAA;AzEklQZ;;AyEzlQQ;EAOI,wDAAA;AzEslQZ;;AyE7lQQ;EAOI,8DAAA;AzE0lQZ;;AyEjmQQ;EAOI,uDAAA;AzE8lQZ;;AyErmQQ;EAOI,2BAAA;AzEkmQZ;;AyEnnQQ;EACE,gFAAA;AzEsnQV;;AyEvnQQ;EACE,kFAAA;AzE0nQV;;AyE3nQQ;EACE,gFAAA;AzE8nQV;;AyE/nQQ;EACE,6EAAA;AzEkoQV;;AyEnoQQ;EACE,gFAAA;AzEsoQV;;AyEvoQQ;EACE,+EAAA;AzE0oQV;;AyE3oQQ;EACE,8EAAA;AzE8oQV;;AyE/oQQ;EACE,6EAAA;AzEkpQV;;AyEzoQQ;EAOI,2BAAA;AzEsoQZ;;AyE7oQQ;EAOI,6BAAA;AzE0oQZ;;AyEjpQQ;EAOI,6BAAA;AzE8oQZ;;AyErpQQ;EAOI,0BAAA;AzEkpQZ;;AyEzpQQ;EAOI,2BAAA;AzEspQZ;;AyE7pQQ;EAOI,iBAAA;AzE0pQZ;;AyEjqQQ;EAOI,mBAAA;AzE8pQZ;;AyErqQQ;EAOI,oBAAA;AzEkqQZ;;AyEzqQQ;EAOI,mBAAA;AzEsqQZ;;AyE7qQQ;EAOI,oBAAA;AzE0qQZ;;AyEjrQQ;EAOI,sBAAA;AzE8qQZ;;AyErrQQ;EAOI,uBAAA;AzEkrQZ;;AyEzrQQ;EAOI,sBAAA;AzEsrQZ;;AyE7rQQ;EAOI,kBAAA;AzE0rQZ;;AyEjsQQ;EAOI,oBAAA;AzE8rQZ;;AyErsQQ;EAOI,qBAAA;AzEksQZ;;AyEzsQQ;EAOI,oBAAA;AzEssQZ;;AyE7sQQ;EAOI,mBAAA;AzE0sQZ;;AyEjtQQ;EAOI,qBAAA;AzE8sQZ;;AyErtQQ;EAOI,sBAAA;AzEktQZ;;AyEztQQ;EAOI,qBAAA;AzEstQZ;;AyE7tQQ;EAOI,2CAAA;AzE0tQZ;;AyEjuQQ;EAOI,sCAAA;AzE8tQZ;;AyEruQQ;EAOI,sCAAA;AzEkuQZ;;AyEzuQQ;EAOI,uFAAA;AzEsuQZ;;AyE7uQQ;EAOI,oBAAA;AzE0uQZ;;AyEjvQQ;EAOI,2FAAA;AzE8uQZ;;AyErvQQ;EAOI,wBAAA;AzEkvQZ;;AyEzvQQ;EAOI,6FAAA;AzEsvQZ;;AyE7vQQ;EAOI,0BAAA;AzE0vQZ;;AyEjwQQ;EAOI,8FAAA;AzE8vQZ;;AyErwQQ;EAOI,2BAAA;AzEkwQZ;;AyEzwQQ;EAOI,4FAAA;AzEswQZ;;AyE7wQQ;EAOI,yBAAA;AzE0wQZ;;AyEjxQQ;EAIQ,sBAAA;EAGJ,8EAAA;AzE+wQZ;;AyEtxQQ;EAIQ,sBAAA;EAGJ,gFAAA;AzEoxQZ;;AyE3xQQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEyxQZ;;AyEhyQQ;EAIQ,sBAAA;EAGJ,2EAAA;AzE8xQZ;;AyEryQQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEmyQZ;;AyE1yQQ;EAIQ,sBAAA;EAGJ,6EAAA;AzEwyQZ;;AyE/yQQ;EAIQ,sBAAA;EAGJ,4EAAA;AzE6yQZ;;AyEpzQQ;EAIQ,sBAAA;EAGJ,2EAAA;AzEkzQZ;;AyEzzQQ;EAIQ,sBAAA;EAGJ,4EAAA;AzEuzQZ;;AyE9zQQ;EAIQ,sBAAA;EAGJ,4EAAA;AzE4zQZ;;AyEn0QQ;EAOI,wDAAA;AzEg0QZ;;AyEv0QQ;EAOI,0DAAA;AzEo0QZ;;AyE30QQ;EAOI,wDAAA;AzEw0QZ;;AyE/0QQ;EAOI,qDAAA;AzE40QZ;;AyEn1QQ;EAOI,wDAAA;AzEg1QZ;;AyEv1QQ;EAOI,uDAAA;AzEo1QZ;;AyE31QQ;EAOI,sDAAA;AzEw1QZ;;AyE/1QQ;EAOI,qDAAA;AzE41QZ;;AyEn2QQ;EAOI,4BAAA;AzEg2QZ;;AyEv2QQ;EAOI,4BAAA;AzEo2QZ;;AyE32QQ;EAOI,4BAAA;AzEw2QZ;;AyE/2QQ;EAOI,4BAAA;AzE42QZ;;AyEn3QQ;EAOI,4BAAA;AzEg3QZ;;AyEj4QQ;EACE,wBAAA;AzEo4QV;;AyEr4QQ;EACE,yBAAA;AzEw4QV;;AyEz4QQ;EACE,wBAAA;AzE44QV;;AyE74QQ;EACE,yBAAA;AzEg5QV;;AyEj5QQ;EACE,sBAAA;AzEo5QV;;AyE34QQ;EAOI,oBAAA;AzEw4QZ;;AyE/4QQ;EAOI,qBAAA;AzE44QZ;;AyEn5QQ;EAOI,qBAAA;AzEg5QZ;;AyEv5QQ;EAOI,qBAAA;AzEo5QZ;;AyE35QQ;EAOI,qBAAA;AzEw5QZ;;AyE/5QQ;EAOI,qBAAA;AzE45QZ;;AyEn6QQ;EAOI,qBAAA;AzEg6QZ;;AyEv6QQ;EAOI,qBAAA;AzEo6QZ;;AyE36QQ;EAOI,qBAAA;AzEw6QZ;;AyE/6QQ;EAOI,qBAAA;AzE46QZ;;AyEn7QQ;EAOI,qBAAA;AzEg7QZ;;AyEv7QQ;EAOI,qBAAA;AzEo7QZ;;AyE37QQ;EAOI,qBAAA;AzEw7QZ;;AyE/7QQ;EAOI,qBAAA;AzE47QZ;;AyEn8QQ;EAOI,qBAAA;AzEg8QZ;;AyEv8QQ;EAOI,qBAAA;AzEo8QZ;;AyE38QQ;EAOI,qBAAA;AzEw8QZ;;AyE/8QQ;EAOI,sBAAA;AzE48QZ;;AyEn9QQ;EAOI,qBAAA;AzEg9QZ;;AyEv9QQ;EAOI,qBAAA;AzEo9QZ;;AyE39QQ;EAOI,qBAAA;AzEw9QZ;;AyE/9QQ;EAOI,qBAAA;AzE49QZ;;AyEn+QQ;EAOI,qBAAA;AzEg+QZ;;AyEv+QQ;EAOI,sBAAA;AzEo+QZ;;AyE3+QQ;EAOI,sBAAA;AzEw+QZ;;AyE/+QQ;EAOI,sBAAA;AzE4+QZ;;AyEn/QQ;EAOI,sBAAA;AzEg/QZ;;AyEv/QQ;EAOI,sBAAA;AzEo/QZ;;AyE3/QQ;EAOI,sBAAA;AzEw/QZ;;AyE//QQ;EAOI,sBAAA;AzE4/QZ;;AyEngRQ;EAOI,sBAAA;AzEggRZ;;AyEvgRQ;EAOI,sBAAA;AzEogRZ;;AyE3gRQ;EAOI,sBAAA;AzEwgRZ;;AyE/gRQ;EAOI,sBAAA;AzE4gRZ;;AyEnhRQ;EAOI,sBAAA;AzEghRZ;;AyEvhRQ;EAOI,sBAAA;AzEohRZ;;AyE3hRQ;EAOI,sBAAA;AzEwhRZ;;AyE/hRQ;EAOI,sBAAA;AzE4hRZ;;AyEniRQ;EAOI,uBAAA;AzEgiRZ;;AyEviRQ;EAOI,uBAAA;AzEoiRZ;;AyE3iRQ;EAOI,uBAAA;AzEwiRZ;;AyE/iRQ;EAOI,uBAAA;AzE4iRZ;;AyEnjRQ;EAOI,uBAAA;AzEgjRZ;;AyEvjRQ;EAOI,uBAAA;AzEojRZ;;AyE3jRQ;EAOI,uBAAA;AzEwjRZ;;AyE/jRQ;EAOI,uBAAA;AzE4jRZ;;AyEnkRQ;EAOI,uBAAA;AzEgkRZ;;AyEvkRQ;EAOI,uBAAA;AzEokRZ;;AyE3kRQ;EAOI,uBAAA;AzEwkRZ;;AyE/kRQ;EAOI,uBAAA;AzE4kRZ;;AyEnlRQ;EAOI,uBAAA;AzEglRZ;;AyEvlRQ;EAOI,uBAAA;AzEolRZ;;AyE3lRQ;EAOI,uBAAA;AzEwlRZ;;AyE/lRQ;EAOI,uBAAA;AzE4lRZ;;AyEnmRQ;EAOI,uBAAA;AzEgmRZ;;AyEvmRQ;EAOI,uBAAA;AzEomRZ;;AyE3mRQ;EAOI,uBAAA;AzEwmRZ;;AyE/mRQ;EAOI,uBAAA;AzE4mRZ;;AyEnnRQ;EAOI,uBAAA;AzEgnRZ;;AyEvnRQ;EAOI,uBAAA;AzEonRZ;;AyE3nRQ;EAOI,uBAAA;AzEwnRZ;;AyE/nRQ;EAOI,uBAAA;AzE4nRZ;;AyEnoRQ;EAOI,uBAAA;AzEgoRZ;;AyEvoRQ;EAOI,uBAAA;AzEooRZ;;AyE3oRQ;EAOI,uBAAA;AzEwoRZ;;AyE/oRQ;EAOI,uBAAA;AzE4oRZ;;AyEnpRQ;EAOI,sBAAA;AzEgpRZ;;AyEvpRQ;EAOI,0BAAA;AzEopRZ;;AyE3pRQ;EAOI,uBAAA;AzEwpRZ;;AyE/pRQ;EAOI,2BAAA;AzE4pRZ;;AyEnqRQ;EAOI,qBAAA;AzEgqRZ;;AyEvqRQ;EAOI,sBAAA;AzEoqRZ;;AyE3qRQ;EAOI,sBAAA;AzEwqRZ;;AyE/qRQ;EAOI,sBAAA;AzE4qRZ;;AyEnrRQ;EAOI,sBAAA;AzEgrRZ;;AyEvrRQ;EAOI,sBAAA;AzEorRZ;;AyE3rRQ;EAOI,sBAAA;AzEwrRZ;;AyE/rRQ;EAOI,sBAAA;AzE4rRZ;;AyEnsRQ;EAOI,sBAAA;AzEgsRZ;;AyEvsRQ;EAOI,sBAAA;AzEosRZ;;AyE3sRQ;EAOI,sBAAA;AzEwsRZ;;AyE/sRQ;EAOI,sBAAA;AzE4sRZ;;AyEntRQ;EAOI,sBAAA;AzEgtRZ;;AyEvtRQ;EAOI,sBAAA;AzEotRZ;;AyE3tRQ;EAOI,sBAAA;AzEwtRZ;;AyE/tRQ;EAOI,uBAAA;AzE4tRZ;;AyEnuRQ;EAOI,sBAAA;AzEguRZ;;AyEvuRQ;EAOI,sBAAA;AzEouRZ;;AyE3uRQ;EAOI,sBAAA;AzEwuRZ;;AyE/uRQ;EAOI,sBAAA;AzE4uRZ;;AyEnvRQ;EAOI,sBAAA;AzEgvRZ;;AyEvvRQ;EAOI,uBAAA;AzEovRZ;;AyE3vRQ;EAOI,uBAAA;AzEwvRZ;;AyE/vRQ;EAOI,uBAAA;AzE4vRZ;;AyEnwRQ;EAOI,uBAAA;AzEgwRZ;;AyEvwRQ;EAOI,uBAAA;AzEowRZ;;AyE3wRQ;EAOI,uBAAA;AzEwwRZ;;AyE/wRQ;EAOI,uBAAA;AzE4wRZ;;AyEnxRQ;EAOI,uBAAA;AzEgxRZ;;AyEvxRQ;EAOI,uBAAA;AzEoxRZ;;AyE3xRQ;EAOI,uBAAA;AzEwxRZ;;AyE/xRQ;EAOI,uBAAA;AzE4xRZ;;AyEnyRQ;EAOI,uBAAA;AzEgyRZ;;AyEvyRQ;EAOI,uBAAA;AzEoyRZ;;AyE3yRQ;EAOI,uBAAA;AzEwyRZ;;AyE/yRQ;EAOI,uBAAA;AzE4yRZ;;AyEnzRQ;EAOI,uBAAA;AzEgzRZ;;AyEvzRQ;EAOI,uBAAA;AzEozRZ;;AyE3zRQ;EAOI,uBAAA;AzEwzRZ;;AyE/zRQ;EAOI,uBAAA;AzE4zRZ;;AyEn0RQ;EAOI,uBAAA;AzEg0RZ;;AyEv0RQ;EAOI,wBAAA;AzEo0RZ;;AyE30RQ;EAOI,wBAAA;AzEw0RZ;;AyE/0RQ;EAOI,wBAAA;AzE40RZ;;AyEn1RQ;EAOI,wBAAA;AzEg1RZ;;AyEv1RQ;EAOI,wBAAA;AzEo1RZ;;AyE31RQ;EAOI,wBAAA;AzEw1RZ;;AyE/1RQ;EAOI,wBAAA;AzE41RZ;;AyEn2RQ;EAOI,wBAAA;AzEg2RZ;;AyEv2RQ;EAOI,wBAAA;AzEo2RZ;;AyE32RQ;EAOI,wBAAA;AzEw2RZ;;AyE/2RQ;EAOI,wBAAA;AzE42RZ;;AyEn3RQ;EAOI,wBAAA;AzEg3RZ;;AyEv3RQ;EAOI,wBAAA;AzEo3RZ;;AyE33RQ;EAOI,wBAAA;AzEw3RZ;;AyE/3RQ;EAOI,wBAAA;AzE43RZ;;AyEn4RQ;EAOI,wBAAA;AzEg4RZ;;AyEv4RQ;EAOI,wBAAA;AzEo4RZ;;AyE34RQ;EAOI,wBAAA;AzEw4RZ;;AyE/4RQ;EAOI,wBAAA;AzE44RZ;;AyEn5RQ;EAOI,wBAAA;AzEg5RZ;;AyEv5RQ;EAOI,wBAAA;AzEo5RZ;;AyE35RQ;EAOI,wBAAA;AzEw5RZ;;AyE/5RQ;EAOI,wBAAA;AzE45RZ;;AyEn6RQ;EAOI,wBAAA;AzEg6RZ;;AyEv6RQ;EAOI,wBAAA;AzEo6RZ;;AyE36RQ;EAOI,wBAAA;AzEw6RZ;;AyE/6RQ;EAOI,wBAAA;AzE46RZ;;AyEn7RQ;EAOI,wBAAA;AzEg7RZ;;AyEv7RQ;EAOI,uBAAA;AzEo7RZ;;AyE37RQ;EAOI,uBAAA;AzEw7RZ;;AyE/7RQ;EAOI,uBAAA;AzE47RZ;;AyEn8RQ;EAOI,uBAAA;AzEg8RZ;;AyEv8RQ;EAOI,uBAAA;AzEo8RZ;;AyE38RQ;EAOI,uBAAA;AzEw8RZ;;AyE/8RQ;EAOI,uBAAA;AzE48RZ;;AyEn9RQ;EAOI,wBAAA;AzEg9RZ;;AyEv9RQ;EAOI,uBAAA;AzEo9RZ;;AyE39RQ;EAOI,2BAAA;AzEw9RZ;;AyE/9RQ;EAOI,wBAAA;AzE49RZ;;AyEn+RQ;EAOI,4BAAA;AzEg+RZ;;AyEv+RQ;EAOI,yBAAA;AzEo+RZ;;AyE3+RQ;EAOI,8BAAA;AzEw+RZ;;AyE/+RQ;EAOI,iCAAA;AzE4+RZ;;AyEn/RQ;EAOI,sCAAA;AzEg/RZ;;AyEv/RQ;EAOI,yCAAA;AzEo/RZ;;AyE3/RQ;EAOI,uBAAA;AzEw/RZ;;AyE//RQ;EAOI,uBAAA;AzE4/RZ;;AyEngSQ;EAOI,yBAAA;AzEggSZ;;AyEvgSQ;EAOI,yBAAA;AzEogSZ;;AyE3gSQ;EAOI,0BAAA;AzEwgSZ;;AyE/gSQ;EAOI,4BAAA;AzE4gSZ;;AyEnhSQ;EAOI,kCAAA;AzEghSZ;;AyEvhSQ;EAOI,sCAAA;AzEohSZ;;AyE3hSQ;EAOI,oCAAA;AzEwhSZ;;AyE/hSQ;EAOI,kCAAA;AzE4hSZ;;AyEniSQ;EAOI,yCAAA;AzEgiSZ;;AyEviSQ;EAOI,wCAAA;AzEoiSZ;;AyE3iSQ;EAOI,wCAAA;AzEwiSZ;;AyE/iSQ;EAOI,kCAAA;AzE4iSZ;;AyEnjSQ;EAOI,gCAAA;AzEgjSZ;;AyEvjSQ;EAOI,8BAAA;AzEojSZ;;AyE3jSQ;EAOI,gCAAA;AzEwjSZ;;AyE/jSQ;EAOI,+BAAA;AzE4jSZ;;AyEnkSQ;EAOI,oCAAA;AzEgkSZ;;AyEvkSQ;EAOI,kCAAA;AzEokSZ;;AyE3kSQ;EAOI,gCAAA;AzEwkSZ;;AyE/kSQ;EAOI,uCAAA;AzE4kSZ;;AyEnlSQ;EAOI,sCAAA;AzEglSZ;;AyEvlSQ;EAOI,iCAAA;AzEolSZ;;AyE3lSQ;EAOI,2BAAA;AzEwlSZ;;AyE/lSQ;EAOI,iCAAA;AzE4lSZ;;AyEnmSQ;EAOI,+BAAA;AzEgmSZ;;AyEvmSQ;EAOI,6BAAA;AzEomSZ;;AyE3mSQ;EAOI,+BAAA;AzEwmSZ;;AyE/mSQ;EAOI,8BAAA;AzE4mSZ;;AyEnnSQ;EAOI,oBAAA;AzEgnSZ;;AyEvnSQ;EAOI,mBAAA;AzEonSZ;;AyE3nSQ;EAOI,mBAAA;AzEwnSZ;;AyE/nSQ;EAOI,mBAAA;AzE4nSZ;;AyEnoSQ;EAOI,mBAAA;AzEgoSZ;;AyEvoSQ;EAOI,mBAAA;AzEooSZ;;AyE3oSQ;EAOI,mBAAA;AzEwoSZ;;AyE/oSQ;EAOI,mBAAA;AzE4oSZ;;AyEnpSQ;EAOI,oBAAA;AzEgpSZ;;AyEvpSQ;EAOI,0BAAA;AzEopSZ;;AyE3pSQ;EAOI,yBAAA;AzEwpSZ;;AyE/pSQ;EAOI,uBAAA;AzE4pSZ;;AyEnqSQ;EAOI,yBAAA;AzEgqSZ;;AyEvqSQ;EAOI,uBAAA;AzEoqSZ;;AyE3qSQ;EAOI,sBAAA;AzEwqSZ;;AyE/qSQ;EAOI,uBAAA;AzE4qSZ;;AyEnrSQ;EAOI,uBAAA;AzEgrSZ;;AyEvrSQ;EAOI,uBAAA;AzEorSZ;;AyE3rSQ;EAOI,uBAAA;AzEwrSZ;;AyE/rSQ;EAOI,uBAAA;AzE4rSZ;;AyEnsSQ;EAOI,uBAAA;AzEgsSZ;;AyEvsSQ;EAOI,uBAAA;AzEosSZ;;AyE3sSQ;EAOI,uBAAA;AzEwsSZ;;AyE/sSQ;EAOI,uBAAA;AzE4sSZ;;AyEntSQ;EAOI,uBAAA;AzEgtSZ;;AyEvtSQ;EAOI,uBAAA;AzEotSZ;;AyE3tSQ;EAOI,wBAAA;AzEwtSZ;;AyE/tSQ;EAOI,wBAAA;AzE4tSZ;;AyEnuSQ;EAOI,wBAAA;AzEguSZ;;AyEvuSQ;EAOI,wBAAA;AzEouSZ;;AyE3uSQ;EAOI,wBAAA;AzEwuSZ;;AyE/uSQ;EAOI,wBAAA;AzE4uSZ;;AyEnvSQ;EAOI,wBAAA;AzEgvSZ;;AyEvvSQ;EAOI,wBAAA;AzEovSZ;;AyE3vSQ;EAOI,wBAAA;AzEwvSZ;;AyE/vSQ;EAOI,wBAAA;AzE4vSZ;;AyEnwSQ;EAOI,uBAAA;AzEgwSZ;;AyEvwSQ;EAOI,0BAAA;EAAA,yBAAA;AzEqwSZ;;AyE5wSQ;EAOI,gCAAA;EAAA,+BAAA;AzE0wSZ;;AyEjxSQ;EAOI,+BAAA;EAAA,8BAAA;AzE+wSZ;;AyEtxSQ;EAOI,6BAAA;EAAA,4BAAA;AzEoxSZ;;AyE3xSQ;EAOI,+BAAA;EAAA,8BAAA;AzEyxSZ;;AyEhySQ;EAOI,6BAAA;EAAA,4BAAA;AzE8xSZ;;AyErySQ;EAOI,4BAAA;EAAA,2BAAA;AzEmySZ;;AyE1ySQ;EAOI,6BAAA;EAAA,4BAAA;AzEwySZ;;AyE/ySQ;EAOI,6BAAA;EAAA,4BAAA;AzE6ySZ;;AyEpzSQ;EAOI,6BAAA;EAAA,4BAAA;AzEkzSZ;;AyEzzSQ;EAOI,6BAAA;EAAA,4BAAA;AzEuzSZ;;AyE9zSQ;EAOI,6BAAA;EAAA,4BAAA;AzE4zSZ;;AyEn0SQ;EAOI,6BAAA;EAAA,4BAAA;AzEi0SZ;;AyEx0SQ;EAOI,6BAAA;EAAA,4BAAA;AzEs0SZ;;AyE70SQ;EAOI,6BAAA;EAAA,4BAAA;AzE20SZ;;AyEl1SQ;EAOI,6BAAA;EAAA,4BAAA;AzEg1SZ;;AyEv1SQ;EAOI,6BAAA;EAAA,4BAAA;AzEq1SZ;;AyE51SQ;EAOI,6BAAA;EAAA,4BAAA;AzE01SZ;;AyEj2SQ;EAOI,8BAAA;EAAA,6BAAA;AzE+1SZ;;AyEt2SQ;EAOI,8BAAA;EAAA,6BAAA;AzEo2SZ;;AyE32SQ;EAOI,8BAAA;EAAA,6BAAA;AzEy2SZ;;AyEh3SQ;EAOI,8BAAA;EAAA,6BAAA;AzE82SZ;;AyEr3SQ;EAOI,8BAAA;EAAA,6BAAA;AzEm3SZ;;AyE13SQ;EAOI,8BAAA;EAAA,6BAAA;AzEw3SZ;;AyE/3SQ;EAOI,8BAAA;EAAA,6BAAA;AzE63SZ;;AyEp4SQ;EAOI,8BAAA;EAAA,6BAAA;AzEk4SZ;;AyEz4SQ;EAOI,8BAAA;EAAA,6BAAA;AzEu4SZ;;AyE94SQ;EAOI,8BAAA;EAAA,6BAAA;AzE44SZ;;AyEn5SQ;EAOI,6BAAA;EAAA,4BAAA;AzEi5SZ;;AyEx5SQ;EAOI,wBAAA;EAAA,2BAAA;AzEs5SZ;;AyE75SQ;EAOI,8BAAA;EAAA,iCAAA;AzE25SZ;;AyEl6SQ;EAOI,6BAAA;EAAA,gCAAA;AzEg6SZ;;AyEv6SQ;EAOI,2BAAA;EAAA,8BAAA;AzEq6SZ;;AyE56SQ;EAOI,6BAAA;EAAA,gCAAA;AzE06SZ;;AyEj7SQ;EAOI,2BAAA;EAAA,8BAAA;AzE+6SZ;;AyEt7SQ;EAOI,0BAAA;EAAA,6BAAA;AzEo7SZ;;AyE37SQ;EAOI,2BAAA;EAAA,8BAAA;AzEy7SZ;;AyEh8SQ;EAOI,2BAAA;EAAA,8BAAA;AzE87SZ;;AyEr8SQ;EAOI,2BAAA;EAAA,8BAAA;AzEm8SZ;;AyE18SQ;EAOI,2BAAA;EAAA,8BAAA;AzEw8SZ;;AyE/8SQ;EAOI,2BAAA;EAAA,8BAAA;AzE68SZ;;AyEp9SQ;EAOI,2BAAA;EAAA,8BAAA;AzEk9SZ;;AyEz9SQ;EAOI,2BAAA;EAAA,8BAAA;AzEu9SZ;;AyE99SQ;EAOI,2BAAA;EAAA,8BAAA;AzE49SZ;;AyEn+SQ;EAOI,2BAAA;EAAA,8BAAA;AzEi+SZ;;AyEx+SQ;EAOI,2BAAA;EAAA,8BAAA;AzEs+SZ;;AyE7+SQ;EAOI,2BAAA;EAAA,8BAAA;AzE2+SZ;;AyEl/SQ;EAOI,4BAAA;EAAA,+BAAA;AzEg/SZ;;AyEv/SQ;EAOI,4BAAA;EAAA,+BAAA;AzEq/SZ;;AyE5/SQ;EAOI,4BAAA;EAAA,+BAAA;AzE0/SZ;;AyEjgTQ;EAOI,4BAAA;EAAA,+BAAA;AzE+/SZ;;AyEtgTQ;EAOI,4BAAA;EAAA,+BAAA;AzEogTZ;;AyE3gTQ;EAOI,4BAAA;EAAA,+BAAA;AzEygTZ;;AyEhhTQ;EAOI,4BAAA;EAAA,+BAAA;AzE8gTZ;;AyErhTQ;EAOI,4BAAA;EAAA,+BAAA;AzEmhTZ;;AyE1hTQ;EAOI,4BAAA;EAAA,+BAAA;AzEwhTZ;;AyE/hTQ;EAOI,4BAAA;EAAA,+BAAA;AzE6hTZ;;AyEpiTQ;EAOI,2BAAA;EAAA,8BAAA;AzEkiTZ;;AyEziTQ;EAOI,wBAAA;AzEsiTZ;;AyE7iTQ;EAOI,8BAAA;AzE0iTZ;;AyEjjTQ;EAOI,6BAAA;AzE8iTZ;;AyErjTQ;EAOI,2BAAA;AzEkjTZ;;AyEzjTQ;EAOI,6BAAA;AzEsjTZ;;AyE7jTQ;EAOI,2BAAA;AzE0jTZ;;AyEjkTQ;EAOI,0BAAA;AzE8jTZ;;AyErkTQ;EAOI,2BAAA;AzEkkTZ;;AyEzkTQ;EAOI,2BAAA;AzEskTZ;;AyE7kTQ;EAOI,2BAAA;AzE0kTZ;;AyEjlTQ;EAOI,2BAAA;AzE8kTZ;;AyErlTQ;EAOI,2BAAA;AzEklTZ;;AyEzlTQ;EAOI,2BAAA;AzEslTZ;;AyE7lTQ;EAOI,2BAAA;AzE0lTZ;;AyEjmTQ;EAOI,2BAAA;AzE8lTZ;;AyErmTQ;EAOI,2BAAA;AzEkmTZ;;AyEzmTQ;EAOI,2BAAA;AzEsmTZ;;AyE7mTQ;EAOI,2BAAA;AzE0mTZ;;AyEjnTQ;EAOI,4BAAA;AzE8mTZ;;AyErnTQ;EAOI,4BAAA;AzEknTZ;;AyEznTQ;EAOI,4BAAA;AzEsnTZ;;AyE7nTQ;EAOI,4BAAA;AzE0nTZ;;AyEjoTQ;EAOI,4BAAA;AzE8nTZ;;AyEroTQ;EAOI,4BAAA;AzEkoTZ;;AyEzoTQ;EAOI,4BAAA;AzEsoTZ;;AyE7oTQ;EAOI,4BAAA;AzE0oTZ;;AyEjpTQ;EAOI,4BAAA;AzE8oTZ;;AyErpTQ;EAOI,4BAAA;AzEkpTZ;;AyEzpTQ;EAOI,2BAAA;AzEspTZ;;AyE7pTQ;EAOI,0BAAA;AzE0pTZ;;AyEjqTQ;EAOI,gCAAA;AzE8pTZ;;AyErqTQ;EAOI,+BAAA;AzEkqTZ;;AyEzqTQ;EAOI,6BAAA;AzEsqTZ;;AyE7qTQ;EAOI,+BAAA;AzE0qTZ;;AyEjrTQ;EAOI,6BAAA;AzE8qTZ;;AyErrTQ;EAOI,4BAAA;AzEkrTZ;;AyEzrTQ;EAOI,6BAAA;AzEsrTZ;;AyE7rTQ;EAOI,6BAAA;AzE0rTZ;;AyEjsTQ;EAOI,6BAAA;AzE8rTZ;;AyErsTQ;EAOI,6BAAA;AzEksTZ;;AyEzsTQ;EAOI,6BAAA;AzEssTZ;;AyE7sTQ;EAOI,6BAAA;AzE0sTZ;;AyEjtTQ;EAOI,6BAAA;AzE8sTZ;;AyErtTQ;EAOI,6BAAA;AzEktTZ;;AyEztTQ;EAOI,6BAAA;AzEstTZ;;AyE7tTQ;EAOI,6BAAA;AzE0tTZ;;AyEjuTQ;EAOI,6BAAA;AzE8tTZ;;AyEruTQ;EAOI,8BAAA;AzEkuTZ;;AyEzuTQ;EAOI,8BAAA;AzEsuTZ;;AyE7uTQ;EAOI,8BAAA;AzE0uTZ;;AyEjvTQ;EAOI,8BAAA;AzE8uTZ;;AyErvTQ;EAOI,8BAAA;AzEkvTZ;;AyEzvTQ;EAOI,8BAAA;AzEsvTZ;;AyE7vTQ;EAOI,8BAAA;AzE0vTZ;;AyEjwTQ;EAOI,8BAAA;AzE8vTZ;;AyErwTQ;EAOI,8BAAA;AzEkwTZ;;AyEzwTQ;EAOI,8BAAA;AzEswTZ;;AyE7wTQ;EAOI,6BAAA;AzE0wTZ;;AyEjxTQ;EAOI,2BAAA;AzE8wTZ;;AyErxTQ;EAOI,iCAAA;AzEkxTZ;;AyEzxTQ;EAOI,gCAAA;AzEsxTZ;;AyE7xTQ;EAOI,8BAAA;AzE0xTZ;;AyEjyTQ;EAOI,gCAAA;AzE8xTZ;;AyEryTQ;EAOI,8BAAA;AzEkyTZ;;AyEzyTQ;EAOI,6BAAA;AzEsyTZ;;AyE7yTQ;EAOI,8BAAA;AzE0yTZ;;AyEjzTQ;EAOI,8BAAA;AzE8yTZ;;AyErzTQ;EAOI,8BAAA;AzEkzTZ;;AyEzzTQ;EAOI,8BAAA;AzEszTZ;;AyE7zTQ;EAOI,8BAAA;AzE0zTZ;;AyEj0TQ;EAOI,8BAAA;AzE8zTZ;;AyEr0TQ;EAOI,8BAAA;AzEk0TZ;;AyEz0TQ;EAOI,8BAAA;AzEs0TZ;;AyE70TQ;EAOI,8BAAA;AzE00TZ;;AyEj1TQ;EAOI,8BAAA;AzE80TZ;;AyEr1TQ;EAOI,8BAAA;AzEk1TZ;;AyEz1TQ;EAOI,+BAAA;AzEs1TZ;;AyE71TQ;EAOI,+BAAA;AzE01TZ;;AyEj2TQ;EAOI,+BAAA;AzE81TZ;;AyEr2TQ;EAOI,+BAAA;AzEk2TZ;;AyEz2TQ;EAOI,+BAAA;AzEs2TZ;;AyE72TQ;EAOI,+BAAA;AzE02TZ;;AyEj3TQ;EAOI,+BAAA;AzE82TZ;;AyEr3TQ;EAOI,+BAAA;AzEk3TZ;;AyEz3TQ;EAOI,+BAAA;AzEs3TZ;;AyE73TQ;EAOI,+BAAA;AzE03TZ;;AyEj4TQ;EAOI,8BAAA;AzE83TZ;;AyEr4TQ;EAOI,yBAAA;AzEk4TZ;;AyEz4TQ;EAOI,+BAAA;AzEs4TZ;;AyE74TQ;EAOI,8BAAA;AzE04TZ;;AyEj5TQ;EAOI,4BAAA;AzE84TZ;;AyEr5TQ;EAOI,8BAAA;AzEk5TZ;;AyEz5TQ;EAOI,4BAAA;AzEs5TZ;;AyE75TQ;EAOI,2BAAA;AzE05TZ;;AyEj6TQ;EAOI,4BAAA;AzE85TZ;;AyEr6TQ;EAOI,4BAAA;AzEk6TZ;;AyEz6TQ;EAOI,4BAAA;AzEs6TZ;;AyE76TQ;EAOI,4BAAA;AzE06TZ;;AyEj7TQ;EAOI,4BAAA;AzE86TZ;;AyEr7TQ;EAOI,4BAAA;AzEk7TZ;;AyEz7TQ;EAOI,4BAAA;AzEs7TZ;;AyE77TQ;EAOI,4BAAA;AzE07TZ;;AyEj8TQ;EAOI,4BAAA;AzE87TZ;;AyEr8TQ;EAOI,4BAAA;AzEk8TZ;;AyEz8TQ;EAOI,4BAAA;AzEs8TZ;;AyE78TQ;EAOI,6BAAA;AzE08TZ;;AyEj9TQ;EAOI,6BAAA;AzE88TZ;;AyEr9TQ;EAOI,6BAAA;AzEk9TZ;;AyEz9TQ;EAOI,6BAAA;AzEs9TZ;;AyE79TQ;EAOI,6BAAA;AzE09TZ;;AyEj+TQ;EAOI,6BAAA;AzE89TZ;;AyEr+TQ;EAOI,6BAAA;AzEk+TZ;;AyEz+TQ;EAOI,6BAAA;AzEs+TZ;;AyE7+TQ;EAOI,6BAAA;AzE0+TZ;;AyEj/TQ;EAOI,6BAAA;AzE8+TZ;;AyEr/TQ;EAOI,4BAAA;AzEk/TZ;;AyEz/TQ;EAOI,2BAAA;AzEs/TZ;;AyE7/TQ;EAOI,0BAAA;AzE0/TZ;;AyEjgUQ;EAOI,wBAAA;AzE8/TZ;;AyErgUQ;EAOI,0BAAA;AzEkgUZ;;AyEzgUQ;EAOI,wBAAA;AzEsgUZ;;AyE7gUQ;EAOI,uBAAA;AzE0gUZ;;AyEjhUQ;EAOI,wBAAA;AzE8gUZ;;AyErhUQ;EAOI,wBAAA;AzEkhUZ;;AyEzhUQ;EAOI,wBAAA;AzEshUZ;;AyE7hUQ;EAOI,wBAAA;AzE0hUZ;;AyEjiUQ;EAOI,wBAAA;AzE8hUZ;;AyEriUQ;EAOI,wBAAA;AzEkiUZ;;AyEziUQ;EAOI,wBAAA;AzEsiUZ;;AyE7iUQ;EAOI,wBAAA;AzE0iUZ;;AyEjjUQ;EAOI,wBAAA;AzE8iUZ;;AyErjUQ;EAOI,wBAAA;AzEkjUZ;;AyEzjUQ;EAOI,wBAAA;AzEsjUZ;;AyE7jUQ;EAOI,yBAAA;AzE0jUZ;;AyEjkUQ;EAOI,yBAAA;AzE8jUZ;;AyErkUQ;EAOI,yBAAA;AzEkkUZ;;AyEzkUQ;EAOI,yBAAA;AzEskUZ;;AyE7kUQ;EAOI,yBAAA;AzE0kUZ;;AyEjlUQ;EAOI,yBAAA;AzE8kUZ;;AyErlUQ;EAOI,yBAAA;AzEklUZ;;AyEzlUQ;EAOI,yBAAA;AzEslUZ;;AyE7lUQ;EAOI,yBAAA;AzE0lUZ;;AyEjmUQ;EAOI,yBAAA;AzE8lUZ;;AyErmUQ;EAOI,iCAAA;EAAA,gCAAA;AzEmmUZ;;AyE1mUQ;EAOI,gCAAA;EAAA,+BAAA;AzEwmUZ;;AyE/mUQ;EAOI,8BAAA;EAAA,6BAAA;AzE6mUZ;;AyEpnUQ;EAOI,gCAAA;EAAA,+BAAA;AzEknUZ;;AyEznUQ;EAOI,8BAAA;EAAA,6BAAA;AzEunUZ;;AyE9nUQ;EAOI,6BAAA;EAAA,4BAAA;AzE4nUZ;;AyEnoUQ;EAOI,8BAAA;EAAA,6BAAA;AzEioUZ;;AyExoUQ;EAOI,8BAAA;EAAA,6BAAA;AzEsoUZ;;AyE7oUQ;EAOI,8BAAA;EAAA,6BAAA;AzE2oUZ;;AyElpUQ;EAOI,8BAAA;EAAA,6BAAA;AzEgpUZ;;AyEvpUQ;EAOI,8BAAA;EAAA,6BAAA;AzEqpUZ;;AyE5pUQ;EAOI,8BAAA;EAAA,6BAAA;AzE0pUZ;;AyEjqUQ;EAOI,8BAAA;EAAA,6BAAA;AzE+pUZ;;AyEtqUQ;EAOI,8BAAA;EAAA,6BAAA;AzEoqUZ;;AyE3qUQ;EAOI,8BAAA;EAAA,6BAAA;AzEyqUZ;;AyEhrUQ;EAOI,8BAAA;EAAA,6BAAA;AzE8qUZ;;AyErrUQ;EAOI,8BAAA;EAAA,6BAAA;AzEmrUZ;;AyE1rUQ;EAOI,+BAAA;EAAA,8BAAA;AzEwrUZ;;AyE/rUQ;EAOI,+BAAA;EAAA,8BAAA;AzE6rUZ;;AyEpsUQ;EAOI,+BAAA;EAAA,8BAAA;AzEksUZ;;AyEzsUQ;EAOI,+BAAA;EAAA,8BAAA;AzEusUZ;;AyE9sUQ;EAOI,+BAAA;EAAA,8BAAA;AzE4sUZ;;AyEntUQ;EAOI,+BAAA;EAAA,8BAAA;AzEitUZ;;AyExtUQ;EAOI,+BAAA;EAAA,8BAAA;AzEstUZ;;AyE7tUQ;EAOI,+BAAA;EAAA,8BAAA;AzE2tUZ;;AyEluUQ;EAOI,+BAAA;EAAA,8BAAA;AzEguUZ;;AyEvuUQ;EAOI,+BAAA;EAAA,8BAAA;AzEquUZ;;AyE5uUQ;EAOI,+BAAA;EAAA,kCAAA;AzE0uUZ;;AyEjvUQ;EAOI,8BAAA;EAAA,iCAAA;AzE+uUZ;;AyEtvUQ;EAOI,4BAAA;EAAA,+BAAA;AzEovUZ;;AyE3vUQ;EAOI,8BAAA;EAAA,iCAAA;AzEyvUZ;;AyEhwUQ;EAOI,4BAAA;EAAA,+BAAA;AzE8vUZ;;AyErwUQ;EAOI,2BAAA;EAAA,8BAAA;AzEmwUZ;;AyE1wUQ;EAOI,4BAAA;EAAA,+BAAA;AzEwwUZ;;AyE/wUQ;EAOI,4BAAA;EAAA,+BAAA;AzE6wUZ;;AyEpxUQ;EAOI,4BAAA;EAAA,+BAAA;AzEkxUZ;;AyEzxUQ;EAOI,4BAAA;EAAA,+BAAA;AzEuxUZ;;AyE9xUQ;EAOI,4BAAA;EAAA,+BAAA;AzE4xUZ;;AyEnyUQ;EAOI,4BAAA;EAAA,+BAAA;AzEiyUZ;;AyExyUQ;EAOI,4BAAA;EAAA,+BAAA;AzEsyUZ;;AyE7yUQ;EAOI,4BAAA;EAAA,+BAAA;AzE2yUZ;;AyElzUQ;EAOI,4BAAA;EAAA,+BAAA;AzEgzUZ;;AyEvzUQ;EAOI,4BAAA;EAAA,+BAAA;AzEqzUZ;;AyE5zUQ;EAOI,4BAAA;EAAA,+BAAA;AzE0zUZ;;AyEj0UQ;EAOI,6BAAA;EAAA,gCAAA;AzE+zUZ;;AyEt0UQ;EAOI,6BAAA;EAAA,gCAAA;AzEo0UZ;;AyE30UQ;EAOI,6BAAA;EAAA,gCAAA;AzEy0UZ;;AyEh1UQ;EAOI,6BAAA;EAAA,gCAAA;AzE80UZ;;AyEr1UQ;EAOI,6BAAA;EAAA,gCAAA;AzEm1UZ;;AyE11UQ;EAOI,6BAAA;EAAA,gCAAA;AzEw1UZ;;AyE/1UQ;EAOI,6BAAA;EAAA,gCAAA;AzE61UZ;;AyEp2UQ;EAOI,6BAAA;EAAA,gCAAA;AzEk2UZ;;AyEz2UQ;EAOI,6BAAA;EAAA,gCAAA;AzEu2UZ;;AyE92UQ;EAOI,6BAAA;EAAA,gCAAA;AzE42UZ;;AyEn3UQ;EAOI,+BAAA;AzEg3UZ;;AyEv3UQ;EAOI,8BAAA;AzEo3UZ;;AyE33UQ;EAOI,4BAAA;AzEw3UZ;;AyE/3UQ;EAOI,8BAAA;AzE43UZ;;AyEn4UQ;EAOI,4BAAA;AzEg4UZ;;AyEv4UQ;EAOI,2BAAA;AzEo4UZ;;AyE34UQ;EAOI,4BAAA;AzEw4UZ;;AyE/4UQ;EAOI,4BAAA;AzE44UZ;;AyEn5UQ;EAOI,4BAAA;AzEg5UZ;;AyEv5UQ;EAOI,4BAAA;AzEo5UZ;;AyE35UQ;EAOI,4BAAA;AzEw5UZ;;AyE/5UQ;EAOI,4BAAA;AzE45UZ;;AyEn6UQ;EAOI,4BAAA;AzEg6UZ;;AyEv6UQ;EAOI,4BAAA;AzEo6UZ;;AyE36UQ;EAOI,4BAAA;AzEw6UZ;;AyE/6UQ;EAOI,4BAAA;AzE46UZ;;AyEn7UQ;EAOI,4BAAA;AzEg7UZ;;AyEv7UQ;EAOI,6BAAA;AzEo7UZ;;AyE37UQ;EAOI,6BAAA;AzEw7UZ;;AyE/7UQ;EAOI,6BAAA;AzE47UZ;;AyEn8UQ;EAOI,6BAAA;AzEg8UZ;;AyEv8UQ;EAOI,6BAAA;AzEo8UZ;;AyE38UQ;EAOI,6BAAA;AzEw8UZ;;AyE/8UQ;EAOI,6BAAA;AzE48UZ;;AyEn9UQ;EAOI,6BAAA;AzEg9UZ;;AyEv9UQ;EAOI,6BAAA;AzEo9UZ;;AyE39UQ;EAOI,6BAAA;AzEw9UZ;;AyE/9UQ;EAOI,iCAAA;AzE49UZ;;AyEn+UQ;EAOI,gCAAA;AzEg+UZ;;AyEv+UQ;EAOI,8BAAA;AzEo+UZ;;AyE3+UQ;EAOI,gCAAA;AzEw+UZ;;AyE/+UQ;EAOI,8BAAA;AzE4+UZ;;AyEn/UQ;EAOI,6BAAA;AzEg/UZ;;AyEv/UQ;EAOI,8BAAA;AzEo/UZ;;AyE3/UQ;EAOI,8BAAA;AzEw/UZ;;AyE//UQ;EAOI,8BAAA;AzE4/UZ;;AyEngVQ;EAOI,8BAAA;AzEggVZ;;AyEvgVQ;EAOI,8BAAA;AzEogVZ;;AyE3gVQ;EAOI,8BAAA;AzEwgVZ;;AyE/gVQ;EAOI,8BAAA;AzE4gVZ;;AyEnhVQ;EAOI,8BAAA;AzEghVZ;;AyEvhVQ;EAOI,8BAAA;AzEohVZ;;AyE3hVQ;EAOI,8BAAA;AzEwhVZ;;AyE/hVQ;EAOI,8BAAA;AzE4hVZ;;AyEniVQ;EAOI,+BAAA;AzEgiVZ;;AyEviVQ;EAOI,+BAAA;AzEoiVZ;;AyE3iVQ;EAOI,+BAAA;AzEwiVZ;;AyE/iVQ;EAOI,+BAAA;AzE4iVZ;;AyEnjVQ;EAOI,+BAAA;AzEgjVZ;;AyEvjVQ;EAOI,+BAAA;AzEojVZ;;AyE3jVQ;EAOI,+BAAA;AzEwjVZ;;AyE/jVQ;EAOI,+BAAA;AzE4jVZ;;AyEnkVQ;EAOI,+BAAA;AzEgkVZ;;AyEvkVQ;EAOI,+BAAA;AzEokVZ;;AyE3kVQ;EAOI,kCAAA;AzEwkVZ;;AyE/kVQ;EAOI,iCAAA;AzE4kVZ;;AyEnlVQ;EAOI,+BAAA;AzEglVZ;;AyEvlVQ;EAOI,iCAAA;AzEolVZ;;AyE3lVQ;EAOI,+BAAA;AzEwlVZ;;AyE/lVQ;EAOI,8BAAA;AzE4lVZ;;AyEnmVQ;EAOI,+BAAA;AzEgmVZ;;AyEvmVQ;EAOI,+BAAA;AzEomVZ;;AyE3mVQ;EAOI,+BAAA;AzEwmVZ;;AyE/mVQ;EAOI,+BAAA;AzE4mVZ;;AyEnnVQ;EAOI,+BAAA;AzEgnVZ;;AyEvnVQ;EAOI,+BAAA;AzEonVZ;;AyE3nVQ;EAOI,+BAAA;AzEwnVZ;;AyE/nVQ;EAOI,+BAAA;AzE4nVZ;;AyEnoVQ;EAOI,+BAAA;AzEgoVZ;;AyEvoVQ;EAOI,+BAAA;AzEooVZ;;AyE3oVQ;EAOI,+BAAA;AzEwoVZ;;AyE/oVQ;EAOI,gCAAA;AzE4oVZ;;AyEnpVQ;EAOI,gCAAA;AzEgpVZ;;AyEvpVQ;EAOI,gCAAA;AzEopVZ;;AyE3pVQ;EAOI,gCAAA;AzEwpVZ;;AyE/pVQ;EAOI,gCAAA;AzE4pVZ;;AyEnqVQ;EAOI,gCAAA;AzEgqVZ;;AyEvqVQ;EAOI,gCAAA;AzEoqVZ;;AyE3qVQ;EAOI,gCAAA;AzEwqVZ;;AyE/qVQ;EAOI,gCAAA;AzE4qVZ;;AyEnrVQ;EAOI,gCAAA;AzEgrVZ;;AyEvrVQ;EAOI,gCAAA;AzEorVZ;;AyE3rVQ;EAOI,+BAAA;AzEwrVZ;;AyE/rVQ;EAOI,6BAAA;AzE4rVZ;;AyEnsVQ;EAOI,+BAAA;AzEgsVZ;;AyEvsVQ;EAOI,6BAAA;AzEosVZ;;AyE3sVQ;EAOI,4BAAA;AzEwsVZ;;AyE/sVQ;EAOI,6BAAA;AzE4sVZ;;AyEntVQ;EAOI,6BAAA;AzEgtVZ;;AyEvtVQ;EAOI,6BAAA;AzEotVZ;;AyE3tVQ;EAOI,6BAAA;AzEwtVZ;;AyE/tVQ;EAOI,6BAAA;AzE4tVZ;;AyEnuVQ;EAOI,6BAAA;AzEguVZ;;AyEvuVQ;EAOI,6BAAA;AzEouVZ;;AyE3uVQ;EAOI,6BAAA;AzEwuVZ;;AyE/uVQ;EAOI,6BAAA;AzE4uVZ;;AyEnvVQ;EAOI,6BAAA;AzEgvVZ;;AyEvvVQ;EAOI,6BAAA;AzEovVZ;;AyE3vVQ;EAOI,8BAAA;AzEwvVZ;;AyE/vVQ;EAOI,8BAAA;AzE4vVZ;;AyEnwVQ;EAOI,8BAAA;AzEgwVZ;;AyEvwVQ;EAOI,8BAAA;AzEowVZ;;AyE3wVQ;EAOI,8BAAA;AzEwwVZ;;AyE/wVQ;EAOI,8BAAA;AzE4wVZ;;AyEnxVQ;EAOI,8BAAA;AzEgxVZ;;AyEvxVQ;EAOI,8BAAA;AzEoxVZ;;AyE3xVQ;EAOI,8BAAA;AzEwxVZ;;AyE/xVQ;EAOI,8BAAA;AzE4xVZ;;AyEnyVQ;EAOI,qBAAA;AzEgyVZ;;AyEvyVQ;EAOI,2BAAA;AzEoyVZ;;AyE3yVQ;EAOI,0BAAA;AzEwyVZ;;AyE/yVQ;EAOI,wBAAA;AzE4yVZ;;AyEnzVQ;EAOI,0BAAA;AzEgzVZ;;AyEvzVQ;EAOI,wBAAA;AzEozVZ;;AyE3zVQ;EAOI,uBAAA;AzEwzVZ;;AyE/zVQ;EAOI,wBAAA;AzE4zVZ;;AyEn0VQ;EAOI,wBAAA;AzEg0VZ;;AyEv0VQ;EAOI,wBAAA;AzEo0VZ;;AyE30VQ;EAOI,wBAAA;AzEw0VZ;;AyE/0VQ;EAOI,wBAAA;AzE40VZ;;AyEn1VQ;EAOI,wBAAA;AzEg1VZ;;AyEv1VQ;EAOI,wBAAA;AzEo1VZ;;AyE31VQ;EAOI,wBAAA;AzEw1VZ;;AyE/1VQ;EAOI,wBAAA;AzE41VZ;;AyEn2VQ;EAOI,wBAAA;AzEg2VZ;;AyEv2VQ;EAOI,wBAAA;AzEo2VZ;;AyE32VQ;EAOI,yBAAA;AzEw2VZ;;AyE/2VQ;EAOI,yBAAA;AzE42VZ;;AyEn3VQ;EAOI,yBAAA;AzEg3VZ;;AyEv3VQ;EAOI,yBAAA;AzEo3VZ;;AyE33VQ;EAOI,yBAAA;AzEw3VZ;;AyE/3VQ;EAOI,yBAAA;AzE43VZ;;AyEn4VQ;EAOI,yBAAA;AzEg4VZ;;AyEv4VQ;EAOI,yBAAA;AzEo4VZ;;AyE34VQ;EAOI,yBAAA;AzEw4VZ;;AyE/4VQ;EAOI,yBAAA;AzE44VZ;;AyEn5VQ;EAOI,2BAAA;EAAA,0BAAA;AzEi5VZ;;AyEx5VQ;EAOI,iCAAA;EAAA,gCAAA;AzEs5VZ;;AyE75VQ;EAOI,gCAAA;EAAA,+BAAA;AzE25VZ;;AyEl6VQ;EAOI,8BAAA;EAAA,6BAAA;AzEg6VZ;;AyEv6VQ;EAOI,gCAAA;EAAA,+BAAA;AzEq6VZ;;AyE56VQ;EAOI,8BAAA;EAAA,6BAAA;AzE06VZ;;AyEj7VQ;EAOI,6BAAA;EAAA,4BAAA;AzE+6VZ;;AyEt7VQ;EAOI,8BAAA;EAAA,6BAAA;AzEo7VZ;;AyE37VQ;EAOI,8BAAA;EAAA,6BAAA;AzEy7VZ;;AyEh8VQ;EAOI,8BAAA;EAAA,6BAAA;AzE87VZ;;AyEr8VQ;EAOI,8BAAA;EAAA,6BAAA;AzEm8VZ;;AyE18VQ;EAOI,8BAAA;EAAA,6BAAA;AzEw8VZ;;AyE/8VQ;EAOI,8BAAA;EAAA,6BAAA;AzE68VZ;;AyEp9VQ;EAOI,8BAAA;EAAA,6BAAA;AzEk9VZ;;AyEz9VQ;EAOI,8BAAA;EAAA,6BAAA;AzEu9VZ;;AyE99VQ;EAOI,8BAAA;EAAA,6BAAA;AzE49VZ;;AyEn+VQ;EAOI,8BAAA;EAAA,6BAAA;AzEi+VZ;;AyEx+VQ;EAOI,8BAAA;EAAA,6BAAA;AzEs+VZ;;AyE7+VQ;EAOI,+BAAA;EAAA,8BAAA;AzE2+VZ;;AyEl/VQ;EAOI,+BAAA;EAAA,8BAAA;AzEg/VZ;;AyEv/VQ;EAOI,+BAAA;EAAA,8BAAA;AzEq/VZ;;AyE5/VQ;EAOI,+BAAA;EAAA,8BAAA;AzE0/VZ;;AyEjgWQ;EAOI,+BAAA;EAAA,8BAAA;AzE+/VZ;;AyEtgWQ;EAOI,+BAAA;EAAA,8BAAA;AzEogWZ;;AyE3gWQ;EAOI,+BAAA;EAAA,8BAAA;AzEygWZ;;AyEhhWQ;EAOI,+BAAA;EAAA,8BAAA;AzE8gWZ;;AyErhWQ;EAOI,+BAAA;EAAA,8BAAA;AzEmhWZ;;AyE1hWQ;EAOI,+BAAA;EAAA,8BAAA;AzEwhWZ;;AyE/hWQ;EAOI,yBAAA;EAAA,4BAAA;AzE6hWZ;;AyEpiWQ;EAOI,+BAAA;EAAA,kCAAA;AzEkiWZ;;AyEziWQ;EAOI,8BAAA;EAAA,iCAAA;AzEuiWZ;;AyE9iWQ;EAOI,4BAAA;EAAA,+BAAA;AzE4iWZ;;AyEnjWQ;EAOI,8BAAA;EAAA,iCAAA;AzEijWZ;;AyExjWQ;EAOI,4BAAA;EAAA,+BAAA;AzEsjWZ;;AyE7jWQ;EAOI,2BAAA;EAAA,8BAAA;AzE2jWZ;;AyElkWQ;EAOI,4BAAA;EAAA,+BAAA;AzEgkWZ;;AyEvkWQ;EAOI,4BAAA;EAAA,+BAAA;AzEqkWZ;;AyE5kWQ;EAOI,4BAAA;EAAA,+BAAA;AzE0kWZ;;AyEjlWQ;EAOI,4BAAA;EAAA,+BAAA;AzE+kWZ;;AyEtlWQ;EAOI,4BAAA;EAAA,+BAAA;AzEolWZ;;AyE3lWQ;EAOI,4BAAA;EAAA,+BAAA;AzEylWZ;;AyEhmWQ;EAOI,4BAAA;EAAA,+BAAA;AzE8lWZ;;AyErmWQ;EAOI,4BAAA;EAAA,+BAAA;AzEmmWZ;;AyE1mWQ;EAOI,4BAAA;EAAA,+BAAA;AzEwmWZ;;AyE/mWQ;EAOI,4BAAA;EAAA,+BAAA;AzE6mWZ;;AyEpnWQ;EAOI,4BAAA;EAAA,+BAAA;AzEknWZ;;AyEznWQ;EAOI,6BAAA;EAAA,gCAAA;AzEunWZ;;AyE9nWQ;EAOI,6BAAA;EAAA,gCAAA;AzE4nWZ;;AyEnoWQ;EAOI,6BAAA;EAAA,gCAAA;AzEioWZ;;AyExoWQ;EAOI,6BAAA;EAAA,gCAAA;AzEsoWZ;;AyE7oWQ;EAOI,6BAAA;EAAA,gCAAA;AzE2oWZ;;AyElpWQ;EAOI,6BAAA;EAAA,gCAAA;AzEgpWZ;;AyEvpWQ;EAOI,6BAAA;EAAA,gCAAA;AzEqpWZ;;AyE5pWQ;EAOI,6BAAA;EAAA,gCAAA;AzE0pWZ;;AyEjqWQ;EAOI,6BAAA;EAAA,gCAAA;AzE+pWZ;;AyEtqWQ;EAOI,6BAAA;EAAA,gCAAA;AzEoqWZ;;AyE3qWQ;EAOI,yBAAA;AzEwqWZ;;AyE/qWQ;EAOI,+BAAA;AzE4qWZ;;AyEnrWQ;EAOI,8BAAA;AzEgrWZ;;AyEvrWQ;EAOI,4BAAA;AzEorWZ;;AyE3rWQ;EAOI,8BAAA;AzEwrWZ;;AyE/rWQ;EAOI,4BAAA;AzE4rWZ;;AyEnsWQ;EAOI,2BAAA;AzEgsWZ;;AyEvsWQ;EAOI,4BAAA;AzEosWZ;;AyE3sWQ;EAOI,4BAAA;AzEwsWZ;;AyE/sWQ;EAOI,4BAAA;AzE4sWZ;;AyEntWQ;EAOI,4BAAA;AzEgtWZ;;AyEvtWQ;EAOI,4BAAA;AzEotWZ;;AyE3tWQ;EAOI,4BAAA;AzEwtWZ;;AyE/tWQ;EAOI,4BAAA;AzE4tWZ;;AyEnuWQ;EAOI,4BAAA;AzEguWZ;;AyEvuWQ;EAOI,4BAAA;AzEouWZ;;AyE3uWQ;EAOI,4BAAA;AzEwuWZ;;AyE/uWQ;EAOI,4BAAA;AzE4uWZ;;AyEnvWQ;EAOI,6BAAA;AzEgvWZ;;AyEvvWQ;EAOI,6BAAA;AzEovWZ;;AyE3vWQ;EAOI,6BAAA;AzEwvWZ;;AyE/vWQ;EAOI,6BAAA;AzE4vWZ;;AyEnwWQ;EAOI,6BAAA;AzEgwWZ;;AyEvwWQ;EAOI,6BAAA;AzEowWZ;;AyE3wWQ;EAOI,6BAAA;AzEwwWZ;;AyE/wWQ;EAOI,6BAAA;AzE4wWZ;;AyEnxWQ;EAOI,6BAAA;AzEgxWZ;;AyEvxWQ;EAOI,6BAAA;AzEoxWZ;;AyE3xWQ;EAOI,2BAAA;AzEwxWZ;;AyE/xWQ;EAOI,iCAAA;AzE4xWZ;;AyEnyWQ;EAOI,gCAAA;AzEgyWZ;;AyEvyWQ;EAOI,8BAAA;AzEoyWZ;;AyE3yWQ;EAOI,gCAAA;AzEwyWZ;;AyE/yWQ;EAOI,8BAAA;AzE4yWZ;;AyEnzWQ;EAOI,6BAAA;AzEgzWZ;;AyEvzWQ;EAOI,8BAAA;AzEozWZ;;AyE3zWQ;EAOI,8BAAA;AzEwzWZ;;AyE/zWQ;EAOI,8BAAA;AzE4zWZ;;AyEn0WQ;EAOI,8BAAA;AzEg0WZ;;AyEv0WQ;EAOI,8BAAA;AzEo0WZ;;AyE30WQ;EAOI,8BAAA;AzEw0WZ;;AyE/0WQ;EAOI,8BAAA;AzE40WZ;;AyEn1WQ;EAOI,8BAAA;AzEg1WZ;;AyEv1WQ;EAOI,8BAAA;AzEo1WZ;;AyE31WQ;EAOI,8BAAA;AzEw1WZ;;AyE/1WQ;EAOI,8BAAA;AzE41WZ;;AyEn2WQ;EAOI,+BAAA;AzEg2WZ;;AyEv2WQ;EAOI,+BAAA;AzEo2WZ;;AyE32WQ;EAOI,+BAAA;AzEw2WZ;;AyE/2WQ;EAOI,+BAAA;AzE42WZ;;AyEn3WQ;EAOI,+BAAA;AzEg3WZ;;AyEv3WQ;EAOI,+BAAA;AzEo3WZ;;AyE33WQ;EAOI,+BAAA;AzEw3WZ;;AyE/3WQ;EAOI,+BAAA;AzE43WZ;;AyEn4WQ;EAOI,+BAAA;AzEg4WZ;;AyEv4WQ;EAOI,+BAAA;AzEo4WZ;;AyE34WQ;EAOI,4BAAA;AzEw4WZ;;AyE/4WQ;EAOI,kCAAA;AzE44WZ;;AyEn5WQ;EAOI,iCAAA;AzEg5WZ;;AyEv5WQ;EAOI,+BAAA;AzEo5WZ;;AyE35WQ;EAOI,iCAAA;AzEw5WZ;;AyE/5WQ;EAOI,+BAAA;AzE45WZ;;AyEn6WQ;EAOI,8BAAA;AzEg6WZ;;AyEv6WQ;EAOI,+BAAA;AzEo6WZ;;AyE36WQ;EAOI,+BAAA;AzEw6WZ;;AyE/6WQ;EAOI,+BAAA;AzE46WZ;;AyEn7WQ;EAOI,+BAAA;AzEg7WZ;;AyEv7WQ;EAOI,+BAAA;AzEo7WZ;;AyE37WQ;EAOI,+BAAA;AzEw7WZ;;AyE/7WQ;EAOI,+BAAA;AzE47WZ;;AyEn8WQ;EAOI,+BAAA;AzEg8WZ;;AyEv8WQ;EAOI,+BAAA;AzEo8WZ;;AyE38WQ;EAOI,+BAAA;AzEw8WZ;;AyE/8WQ;EAOI,+BAAA;AzE48WZ;;AyEn9WQ;EAOI,gCAAA;AzEg9WZ;;AyEv9WQ;EAOI,gCAAA;AzEo9WZ;;AyE39WQ;EAOI,gCAAA;AzEw9WZ;;AyE/9WQ;EAOI,gCAAA;AzE49WZ;;AyEn+WQ;EAOI,gCAAA;AzEg+WZ;;AyEv+WQ;EAOI,gCAAA;AzEo+WZ;;AyE3+WQ;EAOI,gCAAA;AzEw+WZ;;AyE/+WQ;EAOI,gCAAA;AzE4+WZ;;AyEn/WQ;EAOI,gCAAA;AzEg/WZ;;AyEv/WQ;EAOI,gCAAA;AzEo/WZ;;AyE3/WQ;EAOI,0BAAA;AzEw/WZ;;AyE//WQ;EAOI,gCAAA;AzE4/WZ;;AyEngXQ;EAOI,+BAAA;AzEggXZ;;AyEvgXQ;EAOI,6BAAA;AzEogXZ;;AyE3gXQ;EAOI,+BAAA;AzEwgXZ;;AyE/gXQ;EAOI,6BAAA;AzE4gXZ;;AyEnhXQ;EAOI,4BAAA;AzEghXZ;;AyEvhXQ;EAOI,6BAAA;AzEohXZ;;AyE3hXQ;EAOI,6BAAA;AzEwhXZ;;AyE/hXQ;EAOI,6BAAA;AzE4hXZ;;AyEniXQ;EAOI,6BAAA;AzEgiXZ;;AyEviXQ;EAOI,6BAAA;AzEoiXZ;;AyE3iXQ;EAOI,6BAAA;AzEwiXZ;;AyE/iXQ;EAOI,6BAAA;AzE4iXZ;;AyEnjXQ;EAOI,6BAAA;AzEgjXZ;;AyEvjXQ;EAOI,6BAAA;AzEojXZ;;AyE3jXQ;EAOI,6BAAA;AzEwjXZ;;AyE/jXQ;EAOI,6BAAA;AzE4jXZ;;AyEnkXQ;EAOI,8BAAA;AzEgkXZ;;AyEvkXQ;EAOI,8BAAA;AzEokXZ;;AyE3kXQ;EAOI,8BAAA;AzEwkXZ;;AyE/kXQ;EAOI,8BAAA;AzE4kXZ;;AyEnlXQ;EAOI,8BAAA;AzEglXZ;;AyEvlXQ;EAOI,8BAAA;AzEolXZ;;AyE3lXQ;EAOI,8BAAA;AzEwlXZ;;AyE/lXQ;EAOI,8BAAA;AzE4lXZ;;AyEnmXQ;EAOI,8BAAA;AzEgmXZ;;AyEvmXQ;EAOI,8BAAA;AzEomXZ;;AyE3mXQ;EAOI,iBAAA;AzEwmXZ;;AyE/mXQ;EAOI,uBAAA;AzE4mXZ;;AyEnnXQ;EAOI,sBAAA;AzEgnXZ;;AyEvnXQ;EAOI,oBAAA;AzEonXZ;;AyE3nXQ;EAOI,sBAAA;AzEwnXZ;;AyE/nXQ;EAOI,oBAAA;AzE4nXZ;;AyEnoXQ;EAOI,mBAAA;AzEgoXZ;;AyEvoXQ;EAOI,oBAAA;AzEooXZ;;AyE3oXQ;EAOI,oBAAA;AzEwoXZ;;AyE/oXQ;EAOI,oBAAA;AzE4oXZ;;AyEnpXQ;EAOI,oBAAA;AzEgpXZ;;AyEvpXQ;EAOI,oBAAA;AzEopXZ;;AyE3pXQ;EAOI,oBAAA;AzEwpXZ;;AyE/pXQ;EAOI,oBAAA;AzE4pXZ;;AyEnqXQ;EAOI,oBAAA;AzEgqXZ;;AyEvqXQ;EAOI,oBAAA;AzEoqXZ;;AyE3qXQ;EAOI,oBAAA;AzEwqXZ;;AyE/qXQ;EAOI,oBAAA;AzE4qXZ;;AyEnrXQ;EAOI,qBAAA;AzEgrXZ;;AyEvrXQ;EAOI,qBAAA;AzEorXZ;;AyE3rXQ;EAOI,qBAAA;AzEwrXZ;;AyE/rXQ;EAOI,qBAAA;AzE4rXZ;;AyEnsXQ;EAOI,qBAAA;AzEgsXZ;;AyEvsXQ;EAOI,qBAAA;AzEosXZ;;AyE3sXQ;EAOI,qBAAA;AzEwsXZ;;AyE/sXQ;EAOI,qBAAA;AzE4sXZ;;AyEntXQ;EAOI,qBAAA;AzEgtXZ;;AyEvtXQ;EAOI,qBAAA;AzEotXZ;;AyE3tXQ;EAOI,qBAAA;AzEwtXZ;;AyE/tXQ;EAOI,2BAAA;AzE4tXZ;;AyEnuXQ;EAOI,0BAAA;AzEguXZ;;AyEvuXQ;EAOI,wBAAA;AzEouXZ;;AyE3uXQ;EAOI,0BAAA;AzEwuXZ;;AyE/uXQ;EAOI,wBAAA;AzE4uXZ;;AyEnvXQ;EAOI,uBAAA;AzEgvXZ;;AyEvvXQ;EAOI,wBAAA;AzEovXZ;;AyE3vXQ;EAOI,wBAAA;AzEwvXZ;;AyE/vXQ;EAOI,wBAAA;AzE4vXZ;;AyEnwXQ;EAOI,wBAAA;AzEgwXZ;;AyEvwXQ;EAOI,wBAAA;AzEowXZ;;AyE3wXQ;EAOI,wBAAA;AzEwwXZ;;AyE/wXQ;EAOI,wBAAA;AzE4wXZ;;AyEnxXQ;EAOI,wBAAA;AzEgxXZ;;AyEvxXQ;EAOI,wBAAA;AzEoxXZ;;AyE3xXQ;EAOI,wBAAA;AzEwxXZ;;AyE/xXQ;EAOI,wBAAA;AzE4xXZ;;AyEnyXQ;EAOI,yBAAA;AzEgyXZ;;AyEvyXQ;EAOI,yBAAA;AzEoyXZ;;AyE3yXQ;EAOI,yBAAA;AzEwyXZ;;AyE/yXQ;EAOI,yBAAA;AzE4yXZ;;AyEnzXQ;EAOI,yBAAA;AzEgzXZ;;AyEvzXQ;EAOI,yBAAA;AzEozXZ;;AyE3zXQ;EAOI,yBAAA;AzEwzXZ;;AyE/zXQ;EAOI,yBAAA;AzE4zXZ;;AyEn0XQ;EAOI,yBAAA;AzEg0XZ;;AyEv0XQ;EAOI,yBAAA;AzEo0XZ;;AyE30XQ;EAOI,wBAAA;AzEw0XZ;;AyE/0XQ;EAOI,8BAAA;AzE40XZ;;AyEn1XQ;EAOI,6BAAA;AzEg1XZ;;AyEv1XQ;EAOI,2BAAA;AzEo1XZ;;AyE31XQ;EAOI,6BAAA;AzEw1XZ;;AyE/1XQ;EAOI,2BAAA;AzE41XZ;;AyEn2XQ;EAOI,0BAAA;AzEg2XZ;;AyEv2XQ;EAOI,2BAAA;AzEo2XZ;;AyE32XQ;EAOI,2BAAA;AzEw2XZ;;AyE/2XQ;EAOI,2BAAA;AzE42XZ;;AyEn3XQ;EAOI,2BAAA;AzEg3XZ;;AyEv3XQ;EAOI,2BAAA;AzEo3XZ;;AyE33XQ;EAOI,2BAAA;AzEw3XZ;;AyE/3XQ;EAOI,2BAAA;AzE43XZ;;AyEn4XQ;EAOI,2BAAA;AzEg4XZ;;AyEv4XQ;EAOI,2BAAA;AzEo4XZ;;AyE34XQ;EAOI,2BAAA;AzEw4XZ;;AyE/4XQ;EAOI,2BAAA;AzE44XZ;;AyEn5XQ;EAOI,4BAAA;AzEg5XZ;;AyEv5XQ;EAOI,4BAAA;AzEo5XZ;;AyE35XQ;EAOI,4BAAA;AzEw5XZ;;AyE/5XQ;EAOI,4BAAA;AzE45XZ;;AyEn6XQ;EAOI,4BAAA;AzEg6XZ;;AyEv6XQ;EAOI,4BAAA;AzEo6XZ;;AyE36XQ;EAOI,4BAAA;AzEw6XZ;;AyE/6XQ;EAOI,4BAAA;AzE46XZ;;AyEn7XQ;EAOI,4BAAA;AzEg7XZ;;AyEv7XQ;EAOI,4BAAA;AzEo7XZ;;AyE37XQ;EAOI,gDAAA;AzEw7XZ;;AyE/7XQ;EAOI,4CAAA;AzE47XZ;;AyEn8XQ;EAOI,4CAAA;AzEg8XZ;;AyEv8XQ;EAOI,0CAAA;AzEo8XZ;;AyE38XQ;EAOI,4CAAA;AzEw8XZ;;AyE/8XQ;EAOI,6BAAA;AzE48XZ;;AyEn9XQ;EAOI,0BAAA;AzEg9XZ;;AyEv9XQ;EAOI,6BAAA;AzEo9XZ;;AyE39XQ;EAOI,6BAAA;AzEw9XZ;;AyE/9XQ;EAOI,+BAAA;AzE49XZ;;AyEn+XQ;EAOI,2BAAA;AzEg+XZ;;AyEv+XQ;EAOI,2BAAA;AzEo+XZ;;AyE3+XQ;EAOI,2BAAA;AzEw+XZ;;AyE/+XQ;EAOI,2BAAA;AzE4+XZ;;AyEn/XQ;EAOI,2BAAA;AzEg/XZ;;AyEv/XQ;EAOI,8BAAA;AzEo/XZ;;AyE3/XQ;EAOI,yBAAA;AzEw/XZ;;AyE//XQ;EAOI,4BAAA;AzE4/XZ;;AyEngYQ;EAOI,2BAAA;AzEggYZ;;AyEvgYQ;EAOI,yBAAA;AzEogYZ;;AyE3gYQ;EAOI,2BAAA;AzEwgYZ;;AyE/gYQ;EAOI,4BAAA;AzE4gYZ;;AyEnhYQ;EAOI,6BAAA;AzEghYZ;;AyEvhYQ;EAOI,gCAAA;AzEohYZ;;AyE3hYQ;EAOI,qCAAA;AzEwhYZ;;AyE/hYQ;EAOI,wCAAA;AzE4hYZ;;AyEniYQ;EAOI,oCAAA;AzEgiYZ;;AyEviYQ;EAOI,oCAAA;AzEoiYZ;;AyE3iYQ;EAOI,qCAAA;AzEwiYZ;;AyE/iYQ;EAOI,8BAAA;AzE4iYZ;;AyEnjYQ;EAOI,8BAAA;AzEgjYZ;;AyErkYQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AzEsjYZ;;AyEniYQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AzE4jYZ;;AyEnkYQ;EAIQ,oBAAA;EAGJ,uEAAA;AzEikYZ;;AyExkYQ;EAIQ,oBAAA;EAGJ,qEAAA;AzEskYZ;;AyE7kYQ;EAIQ,oBAAA;EAGJ,kEAAA;AzE2kYZ;;AyEllYQ;EAIQ,oBAAA;EAGJ,qEAAA;AzEglYZ;;AyEvlYQ;EAIQ,oBAAA;EAGJ,oEAAA;AzEqlYZ;;AyE5lYQ;EAIQ,oBAAA;EAGJ,mEAAA;AzE0lYZ;;AyEjmYQ;EAIQ,oBAAA;EAGJ,kEAAA;AzE+lYZ;;AyEtmYQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEomYZ;;AyE3mYQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEymYZ;;AyEhnYQ;EAIQ,oBAAA;EAGJ,wEAAA;AzE8mYZ;;AyErnYQ;EAIQ,oBAAA;EAGJ,2CAAA;AzEmnYZ;;AyE1nYQ;EAIQ,oBAAA;EAGJ,oCAAA;AzEwnYZ;;AyE/nYQ;EAIQ,oBAAA;EAGJ,0CAAA;AzE6nYZ;;AyEpoYQ;EAIQ,oBAAA;EAGJ,2CAAA;AzEkoYZ;;AyEzoYQ;EAIQ,oBAAA;EAGJ,0CAAA;AzEuoYZ;;AyE9oYQ;EAIQ,oBAAA;EAGJ,0CAAA;AzE4oYZ;;AyEnpYQ;EAIQ,oBAAA;EAGJ,yBAAA;AzEipYZ;;AyElqYQ;EACE,uBAAA;AzEqqYV;;AyEtqYQ;EACE,sBAAA;AzEyqYV;;AyE1qYQ;EACE,uBAAA;AzE6qYV;;AyE9qYQ;EACE,oBAAA;AzEirYV;;AyExqYQ;EAOI,iDAAA;AzEqqYZ;;AyE5qYQ;EAOI,mDAAA;AzEyqYZ;;AyEhrYQ;EAOI,iDAAA;AzE6qYZ;;AyEprYQ;EAOI,8CAAA;AzEirYZ;;AyExrYQ;EAOI,iDAAA;AzEqrYZ;;AyE5rYQ;EAOI,gDAAA;AzEyrYZ;;AyEhsYQ;EAOI,+CAAA;AzE6rYZ;;AyEpsYQ;EAOI,8CAAA;AzEisYZ;;AyEltYQ;EACE,sBAAA;AzEqtYV;;AyEjtYU;EACE,sBAAA;AzEotYZ;;AyE1tYQ;EACE,uBAAA;AzE6tYV;;AyEztYU;EACE,uBAAA;AzE4tYZ;;AyEluYQ;EACE,sBAAA;AzEquYV;;AyEjuYU;EACE,sBAAA;AzEouYZ;;AyE1uYQ;EACE,uBAAA;AzE6uYV;;AyEzuYU;EACE,uBAAA;AzE4uYZ;;AyElvYQ;EACE,oBAAA;AzEqvYV;;AyEjvYU;EACE,oBAAA;AzEovYZ;;AyEhvYQ;EAOI,yCAAA;AzE6uYZ;;AyExuYU;EAOI,yCAAA;AzEquYd;;AyExvYQ;EAOI,wCAAA;AzEqvYZ;;AyEhvYU;EAOI,wCAAA;AzE6uYd;;AyEhwYQ;EAOI,yCAAA;AzE6vYZ;;AyExvYU;EAOI,yCAAA;AzEqvYd;;AyExwYQ;EAIQ,8BAAA;EAGJ,+FAAA;AzEswYZ;;AyE7wYQ;EAIQ,8BAAA;EAGJ,iGAAA;AzE2wYZ;;AyElxYQ;EAIQ,8BAAA;EAGJ,+FAAA;AzEgxYZ;;AyEvxYQ;EAIQ,8BAAA;EAGJ,4FAAA;AzEqxYZ;;AyE5xYQ;EAIQ,8BAAA;EAGJ,+FAAA;AzE0xYZ;;AyEjyYQ;EAIQ,8BAAA;EAGJ,8FAAA;AzE+xYZ;;AyEtyYQ;EAIQ,8BAAA;EAGJ,6FAAA;AzEoyYZ;;AyE3yYQ;EAIQ,8BAAA;EAGJ,4FAAA;AzEyyYZ;;AyEhzYQ;EAIQ,8BAAA;EAGJ,qGAAA;AzE8yYZ;;AyE/zYQ;EACE,8BAAA;AzEk0YV;;AyE9zYU;EACE,8BAAA;AzEi0YZ;;AyEv0YQ;EACE,gCAAA;AzE00YV;;AyEt0YU;EACE,gCAAA;AzEy0YZ;;AyE/0YQ;EACE,iCAAA;AzEk1YV;;AyE90YU;EACE,iCAAA;AzEi1YZ;;AyEv1YQ;EACE,gCAAA;AzE01YV;;AyEt1YU;EACE,gCAAA;AzEy1YZ;;AyE/1YQ;EACE,iCAAA;AzEk2YV;;AyE91YU;EACE,iCAAA;AzEi2YZ;;AyEv2YQ;EACE,8BAAA;AzE02YV;;AyEt2YU;EACE,8BAAA;AzEy2YZ;;AyEr2YQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEm2YZ;;AyE12YQ;EAIQ,kBAAA;EAGJ,gFAAA;AzEw2YZ;;AyE/2YQ;EAIQ,kBAAA;EAGJ,8EAAA;AzE62YZ;;AyEp3YQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEk3YZ;;AyEz3YQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEu3YZ;;AyE93YQ;EAIQ,kBAAA;EAGJ,6EAAA;AzE43YZ;;AyEn4YQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEi4YZ;;AyEx4YQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEs4YZ;;AyE74YQ;EAIQ,kBAAA;EAGJ,4EAAA;AzE24YZ;;AyEl5YQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEg5YZ;;AyEv5YQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEq5YZ;;AyE55YQ;EAIQ,kBAAA;EAGJ,wCAAA;AzE05YZ;;AyEj6YQ;EAIQ,kBAAA;EAGJ,mFAAA;AzE+5YZ;;AyEt6YQ;EAIQ,kBAAA;EAGJ,kFAAA;AzEo6YZ;;AyEr7YQ;EACE,oBAAA;AzEw7YV;;AyEz7YQ;EACE,qBAAA;AzE47YV;;AyE77YQ;EACE,oBAAA;AzEg8YV;;AyEj8YQ;EACE,qBAAA;AzEo8YV;;AyEr8YQ;EACE,kBAAA;AzEw8YV;;AyE/7YQ;EAOI,wDAAA;AzE47YZ;;AyEn8YQ;EAOI,0DAAA;AzEg8YZ;;AyEv8YQ;EAOI,wDAAA;AzEo8YZ;;AyE38YQ;EAOI,qDAAA;AzEw8YZ;;AyE/8YQ;EAOI,wDAAA;AzE48YZ;;AyEn9YQ;EAOI,uDAAA;AzEg9YZ;;AyEv9YQ;EAOI,sDAAA;AzEo9YZ;;AyE39YQ;EAOI,qDAAA;AzEw9YZ;;AyE/9YQ;EAOI,+CAAA;AzE49YZ;;AyEn+YQ;EAOI,mCAAA;UAAA,2BAAA;AzEg+YZ;;AyEv+YQ;EAOI,oCAAA;UAAA,4BAAA;AzEo+YZ;;AyE3+YQ;EAOI,oCAAA;UAAA,4BAAA;AzEw+YZ;;AyE/+YQ;EAOI,+BAAA;AzE4+YZ;;AyEn/YQ;EAOI,+BAAA;AzEg/YZ;;AyEv/YQ;EAOI,iDAAA;AzEo/YZ;;AyE3/YQ;EAOI,2BAAA;AzEw/YZ;;AyE//YQ;EAOI,oDAAA;AzE4/YZ;;AyEngZQ;EAOI,iDAAA;AzEggZZ;;AyEvgZQ;EAOI,oDAAA;AzEogZZ;;AyE3gZQ;EAOI,oDAAA;AzEwgZZ;;AyE/gZQ;EAOI,qDAAA;AzE4gZZ;;AyEnhZQ;EAOI,6BAAA;AzEghZZ;;AyEvhZQ;EAOI,sDAAA;AzEohZZ;;AyE3hZQ;EAOI,0DAAA;EAAA,2DAAA;AzEyhZZ;;AyEhiZQ;EAOI,oCAAA;EAAA,qCAAA;AzE8hZZ;;AyEriZQ;EAOI,6DAAA;EAAA,8DAAA;AzEmiZZ;;AyE1iZQ;EAOI,0DAAA;EAAA,2DAAA;AzEwiZZ;;AyE/iZQ;EAOI,6DAAA;EAAA,8DAAA;AzE6iZZ;;AyEpjZQ;EAOI,6DAAA;EAAA,8DAAA;AzEkjZZ;;AyEzjZQ;EAOI,8DAAA;EAAA,+DAAA;AzEujZZ;;AyE9jZQ;EAOI,sCAAA;EAAA,uCAAA;AzE4jZZ;;AyEnkZQ;EAOI,+DAAA;EAAA,gEAAA;AzEikZZ;;AyExkZQ;EAOI,2DAAA;EAAA,8DAAA;AzEskZZ;;AyE7kZQ;EAOI,qCAAA;EAAA,wCAAA;AzE2kZZ;;AyEllZQ;EAOI,8DAAA;EAAA,iEAAA;AzEglZZ;;AyEvlZQ;EAOI,2DAAA;EAAA,8DAAA;AzEqlZZ;;AyE5lZQ;EAOI,8DAAA;EAAA,iEAAA;AzE0lZZ;;AyEjmZQ;EAOI,8DAAA;EAAA,iEAAA;AzE+lZZ;;AyEtmZQ;EAOI,+DAAA;EAAA,kEAAA;AzEomZZ;;AyE3mZQ;EAOI,uCAAA;EAAA,0CAAA;AzEymZZ;;AyEhnZQ;EAOI,gEAAA;EAAA,mEAAA;AzE8mZZ;;AyErnZQ;EAOI,8DAAA;EAAA,6DAAA;AzEmnZZ;;AyE1nZQ;EAOI,wCAAA;EAAA,uCAAA;AzEwnZZ;;AyE/nZQ;EAOI,iEAAA;EAAA,gEAAA;AzE6nZZ;;AyEpoZQ;EAOI,8DAAA;EAAA,6DAAA;AzEkoZZ;;AyEzoZQ;EAOI,iEAAA;EAAA,gEAAA;AzEuoZZ;;AyE9oZQ;EAOI,iEAAA;EAAA,gEAAA;AzE4oZZ;;AyEnpZQ;EAOI,kEAAA;EAAA,iEAAA;AzEipZZ;;AyExpZQ;EAOI,0CAAA;EAAA,yCAAA;AzEspZZ;;AyE7pZQ;EAOI,mEAAA;EAAA,kEAAA;AzE2pZZ;;AyElqZQ;EAOI,6DAAA;EAAA,0DAAA;AzEgqZZ;;AyEvqZQ;EAOI,uCAAA;EAAA,oCAAA;AzEqqZZ;;AyE5qZQ;EAOI,gEAAA;EAAA,6DAAA;AzE0qZZ;;AyEjrZQ;EAOI,6DAAA;EAAA,0DAAA;AzE+qZZ;;AyEtrZQ;EAOI,gEAAA;EAAA,6DAAA;AzEorZZ;;AyE3rZQ;EAOI,gEAAA;EAAA,6DAAA;AzEyrZZ;;AyEhsZQ;EAOI,iEAAA;EAAA,8DAAA;AzE8rZZ;;AyErsZQ;EAOI,yCAAA;EAAA,sCAAA;AzEmsZZ;;AyE1sZQ;EAOI,kEAAA;EAAA,+DAAA;AzEwsZZ;;AyE/sZQ;EAOI,8BAAA;AzE4sZZ;;AyEntZQ;EAOI,6BAAA;AzEgtZZ;;AyEvtZQ;EAOI,sBAAA;AzEotZZ;;AyE3tZQ;EAOI,qBAAA;AzEwtZZ;;AyE/tZQ;EAOI,qBAAA;AzE4tZZ;;AyEnuZQ;EAOI,qBAAA;AzEguZZ;;AyEvuZQ;EAOI,qBAAA;AzEouZZ;;Ac9uZI;E2DGI;IAOI,sBAAA;EzEyuZV;EyEhvZM;IAOI,uBAAA;EzE4uZV;EyEnvZM;IAOI,sBAAA;EzE+uZV;EyEtvZM;IAOI,8BAAA;EzEkvZV;EyEzvZM;IAOI,4BAAA;EzEqvZV;EyE5vZM;IAOI,2BAAA;EzEwvZV;EyE/vZM;IAOI,iCAAA;EzE2vZV;EyElwZM;IAOI,2BAAA;EzE8vZV;EyErwZM;IAOI,0BAAA;EzEiwZV;EyExwZM;IAOI,gCAAA;EzEowZV;EyE3wZM;IAOI,yBAAA;EzEuwZV;EyE9wZM;IAOI,wBAAA;EzE0wZV;EyEjxZM;IAOI,+BAAA;EzE6wZV;EyEpxZM;IAOI,yBAAA;EzEgxZV;EyEvxZM;IAOI,6BAAA;EzEmxZV;EyE1xZM;IAOI,8BAAA;EzEsxZV;EyE7xZM;IAOI,wBAAA;EzEyxZV;EyEhyZM;IAOI,+BAAA;EzE4xZV;EyEnyZM;IAOI,wBAAA;EzE+xZV;EyEtyZM;IAOI,yBAAA;EzEkyZV;EyEzyZM;IAOI,8BAAA;EzEqyZV;EyE5yZM;IAOI,iCAAA;EzEwyZV;EyE/yZM;IAOI,sCAAA;EzE2yZV;EyElzZM;IAOI,yCAAA;EzE8yZV;EyErzZM;IAOI,uBAAA;EzEizZV;EyExzZM;IAOI,uBAAA;EzEozZV;EyE3zZM;IAOI,yBAAA;EzEuzZV;EyE9zZM;IAOI,yBAAA;EzE0zZV;EyEj0ZM;IAOI,0BAAA;EzE6zZV;EyEp0ZM;IAOI,4BAAA;EzEg0ZV;EyEv0ZM;IAOI,kCAAA;EzEm0ZV;EyE10ZM;IAOI,sCAAA;EzEs0ZV;EyE70ZM;IAOI,oCAAA;EzEy0ZV;EyEh1ZM;IAOI,kCAAA;EzE40ZV;EyEn1ZM;IAOI,yCAAA;EzE+0ZV;EyEt1ZM;IAOI,wCAAA;EzEk1ZV;EyEz1ZM;IAOI,wCAAA;EzEq1ZV;EyE51ZM;IAOI,kCAAA;EzEw1ZV;EyE/1ZM;IAOI,gCAAA;EzE21ZV;EyEl2ZM;IAOI,8BAAA;EzE81ZV;EyEr2ZM;IAOI,gCAAA;EzEi2ZV;EyEx2ZM;IAOI,+BAAA;EzEo2ZV;EyE32ZM;IAOI,oCAAA;EzEu2ZV;EyE92ZM;IAOI,kCAAA;EzE02ZV;EyEj3ZM;IAOI,gCAAA;EzE62ZV;EyEp3ZM;IAOI,uCAAA;EzEg3ZV;EyEv3ZM;IAOI,sCAAA;EzEm3ZV;EyE13ZM;IAOI,iCAAA;EzEs3ZV;EyE73ZM;IAOI,2BAAA;EzEy3ZV;EyEh4ZM;IAOI,iCAAA;EzE43ZV;EyEn4ZM;IAOI,+BAAA;EzE+3ZV;EyEt4ZM;IAOI,6BAAA;EzEk4ZV;EyEz4ZM;IAOI,+BAAA;EzEq4ZV;EyE54ZM;IAOI,8BAAA;EzEw4ZV;EyE/4ZM;IAOI,oBAAA;EzE24ZV;EyEl5ZM;IAOI,mBAAA;EzE84ZV;EyEr5ZM;IAOI,mBAAA;EzEi5ZV;EyEx5ZM;IAOI,mBAAA;EzEo5ZV;EyE35ZM;IAOI,mBAAA;EzEu5ZV;EyE95ZM;IAOI,mBAAA;EzE05ZV;EyEj6ZM;IAOI,mBAAA;EzE65ZV;EyEp6ZM;IAOI,mBAAA;EzEg6ZV;EyEv6ZM;IAOI,oBAAA;EzEm6ZV;EyE16ZM;IAOI,0BAAA;EzEs6ZV;EyE76ZM;IAOI,yBAAA;EzEy6ZV;EyEh7ZM;IAOI,uBAAA;EzE46ZV;EyEn7ZM;IAOI,yBAAA;EzE+6ZV;EyEt7ZM;IAOI,uBAAA;EzEk7ZV;EyEz7ZM;IAOI,sBAAA;EzEq7ZV;EyE57ZM;IAOI,uBAAA;EzEw7ZV;EyE/7ZM;IAOI,uBAAA;EzE27ZV;EyEl8ZM;IAOI,uBAAA;EzE87ZV;EyEr8ZM;IAOI,uBAAA;EzEi8ZV;EyEx8ZM;IAOI,uBAAA;EzEo8ZV;EyE38ZM;IAOI,uBAAA;EzEu8ZV;EyE98ZM;IAOI,uBAAA;EzE08ZV;EyEj9ZM;IAOI,uBAAA;EzE68ZV;EyEp9ZM;IAOI,uBAAA;EzEg9ZV;EyEv9ZM;IAOI,uBAAA;EzEm9ZV;EyE19ZM;IAOI,uBAAA;EzEs9ZV;EyE79ZM;IAOI,wBAAA;EzEy9ZV;EyEh+ZM;IAOI,wBAAA;EzE49ZV;EyEn+ZM;IAOI,wBAAA;EzE+9ZV;EyEt+ZM;IAOI,wBAAA;EzEk+ZV;EyEz+ZM;IAOI,wBAAA;EzEq+ZV;EyE5+ZM;IAOI,wBAAA;EzEw+ZV;EyE/+ZM;IAOI,wBAAA;EzE2+ZV;EyEl/ZM;IAOI,wBAAA;EzE8+ZV;EyEr/ZM;IAOI,wBAAA;EzEi/ZV;EyEx/ZM;IAOI,wBAAA;EzEo/ZV;EyE3/ZM;IAOI,uBAAA;EzEu/ZV;EyE9/ZM;IAOI,0BAAA;IAAA,yBAAA;EzE2/ZV;EyElgaM;IAOI,gCAAA;IAAA,+BAAA;EzE+/ZV;EyEtgaM;IAOI,+BAAA;IAAA,8BAAA;EzEmgaV;EyE1gaM;IAOI,6BAAA;IAAA,4BAAA;EzEugaV;EyE9gaM;IAOI,+BAAA;IAAA,8BAAA;EzE2gaV;EyElhaM;IAOI,6BAAA;IAAA,4BAAA;EzE+gaV;EyEthaM;IAOI,4BAAA;IAAA,2BAAA;EzEmhaV;EyE1haM;IAOI,6BAAA;IAAA,4BAAA;EzEuhaV;EyE9haM;IAOI,6BAAA;IAAA,4BAAA;EzE2haV;EyEliaM;IAOI,6BAAA;IAAA,4BAAA;EzE+haV;EyEtiaM;IAOI,6BAAA;IAAA,4BAAA;EzEmiaV;EyE1iaM;IAOI,6BAAA;IAAA,4BAAA;EzEuiaV;EyE9iaM;IAOI,6BAAA;IAAA,4BAAA;EzE2iaV;EyEljaM;IAOI,6BAAA;IAAA,4BAAA;EzE+iaV;EyEtjaM;IAOI,6BAAA;IAAA,4BAAA;EzEmjaV;EyE1jaM;IAOI,6BAAA;IAAA,4BAAA;EzEujaV;EyE9jaM;IAOI,6BAAA;IAAA,4BAAA;EzE2jaV;EyElkaM;IAOI,6BAAA;IAAA,4BAAA;EzE+jaV;EyEtkaM;IAOI,8BAAA;IAAA,6BAAA;EzEmkaV;EyE1kaM;IAOI,8BAAA;IAAA,6BAAA;EzEukaV;EyE9kaM;IAOI,8BAAA;IAAA,6BAAA;EzE2kaV;EyEllaM;IAOI,8BAAA;IAAA,6BAAA;EzE+kaV;EyEtlaM;IAOI,8BAAA;IAAA,6BAAA;EzEmlaV;EyE1laM;IAOI,8BAAA;IAAA,6BAAA;EzEulaV;EyE9laM;IAOI,8BAAA;IAAA,6BAAA;EzE2laV;EyElmaM;IAOI,8BAAA;IAAA,6BAAA;EzE+laV;EyEtmaM;IAOI,8BAAA;IAAA,6BAAA;EzEmmaV;EyE1maM;IAOI,8BAAA;IAAA,6BAAA;EzEumaV;EyE9maM;IAOI,6BAAA;IAAA,4BAAA;EzE2maV;EyElnaM;IAOI,wBAAA;IAAA,2BAAA;EzE+maV;EyEtnaM;IAOI,8BAAA;IAAA,iCAAA;EzEmnaV;EyE1naM;IAOI,6BAAA;IAAA,gCAAA;EzEunaV;EyE9naM;IAOI,2BAAA;IAAA,8BAAA;EzE2naV;EyEloaM;IAOI,6BAAA;IAAA,gCAAA;EzE+naV;EyEtoaM;IAOI,2BAAA;IAAA,8BAAA;EzEmoaV;EyE1oaM;IAOI,0BAAA;IAAA,6BAAA;EzEuoaV;EyE9oaM;IAOI,2BAAA;IAAA,8BAAA;EzE2oaV;EyElpaM;IAOI,2BAAA;IAAA,8BAAA;EzE+oaV;EyEtpaM;IAOI,2BAAA;IAAA,8BAAA;EzEmpaV;EyE1paM;IAOI,2BAAA;IAAA,8BAAA;EzEupaV;EyE9paM;IAOI,2BAAA;IAAA,8BAAA;EzE2paV;EyElqaM;IAOI,2BAAA;IAAA,8BAAA;EzE+paV;EyEtqaM;IAOI,2BAAA;IAAA,8BAAA;EzEmqaV;EyE1qaM;IAOI,2BAAA;IAAA,8BAAA;EzEuqaV;EyE9qaM;IAOI,2BAAA;IAAA,8BAAA;EzE2qaV;EyElraM;IAOI,2BAAA;IAAA,8BAAA;EzE+qaV;EyEtraM;IAOI,2BAAA;IAAA,8BAAA;EzEmraV;EyE1raM;IAOI,4BAAA;IAAA,+BAAA;EzEuraV;EyE9raM;IAOI,4BAAA;IAAA,+BAAA;EzE2raV;EyElsaM;IAOI,4BAAA;IAAA,+BAAA;EzE+raV;EyEtsaM;IAOI,4BAAA;IAAA,+BAAA;EzEmsaV;EyE1saM;IAOI,4BAAA;IAAA,+BAAA;EzEusaV;EyE9saM;IAOI,4BAAA;IAAA,+BAAA;EzE2saV;EyEltaM;IAOI,4BAAA;IAAA,+BAAA;EzE+saV;EyEttaM;IAOI,4BAAA;IAAA,+BAAA;EzEmtaV;EyE1taM;IAOI,4BAAA;IAAA,+BAAA;EzEutaV;EyE9taM;IAOI,4BAAA;IAAA,+BAAA;EzE2taV;EyEluaM;IAOI,2BAAA;IAAA,8BAAA;EzE+taV;EyEtuaM;IAOI,wBAAA;EzEkuaV;EyEzuaM;IAOI,8BAAA;EzEquaV;EyE5uaM;IAOI,6BAAA;EzEwuaV;EyE/uaM;IAOI,2BAAA;EzE2uaV;EyElvaM;IAOI,6BAAA;EzE8uaV;EyErvaM;IAOI,2BAAA;EzEivaV;EyExvaM;IAOI,0BAAA;EzEovaV;EyE3vaM;IAOI,2BAAA;EzEuvaV;EyE9vaM;IAOI,2BAAA;EzE0vaV;EyEjwaM;IAOI,2BAAA;EzE6vaV;EyEpwaM;IAOI,2BAAA;EzEgwaV;EyEvwaM;IAOI,2BAAA;EzEmwaV;EyE1waM;IAOI,2BAAA;EzEswaV;EyE7waM;IAOI,2BAAA;EzEywaV;EyEhxaM;IAOI,2BAAA;EzE4waV;EyEnxaM;IAOI,2BAAA;EzE+waV;EyEtxaM;IAOI,2BAAA;EzEkxaV;EyEzxaM;IAOI,2BAAA;EzEqxaV;EyE5xaM;IAOI,4BAAA;EzEwxaV;EyE/xaM;IAOI,4BAAA;EzE2xaV;EyElyaM;IAOI,4BAAA;EzE8xaV;EyEryaM;IAOI,4BAAA;EzEiyaV;EyExyaM;IAOI,4BAAA;EzEoyaV;EyE3yaM;IAOI,4BAAA;EzEuyaV;EyE9yaM;IAOI,4BAAA;EzE0yaV;EyEjzaM;IAOI,4BAAA;EzE6yaV;EyEpzaM;IAOI,4BAAA;EzEgzaV;EyEvzaM;IAOI,4BAAA;EzEmzaV;EyE1zaM;IAOI,2BAAA;EzEszaV;EyE7zaM;IAOI,0BAAA;EzEyzaV;EyEh0aM;IAOI,gCAAA;EzE4zaV;EyEn0aM;IAOI,+BAAA;EzE+zaV;EyEt0aM;IAOI,6BAAA;EzEk0aV;EyEz0aM;IAOI,+BAAA;EzEq0aV;EyE50aM;IAOI,6BAAA;EzEw0aV;EyE/0aM;IAOI,4BAAA;EzE20aV;EyEl1aM;IAOI,6BAAA;EzE80aV;EyEr1aM;IAOI,6BAAA;EzEi1aV;EyEx1aM;IAOI,6BAAA;EzEo1aV;EyE31aM;IAOI,6BAAA;EzEu1aV;EyE91aM;IAOI,6BAAA;EzE01aV;EyEj2aM;IAOI,6BAAA;EzE61aV;EyEp2aM;IAOI,6BAAA;EzEg2aV;EyEv2aM;IAOI,6BAAA;EzEm2aV;EyE12aM;IAOI,6BAAA;EzEs2aV;EyE72aM;IAOI,6BAAA;EzEy2aV;EyEh3aM;IAOI,6BAAA;EzE42aV;EyEn3aM;IAOI,8BAAA;EzE+2aV;EyEt3aM;IAOI,8BAAA;EzEk3aV;EyEz3aM;IAOI,8BAAA;EzEq3aV;EyE53aM;IAOI,8BAAA;EzEw3aV;EyE/3aM;IAOI,8BAAA;EzE23aV;EyEl4aM;IAOI,8BAAA;EzE83aV;EyEr4aM;IAOI,8BAAA;EzEi4aV;EyEx4aM;IAOI,8BAAA;EzEo4aV;EyE34aM;IAOI,8BAAA;EzEu4aV;EyE94aM;IAOI,8BAAA;EzE04aV;EyEj5aM;IAOI,6BAAA;EzE64aV;EyEp5aM;IAOI,2BAAA;EzEg5aV;EyEv5aM;IAOI,iCAAA;EzEm5aV;EyE15aM;IAOI,gCAAA;EzEs5aV;EyE75aM;IAOI,8BAAA;EzEy5aV;EyEh6aM;IAOI,gCAAA;EzE45aV;EyEn6aM;IAOI,8BAAA;EzE+5aV;EyEt6aM;IAOI,6BAAA;EzEk6aV;EyEz6aM;IAOI,8BAAA;EzEq6aV;EyE56aM;IAOI,8BAAA;EzEw6aV;EyE/6aM;IAOI,8BAAA;EzE26aV;EyEl7aM;IAOI,8BAAA;EzE86aV;EyEr7aM;IAOI,8BAAA;EzEi7aV;EyEx7aM;IAOI,8BAAA;EzEo7aV;EyE37aM;IAOI,8BAAA;EzEu7aV;EyE97aM;IAOI,8BAAA;EzE07aV;EyEj8aM;IAOI,8BAAA;EzE67aV;EyEp8aM;IAOI,8BAAA;EzEg8aV;EyEv8aM;IAOI,8BAAA;EzEm8aV;EyE18aM;IAOI,+BAAA;EzEs8aV;EyE78aM;IAOI,+BAAA;EzEy8aV;EyEh9aM;IAOI,+BAAA;EzE48aV;EyEn9aM;IAOI,+BAAA;EzE+8aV;EyEt9aM;IAOI,+BAAA;EzEk9aV;EyEz9aM;IAOI,+BAAA;EzEq9aV;EyE59aM;IAOI,+BAAA;EzEw9aV;EyE/9aM;IAOI,+BAAA;EzE29aV;EyEl+aM;IAOI,+BAAA;EzE89aV;EyEr+aM;IAOI,+BAAA;EzEi+aV;EyEx+aM;IAOI,8BAAA;EzEo+aV;EyE3+aM;IAOI,yBAAA;EzEu+aV;EyE9+aM;IAOI,+BAAA;EzE0+aV;EyEj/aM;IAOI,8BAAA;EzE6+aV;EyEp/aM;IAOI,4BAAA;EzEg/aV;EyEv/aM;IAOI,8BAAA;EzEm/aV;EyE1/aM;IAOI,4BAAA;EzEs/aV;EyE7/aM;IAOI,2BAAA;EzEy/aV;EyEhgbM;IAOI,4BAAA;EzE4/aV;EyEngbM;IAOI,4BAAA;EzE+/aV;EyEtgbM;IAOI,4BAAA;EzEkgbV;EyEzgbM;IAOI,4BAAA;EzEqgbV;EyE5gbM;IAOI,4BAAA;EzEwgbV;EyE/gbM;IAOI,4BAAA;EzE2gbV;EyElhbM;IAOI,4BAAA;EzE8gbV;EyErhbM;IAOI,4BAAA;EzEihbV;EyExhbM;IAOI,4BAAA;EzEohbV;EyE3hbM;IAOI,4BAAA;EzEuhbV;EyE9hbM;IAOI,4BAAA;EzE0hbV;EyEjibM;IAOI,6BAAA;EzE6hbV;EyEpibM;IAOI,6BAAA;EzEgibV;EyEvibM;IAOI,6BAAA;EzEmibV;EyE1ibM;IAOI,6BAAA;EzEsibV;EyE7ibM;IAOI,6BAAA;EzEyibV;EyEhjbM;IAOI,6BAAA;EzE4ibV;EyEnjbM;IAOI,6BAAA;EzE+ibV;EyEtjbM;IAOI,6BAAA;EzEkjbV;EyEzjbM;IAOI,6BAAA;EzEqjbV;EyE5jbM;IAOI,6BAAA;EzEwjbV;EyE/jbM;IAOI,4BAAA;EzE2jbV;EyElkbM;IAOI,2BAAA;EzE8jbV;EyErkbM;IAOI,0BAAA;EzEikbV;EyExkbM;IAOI,wBAAA;EzEokbV;EyE3kbM;IAOI,0BAAA;EzEukbV;EyE9kbM;IAOI,wBAAA;EzE0kbV;EyEjlbM;IAOI,uBAAA;EzE6kbV;EyEplbM;IAOI,wBAAA;EzEglbV;EyEvlbM;IAOI,wBAAA;EzEmlbV;EyE1lbM;IAOI,wBAAA;EzEslbV;EyE7lbM;IAOI,wBAAA;EzEylbV;EyEhmbM;IAOI,wBAAA;EzE4lbV;EyEnmbM;IAOI,wBAAA;EzE+lbV;EyEtmbM;IAOI,wBAAA;EzEkmbV;EyEzmbM;IAOI,wBAAA;EzEqmbV;EyE5mbM;IAOI,wBAAA;EzEwmbV;EyE/mbM;IAOI,wBAAA;EzE2mbV;EyElnbM;IAOI,wBAAA;EzE8mbV;EyErnbM;IAOI,yBAAA;EzEinbV;EyExnbM;IAOI,yBAAA;EzEonbV;EyE3nbM;IAOI,yBAAA;EzEunbV;EyE9nbM;IAOI,yBAAA;EzE0nbV;EyEjobM;IAOI,yBAAA;EzE6nbV;EyEpobM;IAOI,yBAAA;EzEgobV;EyEvobM;IAOI,yBAAA;EzEmobV;EyE1obM;IAOI,yBAAA;EzEsobV;EyE7obM;IAOI,yBAAA;EzEyobV;EyEhpbM;IAOI,yBAAA;EzE4obV;EyEnpbM;IAOI,iCAAA;IAAA,gCAAA;EzEgpbV;EyEvpbM;IAOI,gCAAA;IAAA,+BAAA;EzEopbV;EyE3pbM;IAOI,8BAAA;IAAA,6BAAA;EzEwpbV;EyE/pbM;IAOI,gCAAA;IAAA,+BAAA;EzE4pbV;EyEnqbM;IAOI,8BAAA;IAAA,6BAAA;EzEgqbV;EyEvqbM;IAOI,6BAAA;IAAA,4BAAA;EzEoqbV;EyE3qbM;IAOI,8BAAA;IAAA,6BAAA;EzEwqbV;EyE/qbM;IAOI,8BAAA;IAAA,6BAAA;EzE4qbV;EyEnrbM;IAOI,8BAAA;IAAA,6BAAA;EzEgrbV;EyEvrbM;IAOI,8BAAA;IAAA,6BAAA;EzEorbV;EyE3rbM;IAOI,8BAAA;IAAA,6BAAA;EzEwrbV;EyE/rbM;IAOI,8BAAA;IAAA,6BAAA;EzE4rbV;EyEnsbM;IAOI,8BAAA;IAAA,6BAAA;EzEgsbV;EyEvsbM;IAOI,8BAAA;IAAA,6BAAA;EzEosbV;EyE3sbM;IAOI,8BAAA;IAAA,6BAAA;EzEwsbV;EyE/sbM;IAOI,8BAAA;IAAA,6BAAA;EzE4sbV;EyEntbM;IAOI,8BAAA;IAAA,6BAAA;EzEgtbV;EyEvtbM;IAOI,+BAAA;IAAA,8BAAA;EzEotbV;EyE3tbM;IAOI,+BAAA;IAAA,8BAAA;EzEwtbV;EyE/tbM;IAOI,+BAAA;IAAA,8BAAA;EzE4tbV;EyEnubM;IAOI,+BAAA;IAAA,8BAAA;EzEgubV;EyEvubM;IAOI,+BAAA;IAAA,8BAAA;EzEoubV;EyE3ubM;IAOI,+BAAA;IAAA,8BAAA;EzEwubV;EyE/ubM;IAOI,+BAAA;IAAA,8BAAA;EzE4ubV;EyEnvbM;IAOI,+BAAA;IAAA,8BAAA;EzEgvbV;EyEvvbM;IAOI,+BAAA;IAAA,8BAAA;EzEovbV;EyE3vbM;IAOI,+BAAA;IAAA,8BAAA;EzEwvbV;EyE/vbM;IAOI,+BAAA;IAAA,kCAAA;EzE4vbV;EyEnwbM;IAOI,8BAAA;IAAA,iCAAA;EzEgwbV;EyEvwbM;IAOI,4BAAA;IAAA,+BAAA;EzEowbV;EyE3wbM;IAOI,8BAAA;IAAA,iCAAA;EzEwwbV;EyE/wbM;IAOI,4BAAA;IAAA,+BAAA;EzE4wbV;EyEnxbM;IAOI,2BAAA;IAAA,8BAAA;EzEgxbV;EyEvxbM;IAOI,4BAAA;IAAA,+BAAA;EzEoxbV;EyE3xbM;IAOI,4BAAA;IAAA,+BAAA;EzEwxbV;EyE/xbM;IAOI,4BAAA;IAAA,+BAAA;EzE4xbV;EyEnybM;IAOI,4BAAA;IAAA,+BAAA;EzEgybV;EyEvybM;IAOI,4BAAA;IAAA,+BAAA;EzEoybV;EyE3ybM;IAOI,4BAAA;IAAA,+BAAA;EzEwybV;EyE/ybM;IAOI,4BAAA;IAAA,+BAAA;EzE4ybV;EyEnzbM;IAOI,4BAAA;IAAA,+BAAA;EzEgzbV;EyEvzbM;IAOI,4BAAA;IAAA,+BAAA;EzEozbV;EyE3zbM;IAOI,4BAAA;IAAA,+BAAA;EzEwzbV;EyE/zbM;IAOI,4BAAA;IAAA,+BAAA;EzE4zbV;EyEn0bM;IAOI,6BAAA;IAAA,gCAAA;EzEg0bV;EyEv0bM;IAOI,6BAAA;IAAA,gCAAA;EzEo0bV;EyE30bM;IAOI,6BAAA;IAAA,gCAAA;EzEw0bV;EyE/0bM;IAOI,6BAAA;IAAA,gCAAA;EzE40bV;EyEn1bM;IAOI,6BAAA;IAAA,gCAAA;EzEg1bV;EyEv1bM;IAOI,6BAAA;IAAA,gCAAA;EzEo1bV;EyE31bM;IAOI,6BAAA;IAAA,gCAAA;EzEw1bV;EyE/1bM;IAOI,6BAAA;IAAA,gCAAA;EzE41bV;EyEn2bM;IAOI,6BAAA;IAAA,gCAAA;EzEg2bV;EyEv2bM;IAOI,6BAAA;IAAA,gCAAA;EzEo2bV;EyE32bM;IAOI,+BAAA;EzEu2bV;EyE92bM;IAOI,8BAAA;EzE02bV;EyEj3bM;IAOI,4BAAA;EzE62bV;EyEp3bM;IAOI,8BAAA;EzEg3bV;EyEv3bM;IAOI,4BAAA;EzEm3bV;EyE13bM;IAOI,2BAAA;EzEs3bV;EyE73bM;IAOI,4BAAA;EzEy3bV;EyEh4bM;IAOI,4BAAA;EzE43bV;EyEn4bM;IAOI,4BAAA;EzE+3bV;EyEt4bM;IAOI,4BAAA;EzEk4bV;EyEz4bM;IAOI,4BAAA;EzEq4bV;EyE54bM;IAOI,4BAAA;EzEw4bV;EyE/4bM;IAOI,4BAAA;EzE24bV;EyEl5bM;IAOI,4BAAA;EzE84bV;EyEr5bM;IAOI,4BAAA;EzEi5bV;EyEx5bM;IAOI,4BAAA;EzEo5bV;EyE35bM;IAOI,4BAAA;EzEu5bV;EyE95bM;IAOI,6BAAA;EzE05bV;EyEj6bM;IAOI,6BAAA;EzE65bV;EyEp6bM;IAOI,6BAAA;EzEg6bV;EyEv6bM;IAOI,6BAAA;EzEm6bV;EyE16bM;IAOI,6BAAA;EzEs6bV;EyE76bM;IAOI,6BAAA;EzEy6bV;EyEh7bM;IAOI,6BAAA;EzE46bV;EyEn7bM;IAOI,6BAAA;EzE+6bV;EyEt7bM;IAOI,6BAAA;EzEk7bV;EyEz7bM;IAOI,6BAAA;EzEq7bV;EyE57bM;IAOI,iCAAA;EzEw7bV;EyE/7bM;IAOI,gCAAA;EzE27bV;EyEl8bM;IAOI,8BAAA;EzE87bV;EyEr8bM;IAOI,gCAAA;EzEi8bV;EyEx8bM;IAOI,8BAAA;EzEo8bV;EyE38bM;IAOI,6BAAA;EzEu8bV;EyE98bM;IAOI,8BAAA;EzE08bV;EyEj9bM;IAOI,8BAAA;EzE68bV;EyEp9bM;IAOI,8BAAA;EzEg9bV;EyEv9bM;IAOI,8BAAA;EzEm9bV;EyE19bM;IAOI,8BAAA;EzEs9bV;EyE79bM;IAOI,8BAAA;EzEy9bV;EyEh+bM;IAOI,8BAAA;EzE49bV;EyEn+bM;IAOI,8BAAA;EzE+9bV;EyEt+bM;IAOI,8BAAA;EzEk+bV;EyEz+bM;IAOI,8BAAA;EzEq+bV;EyE5+bM;IAOI,8BAAA;EzEw+bV;EyE/+bM;IAOI,+BAAA;EzE2+bV;EyEl/bM;IAOI,+BAAA;EzE8+bV;EyEr/bM;IAOI,+BAAA;EzEi/bV;EyEx/bM;IAOI,+BAAA;EzEo/bV;EyE3/bM;IAOI,+BAAA;EzEu/bV;EyE9/bM;IAOI,+BAAA;EzE0/bV;EyEjgcM;IAOI,+BAAA;EzE6/bV;EyEpgcM;IAOI,+BAAA;EzEggcV;EyEvgcM;IAOI,+BAAA;EzEmgcV;EyE1gcM;IAOI,+BAAA;EzEsgcV;EyE7gcM;IAOI,kCAAA;EzEygcV;EyEhhcM;IAOI,iCAAA;EzE4gcV;EyEnhcM;IAOI,+BAAA;EzE+gcV;EyEthcM;IAOI,iCAAA;EzEkhcV;EyEzhcM;IAOI,+BAAA;EzEqhcV;EyE5hcM;IAOI,8BAAA;EzEwhcV;EyE/hcM;IAOI,+BAAA;EzE2hcV;EyElicM;IAOI,+BAAA;EzE8hcV;EyEricM;IAOI,+BAAA;EzEiicV;EyExicM;IAOI,+BAAA;EzEoicV;EyE3icM;IAOI,+BAAA;EzEuicV;EyE9icM;IAOI,+BAAA;EzE0icV;EyEjjcM;IAOI,+BAAA;EzE6icV;EyEpjcM;IAOI,+BAAA;EzEgjcV;EyEvjcM;IAOI,+BAAA;EzEmjcV;EyE1jcM;IAOI,+BAAA;EzEsjcV;EyE7jcM;IAOI,+BAAA;EzEyjcV;EyEhkcM;IAOI,gCAAA;EzE4jcV;EyEnkcM;IAOI,gCAAA;EzE+jcV;EyEtkcM;IAOI,gCAAA;EzEkkcV;EyEzkcM;IAOI,gCAAA;EzEqkcV;EyE5kcM;IAOI,gCAAA;EzEwkcV;EyE/kcM;IAOI,gCAAA;EzE2kcV;EyEllcM;IAOI,gCAAA;EzE8kcV;EyErlcM;IAOI,gCAAA;EzEilcV;EyExlcM;IAOI,gCAAA;EzEolcV;EyE3lcM;IAOI,gCAAA;EzEulcV;EyE9lcM;IAOI,gCAAA;EzE0lcV;EyEjmcM;IAOI,+BAAA;EzE6lcV;EyEpmcM;IAOI,6BAAA;EzEgmcV;EyEvmcM;IAOI,+BAAA;EzEmmcV;EyE1mcM;IAOI,6BAAA;EzEsmcV;EyE7mcM;IAOI,4BAAA;EzEymcV;EyEhncM;IAOI,6BAAA;EzE4mcV;EyEnncM;IAOI,6BAAA;EzE+mcV;EyEtncM;IAOI,6BAAA;EzEkncV;EyEzncM;IAOI,6BAAA;EzEqncV;EyE5ncM;IAOI,6BAAA;EzEwncV;EyE/ncM;IAOI,6BAAA;EzE2ncV;EyElocM;IAOI,6BAAA;EzE8ncV;EyErocM;IAOI,6BAAA;EzEiocV;EyExocM;IAOI,6BAAA;EzEoocV;EyE3ocM;IAOI,6BAAA;EzEuocV;EyE9ocM;IAOI,6BAAA;EzE0ocV;EyEjpcM;IAOI,8BAAA;EzE6ocV;EyEppcM;IAOI,8BAAA;EzEgpcV;EyEvpcM;IAOI,8BAAA;EzEmpcV;EyE1pcM;IAOI,8BAAA;EzEspcV;EyE7pcM;IAOI,8BAAA;EzEypcV;EyEhqcM;IAOI,8BAAA;EzE4pcV;EyEnqcM;IAOI,8BAAA;EzE+pcV;EyEtqcM;IAOI,8BAAA;EzEkqcV;EyEzqcM;IAOI,8BAAA;EzEqqcV;EyE5qcM;IAOI,8BAAA;EzEwqcV;EyE/qcM;IAOI,qBAAA;EzE2qcV;EyElrcM;IAOI,2BAAA;EzE8qcV;EyErrcM;IAOI,0BAAA;EzEircV;EyExrcM;IAOI,wBAAA;EzEorcV;EyE3rcM;IAOI,0BAAA;EzEurcV;EyE9rcM;IAOI,wBAAA;EzE0rcV;EyEjscM;IAOI,uBAAA;EzE6rcV;EyEpscM;IAOI,wBAAA;EzEgscV;EyEvscM;IAOI,wBAAA;EzEmscV;EyE1scM;IAOI,wBAAA;EzEsscV;EyE7scM;IAOI,wBAAA;EzEyscV;EyEhtcM;IAOI,wBAAA;EzE4scV;EyEntcM;IAOI,wBAAA;EzE+scV;EyEttcM;IAOI,wBAAA;EzEktcV;EyEztcM;IAOI,wBAAA;EzEqtcV;EyE5tcM;IAOI,wBAAA;EzEwtcV;EyE/tcM;IAOI,wBAAA;EzE2tcV;EyElucM;IAOI,wBAAA;EzE8tcV;EyErucM;IAOI,yBAAA;EzEiucV;EyExucM;IAOI,yBAAA;EzEoucV;EyE3ucM;IAOI,yBAAA;EzEuucV;EyE9ucM;IAOI,yBAAA;EzE0ucV;EyEjvcM;IAOI,yBAAA;EzE6ucV;EyEpvcM;IAOI,yBAAA;EzEgvcV;EyEvvcM;IAOI,yBAAA;EzEmvcV;EyE1vcM;IAOI,yBAAA;EzEsvcV;EyE7vcM;IAOI,yBAAA;EzEyvcV;EyEhwcM;IAOI,yBAAA;EzE4vcV;EyEnwcM;IAOI,2BAAA;IAAA,0BAAA;EzEgwcV;EyEvwcM;IAOI,iCAAA;IAAA,gCAAA;EzEowcV;EyE3wcM;IAOI,gCAAA;IAAA,+BAAA;EzEwwcV;EyE/wcM;IAOI,8BAAA;IAAA,6BAAA;EzE4wcV;EyEnxcM;IAOI,gCAAA;IAAA,+BAAA;EzEgxcV;EyEvxcM;IAOI,8BAAA;IAAA,6BAAA;EzEoxcV;EyE3xcM;IAOI,6BAAA;IAAA,4BAAA;EzEwxcV;EyE/xcM;IAOI,8BAAA;IAAA,6BAAA;EzE4xcV;EyEnycM;IAOI,8BAAA;IAAA,6BAAA;EzEgycV;EyEvycM;IAOI,8BAAA;IAAA,6BAAA;EzEoycV;EyE3ycM;IAOI,8BAAA;IAAA,6BAAA;EzEwycV;EyE/ycM;IAOI,8BAAA;IAAA,6BAAA;EzE4ycV;EyEnzcM;IAOI,8BAAA;IAAA,6BAAA;EzEgzcV;EyEvzcM;IAOI,8BAAA;IAAA,6BAAA;EzEozcV;EyE3zcM;IAOI,8BAAA;IAAA,6BAAA;EzEwzcV;EyE/zcM;IAOI,8BAAA;IAAA,6BAAA;EzE4zcV;EyEn0cM;IAOI,8BAAA;IAAA,6BAAA;EzEg0cV;EyEv0cM;IAOI,8BAAA;IAAA,6BAAA;EzEo0cV;EyE30cM;IAOI,+BAAA;IAAA,8BAAA;EzEw0cV;EyE/0cM;IAOI,+BAAA;IAAA,8BAAA;EzE40cV;EyEn1cM;IAOI,+BAAA;IAAA,8BAAA;EzEg1cV;EyEv1cM;IAOI,+BAAA;IAAA,8BAAA;EzEo1cV;EyE31cM;IAOI,+BAAA;IAAA,8BAAA;EzEw1cV;EyE/1cM;IAOI,+BAAA;IAAA,8BAAA;EzE41cV;EyEn2cM;IAOI,+BAAA;IAAA,8BAAA;EzEg2cV;EyEv2cM;IAOI,+BAAA;IAAA,8BAAA;EzEo2cV;EyE32cM;IAOI,+BAAA;IAAA,8BAAA;EzEw2cV;EyE/2cM;IAOI,+BAAA;IAAA,8BAAA;EzE42cV;EyEn3cM;IAOI,yBAAA;IAAA,4BAAA;EzEg3cV;EyEv3cM;IAOI,+BAAA;IAAA,kCAAA;EzEo3cV;EyE33cM;IAOI,8BAAA;IAAA,iCAAA;EzEw3cV;EyE/3cM;IAOI,4BAAA;IAAA,+BAAA;EzE43cV;EyEn4cM;IAOI,8BAAA;IAAA,iCAAA;EzEg4cV;EyEv4cM;IAOI,4BAAA;IAAA,+BAAA;EzEo4cV;EyE34cM;IAOI,2BAAA;IAAA,8BAAA;EzEw4cV;EyE/4cM;IAOI,4BAAA;IAAA,+BAAA;EzE44cV;EyEn5cM;IAOI,4BAAA;IAAA,+BAAA;EzEg5cV;EyEv5cM;IAOI,4BAAA;IAAA,+BAAA;EzEo5cV;EyE35cM;IAOI,4BAAA;IAAA,+BAAA;EzEw5cV;EyE/5cM;IAOI,4BAAA;IAAA,+BAAA;EzE45cV;EyEn6cM;IAOI,4BAAA;IAAA,+BAAA;EzEg6cV;EyEv6cM;IAOI,4BAAA;IAAA,+BAAA;EzEo6cV;EyE36cM;IAOI,4BAAA;IAAA,+BAAA;EzEw6cV;EyE/6cM;IAOI,4BAAA;IAAA,+BAAA;EzE46cV;EyEn7cM;IAOI,4BAAA;IAAA,+BAAA;EzEg7cV;EyEv7cM;IAOI,4BAAA;IAAA,+BAAA;EzEo7cV;EyE37cM;IAOI,6BAAA;IAAA,gCAAA;EzEw7cV;EyE/7cM;IAOI,6BAAA;IAAA,gCAAA;EzE47cV;EyEn8cM;IAOI,6BAAA;IAAA,gCAAA;EzEg8cV;EyEv8cM;IAOI,6BAAA;IAAA,gCAAA;EzEo8cV;EyE38cM;IAOI,6BAAA;IAAA,gCAAA;EzEw8cV;EyE/8cM;IAOI,6BAAA;IAAA,gCAAA;EzE48cV;EyEn9cM;IAOI,6BAAA;IAAA,gCAAA;EzEg9cV;EyEv9cM;IAOI,6BAAA;IAAA,gCAAA;EzEo9cV;EyE39cM;IAOI,6BAAA;IAAA,gCAAA;EzEw9cV;EyE/9cM;IAOI,6BAAA;IAAA,gCAAA;EzE49cV;EyEn+cM;IAOI,yBAAA;EzE+9cV;EyEt+cM;IAOI,+BAAA;EzEk+cV;EyEz+cM;IAOI,8BAAA;EzEq+cV;EyE5+cM;IAOI,4BAAA;EzEw+cV;EyE/+cM;IAOI,8BAAA;EzE2+cV;EyEl/cM;IAOI,4BAAA;EzE8+cV;EyEr/cM;IAOI,2BAAA;EzEi/cV;EyEx/cM;IAOI,4BAAA;EzEo/cV;EyE3/cM;IAOI,4BAAA;EzEu/cV;EyE9/cM;IAOI,4BAAA;EzE0/cV;EyEjgdM;IAOI,4BAAA;EzE6/cV;EyEpgdM;IAOI,4BAAA;EzEggdV;EyEvgdM;IAOI,4BAAA;EzEmgdV;EyE1gdM;IAOI,4BAAA;EzEsgdV;EyE7gdM;IAOI,4BAAA;EzEygdV;EyEhhdM;IAOI,4BAAA;EzE4gdV;EyEnhdM;IAOI,4BAAA;EzE+gdV;EyEthdM;IAOI,4BAAA;EzEkhdV;EyEzhdM;IAOI,6BAAA;EzEqhdV;EyE5hdM;IAOI,6BAAA;EzEwhdV;EyE/hdM;IAOI,6BAAA;EzE2hdV;EyElidM;IAOI,6BAAA;EzE8hdV;EyEridM;IAOI,6BAAA;EzEiidV;EyExidM;IAOI,6BAAA;EzEoidV;EyE3idM;IAOI,6BAAA;EzEuidV;EyE9idM;IAOI,6BAAA;EzE0idV;EyEjjdM;IAOI,6BAAA;EzE6idV;EyEpjdM;IAOI,6BAAA;EzEgjdV;EyEvjdM;IAOI,2BAAA;EzEmjdV;EyE1jdM;IAOI,iCAAA;EzEsjdV;EyE7jdM;IAOI,gCAAA;EzEyjdV;EyEhkdM;IAOI,8BAAA;EzE4jdV;EyEnkdM;IAOI,gCAAA;EzE+jdV;EyEtkdM;IAOI,8BAAA;EzEkkdV;EyEzkdM;IAOI,6BAAA;EzEqkdV;EyE5kdM;IAOI,8BAAA;EzEwkdV;EyE/kdM;IAOI,8BAAA;EzE2kdV;EyElldM;IAOI,8BAAA;EzE8kdV;EyErldM;IAOI,8BAAA;EzEildV;EyExldM;IAOI,8BAAA;EzEoldV;EyE3ldM;IAOI,8BAAA;EzEuldV;EyE9ldM;IAOI,8BAAA;EzE0ldV;EyEjmdM;IAOI,8BAAA;EzE6ldV;EyEpmdM;IAOI,8BAAA;EzEgmdV;EyEvmdM;IAOI,8BAAA;EzEmmdV;EyE1mdM;IAOI,8BAAA;EzEsmdV;EyE7mdM;IAOI,+BAAA;EzEymdV;EyEhndM;IAOI,+BAAA;EzE4mdV;EyEnndM;IAOI,+BAAA;EzE+mdV;EyEtndM;IAOI,+BAAA;EzEkndV;EyEzndM;IAOI,+BAAA;EzEqndV;EyE5ndM;IAOI,+BAAA;EzEwndV;EyE/ndM;IAOI,+BAAA;EzE2ndV;EyElodM;IAOI,+BAAA;EzE8ndV;EyErodM;IAOI,+BAAA;EzEiodV;EyExodM;IAOI,+BAAA;EzEoodV;EyE3odM;IAOI,4BAAA;EzEuodV;EyE9odM;IAOI,kCAAA;EzE0odV;EyEjpdM;IAOI,iCAAA;EzE6odV;EyEppdM;IAOI,+BAAA;EzEgpdV;EyEvpdM;IAOI,iCAAA;EzEmpdV;EyE1pdM;IAOI,+BAAA;EzEspdV;EyE7pdM;IAOI,8BAAA;EzEypdV;EyEhqdM;IAOI,+BAAA;EzE4pdV;EyEnqdM;IAOI,+BAAA;EzE+pdV;EyEtqdM;IAOI,+BAAA;EzEkqdV;EyEzqdM;IAOI,+BAAA;EzEqqdV;EyE5qdM;IAOI,+BAAA;EzEwqdV;EyE/qdM;IAOI,+BAAA;EzE2qdV;EyElrdM;IAOI,+BAAA;EzE8qdV;EyErrdM;IAOI,+BAAA;EzEirdV;EyExrdM;IAOI,+BAAA;EzEordV;EyE3rdM;IAOI,+BAAA;EzEurdV;EyE9rdM;IAOI,+BAAA;EzE0rdV;EyEjsdM;IAOI,gCAAA;EzE6rdV;EyEpsdM;IAOI,gCAAA;EzEgsdV;EyEvsdM;IAOI,gCAAA;EzEmsdV;EyE1sdM;IAOI,gCAAA;EzEssdV;EyE7sdM;IAOI,gCAAA;EzEysdV;EyEhtdM;IAOI,gCAAA;EzE4sdV;EyEntdM;IAOI,gCAAA;EzE+sdV;EyEttdM;IAOI,gCAAA;EzEktdV;EyEztdM;IAOI,gCAAA;EzEqtdV;EyE5tdM;IAOI,gCAAA;EzEwtdV;EyE/tdM;IAOI,0BAAA;EzE2tdV;EyEludM;IAOI,gCAAA;EzE8tdV;EyErudM;IAOI,+BAAA;EzEiudV;EyExudM;IAOI,6BAAA;EzEoudV;EyE3udM;IAOI,+BAAA;EzEuudV;EyE9udM;IAOI,6BAAA;EzE0udV;EyEjvdM;IAOI,4BAAA;EzE6udV;EyEpvdM;IAOI,6BAAA;EzEgvdV;EyEvvdM;IAOI,6BAAA;EzEmvdV;EyE1vdM;IAOI,6BAAA;EzEsvdV;EyE7vdM;IAOI,6BAAA;EzEyvdV;EyEhwdM;IAOI,6BAAA;EzE4vdV;EyEnwdM;IAOI,6BAAA;EzE+vdV;EyEtwdM;IAOI,6BAAA;EzEkwdV;EyEzwdM;IAOI,6BAAA;EzEqwdV;EyE5wdM;IAOI,6BAAA;EzEwwdV;EyE/wdM;IAOI,6BAAA;EzE2wdV;EyElxdM;IAOI,6BAAA;EzE8wdV;EyErxdM;IAOI,8BAAA;EzEixdV;EyExxdM;IAOI,8BAAA;EzEoxdV;EyE3xdM;IAOI,8BAAA;EzEuxdV;EyE9xdM;IAOI,8BAAA;EzE0xdV;EyEjydM;IAOI,8BAAA;EzE6xdV;EyEpydM;IAOI,8BAAA;EzEgydV;EyEvydM;IAOI,8BAAA;EzEmydV;EyE1ydM;IAOI,8BAAA;EzEsydV;EyE7ydM;IAOI,8BAAA;EzEyydV;EyEhzdM;IAOI,8BAAA;EzE4ydV;EyEnzdM;IAOI,iBAAA;EzE+ydV;EyEtzdM;IAOI,uBAAA;EzEkzdV;EyEzzdM;IAOI,sBAAA;EzEqzdV;EyE5zdM;IAOI,oBAAA;EzEwzdV;EyE/zdM;IAOI,sBAAA;EzE2zdV;EyEl0dM;IAOI,oBAAA;EzE8zdV;EyEr0dM;IAOI,mBAAA;EzEi0dV;EyEx0dM;IAOI,oBAAA;EzEo0dV;EyE30dM;IAOI,oBAAA;EzEu0dV;EyE90dM;IAOI,oBAAA;EzE00dV;EyEj1dM;IAOI,oBAAA;EzE60dV;EyEp1dM;IAOI,oBAAA;EzEg1dV;EyEv1dM;IAOI,oBAAA;EzEm1dV;EyE11dM;IAOI,oBAAA;EzEs1dV;EyE71dM;IAOI,oBAAA;EzEy1dV;EyEh2dM;IAOI,oBAAA;EzE41dV;EyEn2dM;IAOI,oBAAA;EzE+1dV;EyEt2dM;IAOI,oBAAA;EzEk2dV;EyEz2dM;IAOI,qBAAA;EzEq2dV;EyE52dM;IAOI,qBAAA;EzEw2dV;EyE/2dM;IAOI,qBAAA;EzE22dV;EyEl3dM;IAOI,qBAAA;EzE82dV;EyEr3dM;IAOI,qBAAA;EzEi3dV;EyEx3dM;IAOI,qBAAA;EzEo3dV;EyE33dM;IAOI,qBAAA;EzEu3dV;EyE93dM;IAOI,qBAAA;EzE03dV;EyEj4dM;IAOI,qBAAA;EzE63dV;EyEp4dM;IAOI,qBAAA;EzEg4dV;EyEv4dM;IAOI,qBAAA;EzEm4dV;EyE14dM;IAOI,2BAAA;EzEs4dV;EyE74dM;IAOI,0BAAA;EzEy4dV;EyEh5dM;IAOI,wBAAA;EzE44dV;EyEn5dM;IAOI,0BAAA;EzE+4dV;EyEt5dM;IAOI,wBAAA;EzEk5dV;EyEz5dM;IAOI,uBAAA;EzEq5dV;EyE55dM;IAOI,wBAAA;EzEw5dV;EyE/5dM;IAOI,wBAAA;EzE25dV;EyEl6dM;IAOI,wBAAA;EzE85dV;EyEr6dM;IAOI,wBAAA;EzEi6dV;EyEx6dM;IAOI,wBAAA;EzEo6dV;EyE36dM;IAOI,wBAAA;EzEu6dV;EyE96dM;IAOI,wBAAA;EzE06dV;EyEj7dM;IAOI,wBAAA;EzE66dV;EyEp7dM;IAOI,wBAAA;EzEg7dV;EyEv7dM;IAOI,wBAAA;EzEm7dV;EyE17dM;IAOI,wBAAA;EzEs7dV;EyE77dM;IAOI,yBAAA;EzEy7dV;EyEh8dM;IAOI,yBAAA;EzE47dV;EyEn8dM;IAOI,yBAAA;EzE+7dV;EyEt8dM;IAOI,yBAAA;EzEk8dV;EyEz8dM;IAOI,yBAAA;EzEq8dV;EyE58dM;IAOI,yBAAA;EzEw8dV;EyE/8dM;IAOI,yBAAA;EzE28dV;EyEl9dM;IAOI,yBAAA;EzE88dV;EyEr9dM;IAOI,yBAAA;EzEi9dV;EyEx9dM;IAOI,yBAAA;EzEo9dV;EyE39dM;IAOI,wBAAA;EzEu9dV;EyE99dM;IAOI,8BAAA;EzE09dV;EyEj+dM;IAOI,6BAAA;EzE69dV;EyEp+dM;IAOI,2BAAA;EzEg+dV;EyEv+dM;IAOI,6BAAA;EzEm+dV;EyE1+dM;IAOI,2BAAA;EzEs+dV;EyE7+dM;IAOI,0BAAA;EzEy+dV;EyEh/dM;IAOI,2BAAA;EzE4+dV;EyEn/dM;IAOI,2BAAA;EzE++dV;EyEt/dM;IAOI,2BAAA;EzEk/dV;EyEz/dM;IAOI,2BAAA;EzEq/dV;EyE5/dM;IAOI,2BAAA;EzEw/dV;EyE//dM;IAOI,2BAAA;EzE2/dV;EyElgeM;IAOI,2BAAA;EzE8/dV;EyErgeM;IAOI,2BAAA;EzEigeV;EyExgeM;IAOI,2BAAA;EzEogeV;EyE3geM;IAOI,2BAAA;EzEugeV;EyE9geM;IAOI,2BAAA;EzE0geV;EyEjheM;IAOI,4BAAA;EzE6geV;EyEpheM;IAOI,4BAAA;EzEgheV;EyEvheM;IAOI,4BAAA;EzEmheV;EyE1heM;IAOI,4BAAA;EzEsheV;EyE7heM;IAOI,4BAAA;EzEyheV;EyEhieM;IAOI,4BAAA;EzE4heV;EyEnieM;IAOI,4BAAA;EzE+heV;EyEtieM;IAOI,4BAAA;EzEkieV;EyEzieM;IAOI,4BAAA;EzEqieV;EyE5ieM;IAOI,4BAAA;EzEwieV;EyE/ieM;IAOI,2BAAA;EzE2ieV;EyEljeM;IAOI,4BAAA;EzE8ieV;EyErjeM;IAOI,6BAAA;EzEijeV;AACF;Ac5jeI;E2DGI;IAOI,sBAAA;EzEsjeV;EyE7jeM;IAOI,uBAAA;EzEyjeV;EyEhkeM;IAOI,sBAAA;EzE4jeV;EyEnkeM;IAOI,8BAAA;EzE+jeV;EyEtkeM;IAOI,4BAAA;EzEkkeV;EyEzkeM;IAOI,2BAAA;EzEqkeV;EyE5keM;IAOI,iCAAA;EzEwkeV;EyE/keM;IAOI,2BAAA;EzE2keV;EyElleM;IAOI,0BAAA;EzE8keV;EyErleM;IAOI,gCAAA;EzEileV;EyExleM;IAOI,yBAAA;EzEoleV;EyE3leM;IAOI,wBAAA;EzEuleV;EyE9leM;IAOI,+BAAA;EzE0leV;EyEjmeM;IAOI,yBAAA;EzE6leV;EyEpmeM;IAOI,6BAAA;EzEgmeV;EyEvmeM;IAOI,8BAAA;EzEmmeV;EyE1meM;IAOI,wBAAA;EzEsmeV;EyE7meM;IAOI,+BAAA;EzEymeV;EyEhneM;IAOI,wBAAA;EzE4meV;EyEnneM;IAOI,yBAAA;EzE+meV;EyEtneM;IAOI,8BAAA;EzEkneV;EyEzneM;IAOI,iCAAA;EzEqneV;EyE5neM;IAOI,sCAAA;EzEwneV;EyE/neM;IAOI,yCAAA;EzE2neV;EyEloeM;IAOI,uBAAA;EzE8neV;EyEroeM;IAOI,uBAAA;EzEioeV;EyExoeM;IAOI,yBAAA;EzEooeV;EyE3oeM;IAOI,yBAAA;EzEuoeV;EyE9oeM;IAOI,0BAAA;EzE0oeV;EyEjpeM;IAOI,4BAAA;EzE6oeV;EyEppeM;IAOI,kCAAA;EzEgpeV;EyEvpeM;IAOI,sCAAA;EzEmpeV;EyE1peM;IAOI,oCAAA;EzEspeV;EyE7peM;IAOI,kCAAA;EzEypeV;EyEhqeM;IAOI,yCAAA;EzE4peV;EyEnqeM;IAOI,wCAAA;EzE+peV;EyEtqeM;IAOI,wCAAA;EzEkqeV;EyEzqeM;IAOI,kCAAA;EzEqqeV;EyE5qeM;IAOI,gCAAA;EzEwqeV;EyE/qeM;IAOI,8BAAA;EzE2qeV;EyElreM;IAOI,gCAAA;EzE8qeV;EyErreM;IAOI,+BAAA;EzEireV;EyExreM;IAOI,oCAAA;EzEoreV;EyE3reM;IAOI,kCAAA;EzEureV;EyE9reM;IAOI,gCAAA;EzE0reV;EyEjseM;IAOI,uCAAA;EzE6reV;EyEpseM;IAOI,sCAAA;EzEgseV;EyEvseM;IAOI,iCAAA;EzEmseV;EyE1seM;IAOI,2BAAA;EzEsseV;EyE7seM;IAOI,iCAAA;EzEyseV;EyEhteM;IAOI,+BAAA;EzE4seV;EyEnteM;IAOI,6BAAA;EzE+seV;EyEtteM;IAOI,+BAAA;EzEkteV;EyEzteM;IAOI,8BAAA;EzEqteV;EyE5teM;IAOI,oBAAA;EzEwteV;EyE/teM;IAOI,mBAAA;EzE2teV;EyElueM;IAOI,mBAAA;EzE8teV;EyErueM;IAOI,mBAAA;EzEiueV;EyExueM;IAOI,mBAAA;EzEoueV;EyE3ueM;IAOI,mBAAA;EzEuueV;EyE9ueM;IAOI,mBAAA;EzE0ueV;EyEjveM;IAOI,mBAAA;EzE6ueV;EyEpveM;IAOI,oBAAA;EzEgveV;EyEvveM;IAOI,0BAAA;EzEmveV;EyE1veM;IAOI,yBAAA;EzEsveV;EyE7veM;IAOI,uBAAA;EzEyveV;EyEhweM;IAOI,yBAAA;EzE4veV;EyEnweM;IAOI,uBAAA;EzE+veV;EyEtweM;IAOI,sBAAA;EzEkweV;EyEzweM;IAOI,uBAAA;EzEqweV;EyE5weM;IAOI,uBAAA;EzEwweV;EyE/weM;IAOI,uBAAA;EzE2weV;EyElxeM;IAOI,uBAAA;EzE8weV;EyErxeM;IAOI,uBAAA;EzEixeV;EyExxeM;IAOI,uBAAA;EzEoxeV;EyE3xeM;IAOI,uBAAA;EzEuxeV;EyE9xeM;IAOI,uBAAA;EzE0xeV;EyEjyeM;IAOI,uBAAA;EzE6xeV;EyEpyeM;IAOI,uBAAA;EzEgyeV;EyEvyeM;IAOI,uBAAA;EzEmyeV;EyE1yeM;IAOI,wBAAA;EzEsyeV;EyE7yeM;IAOI,wBAAA;EzEyyeV;EyEhzeM;IAOI,wBAAA;EzE4yeV;EyEnzeM;IAOI,wBAAA;EzE+yeV;EyEtzeM;IAOI,wBAAA;EzEkzeV;EyEzzeM;IAOI,wBAAA;EzEqzeV;EyE5zeM;IAOI,wBAAA;EzEwzeV;EyE/zeM;IAOI,wBAAA;EzE2zeV;EyEl0eM;IAOI,wBAAA;EzE8zeV;EyEr0eM;IAOI,wBAAA;EzEi0eV;EyEx0eM;IAOI,uBAAA;EzEo0eV;EyE30eM;IAOI,0BAAA;IAAA,yBAAA;EzEw0eV;EyE/0eM;IAOI,gCAAA;IAAA,+BAAA;EzE40eV;EyEn1eM;IAOI,+BAAA;IAAA,8BAAA;EzEg1eV;EyEv1eM;IAOI,6BAAA;IAAA,4BAAA;EzEo1eV;EyE31eM;IAOI,+BAAA;IAAA,8BAAA;EzEw1eV;EyE/1eM;IAOI,6BAAA;IAAA,4BAAA;EzE41eV;EyEn2eM;IAOI,4BAAA;IAAA,2BAAA;EzEg2eV;EyEv2eM;IAOI,6BAAA;IAAA,4BAAA;EzEo2eV;EyE32eM;IAOI,6BAAA;IAAA,4BAAA;EzEw2eV;EyE/2eM;IAOI,6BAAA;IAAA,4BAAA;EzE42eV;EyEn3eM;IAOI,6BAAA;IAAA,4BAAA;EzEg3eV;EyEv3eM;IAOI,6BAAA;IAAA,4BAAA;EzEo3eV;EyE33eM;IAOI,6BAAA;IAAA,4BAAA;EzEw3eV;EyE/3eM;IAOI,6BAAA;IAAA,4BAAA;EzE43eV;EyEn4eM;IAOI,6BAAA;IAAA,4BAAA;EzEg4eV;EyEv4eM;IAOI,6BAAA;IAAA,4BAAA;EzEo4eV;EyE34eM;IAOI,6BAAA;IAAA,4BAAA;EzEw4eV;EyE/4eM;IAOI,6BAAA;IAAA,4BAAA;EzE44eV;EyEn5eM;IAOI,8BAAA;IAAA,6BAAA;EzEg5eV;EyEv5eM;IAOI,8BAAA;IAAA,6BAAA;EzEo5eV;EyE35eM;IAOI,8BAAA;IAAA,6BAAA;EzEw5eV;EyE/5eM;IAOI,8BAAA;IAAA,6BAAA;EzE45eV;EyEn6eM;IAOI,8BAAA;IAAA,6BAAA;EzEg6eV;EyEv6eM;IAOI,8BAAA;IAAA,6BAAA;EzEo6eV;EyE36eM;IAOI,8BAAA;IAAA,6BAAA;EzEw6eV;EyE/6eM;IAOI,8BAAA;IAAA,6BAAA;EzE46eV;EyEn7eM;IAOI,8BAAA;IAAA,6BAAA;EzEg7eV;EyEv7eM;IAOI,8BAAA;IAAA,6BAAA;EzEo7eV;EyE37eM;IAOI,6BAAA;IAAA,4BAAA;EzEw7eV;EyE/7eM;IAOI,wBAAA;IAAA,2BAAA;EzE47eV;EyEn8eM;IAOI,8BAAA;IAAA,iCAAA;EzEg8eV;EyEv8eM;IAOI,6BAAA;IAAA,gCAAA;EzEo8eV;EyE38eM;IAOI,2BAAA;IAAA,8BAAA;EzEw8eV;EyE/8eM;IAOI,6BAAA;IAAA,gCAAA;EzE48eV;EyEn9eM;IAOI,2BAAA;IAAA,8BAAA;EzEg9eV;EyEv9eM;IAOI,0BAAA;IAAA,6BAAA;EzEo9eV;EyE39eM;IAOI,2BAAA;IAAA,8BAAA;EzEw9eV;EyE/9eM;IAOI,2BAAA;IAAA,8BAAA;EzE49eV;EyEn+eM;IAOI,2BAAA;IAAA,8BAAA;EzEg+eV;EyEv+eM;IAOI,2BAAA;IAAA,8BAAA;EzEo+eV;EyE3+eM;IAOI,2BAAA;IAAA,8BAAA;EzEw+eV;EyE/+eM;IAOI,2BAAA;IAAA,8BAAA;EzE4+eV;EyEn/eM;IAOI,2BAAA;IAAA,8BAAA;EzEg/eV;EyEv/eM;IAOI,2BAAA;IAAA,8BAAA;EzEo/eV;EyE3/eM;IAOI,2BAAA;IAAA,8BAAA;EzEw/eV;EyE//eM;IAOI,2BAAA;IAAA,8BAAA;EzE4/eV;EyEngfM;IAOI,2BAAA;IAAA,8BAAA;EzEggfV;EyEvgfM;IAOI,4BAAA;IAAA,+BAAA;EzEogfV;EyE3gfM;IAOI,4BAAA;IAAA,+BAAA;EzEwgfV;EyE/gfM;IAOI,4BAAA;IAAA,+BAAA;EzE4gfV;EyEnhfM;IAOI,4BAAA;IAAA,+BAAA;EzEghfV;EyEvhfM;IAOI,4BAAA;IAAA,+BAAA;EzEohfV;EyE3hfM;IAOI,4BAAA;IAAA,+BAAA;EzEwhfV;EyE/hfM;IAOI,4BAAA;IAAA,+BAAA;EzE4hfV;EyEnifM;IAOI,4BAAA;IAAA,+BAAA;EzEgifV;EyEvifM;IAOI,4BAAA;IAAA,+BAAA;EzEoifV;EyE3ifM;IAOI,4BAAA;IAAA,+BAAA;EzEwifV;EyE/ifM;IAOI,2BAAA;IAAA,8BAAA;EzE4ifV;EyEnjfM;IAOI,wBAAA;EzE+ifV;EyEtjfM;IAOI,8BAAA;EzEkjfV;EyEzjfM;IAOI,6BAAA;EzEqjfV;EyE5jfM;IAOI,2BAAA;EzEwjfV;EyE/jfM;IAOI,6BAAA;EzE2jfV;EyElkfM;IAOI,2BAAA;EzE8jfV;EyErkfM;IAOI,0BAAA;EzEikfV;EyExkfM;IAOI,2BAAA;EzEokfV;EyE3kfM;IAOI,2BAAA;EzEukfV;EyE9kfM;IAOI,2BAAA;EzE0kfV;EyEjlfM;IAOI,2BAAA;EzE6kfV;EyEplfM;IAOI,2BAAA;EzEglfV;EyEvlfM;IAOI,2BAAA;EzEmlfV;EyE1lfM;IAOI,2BAAA;EzEslfV;EyE7lfM;IAOI,2BAAA;EzEylfV;EyEhmfM;IAOI,2BAAA;EzE4lfV;EyEnmfM;IAOI,2BAAA;EzE+lfV;EyEtmfM;IAOI,2BAAA;EzEkmfV;EyEzmfM;IAOI,4BAAA;EzEqmfV;EyE5mfM;IAOI,4BAAA;EzEwmfV;EyE/mfM;IAOI,4BAAA;EzE2mfV;EyElnfM;IAOI,4BAAA;EzE8mfV;EyErnfM;IAOI,4BAAA;EzEinfV;EyExnfM;IAOI,4BAAA;EzEonfV;EyE3nfM;IAOI,4BAAA;EzEunfV;EyE9nfM;IAOI,4BAAA;EzE0nfV;EyEjofM;IAOI,4BAAA;EzE6nfV;EyEpofM;IAOI,4BAAA;EzEgofV;EyEvofM;IAOI,2BAAA;EzEmofV;EyE1ofM;IAOI,0BAAA;EzEsofV;EyE7ofM;IAOI,gCAAA;EzEyofV;EyEhpfM;IAOI,+BAAA;EzE4ofV;EyEnpfM;IAOI,6BAAA;EzE+ofV;EyEtpfM;IAOI,+BAAA;EzEkpfV;EyEzpfM;IAOI,6BAAA;EzEqpfV;EyE5pfM;IAOI,4BAAA;EzEwpfV;EyE/pfM;IAOI,6BAAA;EzE2pfV;EyElqfM;IAOI,6BAAA;EzE8pfV;EyErqfM;IAOI,6BAAA;EzEiqfV;EyExqfM;IAOI,6BAAA;EzEoqfV;EyE3qfM;IAOI,6BAAA;EzEuqfV;EyE9qfM;IAOI,6BAAA;EzE0qfV;EyEjrfM;IAOI,6BAAA;EzE6qfV;EyEprfM;IAOI,6BAAA;EzEgrfV;EyEvrfM;IAOI,6BAAA;EzEmrfV;EyE1rfM;IAOI,6BAAA;EzEsrfV;EyE7rfM;IAOI,6BAAA;EzEyrfV;EyEhsfM;IAOI,8BAAA;EzE4rfV;EyEnsfM;IAOI,8BAAA;EzE+rfV;EyEtsfM;IAOI,8BAAA;EzEksfV;EyEzsfM;IAOI,8BAAA;EzEqsfV;EyE5sfM;IAOI,8BAAA;EzEwsfV;EyE/sfM;IAOI,8BAAA;EzE2sfV;EyEltfM;IAOI,8BAAA;EzE8sfV;EyErtfM;IAOI,8BAAA;EzEitfV;EyExtfM;IAOI,8BAAA;EzEotfV;EyE3tfM;IAOI,8BAAA;EzEutfV;EyE9tfM;IAOI,6BAAA;EzE0tfV;EyEjufM;IAOI,2BAAA;EzE6tfV;EyEpufM;IAOI,iCAAA;EzEgufV;EyEvufM;IAOI,gCAAA;EzEmufV;EyE1ufM;IAOI,8BAAA;EzEsufV;EyE7ufM;IAOI,gCAAA;EzEyufV;EyEhvfM;IAOI,8BAAA;EzE4ufV;EyEnvfM;IAOI,6BAAA;EzE+ufV;EyEtvfM;IAOI,8BAAA;EzEkvfV;EyEzvfM;IAOI,8BAAA;EzEqvfV;EyE5vfM;IAOI,8BAAA;EzEwvfV;EyE/vfM;IAOI,8BAAA;EzE2vfV;EyElwfM;IAOI,8BAAA;EzE8vfV;EyErwfM;IAOI,8BAAA;EzEiwfV;EyExwfM;IAOI,8BAAA;EzEowfV;EyE3wfM;IAOI,8BAAA;EzEuwfV;EyE9wfM;IAOI,8BAAA;EzE0wfV;EyEjxfM;IAOI,8BAAA;EzE6wfV;EyEpxfM;IAOI,8BAAA;EzEgxfV;EyEvxfM;IAOI,+BAAA;EzEmxfV;EyE1xfM;IAOI,+BAAA;EzEsxfV;EyE7xfM;IAOI,+BAAA;EzEyxfV;EyEhyfM;IAOI,+BAAA;EzE4xfV;EyEnyfM;IAOI,+BAAA;EzE+xfV;EyEtyfM;IAOI,+BAAA;EzEkyfV;EyEzyfM;IAOI,+BAAA;EzEqyfV;EyE5yfM;IAOI,+BAAA;EzEwyfV;EyE/yfM;IAOI,+BAAA;EzE2yfV;EyElzfM;IAOI,+BAAA;EzE8yfV;EyErzfM;IAOI,8BAAA;EzEizfV;EyExzfM;IAOI,yBAAA;EzEozfV;EyE3zfM;IAOI,+BAAA;EzEuzfV;EyE9zfM;IAOI,8BAAA;EzE0zfV;EyEj0fM;IAOI,4BAAA;EzE6zfV;EyEp0fM;IAOI,8BAAA;EzEg0fV;EyEv0fM;IAOI,4BAAA;EzEm0fV;EyE10fM;IAOI,2BAAA;EzEs0fV;EyE70fM;IAOI,4BAAA;EzEy0fV;EyEh1fM;IAOI,4BAAA;EzE40fV;EyEn1fM;IAOI,4BAAA;EzE+0fV;EyEt1fM;IAOI,4BAAA;EzEk1fV;EyEz1fM;IAOI,4BAAA;EzEq1fV;EyE51fM;IAOI,4BAAA;EzEw1fV;EyE/1fM;IAOI,4BAAA;EzE21fV;EyEl2fM;IAOI,4BAAA;EzE81fV;EyEr2fM;IAOI,4BAAA;EzEi2fV;EyEx2fM;IAOI,4BAAA;EzEo2fV;EyE32fM;IAOI,4BAAA;EzEu2fV;EyE92fM;IAOI,6BAAA;EzE02fV;EyEj3fM;IAOI,6BAAA;EzE62fV;EyEp3fM;IAOI,6BAAA;EzEg3fV;EyEv3fM;IAOI,6BAAA;EzEm3fV;EyE13fM;IAOI,6BAAA;EzEs3fV;EyE73fM;IAOI,6BAAA;EzEy3fV;EyEh4fM;IAOI,6BAAA;EzE43fV;EyEn4fM;IAOI,6BAAA;EzE+3fV;EyEt4fM;IAOI,6BAAA;EzEk4fV;EyEz4fM;IAOI,6BAAA;EzEq4fV;EyE54fM;IAOI,4BAAA;EzEw4fV;EyE/4fM;IAOI,2BAAA;EzE24fV;EyEl5fM;IAOI,0BAAA;EzE84fV;EyEr5fM;IAOI,wBAAA;EzEi5fV;EyEx5fM;IAOI,0BAAA;EzEo5fV;EyE35fM;IAOI,wBAAA;EzEu5fV;EyE95fM;IAOI,uBAAA;EzE05fV;EyEj6fM;IAOI,wBAAA;EzE65fV;EyEp6fM;IAOI,wBAAA;EzEg6fV;EyEv6fM;IAOI,wBAAA;EzEm6fV;EyE16fM;IAOI,wBAAA;EzEs6fV;EyE76fM;IAOI,wBAAA;EzEy6fV;EyEh7fM;IAOI,wBAAA;EzE46fV;EyEn7fM;IAOI,wBAAA;EzE+6fV;EyEt7fM;IAOI,wBAAA;EzEk7fV;EyEz7fM;IAOI,wBAAA;EzEq7fV;EyE57fM;IAOI,wBAAA;EzEw7fV;EyE/7fM;IAOI,wBAAA;EzE27fV;EyEl8fM;IAOI,yBAAA;EzE87fV;EyEr8fM;IAOI,yBAAA;EzEi8fV;EyEx8fM;IAOI,yBAAA;EzEo8fV;EyE38fM;IAOI,yBAAA;EzEu8fV;EyE98fM;IAOI,yBAAA;EzE08fV;EyEj9fM;IAOI,yBAAA;EzE68fV;EyEp9fM;IAOI,yBAAA;EzEg9fV;EyEv9fM;IAOI,yBAAA;EzEm9fV;EyE19fM;IAOI,yBAAA;EzEs9fV;EyE79fM;IAOI,yBAAA;EzEy9fV;EyEh+fM;IAOI,iCAAA;IAAA,gCAAA;EzE69fV;EyEp+fM;IAOI,gCAAA;IAAA,+BAAA;EzEi+fV;EyEx+fM;IAOI,8BAAA;IAAA,6BAAA;EzEq+fV;EyE5+fM;IAOI,gCAAA;IAAA,+BAAA;EzEy+fV;EyEh/fM;IAOI,8BAAA;IAAA,6BAAA;EzE6+fV;EyEp/fM;IAOI,6BAAA;IAAA,4BAAA;EzEi/fV;EyEx/fM;IAOI,8BAAA;IAAA,6BAAA;EzEq/fV;EyE5/fM;IAOI,8BAAA;IAAA,6BAAA;EzEy/fV;EyEhggBM;IAOI,8BAAA;IAAA,6BAAA;EzE6/fV;EyEpggBM;IAOI,8BAAA;IAAA,6BAAA;EzEiggBV;EyExggBM;IAOI,8BAAA;IAAA,6BAAA;EzEqggBV;EyE5ggBM;IAOI,8BAAA;IAAA,6BAAA;EzEyggBV;EyEhhgBM;IAOI,8BAAA;IAAA,6BAAA;EzE6ggBV;EyEphgBM;IAOI,8BAAA;IAAA,6BAAA;EzEihgBV;EyExhgBM;IAOI,8BAAA;IAAA,6BAAA;EzEqhgBV;EyE5hgBM;IAOI,8BAAA;IAAA,6BAAA;EzEyhgBV;EyEhigBM;IAOI,8BAAA;IAAA,6BAAA;EzE6hgBV;EyEpigBM;IAOI,+BAAA;IAAA,8BAAA;EzEiigBV;EyExigBM;IAOI,+BAAA;IAAA,8BAAA;EzEqigBV;EyE5igBM;IAOI,+BAAA;IAAA,8BAAA;EzEyigBV;EyEhjgBM;IAOI,+BAAA;IAAA,8BAAA;EzE6igBV;EyEpjgBM;IAOI,+BAAA;IAAA,8BAAA;EzEijgBV;EyExjgBM;IAOI,+BAAA;IAAA,8BAAA;EzEqjgBV;EyE5jgBM;IAOI,+BAAA;IAAA,8BAAA;EzEyjgBV;EyEhkgBM;IAOI,+BAAA;IAAA,8BAAA;EzE6jgBV;EyEpkgBM;IAOI,+BAAA;IAAA,8BAAA;EzEikgBV;EyExkgBM;IAOI,+BAAA;IAAA,8BAAA;EzEqkgBV;EyE5kgBM;IAOI,+BAAA;IAAA,kCAAA;EzEykgBV;EyEhlgBM;IAOI,8BAAA;IAAA,iCAAA;EzE6kgBV;EyEplgBM;IAOI,4BAAA;IAAA,+BAAA;EzEilgBV;EyExlgBM;IAOI,8BAAA;IAAA,iCAAA;EzEqlgBV;EyE5lgBM;IAOI,4BAAA;IAAA,+BAAA;EzEylgBV;EyEhmgBM;IAOI,2BAAA;IAAA,8BAAA;EzE6lgBV;EyEpmgBM;IAOI,4BAAA;IAAA,+BAAA;EzEimgBV;EyExmgBM;IAOI,4BAAA;IAAA,+BAAA;EzEqmgBV;EyE5mgBM;IAOI,4BAAA;IAAA,+BAAA;EzEymgBV;EyEhngBM;IAOI,4BAAA;IAAA,+BAAA;EzE6mgBV;EyEpngBM;IAOI,4BAAA;IAAA,+BAAA;EzEingBV;EyExngBM;IAOI,4BAAA;IAAA,+BAAA;EzEqngBV;EyE5ngBM;IAOI,4BAAA;IAAA,+BAAA;EzEyngBV;EyEhogBM;IAOI,4BAAA;IAAA,+BAAA;EzE6ngBV;EyEpogBM;IAOI,4BAAA;IAAA,+BAAA;EzEiogBV;EyExogBM;IAOI,4BAAA;IAAA,+BAAA;EzEqogBV;EyE5ogBM;IAOI,4BAAA;IAAA,+BAAA;EzEyogBV;EyEhpgBM;IAOI,6BAAA;IAAA,gCAAA;EzE6ogBV;EyEppgBM;IAOI,6BAAA;IAAA,gCAAA;EzEipgBV;EyExpgBM;IAOI,6BAAA;IAAA,gCAAA;EzEqpgBV;EyE5pgBM;IAOI,6BAAA;IAAA,gCAAA;EzEypgBV;EyEhqgBM;IAOI,6BAAA;IAAA,gCAAA;EzE6pgBV;EyEpqgBM;IAOI,6BAAA;IAAA,gCAAA;EzEiqgBV;EyExqgBM;IAOI,6BAAA;IAAA,gCAAA;EzEqqgBV;EyE5qgBM;IAOI,6BAAA;IAAA,gCAAA;EzEyqgBV;EyEhrgBM;IAOI,6BAAA;IAAA,gCAAA;EzE6qgBV;EyEprgBM;IAOI,6BAAA;IAAA,gCAAA;EzEirgBV;EyExrgBM;IAOI,+BAAA;EzEorgBV;EyE3rgBM;IAOI,8BAAA;EzEurgBV;EyE9rgBM;IAOI,4BAAA;EzE0rgBV;EyEjsgBM;IAOI,8BAAA;EzE6rgBV;EyEpsgBM;IAOI,4BAAA;EzEgsgBV;EyEvsgBM;IAOI,2BAAA;EzEmsgBV;EyE1sgBM;IAOI,4BAAA;EzEssgBV;EyE7sgBM;IAOI,4BAAA;EzEysgBV;EyEhtgBM;IAOI,4BAAA;EzE4sgBV;EyEntgBM;IAOI,4BAAA;EzE+sgBV;EyEttgBM;IAOI,4BAAA;EzEktgBV;EyEztgBM;IAOI,4BAAA;EzEqtgBV;EyE5tgBM;IAOI,4BAAA;EzEwtgBV;EyE/tgBM;IAOI,4BAAA;EzE2tgBV;EyElugBM;IAOI,4BAAA;EzE8tgBV;EyErugBM;IAOI,4BAAA;EzEiugBV;EyExugBM;IAOI,4BAAA;EzEougBV;EyE3ugBM;IAOI,6BAAA;EzEuugBV;EyE9ugBM;IAOI,6BAAA;EzE0ugBV;EyEjvgBM;IAOI,6BAAA;EzE6ugBV;EyEpvgBM;IAOI,6BAAA;EzEgvgBV;EyEvvgBM;IAOI,6BAAA;EzEmvgBV;EyE1vgBM;IAOI,6BAAA;EzEsvgBV;EyE7vgBM;IAOI,6BAAA;EzEyvgBV;EyEhwgBM;IAOI,6BAAA;EzE4vgBV;EyEnwgBM;IAOI,6BAAA;EzE+vgBV;EyEtwgBM;IAOI,6BAAA;EzEkwgBV;EyEzwgBM;IAOI,iCAAA;EzEqwgBV;EyE5wgBM;IAOI,gCAAA;EzEwwgBV;EyE/wgBM;IAOI,8BAAA;EzE2wgBV;EyElxgBM;IAOI,gCAAA;EzE8wgBV;EyErxgBM;IAOI,8BAAA;EzEixgBV;EyExxgBM;IAOI,6BAAA;EzEoxgBV;EyE3xgBM;IAOI,8BAAA;EzEuxgBV;EyE9xgBM;IAOI,8BAAA;EzE0xgBV;EyEjygBM;IAOI,8BAAA;EzE6xgBV;EyEpygBM;IAOI,8BAAA;EzEgygBV;EyEvygBM;IAOI,8BAAA;EzEmygBV;EyE1ygBM;IAOI,8BAAA;EzEsygBV;EyE7ygBM;IAOI,8BAAA;EzEyygBV;EyEhzgBM;IAOI,8BAAA;EzE4ygBV;EyEnzgBM;IAOI,8BAAA;EzE+ygBV;EyEtzgBM;IAOI,8BAAA;EzEkzgBV;EyEzzgBM;IAOI,8BAAA;EzEqzgBV;EyE5zgBM;IAOI,+BAAA;EzEwzgBV;EyE/zgBM;IAOI,+BAAA;EzE2zgBV;EyEl0gBM;IAOI,+BAAA;EzE8zgBV;EyEr0gBM;IAOI,+BAAA;EzEi0gBV;EyEx0gBM;IAOI,+BAAA;EzEo0gBV;EyE30gBM;IAOI,+BAAA;EzEu0gBV;EyE90gBM;IAOI,+BAAA;EzE00gBV;EyEj1gBM;IAOI,+BAAA;EzE60gBV;EyEp1gBM;IAOI,+BAAA;EzEg1gBV;EyEv1gBM;IAOI,+BAAA;EzEm1gBV;EyE11gBM;IAOI,kCAAA;EzEs1gBV;EyE71gBM;IAOI,iCAAA;EzEy1gBV;EyEh2gBM;IAOI,+BAAA;EzE41gBV;EyEn2gBM;IAOI,iCAAA;EzE+1gBV;EyEt2gBM;IAOI,+BAAA;EzEk2gBV;EyEz2gBM;IAOI,8BAAA;EzEq2gBV;EyE52gBM;IAOI,+BAAA;EzEw2gBV;EyE/2gBM;IAOI,+BAAA;EzE22gBV;EyEl3gBM;IAOI,+BAAA;EzE82gBV;EyEr3gBM;IAOI,+BAAA;EzEi3gBV;EyEx3gBM;IAOI,+BAAA;EzEo3gBV;EyE33gBM;IAOI,+BAAA;EzEu3gBV;EyE93gBM;IAOI,+BAAA;EzE03gBV;EyEj4gBM;IAOI,+BAAA;EzE63gBV;EyEp4gBM;IAOI,+BAAA;EzEg4gBV;EyEv4gBM;IAOI,+BAAA;EzEm4gBV;EyE14gBM;IAOI,+BAAA;EzEs4gBV;EyE74gBM;IAOI,gCAAA;EzEy4gBV;EyEh5gBM;IAOI,gCAAA;EzE44gBV;EyEn5gBM;IAOI,gCAAA;EzE+4gBV;EyEt5gBM;IAOI,gCAAA;EzEk5gBV;EyEz5gBM;IAOI,gCAAA;EzEq5gBV;EyE55gBM;IAOI,gCAAA;EzEw5gBV;EyE/5gBM;IAOI,gCAAA;EzE25gBV;EyEl6gBM;IAOI,gCAAA;EzE85gBV;EyEr6gBM;IAOI,gCAAA;EzEi6gBV;EyEx6gBM;IAOI,gCAAA;EzEo6gBV;EyE36gBM;IAOI,gCAAA;EzEu6gBV;EyE96gBM;IAOI,+BAAA;EzE06gBV;EyEj7gBM;IAOI,6BAAA;EzE66gBV;EyEp7gBM;IAOI,+BAAA;EzEg7gBV;EyEv7gBM;IAOI,6BAAA;EzEm7gBV;EyE17gBM;IAOI,4BAAA;EzEs7gBV;EyE77gBM;IAOI,6BAAA;EzEy7gBV;EyEh8gBM;IAOI,6BAAA;EzE47gBV;EyEn8gBM;IAOI,6BAAA;EzE+7gBV;EyEt8gBM;IAOI,6BAAA;EzEk8gBV;EyEz8gBM;IAOI,6BAAA;EzEq8gBV;EyE58gBM;IAOI,6BAAA;EzEw8gBV;EyE/8gBM;IAOI,6BAAA;EzE28gBV;EyEl9gBM;IAOI,6BAAA;EzE88gBV;EyEr9gBM;IAOI,6BAAA;EzEi9gBV;EyEx9gBM;IAOI,6BAAA;EzEo9gBV;EyE39gBM;IAOI,6BAAA;EzEu9gBV;EyE99gBM;IAOI,8BAAA;EzE09gBV;EyEj+gBM;IAOI,8BAAA;EzE69gBV;EyEp+gBM;IAOI,8BAAA;EzEg+gBV;EyEv+gBM;IAOI,8BAAA;EzEm+gBV;EyE1+gBM;IAOI,8BAAA;EzEs+gBV;EyE7+gBM;IAOI,8BAAA;EzEy+gBV;EyEh/gBM;IAOI,8BAAA;EzE4+gBV;EyEn/gBM;IAOI,8BAAA;EzE++gBV;EyEt/gBM;IAOI,8BAAA;EzEk/gBV;EyEz/gBM;IAOI,8BAAA;EzEq/gBV;EyE5/gBM;IAOI,qBAAA;EzEw/gBV;EyE//gBM;IAOI,2BAAA;EzE2/gBV;EyElghBM;IAOI,0BAAA;EzE8/gBV;EyErghBM;IAOI,wBAAA;EzEighBV;EyExghBM;IAOI,0BAAA;EzEoghBV;EyE3ghBM;IAOI,wBAAA;EzEughBV;EyE9ghBM;IAOI,uBAAA;EzE0ghBV;EyEjhhBM;IAOI,wBAAA;EzE6ghBV;EyEphhBM;IAOI,wBAAA;EzEghhBV;EyEvhhBM;IAOI,wBAAA;EzEmhhBV;EyE1hhBM;IAOI,wBAAA;EzEshhBV;EyE7hhBM;IAOI,wBAAA;EzEyhhBV;EyEhihBM;IAOI,wBAAA;EzE4hhBV;EyEnihBM;IAOI,wBAAA;EzE+hhBV;EyEtihBM;IAOI,wBAAA;EzEkihBV;EyEzihBM;IAOI,wBAAA;EzEqihBV;EyE5ihBM;IAOI,wBAAA;EzEwihBV;EyE/ihBM;IAOI,wBAAA;EzE2ihBV;EyEljhBM;IAOI,yBAAA;EzE8ihBV;EyErjhBM;IAOI,yBAAA;EzEijhBV;EyExjhBM;IAOI,yBAAA;EzEojhBV;EyE3jhBM;IAOI,yBAAA;EzEujhBV;EyE9jhBM;IAOI,yBAAA;EzE0jhBV;EyEjkhBM;IAOI,yBAAA;EzE6jhBV;EyEpkhBM;IAOI,yBAAA;EzEgkhBV;EyEvkhBM;IAOI,yBAAA;EzEmkhBV;EyE1khBM;IAOI,yBAAA;EzEskhBV;EyE7khBM;IAOI,yBAAA;EzEykhBV;EyEhlhBM;IAOI,2BAAA;IAAA,0BAAA;EzE6khBV;EyEplhBM;IAOI,iCAAA;IAAA,gCAAA;EzEilhBV;EyExlhBM;IAOI,gCAAA;IAAA,+BAAA;EzEqlhBV;EyE5lhBM;IAOI,8BAAA;IAAA,6BAAA;EzEylhBV;EyEhmhBM;IAOI,gCAAA;IAAA,+BAAA;EzE6lhBV;EyEpmhBM;IAOI,8BAAA;IAAA,6BAAA;EzEimhBV;EyExmhBM;IAOI,6BAAA;IAAA,4BAAA;EzEqmhBV;EyE5mhBM;IAOI,8BAAA;IAAA,6BAAA;EzEymhBV;EyEhnhBM;IAOI,8BAAA;IAAA,6BAAA;EzE6mhBV;EyEpnhBM;IAOI,8BAAA;IAAA,6BAAA;EzEinhBV;EyExnhBM;IAOI,8BAAA;IAAA,6BAAA;EzEqnhBV;EyE5nhBM;IAOI,8BAAA;IAAA,6BAAA;EzEynhBV;EyEhohBM;IAOI,8BAAA;IAAA,6BAAA;EzE6nhBV;EyEpohBM;IAOI,8BAAA;IAAA,6BAAA;EzEiohBV;EyExohBM;IAOI,8BAAA;IAAA,6BAAA;EzEqohBV;EyE5ohBM;IAOI,8BAAA;IAAA,6BAAA;EzEyohBV;EyEhphBM;IAOI,8BAAA;IAAA,6BAAA;EzE6ohBV;EyEpphBM;IAOI,8BAAA;IAAA,6BAAA;EzEiphBV;EyExphBM;IAOI,+BAAA;IAAA,8BAAA;EzEqphBV;EyE5phBM;IAOI,+BAAA;IAAA,8BAAA;EzEyphBV;EyEhqhBM;IAOI,+BAAA;IAAA,8BAAA;EzE6phBV;EyEpqhBM;IAOI,+BAAA;IAAA,8BAAA;EzEiqhBV;EyExqhBM;IAOI,+BAAA;IAAA,8BAAA;EzEqqhBV;EyE5qhBM;IAOI,+BAAA;IAAA,8BAAA;EzEyqhBV;EyEhrhBM;IAOI,+BAAA;IAAA,8BAAA;EzE6qhBV;EyEprhBM;IAOI,+BAAA;IAAA,8BAAA;EzEirhBV;EyExrhBM;IAOI,+BAAA;IAAA,8BAAA;EzEqrhBV;EyE5rhBM;IAOI,+BAAA;IAAA,8BAAA;EzEyrhBV;EyEhshBM;IAOI,yBAAA;IAAA,4BAAA;EzE6rhBV;EyEpshBM;IAOI,+BAAA;IAAA,kCAAA;EzEishBV;EyExshBM;IAOI,8BAAA;IAAA,iCAAA;EzEqshBV;EyE5shBM;IAOI,4BAAA;IAAA,+BAAA;EzEyshBV;EyEhthBM;IAOI,8BAAA;IAAA,iCAAA;EzE6shBV;EyEpthBM;IAOI,4BAAA;IAAA,+BAAA;EzEithBV;EyExthBM;IAOI,2BAAA;IAAA,8BAAA;EzEqthBV;EyE5thBM;IAOI,4BAAA;IAAA,+BAAA;EzEythBV;EyEhuhBM;IAOI,4BAAA;IAAA,+BAAA;EzE6thBV;EyEpuhBM;IAOI,4BAAA;IAAA,+BAAA;EzEiuhBV;EyExuhBM;IAOI,4BAAA;IAAA,+BAAA;EzEquhBV;EyE5uhBM;IAOI,4BAAA;IAAA,+BAAA;EzEyuhBV;EyEhvhBM;IAOI,4BAAA;IAAA,+BAAA;EzE6uhBV;EyEpvhBM;IAOI,4BAAA;IAAA,+BAAA;EzEivhBV;EyExvhBM;IAOI,4BAAA;IAAA,+BAAA;EzEqvhBV;EyE5vhBM;IAOI,4BAAA;IAAA,+BAAA;EzEyvhBV;EyEhwhBM;IAOI,4BAAA;IAAA,+BAAA;EzE6vhBV;EyEpwhBM;IAOI,4BAAA;IAAA,+BAAA;EzEiwhBV;EyExwhBM;IAOI,6BAAA;IAAA,gCAAA;EzEqwhBV;EyE5whBM;IAOI,6BAAA;IAAA,gCAAA;EzEywhBV;EyEhxhBM;IAOI,6BAAA;IAAA,gCAAA;EzE6whBV;EyEpxhBM;IAOI,6BAAA;IAAA,gCAAA;EzEixhBV;EyExxhBM;IAOI,6BAAA;IAAA,gCAAA;EzEqxhBV;EyE5xhBM;IAOI,6BAAA;IAAA,gCAAA;EzEyxhBV;EyEhyhBM;IAOI,6BAAA;IAAA,gCAAA;EzE6xhBV;EyEpyhBM;IAOI,6BAAA;IAAA,gCAAA;EzEiyhBV;EyExyhBM;IAOI,6BAAA;IAAA,gCAAA;EzEqyhBV;EyE5yhBM;IAOI,6BAAA;IAAA,gCAAA;EzEyyhBV;EyEhzhBM;IAOI,yBAAA;EzE4yhBV;EyEnzhBM;IAOI,+BAAA;EzE+yhBV;EyEtzhBM;IAOI,8BAAA;EzEkzhBV;EyEzzhBM;IAOI,4BAAA;EzEqzhBV;EyE5zhBM;IAOI,8BAAA;EzEwzhBV;EyE/zhBM;IAOI,4BAAA;EzE2zhBV;EyEl0hBM;IAOI,2BAAA;EzE8zhBV;EyEr0hBM;IAOI,4BAAA;EzEi0hBV;EyEx0hBM;IAOI,4BAAA;EzEo0hBV;EyE30hBM;IAOI,4BAAA;EzEu0hBV;EyE90hBM;IAOI,4BAAA;EzE00hBV;EyEj1hBM;IAOI,4BAAA;EzE60hBV;EyEp1hBM;IAOI,4BAAA;EzEg1hBV;EyEv1hBM;IAOI,4BAAA;EzEm1hBV;EyE11hBM;IAOI,4BAAA;EzEs1hBV;EyE71hBM;IAOI,4BAAA;EzEy1hBV;EyEh2hBM;IAOI,4BAAA;EzE41hBV;EyEn2hBM;IAOI,4BAAA;EzE+1hBV;EyEt2hBM;IAOI,6BAAA;EzEk2hBV;EyEz2hBM;IAOI,6BAAA;EzEq2hBV;EyE52hBM;IAOI,6BAAA;EzEw2hBV;EyE/2hBM;IAOI,6BAAA;EzE22hBV;EyEl3hBM;IAOI,6BAAA;EzE82hBV;EyEr3hBM;IAOI,6BAAA;EzEi3hBV;EyEx3hBM;IAOI,6BAAA;EzEo3hBV;EyE33hBM;IAOI,6BAAA;EzEu3hBV;EyE93hBM;IAOI,6BAAA;EzE03hBV;EyEj4hBM;IAOI,6BAAA;EzE63hBV;EyEp4hBM;IAOI,2BAAA;EzEg4hBV;EyEv4hBM;IAOI,iCAAA;EzEm4hBV;EyE14hBM;IAOI,gCAAA;EzEs4hBV;EyE74hBM;IAOI,8BAAA;EzEy4hBV;EyEh5hBM;IAOI,gCAAA;EzE44hBV;EyEn5hBM;IAOI,8BAAA;EzE+4hBV;EyEt5hBM;IAOI,6BAAA;EzEk5hBV;EyEz5hBM;IAOI,8BAAA;EzEq5hBV;EyE55hBM;IAOI,8BAAA;EzEw5hBV;EyE/5hBM;IAOI,8BAAA;EzE25hBV;EyEl6hBM;IAOI,8BAAA;EzE85hBV;EyEr6hBM;IAOI,8BAAA;EzEi6hBV;EyEx6hBM;IAOI,8BAAA;EzEo6hBV;EyE36hBM;IAOI,8BAAA;EzEu6hBV;EyE96hBM;IAOI,8BAAA;EzE06hBV;EyEj7hBM;IAOI,8BAAA;EzE66hBV;EyEp7hBM;IAOI,8BAAA;EzEg7hBV;EyEv7hBM;IAOI,8BAAA;EzEm7hBV;EyE17hBM;IAOI,+BAAA;EzEs7hBV;EyE77hBM;IAOI,+BAAA;EzEy7hBV;EyEh8hBM;IAOI,+BAAA;EzE47hBV;EyEn8hBM;IAOI,+BAAA;EzE+7hBV;EyEt8hBM;IAOI,+BAAA;EzEk8hBV;EyEz8hBM;IAOI,+BAAA;EzEq8hBV;EyE58hBM;IAOI,+BAAA;EzEw8hBV;EyE/8hBM;IAOI,+BAAA;EzE28hBV;EyEl9hBM;IAOI,+BAAA;EzE88hBV;EyEr9hBM;IAOI,+BAAA;EzEi9hBV;EyEx9hBM;IAOI,4BAAA;EzEo9hBV;EyE39hBM;IAOI,kCAAA;EzEu9hBV;EyE99hBM;IAOI,iCAAA;EzE09hBV;EyEj+hBM;IAOI,+BAAA;EzE69hBV;EyEp+hBM;IAOI,iCAAA;EzEg+hBV;EyEv+hBM;IAOI,+BAAA;EzEm+hBV;EyE1+hBM;IAOI,8BAAA;EzEs+hBV;EyE7+hBM;IAOI,+BAAA;EzEy+hBV;EyEh/hBM;IAOI,+BAAA;EzE4+hBV;EyEn/hBM;IAOI,+BAAA;EzE++hBV;EyEt/hBM;IAOI,+BAAA;EzEk/hBV;EyEz/hBM;IAOI,+BAAA;EzEq/hBV;EyE5/hBM;IAOI,+BAAA;EzEw/hBV;EyE//hBM;IAOI,+BAAA;EzE2/hBV;EyElgiBM;IAOI,+BAAA;EzE8/hBV;EyErgiBM;IAOI,+BAAA;EzEigiBV;EyExgiBM;IAOI,+BAAA;EzEogiBV;EyE3giBM;IAOI,+BAAA;EzEugiBV;EyE9giBM;IAOI,gCAAA;EzE0giBV;EyEjhiBM;IAOI,gCAAA;EzE6giBV;EyEphiBM;IAOI,gCAAA;EzEghiBV;EyEvhiBM;IAOI,gCAAA;EzEmhiBV;EyE1hiBM;IAOI,gCAAA;EzEshiBV;EyE7hiBM;IAOI,gCAAA;EzEyhiBV;EyEhiiBM;IAOI,gCAAA;EzE4hiBV;EyEniiBM;IAOI,gCAAA;EzE+hiBV;EyEtiiBM;IAOI,gCAAA;EzEkiiBV;EyEziiBM;IAOI,gCAAA;EzEqiiBV;EyE5iiBM;IAOI,0BAAA;EzEwiiBV;EyE/iiBM;IAOI,gCAAA;EzE2iiBV;EyEljiBM;IAOI,+BAAA;EzE8iiBV;EyErjiBM;IAOI,6BAAA;EzEijiBV;EyExjiBM;IAOI,+BAAA;EzEojiBV;EyE3jiBM;IAOI,6BAAA;EzEujiBV;EyE9jiBM;IAOI,4BAAA;EzE0jiBV;EyEjkiBM;IAOI,6BAAA;EzE6jiBV;EyEpkiBM;IAOI,6BAAA;EzEgkiBV;EyEvkiBM;IAOI,6BAAA;EzEmkiBV;EyE1kiBM;IAOI,6BAAA;EzEskiBV;EyE7kiBM;IAOI,6BAAA;EzEykiBV;EyEhliBM;IAOI,6BAAA;EzE4kiBV;EyEnliBM;IAOI,6BAAA;EzE+kiBV;EyEtliBM;IAOI,6BAAA;EzEkliBV;EyEzliBM;IAOI,6BAAA;EzEqliBV;EyE5liBM;IAOI,6BAAA;EzEwliBV;EyE/liBM;IAOI,6BAAA;EzE2liBV;EyElmiBM;IAOI,8BAAA;EzE8liBV;EyErmiBM;IAOI,8BAAA;EzEimiBV;EyExmiBM;IAOI,8BAAA;EzEomiBV;EyE3miBM;IAOI,8BAAA;EzEumiBV;EyE9miBM;IAOI,8BAAA;EzE0miBV;EyEjniBM;IAOI,8BAAA;EzE6miBV;EyEpniBM;IAOI,8BAAA;EzEgniBV;EyEvniBM;IAOI,8BAAA;EzEmniBV;EyE1niBM;IAOI,8BAAA;EzEsniBV;EyE7niBM;IAOI,8BAAA;EzEyniBV;EyEhoiBM;IAOI,iBAAA;EzE4niBV;EyEnoiBM;IAOI,uBAAA;EzE+niBV;EyEtoiBM;IAOI,sBAAA;EzEkoiBV;EyEzoiBM;IAOI,oBAAA;EzEqoiBV;EyE5oiBM;IAOI,sBAAA;EzEwoiBV;EyE/oiBM;IAOI,oBAAA;EzE2oiBV;EyElpiBM;IAOI,mBAAA;EzE8oiBV;EyErpiBM;IAOI,oBAAA;EzEipiBV;EyExpiBM;IAOI,oBAAA;EzEopiBV;EyE3piBM;IAOI,oBAAA;EzEupiBV;EyE9piBM;IAOI,oBAAA;EzE0piBV;EyEjqiBM;IAOI,oBAAA;EzE6piBV;EyEpqiBM;IAOI,oBAAA;EzEgqiBV;EyEvqiBM;IAOI,oBAAA;EzEmqiBV;EyE1qiBM;IAOI,oBAAA;EzEsqiBV;EyE7qiBM;IAOI,oBAAA;EzEyqiBV;EyEhriBM;IAOI,oBAAA;EzE4qiBV;EyEnriBM;IAOI,oBAAA;EzE+qiBV;EyEtriBM;IAOI,qBAAA;EzEkriBV;EyEzriBM;IAOI,qBAAA;EzEqriBV;EyE5riBM;IAOI,qBAAA;EzEwriBV;EyE/riBM;IAOI,qBAAA;EzE2riBV;EyElsiBM;IAOI,qBAAA;EzE8riBV;EyErsiBM;IAOI,qBAAA;EzEisiBV;EyExsiBM;IAOI,qBAAA;EzEosiBV;EyE3siBM;IAOI,qBAAA;EzEusiBV;EyE9siBM;IAOI,qBAAA;EzE0siBV;EyEjtiBM;IAOI,qBAAA;EzE6siBV;EyEptiBM;IAOI,qBAAA;EzEgtiBV;EyEvtiBM;IAOI,2BAAA;EzEmtiBV;EyE1tiBM;IAOI,0BAAA;EzEstiBV;EyE7tiBM;IAOI,wBAAA;EzEytiBV;EyEhuiBM;IAOI,0BAAA;EzE4tiBV;EyEnuiBM;IAOI,wBAAA;EzE+tiBV;EyEtuiBM;IAOI,uBAAA;EzEkuiBV;EyEzuiBM;IAOI,wBAAA;EzEquiBV;EyE5uiBM;IAOI,wBAAA;EzEwuiBV;EyE/uiBM;IAOI,wBAAA;EzE2uiBV;EyElviBM;IAOI,wBAAA;EzE8uiBV;EyErviBM;IAOI,wBAAA;EzEiviBV;EyExviBM;IAOI,wBAAA;EzEoviBV;EyE3viBM;IAOI,wBAAA;EzEuviBV;EyE9viBM;IAOI,wBAAA;EzE0viBV;EyEjwiBM;IAOI,wBAAA;EzE6viBV;EyEpwiBM;IAOI,wBAAA;EzEgwiBV;EyEvwiBM;IAOI,wBAAA;EzEmwiBV;EyE1wiBM;IAOI,yBAAA;EzEswiBV;EyE7wiBM;IAOI,yBAAA;EzEywiBV;EyEhxiBM;IAOI,yBAAA;EzE4wiBV;EyEnxiBM;IAOI,yBAAA;EzE+wiBV;EyEtxiBM;IAOI,yBAAA;EzEkxiBV;EyEzxiBM;IAOI,yBAAA;EzEqxiBV;EyE5xiBM;IAOI,yBAAA;EzEwxiBV;EyE/xiBM;IAOI,yBAAA;EzE2xiBV;EyElyiBM;IAOI,yBAAA;EzE8xiBV;EyEryiBM;IAOI,yBAAA;EzEiyiBV;EyExyiBM;IAOI,wBAAA;EzEoyiBV;EyE3yiBM;IAOI,8BAAA;EzEuyiBV;EyE9yiBM;IAOI,6BAAA;EzE0yiBV;EyEjziBM;IAOI,2BAAA;EzE6yiBV;EyEpziBM;IAOI,6BAAA;EzEgziBV;EyEvziBM;IAOI,2BAAA;EzEmziBV;EyE1ziBM;IAOI,0BAAA;EzEsziBV;EyE7ziBM;IAOI,2BAAA;EzEyziBV;EyEh0iBM;IAOI,2BAAA;EzE4ziBV;EyEn0iBM;IAOI,2BAAA;EzE+ziBV;EyEt0iBM;IAOI,2BAAA;EzEk0iBV;EyEz0iBM;IAOI,2BAAA;EzEq0iBV;EyE50iBM;IAOI,2BAAA;EzEw0iBV;EyE/0iBM;IAOI,2BAAA;EzE20iBV;EyEl1iBM;IAOI,2BAAA;EzE80iBV;EyEr1iBM;IAOI,2BAAA;EzEi1iBV;EyEx1iBM;IAOI,2BAAA;EzEo1iBV;EyE31iBM;IAOI,2BAAA;EzEu1iBV;EyE91iBM;IAOI,4BAAA;EzE01iBV;EyEj2iBM;IAOI,4BAAA;EzE61iBV;EyEp2iBM;IAOI,4BAAA;EzEg2iBV;EyEv2iBM;IAOI,4BAAA;EzEm2iBV;EyE12iBM;IAOI,4BAAA;EzEs2iBV;EyE72iBM;IAOI,4BAAA;EzEy2iBV;EyEh3iBM;IAOI,4BAAA;EzE42iBV;EyEn3iBM;IAOI,4BAAA;EzE+2iBV;EyEt3iBM;IAOI,4BAAA;EzEk3iBV;EyEz3iBM;IAOI,4BAAA;EzEq3iBV;EyE53iBM;IAOI,2BAAA;EzEw3iBV;EyE/3iBM;IAOI,4BAAA;EzE23iBV;EyEl4iBM;IAOI,6BAAA;EzE83iBV;AACF;Acz4iBI;E2DGI;IAOI,sBAAA;EzEm4iBV;EyE14iBM;IAOI,uBAAA;EzEs4iBV;EyE74iBM;IAOI,sBAAA;EzEy4iBV;EyEh5iBM;IAOI,8BAAA;EzE44iBV;EyEn5iBM;IAOI,4BAAA;EzE+4iBV;EyEt5iBM;IAOI,2BAAA;EzEk5iBV;EyEz5iBM;IAOI,iCAAA;EzEq5iBV;EyE55iBM;IAOI,2BAAA;EzEw5iBV;EyE/5iBM;IAOI,0BAAA;EzE25iBV;EyEl6iBM;IAOI,gCAAA;EzE85iBV;EyEr6iBM;IAOI,yBAAA;EzEi6iBV;EyEx6iBM;IAOI,wBAAA;EzEo6iBV;EyE36iBM;IAOI,+BAAA;EzEu6iBV;EyE96iBM;IAOI,yBAAA;EzE06iBV;EyEj7iBM;IAOI,6BAAA;EzE66iBV;EyEp7iBM;IAOI,8BAAA;EzEg7iBV;EyEv7iBM;IAOI,wBAAA;EzEm7iBV;EyE17iBM;IAOI,+BAAA;EzEs7iBV;EyE77iBM;IAOI,wBAAA;EzEy7iBV;EyEh8iBM;IAOI,yBAAA;EzE47iBV;EyEn8iBM;IAOI,8BAAA;EzE+7iBV;EyEt8iBM;IAOI,iCAAA;EzEk8iBV;EyEz8iBM;IAOI,sCAAA;EzEq8iBV;EyE58iBM;IAOI,yCAAA;EzEw8iBV;EyE/8iBM;IAOI,uBAAA;EzE28iBV;EyEl9iBM;IAOI,uBAAA;EzE88iBV;EyEr9iBM;IAOI,yBAAA;EzEi9iBV;EyEx9iBM;IAOI,yBAAA;EzEo9iBV;EyE39iBM;IAOI,0BAAA;EzEu9iBV;EyE99iBM;IAOI,4BAAA;EzE09iBV;EyEj+iBM;IAOI,kCAAA;EzE69iBV;EyEp+iBM;IAOI,sCAAA;EzEg+iBV;EyEv+iBM;IAOI,oCAAA;EzEm+iBV;EyE1+iBM;IAOI,kCAAA;EzEs+iBV;EyE7+iBM;IAOI,yCAAA;EzEy+iBV;EyEh/iBM;IAOI,wCAAA;EzE4+iBV;EyEn/iBM;IAOI,wCAAA;EzE++iBV;EyEt/iBM;IAOI,kCAAA;EzEk/iBV;EyEz/iBM;IAOI,gCAAA;EzEq/iBV;EyE5/iBM;IAOI,8BAAA;EzEw/iBV;EyE//iBM;IAOI,gCAAA;EzE2/iBV;EyElgjBM;IAOI,+BAAA;EzE8/iBV;EyErgjBM;IAOI,oCAAA;EzEigjBV;EyExgjBM;IAOI,kCAAA;EzEogjBV;EyE3gjBM;IAOI,gCAAA;EzEugjBV;EyE9gjBM;IAOI,uCAAA;EzE0gjBV;EyEjhjBM;IAOI,sCAAA;EzE6gjBV;EyEphjBM;IAOI,iCAAA;EzEghjBV;EyEvhjBM;IAOI,2BAAA;EzEmhjBV;EyE1hjBM;IAOI,iCAAA;EzEshjBV;EyE7hjBM;IAOI,+BAAA;EzEyhjBV;EyEhijBM;IAOI,6BAAA;EzE4hjBV;EyEnijBM;IAOI,+BAAA;EzE+hjBV;EyEtijBM;IAOI,8BAAA;EzEkijBV;EyEzijBM;IAOI,oBAAA;EzEqijBV;EyE5ijBM;IAOI,mBAAA;EzEwijBV;EyE/ijBM;IAOI,mBAAA;EzE2ijBV;EyEljjBM;IAOI,mBAAA;EzE8ijBV;EyErjjBM;IAOI,mBAAA;EzEijjBV;EyExjjBM;IAOI,mBAAA;EzEojjBV;EyE3jjBM;IAOI,mBAAA;EzEujjBV;EyE9jjBM;IAOI,mBAAA;EzE0jjBV;EyEjkjBM;IAOI,oBAAA;EzE6jjBV;EyEpkjBM;IAOI,0BAAA;EzEgkjBV;EyEvkjBM;IAOI,yBAAA;EzEmkjBV;EyE1kjBM;IAOI,uBAAA;EzEskjBV;EyE7kjBM;IAOI,yBAAA;EzEykjBV;EyEhljBM;IAOI,uBAAA;EzE4kjBV;EyEnljBM;IAOI,sBAAA;EzE+kjBV;EyEtljBM;IAOI,uBAAA;EzEkljBV;EyEzljBM;IAOI,uBAAA;EzEqljBV;EyE5ljBM;IAOI,uBAAA;EzEwljBV;EyE/ljBM;IAOI,uBAAA;EzE2ljBV;EyElmjBM;IAOI,uBAAA;EzE8ljBV;EyErmjBM;IAOI,uBAAA;EzEimjBV;EyExmjBM;IAOI,uBAAA;EzEomjBV;EyE3mjBM;IAOI,uBAAA;EzEumjBV;EyE9mjBM;IAOI,uBAAA;EzE0mjBV;EyEjnjBM;IAOI,uBAAA;EzE6mjBV;EyEpnjBM;IAOI,uBAAA;EzEgnjBV;EyEvnjBM;IAOI,wBAAA;EzEmnjBV;EyE1njBM;IAOI,wBAAA;EzEsnjBV;EyE7njBM;IAOI,wBAAA;EzEynjBV;EyEhojBM;IAOI,wBAAA;EzE4njBV;EyEnojBM;IAOI,wBAAA;EzE+njBV;EyEtojBM;IAOI,wBAAA;EzEkojBV;EyEzojBM;IAOI,wBAAA;EzEqojBV;EyE5ojBM;IAOI,wBAAA;EzEwojBV;EyE/ojBM;IAOI,wBAAA;EzE2ojBV;EyElpjBM;IAOI,wBAAA;EzE8ojBV;EyErpjBM;IAOI,uBAAA;EzEipjBV;EyExpjBM;IAOI,0BAAA;IAAA,yBAAA;EzEqpjBV;EyE5pjBM;IAOI,gCAAA;IAAA,+BAAA;EzEypjBV;EyEhqjBM;IAOI,+BAAA;IAAA,8BAAA;EzE6pjBV;EyEpqjBM;IAOI,6BAAA;IAAA,4BAAA;EzEiqjBV;EyExqjBM;IAOI,+BAAA;IAAA,8BAAA;EzEqqjBV;EyE5qjBM;IAOI,6BAAA;IAAA,4BAAA;EzEyqjBV;EyEhrjBM;IAOI,4BAAA;IAAA,2BAAA;EzE6qjBV;EyEprjBM;IAOI,6BAAA;IAAA,4BAAA;EzEirjBV;EyExrjBM;IAOI,6BAAA;IAAA,4BAAA;EzEqrjBV;EyE5rjBM;IAOI,6BAAA;IAAA,4BAAA;EzEyrjBV;EyEhsjBM;IAOI,6BAAA;IAAA,4BAAA;EzE6rjBV;EyEpsjBM;IAOI,6BAAA;IAAA,4BAAA;EzEisjBV;EyExsjBM;IAOI,6BAAA;IAAA,4BAAA;EzEqsjBV;EyE5sjBM;IAOI,6BAAA;IAAA,4BAAA;EzEysjBV;EyEhtjBM;IAOI,6BAAA;IAAA,4BAAA;EzE6sjBV;EyEptjBM;IAOI,6BAAA;IAAA,4BAAA;EzEitjBV;EyExtjBM;IAOI,6BAAA;IAAA,4BAAA;EzEqtjBV;EyE5tjBM;IAOI,6BAAA;IAAA,4BAAA;EzEytjBV;EyEhujBM;IAOI,8BAAA;IAAA,6BAAA;EzE6tjBV;EyEpujBM;IAOI,8BAAA;IAAA,6BAAA;EzEiujBV;EyExujBM;IAOI,8BAAA;IAAA,6BAAA;EzEqujBV;EyE5ujBM;IAOI,8BAAA;IAAA,6BAAA;EzEyujBV;EyEhvjBM;IAOI,8BAAA;IAAA,6BAAA;EzE6ujBV;EyEpvjBM;IAOI,8BAAA;IAAA,6BAAA;EzEivjBV;EyExvjBM;IAOI,8BAAA;IAAA,6BAAA;EzEqvjBV;EyE5vjBM;IAOI,8BAAA;IAAA,6BAAA;EzEyvjBV;EyEhwjBM;IAOI,8BAAA;IAAA,6BAAA;EzE6vjBV;EyEpwjBM;IAOI,8BAAA;IAAA,6BAAA;EzEiwjBV;EyExwjBM;IAOI,6BAAA;IAAA,4BAAA;EzEqwjBV;EyE5wjBM;IAOI,wBAAA;IAAA,2BAAA;EzEywjBV;EyEhxjBM;IAOI,8BAAA;IAAA,iCAAA;EzE6wjBV;EyEpxjBM;IAOI,6BAAA;IAAA,gCAAA;EzEixjBV;EyExxjBM;IAOI,2BAAA;IAAA,8BAAA;EzEqxjBV;EyE5xjBM;IAOI,6BAAA;IAAA,gCAAA;EzEyxjBV;EyEhyjBM;IAOI,2BAAA;IAAA,8BAAA;EzE6xjBV;EyEpyjBM;IAOI,0BAAA;IAAA,6BAAA;EzEiyjBV;EyExyjBM;IAOI,2BAAA;IAAA,8BAAA;EzEqyjBV;EyE5yjBM;IAOI,2BAAA;IAAA,8BAAA;EzEyyjBV;EyEhzjBM;IAOI,2BAAA;IAAA,8BAAA;EzE6yjBV;EyEpzjBM;IAOI,2BAAA;IAAA,8BAAA;EzEizjBV;EyExzjBM;IAOI,2BAAA;IAAA,8BAAA;EzEqzjBV;EyE5zjBM;IAOI,2BAAA;IAAA,8BAAA;EzEyzjBV;EyEh0jBM;IAOI,2BAAA;IAAA,8BAAA;EzE6zjBV;EyEp0jBM;IAOI,2BAAA;IAAA,8BAAA;EzEi0jBV;EyEx0jBM;IAOI,2BAAA;IAAA,8BAAA;EzEq0jBV;EyE50jBM;IAOI,2BAAA;IAAA,8BAAA;EzEy0jBV;EyEh1jBM;IAOI,2BAAA;IAAA,8BAAA;EzE60jBV;EyEp1jBM;IAOI,4BAAA;IAAA,+BAAA;EzEi1jBV;EyEx1jBM;IAOI,4BAAA;IAAA,+BAAA;EzEq1jBV;EyE51jBM;IAOI,4BAAA;IAAA,+BAAA;EzEy1jBV;EyEh2jBM;IAOI,4BAAA;IAAA,+BAAA;EzE61jBV;EyEp2jBM;IAOI,4BAAA;IAAA,+BAAA;EzEi2jBV;EyEx2jBM;IAOI,4BAAA;IAAA,+BAAA;EzEq2jBV;EyE52jBM;IAOI,4BAAA;IAAA,+BAAA;EzEy2jBV;EyEh3jBM;IAOI,4BAAA;IAAA,+BAAA;EzE62jBV;EyEp3jBM;IAOI,4BAAA;IAAA,+BAAA;EzEi3jBV;EyEx3jBM;IAOI,4BAAA;IAAA,+BAAA;EzEq3jBV;EyE53jBM;IAOI,2BAAA;IAAA,8BAAA;EzEy3jBV;EyEh4jBM;IAOI,wBAAA;EzE43jBV;EyEn4jBM;IAOI,8BAAA;EzE+3jBV;EyEt4jBM;IAOI,6BAAA;EzEk4jBV;EyEz4jBM;IAOI,2BAAA;EzEq4jBV;EyE54jBM;IAOI,6BAAA;EzEw4jBV;EyE/4jBM;IAOI,2BAAA;EzE24jBV;EyEl5jBM;IAOI,0BAAA;EzE84jBV;EyEr5jBM;IAOI,2BAAA;EzEi5jBV;EyEx5jBM;IAOI,2BAAA;EzEo5jBV;EyE35jBM;IAOI,2BAAA;EzEu5jBV;EyE95jBM;IAOI,2BAAA;EzE05jBV;EyEj6jBM;IAOI,2BAAA;EzE65jBV;EyEp6jBM;IAOI,2BAAA;EzEg6jBV;EyEv6jBM;IAOI,2BAAA;EzEm6jBV;EyE16jBM;IAOI,2BAAA;EzEs6jBV;EyE76jBM;IAOI,2BAAA;EzEy6jBV;EyEh7jBM;IAOI,2BAAA;EzE46jBV;EyEn7jBM;IAOI,2BAAA;EzE+6jBV;EyEt7jBM;IAOI,4BAAA;EzEk7jBV;EyEz7jBM;IAOI,4BAAA;EzEq7jBV;EyE57jBM;IAOI,4BAAA;EzEw7jBV;EyE/7jBM;IAOI,4BAAA;EzE27jBV;EyEl8jBM;IAOI,4BAAA;EzE87jBV;EyEr8jBM;IAOI,4BAAA;EzEi8jBV;EyEx8jBM;IAOI,4BAAA;EzEo8jBV;EyE38jBM;IAOI,4BAAA;EzEu8jBV;EyE98jBM;IAOI,4BAAA;EzE08jBV;EyEj9jBM;IAOI,4BAAA;EzE68jBV;EyEp9jBM;IAOI,2BAAA;EzEg9jBV;EyEv9jBM;IAOI,0BAAA;EzEm9jBV;EyE19jBM;IAOI,gCAAA;EzEs9jBV;EyE79jBM;IAOI,+BAAA;EzEy9jBV;EyEh+jBM;IAOI,6BAAA;EzE49jBV;EyEn+jBM;IAOI,+BAAA;EzE+9jBV;EyEt+jBM;IAOI,6BAAA;EzEk+jBV;EyEz+jBM;IAOI,4BAAA;EzEq+jBV;EyE5+jBM;IAOI,6BAAA;EzEw+jBV;EyE/+jBM;IAOI,6BAAA;EzE2+jBV;EyEl/jBM;IAOI,6BAAA;EzE8+jBV;EyEr/jBM;IAOI,6BAAA;EzEi/jBV;EyEx/jBM;IAOI,6BAAA;EzEo/jBV;EyE3/jBM;IAOI,6BAAA;EzEu/jBV;EyE9/jBM;IAOI,6BAAA;EzE0/jBV;EyEjgkBM;IAOI,6BAAA;EzE6/jBV;EyEpgkBM;IAOI,6BAAA;EzEggkBV;EyEvgkBM;IAOI,6BAAA;EzEmgkBV;EyE1gkBM;IAOI,6BAAA;EzEsgkBV;EyE7gkBM;IAOI,8BAAA;EzEygkBV;EyEhhkBM;IAOI,8BAAA;EzE4gkBV;EyEnhkBM;IAOI,8BAAA;EzE+gkBV;EyEthkBM;IAOI,8BAAA;EzEkhkBV;EyEzhkBM;IAOI,8BAAA;EzEqhkBV;EyE5hkBM;IAOI,8BAAA;EzEwhkBV;EyE/hkBM;IAOI,8BAAA;EzE2hkBV;EyElikBM;IAOI,8BAAA;EzE8hkBV;EyErikBM;IAOI,8BAAA;EzEiikBV;EyExikBM;IAOI,8BAAA;EzEoikBV;EyE3ikBM;IAOI,6BAAA;EzEuikBV;EyE9ikBM;IAOI,2BAAA;EzE0ikBV;EyEjjkBM;IAOI,iCAAA;EzE6ikBV;EyEpjkBM;IAOI,gCAAA;EzEgjkBV;EyEvjkBM;IAOI,8BAAA;EzEmjkBV;EyE1jkBM;IAOI,gCAAA;EzEsjkBV;EyE7jkBM;IAOI,8BAAA;EzEyjkBV;EyEhkkBM;IAOI,6BAAA;EzE4jkBV;EyEnkkBM;IAOI,8BAAA;EzE+jkBV;EyEtkkBM;IAOI,8BAAA;EzEkkkBV;EyEzkkBM;IAOI,8BAAA;EzEqkkBV;EyE5kkBM;IAOI,8BAAA;EzEwkkBV;EyE/kkBM;IAOI,8BAAA;EzE2kkBV;EyEllkBM;IAOI,8BAAA;EzE8kkBV;EyErlkBM;IAOI,8BAAA;EzEilkBV;EyExlkBM;IAOI,8BAAA;EzEolkBV;EyE3lkBM;IAOI,8BAAA;EzEulkBV;EyE9lkBM;IAOI,8BAAA;EzE0lkBV;EyEjmkBM;IAOI,8BAAA;EzE6lkBV;EyEpmkBM;IAOI,+BAAA;EzEgmkBV;EyEvmkBM;IAOI,+BAAA;EzEmmkBV;EyE1mkBM;IAOI,+BAAA;EzEsmkBV;EyE7mkBM;IAOI,+BAAA;EzEymkBV;EyEhnkBM;IAOI,+BAAA;EzE4mkBV;EyEnnkBM;IAOI,+BAAA;EzE+mkBV;EyEtnkBM;IAOI,+BAAA;EzEknkBV;EyEznkBM;IAOI,+BAAA;EzEqnkBV;EyE5nkBM;IAOI,+BAAA;EzEwnkBV;EyE/nkBM;IAOI,+BAAA;EzE2nkBV;EyElokBM;IAOI,8BAAA;EzE8nkBV;EyErokBM;IAOI,yBAAA;EzEiokBV;EyExokBM;IAOI,+BAAA;EzEookBV;EyE3okBM;IAOI,8BAAA;EzEuokBV;EyE9okBM;IAOI,4BAAA;EzE0okBV;EyEjpkBM;IAOI,8BAAA;EzE6okBV;EyEppkBM;IAOI,4BAAA;EzEgpkBV;EyEvpkBM;IAOI,2BAAA;EzEmpkBV;EyE1pkBM;IAOI,4BAAA;EzEspkBV;EyE7pkBM;IAOI,4BAAA;EzEypkBV;EyEhqkBM;IAOI,4BAAA;EzE4pkBV;EyEnqkBM;IAOI,4BAAA;EzE+pkBV;EyEtqkBM;IAOI,4BAAA;EzEkqkBV;EyEzqkBM;IAOI,4BAAA;EzEqqkBV;EyE5qkBM;IAOI,4BAAA;EzEwqkBV;EyE/qkBM;IAOI,4BAAA;EzE2qkBV;EyElrkBM;IAOI,4BAAA;EzE8qkBV;EyErrkBM;IAOI,4BAAA;EzEirkBV;EyExrkBM;IAOI,4BAAA;EzEorkBV;EyE3rkBM;IAOI,6BAAA;EzEurkBV;EyE9rkBM;IAOI,6BAAA;EzE0rkBV;EyEjskBM;IAOI,6BAAA;EzE6rkBV;EyEpskBM;IAOI,6BAAA;EzEgskBV;EyEvskBM;IAOI,6BAAA;EzEmskBV;EyE1skBM;IAOI,6BAAA;EzEsskBV;EyE7skBM;IAOI,6BAAA;EzEyskBV;EyEhtkBM;IAOI,6BAAA;EzE4skBV;EyEntkBM;IAOI,6BAAA;EzE+skBV;EyEttkBM;IAOI,6BAAA;EzEktkBV;EyEztkBM;IAOI,4BAAA;EzEqtkBV;EyE5tkBM;IAOI,2BAAA;EzEwtkBV;EyE/tkBM;IAOI,0BAAA;EzE2tkBV;EyElukBM;IAOI,wBAAA;EzE8tkBV;EyErukBM;IAOI,0BAAA;EzEiukBV;EyExukBM;IAOI,wBAAA;EzEoukBV;EyE3ukBM;IAOI,uBAAA;EzEuukBV;EyE9ukBM;IAOI,wBAAA;EzE0ukBV;EyEjvkBM;IAOI,wBAAA;EzE6ukBV;EyEpvkBM;IAOI,wBAAA;EzEgvkBV;EyEvvkBM;IAOI,wBAAA;EzEmvkBV;EyE1vkBM;IAOI,wBAAA;EzEsvkBV;EyE7vkBM;IAOI,wBAAA;EzEyvkBV;EyEhwkBM;IAOI,wBAAA;EzE4vkBV;EyEnwkBM;IAOI,wBAAA;EzE+vkBV;EyEtwkBM;IAOI,wBAAA;EzEkwkBV;EyEzwkBM;IAOI,wBAAA;EzEqwkBV;EyE5wkBM;IAOI,wBAAA;EzEwwkBV;EyE/wkBM;IAOI,yBAAA;EzE2wkBV;EyElxkBM;IAOI,yBAAA;EzE8wkBV;EyErxkBM;IAOI,yBAAA;EzEixkBV;EyExxkBM;IAOI,yBAAA;EzEoxkBV;EyE3xkBM;IAOI,yBAAA;EzEuxkBV;EyE9xkBM;IAOI,yBAAA;EzE0xkBV;EyEjykBM;IAOI,yBAAA;EzE6xkBV;EyEpykBM;IAOI,yBAAA;EzEgykBV;EyEvykBM;IAOI,yBAAA;EzEmykBV;EyE1ykBM;IAOI,yBAAA;EzEsykBV;EyE7ykBM;IAOI,iCAAA;IAAA,gCAAA;EzE0ykBV;EyEjzkBM;IAOI,gCAAA;IAAA,+BAAA;EzE8ykBV;EyErzkBM;IAOI,8BAAA;IAAA,6BAAA;EzEkzkBV;EyEzzkBM;IAOI,gCAAA;IAAA,+BAAA;EzEszkBV;EyE7zkBM;IAOI,8BAAA;IAAA,6BAAA;EzE0zkBV;EyEj0kBM;IAOI,6BAAA;IAAA,4BAAA;EzE8zkBV;EyEr0kBM;IAOI,8BAAA;IAAA,6BAAA;EzEk0kBV;EyEz0kBM;IAOI,8BAAA;IAAA,6BAAA;EzEs0kBV;EyE70kBM;IAOI,8BAAA;IAAA,6BAAA;EzE00kBV;EyEj1kBM;IAOI,8BAAA;IAAA,6BAAA;EzE80kBV;EyEr1kBM;IAOI,8BAAA;IAAA,6BAAA;EzEk1kBV;EyEz1kBM;IAOI,8BAAA;IAAA,6BAAA;EzEs1kBV;EyE71kBM;IAOI,8BAAA;IAAA,6BAAA;EzE01kBV;EyEj2kBM;IAOI,8BAAA;IAAA,6BAAA;EzE81kBV;EyEr2kBM;IAOI,8BAAA;IAAA,6BAAA;EzEk2kBV;EyEz2kBM;IAOI,8BAAA;IAAA,6BAAA;EzEs2kBV;EyE72kBM;IAOI,8BAAA;IAAA,6BAAA;EzE02kBV;EyEj3kBM;IAOI,+BAAA;IAAA,8BAAA;EzE82kBV;EyEr3kBM;IAOI,+BAAA;IAAA,8BAAA;EzEk3kBV;EyEz3kBM;IAOI,+BAAA;IAAA,8BAAA;EzEs3kBV;EyE73kBM;IAOI,+BAAA;IAAA,8BAAA;EzE03kBV;EyEj4kBM;IAOI,+BAAA;IAAA,8BAAA;EzE83kBV;EyEr4kBM;IAOI,+BAAA;IAAA,8BAAA;EzEk4kBV;EyEz4kBM;IAOI,+BAAA;IAAA,8BAAA;EzEs4kBV;EyE74kBM;IAOI,+BAAA;IAAA,8BAAA;EzE04kBV;EyEj5kBM;IAOI,+BAAA;IAAA,8BAAA;EzE84kBV;EyEr5kBM;IAOI,+BAAA;IAAA,8BAAA;EzEk5kBV;EyEz5kBM;IAOI,+BAAA;IAAA,kCAAA;EzEs5kBV;EyE75kBM;IAOI,8BAAA;IAAA,iCAAA;EzE05kBV;EyEj6kBM;IAOI,4BAAA;IAAA,+BAAA;EzE85kBV;EyEr6kBM;IAOI,8BAAA;IAAA,iCAAA;EzEk6kBV;EyEz6kBM;IAOI,4BAAA;IAAA,+BAAA;EzEs6kBV;EyE76kBM;IAOI,2BAAA;IAAA,8BAAA;EzE06kBV;EyEj7kBM;IAOI,4BAAA;IAAA,+BAAA;EzE86kBV;EyEr7kBM;IAOI,4BAAA;IAAA,+BAAA;EzEk7kBV;EyEz7kBM;IAOI,4BAAA;IAAA,+BAAA;EzEs7kBV;EyE77kBM;IAOI,4BAAA;IAAA,+BAAA;EzE07kBV;EyEj8kBM;IAOI,4BAAA;IAAA,+BAAA;EzE87kBV;EyEr8kBM;IAOI,4BAAA;IAAA,+BAAA;EzEk8kBV;EyEz8kBM;IAOI,4BAAA;IAAA,+BAAA;EzEs8kBV;EyE78kBM;IAOI,4BAAA;IAAA,+BAAA;EzE08kBV;EyEj9kBM;IAOI,4BAAA;IAAA,+BAAA;EzE88kBV;EyEr9kBM;IAOI,4BAAA;IAAA,+BAAA;EzEk9kBV;EyEz9kBM;IAOI,4BAAA;IAAA,+BAAA;EzEs9kBV;EyE79kBM;IAOI,6BAAA;IAAA,gCAAA;EzE09kBV;EyEj+kBM;IAOI,6BAAA;IAAA,gCAAA;EzE89kBV;EyEr+kBM;IAOI,6BAAA;IAAA,gCAAA;EzEk+kBV;EyEz+kBM;IAOI,6BAAA;IAAA,gCAAA;EzEs+kBV;EyE7+kBM;IAOI,6BAAA;IAAA,gCAAA;EzE0+kBV;EyEj/kBM;IAOI,6BAAA;IAAA,gCAAA;EzE8+kBV;EyEr/kBM;IAOI,6BAAA;IAAA,gCAAA;EzEk/kBV;EyEz/kBM;IAOI,6BAAA;IAAA,gCAAA;EzEs/kBV;EyE7/kBM;IAOI,6BAAA;IAAA,gCAAA;EzE0/kBV;EyEjglBM;IAOI,6BAAA;IAAA,gCAAA;EzE8/kBV;EyErglBM;IAOI,+BAAA;EzEiglBV;EyExglBM;IAOI,8BAAA;EzEoglBV;EyE3glBM;IAOI,4BAAA;EzEuglBV;EyE9glBM;IAOI,8BAAA;EzE0glBV;EyEjhlBM;IAOI,4BAAA;EzE6glBV;EyEphlBM;IAOI,2BAAA;EzEghlBV;EyEvhlBM;IAOI,4BAAA;EzEmhlBV;EyE1hlBM;IAOI,4BAAA;EzEshlBV;EyE7hlBM;IAOI,4BAAA;EzEyhlBV;EyEhilBM;IAOI,4BAAA;EzE4hlBV;EyEnilBM;IAOI,4BAAA;EzE+hlBV;EyEtilBM;IAOI,4BAAA;EzEkilBV;EyEzilBM;IAOI,4BAAA;EzEqilBV;EyE5ilBM;IAOI,4BAAA;EzEwilBV;EyE/ilBM;IAOI,4BAAA;EzE2ilBV;EyEljlBM;IAOI,4BAAA;EzE8ilBV;EyErjlBM;IAOI,4BAAA;EzEijlBV;EyExjlBM;IAOI,6BAAA;EzEojlBV;EyE3jlBM;IAOI,6BAAA;EzEujlBV;EyE9jlBM;IAOI,6BAAA;EzE0jlBV;EyEjklBM;IAOI,6BAAA;EzE6jlBV;EyEpklBM;IAOI,6BAAA;EzEgklBV;EyEvklBM;IAOI,6BAAA;EzEmklBV;EyE1klBM;IAOI,6BAAA;EzEsklBV;EyE7klBM;IAOI,6BAAA;EzEyklBV;EyEhllBM;IAOI,6BAAA;EzE4klBV;EyEnllBM;IAOI,6BAAA;EzE+klBV;EyEtllBM;IAOI,iCAAA;EzEkllBV;EyEzllBM;IAOI,gCAAA;EzEqllBV;EyE5llBM;IAOI,8BAAA;EzEwllBV;EyE/llBM;IAOI,gCAAA;EzE2llBV;EyElmlBM;IAOI,8BAAA;EzE8llBV;EyErmlBM;IAOI,6BAAA;EzEimlBV;EyExmlBM;IAOI,8BAAA;EzEomlBV;EyE3mlBM;IAOI,8BAAA;EzEumlBV;EyE9mlBM;IAOI,8BAAA;EzE0mlBV;EyEjnlBM;IAOI,8BAAA;EzE6mlBV;EyEpnlBM;IAOI,8BAAA;EzEgnlBV;EyEvnlBM;IAOI,8BAAA;EzEmnlBV;EyE1nlBM;IAOI,8BAAA;EzEsnlBV;EyE7nlBM;IAOI,8BAAA;EzEynlBV;EyEholBM;IAOI,8BAAA;EzE4nlBV;EyEnolBM;IAOI,8BAAA;EzE+nlBV;EyEtolBM;IAOI,8BAAA;EzEkolBV;EyEzolBM;IAOI,+BAAA;EzEqolBV;EyE5olBM;IAOI,+BAAA;EzEwolBV;EyE/olBM;IAOI,+BAAA;EzE2olBV;EyElplBM;IAOI,+BAAA;EzE8olBV;EyErplBM;IAOI,+BAAA;EzEiplBV;EyExplBM;IAOI,+BAAA;EzEoplBV;EyE3plBM;IAOI,+BAAA;EzEuplBV;EyE9plBM;IAOI,+BAAA;EzE0plBV;EyEjqlBM;IAOI,+BAAA;EzE6plBV;EyEpqlBM;IAOI,+BAAA;EzEgqlBV;EyEvqlBM;IAOI,kCAAA;EzEmqlBV;EyE1qlBM;IAOI,iCAAA;EzEsqlBV;EyE7qlBM;IAOI,+BAAA;EzEyqlBV;EyEhrlBM;IAOI,iCAAA;EzE4qlBV;EyEnrlBM;IAOI,+BAAA;EzE+qlBV;EyEtrlBM;IAOI,8BAAA;EzEkrlBV;EyEzrlBM;IAOI,+BAAA;EzEqrlBV;EyE5rlBM;IAOI,+BAAA;EzEwrlBV;EyE/rlBM;IAOI,+BAAA;EzE2rlBV;EyElslBM;IAOI,+BAAA;EzE8rlBV;EyErslBM;IAOI,+BAAA;EzEislBV;EyExslBM;IAOI,+BAAA;EzEoslBV;EyE3slBM;IAOI,+BAAA;EzEuslBV;EyE9slBM;IAOI,+BAAA;EzE0slBV;EyEjtlBM;IAOI,+BAAA;EzE6slBV;EyEptlBM;IAOI,+BAAA;EzEgtlBV;EyEvtlBM;IAOI,+BAAA;EzEmtlBV;EyE1tlBM;IAOI,gCAAA;EzEstlBV;EyE7tlBM;IAOI,gCAAA;EzEytlBV;EyEhulBM;IAOI,gCAAA;EzE4tlBV;EyEnulBM;IAOI,gCAAA;EzE+tlBV;EyEtulBM;IAOI,gCAAA;EzEkulBV;EyEzulBM;IAOI,gCAAA;EzEqulBV;EyE5ulBM;IAOI,gCAAA;EzEwulBV;EyE/ulBM;IAOI,gCAAA;EzE2ulBV;EyElvlBM;IAOI,gCAAA;EzE8ulBV;EyErvlBM;IAOI,gCAAA;EzEivlBV;EyExvlBM;IAOI,gCAAA;EzEovlBV;EyE3vlBM;IAOI,+BAAA;EzEuvlBV;EyE9vlBM;IAOI,6BAAA;EzE0vlBV;EyEjwlBM;IAOI,+BAAA;EzE6vlBV;EyEpwlBM;IAOI,6BAAA;EzEgwlBV;EyEvwlBM;IAOI,4BAAA;EzEmwlBV;EyE1wlBM;IAOI,6BAAA;EzEswlBV;EyE7wlBM;IAOI,6BAAA;EzEywlBV;EyEhxlBM;IAOI,6BAAA;EzE4wlBV;EyEnxlBM;IAOI,6BAAA;EzE+wlBV;EyEtxlBM;IAOI,6BAAA;EzEkxlBV;EyEzxlBM;IAOI,6BAAA;EzEqxlBV;EyE5xlBM;IAOI,6BAAA;EzEwxlBV;EyE/xlBM;IAOI,6BAAA;EzE2xlBV;EyElylBM;IAOI,6BAAA;EzE8xlBV;EyErylBM;IAOI,6BAAA;EzEiylBV;EyExylBM;IAOI,6BAAA;EzEoylBV;EyE3ylBM;IAOI,8BAAA;EzEuylBV;EyE9ylBM;IAOI,8BAAA;EzE0ylBV;EyEjzlBM;IAOI,8BAAA;EzE6ylBV;EyEpzlBM;IAOI,8BAAA;EzEgzlBV;EyEvzlBM;IAOI,8BAAA;EzEmzlBV;EyE1zlBM;IAOI,8BAAA;EzEszlBV;EyE7zlBM;IAOI,8BAAA;EzEyzlBV;EyEh0lBM;IAOI,8BAAA;EzE4zlBV;EyEn0lBM;IAOI,8BAAA;EzE+zlBV;EyEt0lBM;IAOI,8BAAA;EzEk0lBV;EyEz0lBM;IAOI,qBAAA;EzEq0lBV;EyE50lBM;IAOI,2BAAA;EzEw0lBV;EyE/0lBM;IAOI,0BAAA;EzE20lBV;EyEl1lBM;IAOI,wBAAA;EzE80lBV;EyEr1lBM;IAOI,0BAAA;EzEi1lBV;EyEx1lBM;IAOI,wBAAA;EzEo1lBV;EyE31lBM;IAOI,uBAAA;EzEu1lBV;EyE91lBM;IAOI,wBAAA;EzE01lBV;EyEj2lBM;IAOI,wBAAA;EzE61lBV;EyEp2lBM;IAOI,wBAAA;EzEg2lBV;EyEv2lBM;IAOI,wBAAA;EzEm2lBV;EyE12lBM;IAOI,wBAAA;EzEs2lBV;EyE72lBM;IAOI,wBAAA;EzEy2lBV;EyEh3lBM;IAOI,wBAAA;EzE42lBV;EyEn3lBM;IAOI,wBAAA;EzE+2lBV;EyEt3lBM;IAOI,wBAAA;EzEk3lBV;EyEz3lBM;IAOI,wBAAA;EzEq3lBV;EyE53lBM;IAOI,wBAAA;EzEw3lBV;EyE/3lBM;IAOI,yBAAA;EzE23lBV;EyEl4lBM;IAOI,yBAAA;EzE83lBV;EyEr4lBM;IAOI,yBAAA;EzEi4lBV;EyEx4lBM;IAOI,yBAAA;EzEo4lBV;EyE34lBM;IAOI,yBAAA;EzEu4lBV;EyE94lBM;IAOI,yBAAA;EzE04lBV;EyEj5lBM;IAOI,yBAAA;EzE64lBV;EyEp5lBM;IAOI,yBAAA;EzEg5lBV;EyEv5lBM;IAOI,yBAAA;EzEm5lBV;EyE15lBM;IAOI,yBAAA;EzEs5lBV;EyE75lBM;IAOI,2BAAA;IAAA,0BAAA;EzE05lBV;EyEj6lBM;IAOI,iCAAA;IAAA,gCAAA;EzE85lBV;EyEr6lBM;IAOI,gCAAA;IAAA,+BAAA;EzEk6lBV;EyEz6lBM;IAOI,8BAAA;IAAA,6BAAA;EzEs6lBV;EyE76lBM;IAOI,gCAAA;IAAA,+BAAA;EzE06lBV;EyEj7lBM;IAOI,8BAAA;IAAA,6BAAA;EzE86lBV;EyEr7lBM;IAOI,6BAAA;IAAA,4BAAA;EzEk7lBV;EyEz7lBM;IAOI,8BAAA;IAAA,6BAAA;EzEs7lBV;EyE77lBM;IAOI,8BAAA;IAAA,6BAAA;EzE07lBV;EyEj8lBM;IAOI,8BAAA;IAAA,6BAAA;EzE87lBV;EyEr8lBM;IAOI,8BAAA;IAAA,6BAAA;EzEk8lBV;EyEz8lBM;IAOI,8BAAA;IAAA,6BAAA;EzEs8lBV;EyE78lBM;IAOI,8BAAA;IAAA,6BAAA;EzE08lBV;EyEj9lBM;IAOI,8BAAA;IAAA,6BAAA;EzE88lBV;EyEr9lBM;IAOI,8BAAA;IAAA,6BAAA;EzEk9lBV;EyEz9lBM;IAOI,8BAAA;IAAA,6BAAA;EzEs9lBV;EyE79lBM;IAOI,8BAAA;IAAA,6BAAA;EzE09lBV;EyEj+lBM;IAOI,8BAAA;IAAA,6BAAA;EzE89lBV;EyEr+lBM;IAOI,+BAAA;IAAA,8BAAA;EzEk+lBV;EyEz+lBM;IAOI,+BAAA;IAAA,8BAAA;EzEs+lBV;EyE7+lBM;IAOI,+BAAA;IAAA,8BAAA;EzE0+lBV;EyEj/lBM;IAOI,+BAAA;IAAA,8BAAA;EzE8+lBV;EyEr/lBM;IAOI,+BAAA;IAAA,8BAAA;EzEk/lBV;EyEz/lBM;IAOI,+BAAA;IAAA,8BAAA;EzEs/lBV;EyE7/lBM;IAOI,+BAAA;IAAA,8BAAA;EzE0/lBV;EyEjgmBM;IAOI,+BAAA;IAAA,8BAAA;EzE8/lBV;EyErgmBM;IAOI,+BAAA;IAAA,8BAAA;EzEkgmBV;EyEzgmBM;IAOI,+BAAA;IAAA,8BAAA;EzEsgmBV;EyE7gmBM;IAOI,yBAAA;IAAA,4BAAA;EzE0gmBV;EyEjhmBM;IAOI,+BAAA;IAAA,kCAAA;EzE8gmBV;EyErhmBM;IAOI,8BAAA;IAAA,iCAAA;EzEkhmBV;EyEzhmBM;IAOI,4BAAA;IAAA,+BAAA;EzEshmBV;EyE7hmBM;IAOI,8BAAA;IAAA,iCAAA;EzE0hmBV;EyEjimBM;IAOI,4BAAA;IAAA,+BAAA;EzE8hmBV;EyErimBM;IAOI,2BAAA;IAAA,8BAAA;EzEkimBV;EyEzimBM;IAOI,4BAAA;IAAA,+BAAA;EzEsimBV;EyE7imBM;IAOI,4BAAA;IAAA,+BAAA;EzE0imBV;EyEjjmBM;IAOI,4BAAA;IAAA,+BAAA;EzE8imBV;EyErjmBM;IAOI,4BAAA;IAAA,+BAAA;EzEkjmBV;EyEzjmBM;IAOI,4BAAA;IAAA,+BAAA;EzEsjmBV;EyE7jmBM;IAOI,4BAAA;IAAA,+BAAA;EzE0jmBV;EyEjkmBM;IAOI,4BAAA;IAAA,+BAAA;EzE8jmBV;EyErkmBM;IAOI,4BAAA;IAAA,+BAAA;EzEkkmBV;EyEzkmBM;IAOI,4BAAA;IAAA,+BAAA;EzEskmBV;EyE7kmBM;IAOI,4BAAA;IAAA,+BAAA;EzE0kmBV;EyEjlmBM;IAOI,4BAAA;IAAA,+BAAA;EzE8kmBV;EyErlmBM;IAOI,6BAAA;IAAA,gCAAA;EzEklmBV;EyEzlmBM;IAOI,6BAAA;IAAA,gCAAA;EzEslmBV;EyE7lmBM;IAOI,6BAAA;IAAA,gCAAA;EzE0lmBV;EyEjmmBM;IAOI,6BAAA;IAAA,gCAAA;EzE8lmBV;EyErmmBM;IAOI,6BAAA;IAAA,gCAAA;EzEkmmBV;EyEzmmBM;IAOI,6BAAA;IAAA,gCAAA;EzEsmmBV;EyE7mmBM;IAOI,6BAAA;IAAA,gCAAA;EzE0mmBV;EyEjnmBM;IAOI,6BAAA;IAAA,gCAAA;EzE8mmBV;EyErnmBM;IAOI,6BAAA;IAAA,gCAAA;EzEknmBV;EyEznmBM;IAOI,6BAAA;IAAA,gCAAA;EzEsnmBV;EyE7nmBM;IAOI,yBAAA;EzEynmBV;EyEhomBM;IAOI,+BAAA;EzE4nmBV;EyEnomBM;IAOI,8BAAA;EzE+nmBV;EyEtomBM;IAOI,4BAAA;EzEkomBV;EyEzomBM;IAOI,8BAAA;EzEqomBV;EyE5omBM;IAOI,4BAAA;EzEwomBV;EyE/omBM;IAOI,2BAAA;EzE2omBV;EyElpmBM;IAOI,4BAAA;EzE8omBV;EyErpmBM;IAOI,4BAAA;EzEipmBV;EyExpmBM;IAOI,4BAAA;EzEopmBV;EyE3pmBM;IAOI,4BAAA;EzEupmBV;EyE9pmBM;IAOI,4BAAA;EzE0pmBV;EyEjqmBM;IAOI,4BAAA;EzE6pmBV;EyEpqmBM;IAOI,4BAAA;EzEgqmBV;EyEvqmBM;IAOI,4BAAA;EzEmqmBV;EyE1qmBM;IAOI,4BAAA;EzEsqmBV;EyE7qmBM;IAOI,4BAAA;EzEyqmBV;EyEhrmBM;IAOI,4BAAA;EzE4qmBV;EyEnrmBM;IAOI,6BAAA;EzE+qmBV;EyEtrmBM;IAOI,6BAAA;EzEkrmBV;EyEzrmBM;IAOI,6BAAA;EzEqrmBV;EyE5rmBM;IAOI,6BAAA;EzEwrmBV;EyE/rmBM;IAOI,6BAAA;EzE2rmBV;EyElsmBM;IAOI,6BAAA;EzE8rmBV;EyErsmBM;IAOI,6BAAA;EzEismBV;EyExsmBM;IAOI,6BAAA;EzEosmBV;EyE3smBM;IAOI,6BAAA;EzEusmBV;EyE9smBM;IAOI,6BAAA;EzE0smBV;EyEjtmBM;IAOI,2BAAA;EzE6smBV;EyEptmBM;IAOI,iCAAA;EzEgtmBV;EyEvtmBM;IAOI,gCAAA;EzEmtmBV;EyE1tmBM;IAOI,8BAAA;EzEstmBV;EyE7tmBM;IAOI,gCAAA;EzEytmBV;EyEhumBM;IAOI,8BAAA;EzE4tmBV;EyEnumBM;IAOI,6BAAA;EzE+tmBV;EyEtumBM;IAOI,8BAAA;EzEkumBV;EyEzumBM;IAOI,8BAAA;EzEqumBV;EyE5umBM;IAOI,8BAAA;EzEwumBV;EyE/umBM;IAOI,8BAAA;EzE2umBV;EyElvmBM;IAOI,8BAAA;EzE8umBV;EyErvmBM;IAOI,8BAAA;EzEivmBV;EyExvmBM;IAOI,8BAAA;EzEovmBV;EyE3vmBM;IAOI,8BAAA;EzEuvmBV;EyE9vmBM;IAOI,8BAAA;EzE0vmBV;EyEjwmBM;IAOI,8BAAA;EzE6vmBV;EyEpwmBM;IAOI,8BAAA;EzEgwmBV;EyEvwmBM;IAOI,+BAAA;EzEmwmBV;EyE1wmBM;IAOI,+BAAA;EzEswmBV;EyE7wmBM;IAOI,+BAAA;EzEywmBV;EyEhxmBM;IAOI,+BAAA;EzE4wmBV;EyEnxmBM;IAOI,+BAAA;EzE+wmBV;EyEtxmBM;IAOI,+BAAA;EzEkxmBV;EyEzxmBM;IAOI,+BAAA;EzEqxmBV;EyE5xmBM;IAOI,+BAAA;EzEwxmBV;EyE/xmBM;IAOI,+BAAA;EzE2xmBV;EyElymBM;IAOI,+BAAA;EzE8xmBV;EyErymBM;IAOI,4BAAA;EzEiymBV;EyExymBM;IAOI,kCAAA;EzEoymBV;EyE3ymBM;IAOI,iCAAA;EzEuymBV;EyE9ymBM;IAOI,+BAAA;EzE0ymBV;EyEjzmBM;IAOI,iCAAA;EzE6ymBV;EyEpzmBM;IAOI,+BAAA;EzEgzmBV;EyEvzmBM;IAOI,8BAAA;EzEmzmBV;EyE1zmBM;IAOI,+BAAA;EzEszmBV;EyE7zmBM;IAOI,+BAAA;EzEyzmBV;EyEh0mBM;IAOI,+BAAA;EzE4zmBV;EyEn0mBM;IAOI,+BAAA;EzE+zmBV;EyEt0mBM;IAOI,+BAAA;EzEk0mBV;EyEz0mBM;IAOI,+BAAA;EzEq0mBV;EyE50mBM;IAOI,+BAAA;EzEw0mBV;EyE/0mBM;IAOI,+BAAA;EzE20mBV;EyEl1mBM;IAOI,+BAAA;EzE80mBV;EyEr1mBM;IAOI,+BAAA;EzEi1mBV;EyEx1mBM;IAOI,+BAAA;EzEo1mBV;EyE31mBM;IAOI,gCAAA;EzEu1mBV;EyE91mBM;IAOI,gCAAA;EzE01mBV;EyEj2mBM;IAOI,gCAAA;EzE61mBV;EyEp2mBM;IAOI,gCAAA;EzEg2mBV;EyEv2mBM;IAOI,gCAAA;EzEm2mBV;EyE12mBM;IAOI,gCAAA;EzEs2mBV;EyE72mBM;IAOI,gCAAA;EzEy2mBV;EyEh3mBM;IAOI,gCAAA;EzE42mBV;EyEn3mBM;IAOI,gCAAA;EzE+2mBV;EyEt3mBM;IAOI,gCAAA;EzEk3mBV;EyEz3mBM;IAOI,0BAAA;EzEq3mBV;EyE53mBM;IAOI,gCAAA;EzEw3mBV;EyE/3mBM;IAOI,+BAAA;EzE23mBV;EyEl4mBM;IAOI,6BAAA;EzE83mBV;EyEr4mBM;IAOI,+BAAA;EzEi4mBV;EyEx4mBM;IAOI,6BAAA;EzEo4mBV;EyE34mBM;IAOI,4BAAA;EzEu4mBV;EyE94mBM;IAOI,6BAAA;EzE04mBV;EyEj5mBM;IAOI,6BAAA;EzE64mBV;EyEp5mBM;IAOI,6BAAA;EzEg5mBV;EyEv5mBM;IAOI,6BAAA;EzEm5mBV;EyE15mBM;IAOI,6BAAA;EzEs5mBV;EyE75mBM;IAOI,6BAAA;EzEy5mBV;EyEh6mBM;IAOI,6BAAA;EzE45mBV;EyEn6mBM;IAOI,6BAAA;EzE+5mBV;EyEt6mBM;IAOI,6BAAA;EzEk6mBV;EyEz6mBM;IAOI,6BAAA;EzEq6mBV;EyE56mBM;IAOI,6BAAA;EzEw6mBV;EyE/6mBM;IAOI,8BAAA;EzE26mBV;EyEl7mBM;IAOI,8BAAA;EzE86mBV;EyEr7mBM;IAOI,8BAAA;EzEi7mBV;EyEx7mBM;IAOI,8BAAA;EzEo7mBV;EyE37mBM;IAOI,8BAAA;EzEu7mBV;EyE97mBM;IAOI,8BAAA;EzE07mBV;EyEj8mBM;IAOI,8BAAA;EzE67mBV;EyEp8mBM;IAOI,8BAAA;EzEg8mBV;EyEv8mBM;IAOI,8BAAA;EzEm8mBV;EyE18mBM;IAOI,8BAAA;EzEs8mBV;EyE78mBM;IAOI,iBAAA;EzEy8mBV;EyEh9mBM;IAOI,uBAAA;EzE48mBV;EyEn9mBM;IAOI,sBAAA;EzE+8mBV;EyEt9mBM;IAOI,oBAAA;EzEk9mBV;EyEz9mBM;IAOI,sBAAA;EzEq9mBV;EyE59mBM;IAOI,oBAAA;EzEw9mBV;EyE/9mBM;IAOI,mBAAA;EzE29mBV;EyEl+mBM;IAOI,oBAAA;EzE89mBV;EyEr+mBM;IAOI,oBAAA;EzEi+mBV;EyEx+mBM;IAOI,oBAAA;EzEo+mBV;EyE3+mBM;IAOI,oBAAA;EzEu+mBV;EyE9+mBM;IAOI,oBAAA;EzE0+mBV;EyEj/mBM;IAOI,oBAAA;EzE6+mBV;EyEp/mBM;IAOI,oBAAA;EzEg/mBV;EyEv/mBM;IAOI,oBAAA;EzEm/mBV;EyE1/mBM;IAOI,oBAAA;EzEs/mBV;EyE7/mBM;IAOI,oBAAA;EzEy/mBV;EyEhgnBM;IAOI,oBAAA;EzE4/mBV;EyEngnBM;IAOI,qBAAA;EzE+/mBV;EyEtgnBM;IAOI,qBAAA;EzEkgnBV;EyEzgnBM;IAOI,qBAAA;EzEqgnBV;EyE5gnBM;IAOI,qBAAA;EzEwgnBV;EyE/gnBM;IAOI,qBAAA;EzE2gnBV;EyElhnBM;IAOI,qBAAA;EzE8gnBV;EyErhnBM;IAOI,qBAAA;EzEihnBV;EyExhnBM;IAOI,qBAAA;EzEohnBV;EyE3hnBM;IAOI,qBAAA;EzEuhnBV;EyE9hnBM;IAOI,qBAAA;EzE0hnBV;EyEjinBM;IAOI,qBAAA;EzE6hnBV;EyEpinBM;IAOI,2BAAA;EzEginBV;EyEvinBM;IAOI,0BAAA;EzEminBV;EyE1inBM;IAOI,wBAAA;EzEsinBV;EyE7inBM;IAOI,0BAAA;EzEyinBV;EyEhjnBM;IAOI,wBAAA;EzE4inBV;EyEnjnBM;IAOI,uBAAA;EzE+inBV;EyEtjnBM;IAOI,wBAAA;EzEkjnBV;EyEzjnBM;IAOI,wBAAA;EzEqjnBV;EyE5jnBM;IAOI,wBAAA;EzEwjnBV;EyE/jnBM;IAOI,wBAAA;EzE2jnBV;EyElknBM;IAOI,wBAAA;EzE8jnBV;EyErknBM;IAOI,wBAAA;EzEiknBV;EyExknBM;IAOI,wBAAA;EzEoknBV;EyE3knBM;IAOI,wBAAA;EzEuknBV;EyE9knBM;IAOI,wBAAA;EzE0knBV;EyEjlnBM;IAOI,wBAAA;EzE6knBV;EyEplnBM;IAOI,wBAAA;EzEglnBV;EyEvlnBM;IAOI,yBAAA;EzEmlnBV;EyE1lnBM;IAOI,yBAAA;EzEslnBV;EyE7lnBM;IAOI,yBAAA;EzEylnBV;EyEhmnBM;IAOI,yBAAA;EzE4lnBV;EyEnmnBM;IAOI,yBAAA;EzE+lnBV;EyEtmnBM;IAOI,yBAAA;EzEkmnBV;EyEzmnBM;IAOI,yBAAA;EzEqmnBV;EyE5mnBM;IAOI,yBAAA;EzEwmnBV;EyE/mnBM;IAOI,yBAAA;EzE2mnBV;EyElnnBM;IAOI,yBAAA;EzE8mnBV;EyErnnBM;IAOI,wBAAA;EzEinnBV;EyExnnBM;IAOI,8BAAA;EzEonnBV;EyE3nnBM;IAOI,6BAAA;EzEunnBV;EyE9nnBM;IAOI,2BAAA;EzE0nnBV;EyEjonBM;IAOI,6BAAA;EzE6nnBV;EyEponBM;IAOI,2BAAA;EzEgonBV;EyEvonBM;IAOI,0BAAA;EzEmonBV;EyE1onBM;IAOI,2BAAA;EzEsonBV;EyE7onBM;IAOI,2BAAA;EzEyonBV;EyEhpnBM;IAOI,2BAAA;EzE4onBV;EyEnpnBM;IAOI,2BAAA;EzE+onBV;EyEtpnBM;IAOI,2BAAA;EzEkpnBV;EyEzpnBM;IAOI,2BAAA;EzEqpnBV;EyE5pnBM;IAOI,2BAAA;EzEwpnBV;EyE/pnBM;IAOI,2BAAA;EzE2pnBV;EyElqnBM;IAOI,2BAAA;EzE8pnBV;EyErqnBM;IAOI,2BAAA;EzEiqnBV;EyExqnBM;IAOI,2BAAA;EzEoqnBV;EyE3qnBM;IAOI,4BAAA;EzEuqnBV;EyE9qnBM;IAOI,4BAAA;EzE0qnBV;EyEjrnBM;IAOI,4BAAA;EzE6qnBV;EyEprnBM;IAOI,4BAAA;EzEgrnBV;EyEvrnBM;IAOI,4BAAA;EzEmrnBV;EyE1rnBM;IAOI,4BAAA;EzEsrnBV;EyE7rnBM;IAOI,4BAAA;EzEyrnBV;EyEhsnBM;IAOI,4BAAA;EzE4rnBV;EyEnsnBM;IAOI,4BAAA;EzE+rnBV;EyEtsnBM;IAOI,4BAAA;EzEksnBV;EyEzsnBM;IAOI,2BAAA;EzEqsnBV;EyE5snBM;IAOI,4BAAA;EzEwsnBV;EyE/snBM;IAOI,6BAAA;EzE2snBV;AACF;ActtnBI;E2DGI;IAOI,sBAAA;EzEgtnBV;EyEvtnBM;IAOI,uBAAA;EzEmtnBV;EyE1tnBM;IAOI,sBAAA;EzEstnBV;EyE7tnBM;IAOI,8BAAA;EzEytnBV;EyEhunBM;IAOI,4BAAA;EzE4tnBV;EyEnunBM;IAOI,2BAAA;EzE+tnBV;EyEtunBM;IAOI,iCAAA;EzEkunBV;EyEzunBM;IAOI,2BAAA;EzEqunBV;EyE5unBM;IAOI,0BAAA;EzEwunBV;EyE/unBM;IAOI,gCAAA;EzE2unBV;EyElvnBM;IAOI,yBAAA;EzE8unBV;EyErvnBM;IAOI,wBAAA;EzEivnBV;EyExvnBM;IAOI,+BAAA;EzEovnBV;EyE3vnBM;IAOI,yBAAA;EzEuvnBV;EyE9vnBM;IAOI,6BAAA;EzE0vnBV;EyEjwnBM;IAOI,8BAAA;EzE6vnBV;EyEpwnBM;IAOI,wBAAA;EzEgwnBV;EyEvwnBM;IAOI,+BAAA;EzEmwnBV;EyE1wnBM;IAOI,wBAAA;EzEswnBV;EyE7wnBM;IAOI,yBAAA;EzEywnBV;EyEhxnBM;IAOI,8BAAA;EzE4wnBV;EyEnxnBM;IAOI,iCAAA;EzE+wnBV;EyEtxnBM;IAOI,sCAAA;EzEkxnBV;EyEzxnBM;IAOI,yCAAA;EzEqxnBV;EyE5xnBM;IAOI,uBAAA;EzEwxnBV;EyE/xnBM;IAOI,uBAAA;EzE2xnBV;EyElynBM;IAOI,yBAAA;EzE8xnBV;EyErynBM;IAOI,yBAAA;EzEiynBV;EyExynBM;IAOI,0BAAA;EzEoynBV;EyE3ynBM;IAOI,4BAAA;EzEuynBV;EyE9ynBM;IAOI,kCAAA;EzE0ynBV;EyEjznBM;IAOI,sCAAA;EzE6ynBV;EyEpznBM;IAOI,oCAAA;EzEgznBV;EyEvznBM;IAOI,kCAAA;EzEmznBV;EyE1znBM;IAOI,yCAAA;EzEsznBV;EyE7znBM;IAOI,wCAAA;EzEyznBV;EyEh0nBM;IAOI,wCAAA;EzE4znBV;EyEn0nBM;IAOI,kCAAA;EzE+znBV;EyEt0nBM;IAOI,gCAAA;EzEk0nBV;EyEz0nBM;IAOI,8BAAA;EzEq0nBV;EyE50nBM;IAOI,gCAAA;EzEw0nBV;EyE/0nBM;IAOI,+BAAA;EzE20nBV;EyEl1nBM;IAOI,oCAAA;EzE80nBV;EyEr1nBM;IAOI,kCAAA;EzEi1nBV;EyEx1nBM;IAOI,gCAAA;EzEo1nBV;EyE31nBM;IAOI,uCAAA;EzEu1nBV;EyE91nBM;IAOI,sCAAA;EzE01nBV;EyEj2nBM;IAOI,iCAAA;EzE61nBV;EyEp2nBM;IAOI,2BAAA;EzEg2nBV;EyEv2nBM;IAOI,iCAAA;EzEm2nBV;EyE12nBM;IAOI,+BAAA;EzEs2nBV;EyE72nBM;IAOI,6BAAA;EzEy2nBV;EyEh3nBM;IAOI,+BAAA;EzE42nBV;EyEn3nBM;IAOI,8BAAA;EzE+2nBV;EyEt3nBM;IAOI,oBAAA;EzEk3nBV;EyEz3nBM;IAOI,mBAAA;EzEq3nBV;EyE53nBM;IAOI,mBAAA;EzEw3nBV;EyE/3nBM;IAOI,mBAAA;EzE23nBV;EyEl4nBM;IAOI,mBAAA;EzE83nBV;EyEr4nBM;IAOI,mBAAA;EzEi4nBV;EyEx4nBM;IAOI,mBAAA;EzEo4nBV;EyE34nBM;IAOI,mBAAA;EzEu4nBV;EyE94nBM;IAOI,oBAAA;EzE04nBV;EyEj5nBM;IAOI,0BAAA;EzE64nBV;EyEp5nBM;IAOI,yBAAA;EzEg5nBV;EyEv5nBM;IAOI,uBAAA;EzEm5nBV;EyE15nBM;IAOI,yBAAA;EzEs5nBV;EyE75nBM;IAOI,uBAAA;EzEy5nBV;EyEh6nBM;IAOI,sBAAA;EzE45nBV;EyEn6nBM;IAOI,uBAAA;EzE+5nBV;EyEt6nBM;IAOI,uBAAA;EzEk6nBV;EyEz6nBM;IAOI,uBAAA;EzEq6nBV;EyE56nBM;IAOI,uBAAA;EzEw6nBV;EyE/6nBM;IAOI,uBAAA;EzE26nBV;EyEl7nBM;IAOI,uBAAA;EzE86nBV;EyEr7nBM;IAOI,uBAAA;EzEi7nBV;EyEx7nBM;IAOI,uBAAA;EzEo7nBV;EyE37nBM;IAOI,uBAAA;EzEu7nBV;EyE97nBM;IAOI,uBAAA;EzE07nBV;EyEj8nBM;IAOI,uBAAA;EzE67nBV;EyEp8nBM;IAOI,wBAAA;EzEg8nBV;EyEv8nBM;IAOI,wBAAA;EzEm8nBV;EyE18nBM;IAOI,wBAAA;EzEs8nBV;EyE78nBM;IAOI,wBAAA;EzEy8nBV;EyEh9nBM;IAOI,wBAAA;EzE48nBV;EyEn9nBM;IAOI,wBAAA;EzE+8nBV;EyEt9nBM;IAOI,wBAAA;EzEk9nBV;EyEz9nBM;IAOI,wBAAA;EzEq9nBV;EyE59nBM;IAOI,wBAAA;EzEw9nBV;EyE/9nBM;IAOI,wBAAA;EzE29nBV;EyEl+nBM;IAOI,uBAAA;EzE89nBV;EyEr+nBM;IAOI,0BAAA;IAAA,yBAAA;EzEk+nBV;EyEz+nBM;IAOI,gCAAA;IAAA,+BAAA;EzEs+nBV;EyE7+nBM;IAOI,+BAAA;IAAA,8BAAA;EzE0+nBV;EyEj/nBM;IAOI,6BAAA;IAAA,4BAAA;EzE8+nBV;EyEr/nBM;IAOI,+BAAA;IAAA,8BAAA;EzEk/nBV;EyEz/nBM;IAOI,6BAAA;IAAA,4BAAA;EzEs/nBV;EyE7/nBM;IAOI,4BAAA;IAAA,2BAAA;EzE0/nBV;EyEjgoBM;IAOI,6BAAA;IAAA,4BAAA;EzE8/nBV;EyErgoBM;IAOI,6BAAA;IAAA,4BAAA;EzEkgoBV;EyEzgoBM;IAOI,6BAAA;IAAA,4BAAA;EzEsgoBV;EyE7goBM;IAOI,6BAAA;IAAA,4BAAA;EzE0goBV;EyEjhoBM;IAOI,6BAAA;IAAA,4BAAA;EzE8goBV;EyErhoBM;IAOI,6BAAA;IAAA,4BAAA;EzEkhoBV;EyEzhoBM;IAOI,6BAAA;IAAA,4BAAA;EzEshoBV;EyE7hoBM;IAOI,6BAAA;IAAA,4BAAA;EzE0hoBV;EyEjioBM;IAOI,6BAAA;IAAA,4BAAA;EzE8hoBV;EyErioBM;IAOI,6BAAA;IAAA,4BAAA;EzEkioBV;EyEzioBM;IAOI,6BAAA;IAAA,4BAAA;EzEsioBV;EyE7ioBM;IAOI,8BAAA;IAAA,6BAAA;EzE0ioBV;EyEjjoBM;IAOI,8BAAA;IAAA,6BAAA;EzE8ioBV;EyErjoBM;IAOI,8BAAA;IAAA,6BAAA;EzEkjoBV;EyEzjoBM;IAOI,8BAAA;IAAA,6BAAA;EzEsjoBV;EyE7joBM;IAOI,8BAAA;IAAA,6BAAA;EzE0joBV;EyEjkoBM;IAOI,8BAAA;IAAA,6BAAA;EzE8joBV;EyErkoBM;IAOI,8BAAA;IAAA,6BAAA;EzEkkoBV;EyEzkoBM;IAOI,8BAAA;IAAA,6BAAA;EzEskoBV;EyE7koBM;IAOI,8BAAA;IAAA,6BAAA;EzE0koBV;EyEjloBM;IAOI,8BAAA;IAAA,6BAAA;EzE8koBV;EyErloBM;IAOI,6BAAA;IAAA,4BAAA;EzEkloBV;EyEzloBM;IAOI,wBAAA;IAAA,2BAAA;EzEsloBV;EyE7loBM;IAOI,8BAAA;IAAA,iCAAA;EzE0loBV;EyEjmoBM;IAOI,6BAAA;IAAA,gCAAA;EzE8loBV;EyErmoBM;IAOI,2BAAA;IAAA,8BAAA;EzEkmoBV;EyEzmoBM;IAOI,6BAAA;IAAA,gCAAA;EzEsmoBV;EyE7moBM;IAOI,2BAAA;IAAA,8BAAA;EzE0moBV;EyEjnoBM;IAOI,0BAAA;IAAA,6BAAA;EzE8moBV;EyErnoBM;IAOI,2BAAA;IAAA,8BAAA;EzEknoBV;EyEznoBM;IAOI,2BAAA;IAAA,8BAAA;EzEsnoBV;EyE7noBM;IAOI,2BAAA;IAAA,8BAAA;EzE0noBV;EyEjooBM;IAOI,2BAAA;IAAA,8BAAA;EzE8noBV;EyErooBM;IAOI,2BAAA;IAAA,8BAAA;EzEkooBV;EyEzooBM;IAOI,2BAAA;IAAA,8BAAA;EzEsooBV;EyE7ooBM;IAOI,2BAAA;IAAA,8BAAA;EzE0ooBV;EyEjpoBM;IAOI,2BAAA;IAAA,8BAAA;EzE8ooBV;EyErpoBM;IAOI,2BAAA;IAAA,8BAAA;EzEkpoBV;EyEzpoBM;IAOI,2BAAA;IAAA,8BAAA;EzEspoBV;EyE7poBM;IAOI,2BAAA;IAAA,8BAAA;EzE0poBV;EyEjqoBM;IAOI,4BAAA;IAAA,+BAAA;EzE8poBV;EyErqoBM;IAOI,4BAAA;IAAA,+BAAA;EzEkqoBV;EyEzqoBM;IAOI,4BAAA;IAAA,+BAAA;EzEsqoBV;EyE7qoBM;IAOI,4BAAA;IAAA,+BAAA;EzE0qoBV;EyEjroBM;IAOI,4BAAA;IAAA,+BAAA;EzE8qoBV;EyErroBM;IAOI,4BAAA;IAAA,+BAAA;EzEkroBV;EyEzroBM;IAOI,4BAAA;IAAA,+BAAA;EzEsroBV;EyE7roBM;IAOI,4BAAA;IAAA,+BAAA;EzE0roBV;EyEjsoBM;IAOI,4BAAA;IAAA,+BAAA;EzE8roBV;EyErsoBM;IAOI,4BAAA;IAAA,+BAAA;EzEksoBV;EyEzsoBM;IAOI,2BAAA;IAAA,8BAAA;EzEssoBV;EyE7soBM;IAOI,wBAAA;EzEysoBV;EyEhtoBM;IAOI,8BAAA;EzE4soBV;EyEntoBM;IAOI,6BAAA;EzE+soBV;EyEttoBM;IAOI,2BAAA;EzEktoBV;EyEztoBM;IAOI,6BAAA;EzEqtoBV;EyE5toBM;IAOI,2BAAA;EzEwtoBV;EyE/toBM;IAOI,0BAAA;EzE2toBV;EyEluoBM;IAOI,2BAAA;EzE8toBV;EyEruoBM;IAOI,2BAAA;EzEiuoBV;EyExuoBM;IAOI,2BAAA;EzEouoBV;EyE3uoBM;IAOI,2BAAA;EzEuuoBV;EyE9uoBM;IAOI,2BAAA;EzE0uoBV;EyEjvoBM;IAOI,2BAAA;EzE6uoBV;EyEpvoBM;IAOI,2BAAA;EzEgvoBV;EyEvvoBM;IAOI,2BAAA;EzEmvoBV;EyE1voBM;IAOI,2BAAA;EzEsvoBV;EyE7voBM;IAOI,2BAAA;EzEyvoBV;EyEhwoBM;IAOI,2BAAA;EzE4voBV;EyEnwoBM;IAOI,4BAAA;EzE+voBV;EyEtwoBM;IAOI,4BAAA;EzEkwoBV;EyEzwoBM;IAOI,4BAAA;EzEqwoBV;EyE5woBM;IAOI,4BAAA;EzEwwoBV;EyE/woBM;IAOI,4BAAA;EzE2woBV;EyElxoBM;IAOI,4BAAA;EzE8woBV;EyErxoBM;IAOI,4BAAA;EzEixoBV;EyExxoBM;IAOI,4BAAA;EzEoxoBV;EyE3xoBM;IAOI,4BAAA;EzEuxoBV;EyE9xoBM;IAOI,4BAAA;EzE0xoBV;EyEjyoBM;IAOI,2BAAA;EzE6xoBV;EyEpyoBM;IAOI,0BAAA;EzEgyoBV;EyEvyoBM;IAOI,gCAAA;EzEmyoBV;EyE1yoBM;IAOI,+BAAA;EzEsyoBV;EyE7yoBM;IAOI,6BAAA;EzEyyoBV;EyEhzoBM;IAOI,+BAAA;EzE4yoBV;EyEnzoBM;IAOI,6BAAA;EzE+yoBV;EyEtzoBM;IAOI,4BAAA;EzEkzoBV;EyEzzoBM;IAOI,6BAAA;EzEqzoBV;EyE5zoBM;IAOI,6BAAA;EzEwzoBV;EyE/zoBM;IAOI,6BAAA;EzE2zoBV;EyEl0oBM;IAOI,6BAAA;EzE8zoBV;EyEr0oBM;IAOI,6BAAA;EzEi0oBV;EyEx0oBM;IAOI,6BAAA;EzEo0oBV;EyE30oBM;IAOI,6BAAA;EzEu0oBV;EyE90oBM;IAOI,6BAAA;EzE00oBV;EyEj1oBM;IAOI,6BAAA;EzE60oBV;EyEp1oBM;IAOI,6BAAA;EzEg1oBV;EyEv1oBM;IAOI,6BAAA;EzEm1oBV;EyE11oBM;IAOI,8BAAA;EzEs1oBV;EyE71oBM;IAOI,8BAAA;EzEy1oBV;EyEh2oBM;IAOI,8BAAA;EzE41oBV;EyEn2oBM;IAOI,8BAAA;EzE+1oBV;EyEt2oBM;IAOI,8BAAA;EzEk2oBV;EyEz2oBM;IAOI,8BAAA;EzEq2oBV;EyE52oBM;IAOI,8BAAA;EzEw2oBV;EyE/2oBM;IAOI,8BAAA;EzE22oBV;EyEl3oBM;IAOI,8BAAA;EzE82oBV;EyEr3oBM;IAOI,8BAAA;EzEi3oBV;EyEx3oBM;IAOI,6BAAA;EzEo3oBV;EyE33oBM;IAOI,2BAAA;EzEu3oBV;EyE93oBM;IAOI,iCAAA;EzE03oBV;EyEj4oBM;IAOI,gCAAA;EzE63oBV;EyEp4oBM;IAOI,8BAAA;EzEg4oBV;EyEv4oBM;IAOI,gCAAA;EzEm4oBV;EyE14oBM;IAOI,8BAAA;EzEs4oBV;EyE74oBM;IAOI,6BAAA;EzEy4oBV;EyEh5oBM;IAOI,8BAAA;EzE44oBV;EyEn5oBM;IAOI,8BAAA;EzE+4oBV;EyEt5oBM;IAOI,8BAAA;EzEk5oBV;EyEz5oBM;IAOI,8BAAA;EzEq5oBV;EyE55oBM;IAOI,8BAAA;EzEw5oBV;EyE/5oBM;IAOI,8BAAA;EzE25oBV;EyEl6oBM;IAOI,8BAAA;EzE85oBV;EyEr6oBM;IAOI,8BAAA;EzEi6oBV;EyEx6oBM;IAOI,8BAAA;EzEo6oBV;EyE36oBM;IAOI,8BAAA;EzEu6oBV;EyE96oBM;IAOI,8BAAA;EzE06oBV;EyEj7oBM;IAOI,+BAAA;EzE66oBV;EyEp7oBM;IAOI,+BAAA;EzEg7oBV;EyEv7oBM;IAOI,+BAAA;EzEm7oBV;EyE17oBM;IAOI,+BAAA;EzEs7oBV;EyE77oBM;IAOI,+BAAA;EzEy7oBV;EyEh8oBM;IAOI,+BAAA;EzE47oBV;EyEn8oBM;IAOI,+BAAA;EzE+7oBV;EyEt8oBM;IAOI,+BAAA;EzEk8oBV;EyEz8oBM;IAOI,+BAAA;EzEq8oBV;EyE58oBM;IAOI,+BAAA;EzEw8oBV;EyE/8oBM;IAOI,8BAAA;EzE28oBV;EyEl9oBM;IAOI,yBAAA;EzE88oBV;EyEr9oBM;IAOI,+BAAA;EzEi9oBV;EyEx9oBM;IAOI,8BAAA;EzEo9oBV;EyE39oBM;IAOI,4BAAA;EzEu9oBV;EyE99oBM;IAOI,8BAAA;EzE09oBV;EyEj+oBM;IAOI,4BAAA;EzE69oBV;EyEp+oBM;IAOI,2BAAA;EzEg+oBV;EyEv+oBM;IAOI,4BAAA;EzEm+oBV;EyE1+oBM;IAOI,4BAAA;EzEs+oBV;EyE7+oBM;IAOI,4BAAA;EzEy+oBV;EyEh/oBM;IAOI,4BAAA;EzE4+oBV;EyEn/oBM;IAOI,4BAAA;EzE++oBV;EyEt/oBM;IAOI,4BAAA;EzEk/oBV;EyEz/oBM;IAOI,4BAAA;EzEq/oBV;EyE5/oBM;IAOI,4BAAA;EzEw/oBV;EyE//oBM;IAOI,4BAAA;EzE2/oBV;EyElgpBM;IAOI,4BAAA;EzE8/oBV;EyErgpBM;IAOI,4BAAA;EzEigpBV;EyExgpBM;IAOI,6BAAA;EzEogpBV;EyE3gpBM;IAOI,6BAAA;EzEugpBV;EyE9gpBM;IAOI,6BAAA;EzE0gpBV;EyEjhpBM;IAOI,6BAAA;EzE6gpBV;EyEphpBM;IAOI,6BAAA;EzEghpBV;EyEvhpBM;IAOI,6BAAA;EzEmhpBV;EyE1hpBM;IAOI,6BAAA;EzEshpBV;EyE7hpBM;IAOI,6BAAA;EzEyhpBV;EyEhipBM;IAOI,6BAAA;EzE4hpBV;EyEnipBM;IAOI,6BAAA;EzE+hpBV;EyEtipBM;IAOI,4BAAA;EzEkipBV;EyEzipBM;IAOI,2BAAA;EzEqipBV;EyE5ipBM;IAOI,0BAAA;EzEwipBV;EyE/ipBM;IAOI,wBAAA;EzE2ipBV;EyEljpBM;IAOI,0BAAA;EzE8ipBV;EyErjpBM;IAOI,wBAAA;EzEijpBV;EyExjpBM;IAOI,uBAAA;EzEojpBV;EyE3jpBM;IAOI,wBAAA;EzEujpBV;EyE9jpBM;IAOI,wBAAA;EzE0jpBV;EyEjkpBM;IAOI,wBAAA;EzE6jpBV;EyEpkpBM;IAOI,wBAAA;EzEgkpBV;EyEvkpBM;IAOI,wBAAA;EzEmkpBV;EyE1kpBM;IAOI,wBAAA;EzEskpBV;EyE7kpBM;IAOI,wBAAA;EzEykpBV;EyEhlpBM;IAOI,wBAAA;EzE4kpBV;EyEnlpBM;IAOI,wBAAA;EzE+kpBV;EyEtlpBM;IAOI,wBAAA;EzEklpBV;EyEzlpBM;IAOI,wBAAA;EzEqlpBV;EyE5lpBM;IAOI,yBAAA;EzEwlpBV;EyE/lpBM;IAOI,yBAAA;EzE2lpBV;EyElmpBM;IAOI,yBAAA;EzE8lpBV;EyErmpBM;IAOI,yBAAA;EzEimpBV;EyExmpBM;IAOI,yBAAA;EzEompBV;EyE3mpBM;IAOI,yBAAA;EzEumpBV;EyE9mpBM;IAOI,yBAAA;EzE0mpBV;EyEjnpBM;IAOI,yBAAA;EzE6mpBV;EyEpnpBM;IAOI,yBAAA;EzEgnpBV;EyEvnpBM;IAOI,yBAAA;EzEmnpBV;EyE1npBM;IAOI,iCAAA;IAAA,gCAAA;EzEunpBV;EyE9npBM;IAOI,gCAAA;IAAA,+BAAA;EzE2npBV;EyElopBM;IAOI,8BAAA;IAAA,6BAAA;EzE+npBV;EyEtopBM;IAOI,gCAAA;IAAA,+BAAA;EzEmopBV;EyE1opBM;IAOI,8BAAA;IAAA,6BAAA;EzEuopBV;EyE9opBM;IAOI,6BAAA;IAAA,4BAAA;EzE2opBV;EyElppBM;IAOI,8BAAA;IAAA,6BAAA;EzE+opBV;EyEtppBM;IAOI,8BAAA;IAAA,6BAAA;EzEmppBV;EyE1ppBM;IAOI,8BAAA;IAAA,6BAAA;EzEuppBV;EyE9ppBM;IAOI,8BAAA;IAAA,6BAAA;EzE2ppBV;EyElqpBM;IAOI,8BAAA;IAAA,6BAAA;EzE+ppBV;EyEtqpBM;IAOI,8BAAA;IAAA,6BAAA;EzEmqpBV;EyE1qpBM;IAOI,8BAAA;IAAA,6BAAA;EzEuqpBV;EyE9qpBM;IAOI,8BAAA;IAAA,6BAAA;EzE2qpBV;EyElrpBM;IAOI,8BAAA;IAAA,6BAAA;EzE+qpBV;EyEtrpBM;IAOI,8BAAA;IAAA,6BAAA;EzEmrpBV;EyE1rpBM;IAOI,8BAAA;IAAA,6BAAA;EzEurpBV;EyE9rpBM;IAOI,+BAAA;IAAA,8BAAA;EzE2rpBV;EyElspBM;IAOI,+BAAA;IAAA,8BAAA;EzE+rpBV;EyEtspBM;IAOI,+BAAA;IAAA,8BAAA;EzEmspBV;EyE1spBM;IAOI,+BAAA;IAAA,8BAAA;EzEuspBV;EyE9spBM;IAOI,+BAAA;IAAA,8BAAA;EzE2spBV;EyEltpBM;IAOI,+BAAA;IAAA,8BAAA;EzE+spBV;EyEttpBM;IAOI,+BAAA;IAAA,8BAAA;EzEmtpBV;EyE1tpBM;IAOI,+BAAA;IAAA,8BAAA;EzEutpBV;EyE9tpBM;IAOI,+BAAA;IAAA,8BAAA;EzE2tpBV;EyElupBM;IAOI,+BAAA;IAAA,8BAAA;EzE+tpBV;EyEtupBM;IAOI,+BAAA;IAAA,kCAAA;EzEmupBV;EyE1upBM;IAOI,8BAAA;IAAA,iCAAA;EzEuupBV;EyE9upBM;IAOI,4BAAA;IAAA,+BAAA;EzE2upBV;EyElvpBM;IAOI,8BAAA;IAAA,iCAAA;EzE+upBV;EyEtvpBM;IAOI,4BAAA;IAAA,+BAAA;EzEmvpBV;EyE1vpBM;IAOI,2BAAA;IAAA,8BAAA;EzEuvpBV;EyE9vpBM;IAOI,4BAAA;IAAA,+BAAA;EzE2vpBV;EyElwpBM;IAOI,4BAAA;IAAA,+BAAA;EzE+vpBV;EyEtwpBM;IAOI,4BAAA;IAAA,+BAAA;EzEmwpBV;EyE1wpBM;IAOI,4BAAA;IAAA,+BAAA;EzEuwpBV;EyE9wpBM;IAOI,4BAAA;IAAA,+BAAA;EzE2wpBV;EyElxpBM;IAOI,4BAAA;IAAA,+BAAA;EzE+wpBV;EyEtxpBM;IAOI,4BAAA;IAAA,+BAAA;EzEmxpBV;EyE1xpBM;IAOI,4BAAA;IAAA,+BAAA;EzEuxpBV;EyE9xpBM;IAOI,4BAAA;IAAA,+BAAA;EzE2xpBV;EyElypBM;IAOI,4BAAA;IAAA,+BAAA;EzE+xpBV;EyEtypBM;IAOI,4BAAA;IAAA,+BAAA;EzEmypBV;EyE1ypBM;IAOI,6BAAA;IAAA,gCAAA;EzEuypBV;EyE9ypBM;IAOI,6BAAA;IAAA,gCAAA;EzE2ypBV;EyElzpBM;IAOI,6BAAA;IAAA,gCAAA;EzE+ypBV;EyEtzpBM;IAOI,6BAAA;IAAA,gCAAA;EzEmzpBV;EyE1zpBM;IAOI,6BAAA;IAAA,gCAAA;EzEuzpBV;EyE9zpBM;IAOI,6BAAA;IAAA,gCAAA;EzE2zpBV;EyEl0pBM;IAOI,6BAAA;IAAA,gCAAA;EzE+zpBV;EyEt0pBM;IAOI,6BAAA;IAAA,gCAAA;EzEm0pBV;EyE10pBM;IAOI,6BAAA;IAAA,gCAAA;EzEu0pBV;EyE90pBM;IAOI,6BAAA;IAAA,gCAAA;EzE20pBV;EyEl1pBM;IAOI,+BAAA;EzE80pBV;EyEr1pBM;IAOI,8BAAA;EzEi1pBV;EyEx1pBM;IAOI,4BAAA;EzEo1pBV;EyE31pBM;IAOI,8BAAA;EzEu1pBV;EyE91pBM;IAOI,4BAAA;EzE01pBV;EyEj2pBM;IAOI,2BAAA;EzE61pBV;EyEp2pBM;IAOI,4BAAA;EzEg2pBV;EyEv2pBM;IAOI,4BAAA;EzEm2pBV;EyE12pBM;IAOI,4BAAA;EzEs2pBV;EyE72pBM;IAOI,4BAAA;EzEy2pBV;EyEh3pBM;IAOI,4BAAA;EzE42pBV;EyEn3pBM;IAOI,4BAAA;EzE+2pBV;EyEt3pBM;IAOI,4BAAA;EzEk3pBV;EyEz3pBM;IAOI,4BAAA;EzEq3pBV;EyE53pBM;IAOI,4BAAA;EzEw3pBV;EyE/3pBM;IAOI,4BAAA;EzE23pBV;EyEl4pBM;IAOI,4BAAA;EzE83pBV;EyEr4pBM;IAOI,6BAAA;EzEi4pBV;EyEx4pBM;IAOI,6BAAA;EzEo4pBV;EyE34pBM;IAOI,6BAAA;EzEu4pBV;EyE94pBM;IAOI,6BAAA;EzE04pBV;EyEj5pBM;IAOI,6BAAA;EzE64pBV;EyEp5pBM;IAOI,6BAAA;EzEg5pBV;EyEv5pBM;IAOI,6BAAA;EzEm5pBV;EyE15pBM;IAOI,6BAAA;EzEs5pBV;EyE75pBM;IAOI,6BAAA;EzEy5pBV;EyEh6pBM;IAOI,6BAAA;EzE45pBV;EyEn6pBM;IAOI,iCAAA;EzE+5pBV;EyEt6pBM;IAOI,gCAAA;EzEk6pBV;EyEz6pBM;IAOI,8BAAA;EzEq6pBV;EyE56pBM;IAOI,gCAAA;EzEw6pBV;EyE/6pBM;IAOI,8BAAA;EzE26pBV;EyEl7pBM;IAOI,6BAAA;EzE86pBV;EyEr7pBM;IAOI,8BAAA;EzEi7pBV;EyEx7pBM;IAOI,8BAAA;EzEo7pBV;EyE37pBM;IAOI,8BAAA;EzEu7pBV;EyE97pBM;IAOI,8BAAA;EzE07pBV;EyEj8pBM;IAOI,8BAAA;EzE67pBV;EyEp8pBM;IAOI,8BAAA;EzEg8pBV;EyEv8pBM;IAOI,8BAAA;EzEm8pBV;EyE18pBM;IAOI,8BAAA;EzEs8pBV;EyE78pBM;IAOI,8BAAA;EzEy8pBV;EyEh9pBM;IAOI,8BAAA;EzE48pBV;EyEn9pBM;IAOI,8BAAA;EzE+8pBV;EyEt9pBM;IAOI,+BAAA;EzEk9pBV;EyEz9pBM;IAOI,+BAAA;EzEq9pBV;EyE59pBM;IAOI,+BAAA;EzEw9pBV;EyE/9pBM;IAOI,+BAAA;EzE29pBV;EyEl+pBM;IAOI,+BAAA;EzE89pBV;EyEr+pBM;IAOI,+BAAA;EzEi+pBV;EyEx+pBM;IAOI,+BAAA;EzEo+pBV;EyE3+pBM;IAOI,+BAAA;EzEu+pBV;EyE9+pBM;IAOI,+BAAA;EzE0+pBV;EyEj/pBM;IAOI,+BAAA;EzE6+pBV;EyEp/pBM;IAOI,kCAAA;EzEg/pBV;EyEv/pBM;IAOI,iCAAA;EzEm/pBV;EyE1/pBM;IAOI,+BAAA;EzEs/pBV;EyE7/pBM;IAOI,iCAAA;EzEy/pBV;EyEhgqBM;IAOI,+BAAA;EzE4/pBV;EyEngqBM;IAOI,8BAAA;EzE+/pBV;EyEtgqBM;IAOI,+BAAA;EzEkgqBV;EyEzgqBM;IAOI,+BAAA;EzEqgqBV;EyE5gqBM;IAOI,+BAAA;EzEwgqBV;EyE/gqBM;IAOI,+BAAA;EzE2gqBV;EyElhqBM;IAOI,+BAAA;EzE8gqBV;EyErhqBM;IAOI,+BAAA;EzEihqBV;EyExhqBM;IAOI,+BAAA;EzEohqBV;EyE3hqBM;IAOI,+BAAA;EzEuhqBV;EyE9hqBM;IAOI,+BAAA;EzE0hqBV;EyEjiqBM;IAOI,+BAAA;EzE6hqBV;EyEpiqBM;IAOI,+BAAA;EzEgiqBV;EyEviqBM;IAOI,gCAAA;EzEmiqBV;EyE1iqBM;IAOI,gCAAA;EzEsiqBV;EyE7iqBM;IAOI,gCAAA;EzEyiqBV;EyEhjqBM;IAOI,gCAAA;EzE4iqBV;EyEnjqBM;IAOI,gCAAA;EzE+iqBV;EyEtjqBM;IAOI,gCAAA;EzEkjqBV;EyEzjqBM;IAOI,gCAAA;EzEqjqBV;EyE5jqBM;IAOI,gCAAA;EzEwjqBV;EyE/jqBM;IAOI,gCAAA;EzE2jqBV;EyElkqBM;IAOI,gCAAA;EzE8jqBV;EyErkqBM;IAOI,gCAAA;EzEikqBV;EyExkqBM;IAOI,+BAAA;EzEokqBV;EyE3kqBM;IAOI,6BAAA;EzEukqBV;EyE9kqBM;IAOI,+BAAA;EzE0kqBV;EyEjlqBM;IAOI,6BAAA;EzE6kqBV;EyEplqBM;IAOI,4BAAA;EzEglqBV;EyEvlqBM;IAOI,6BAAA;EzEmlqBV;EyE1lqBM;IAOI,6BAAA;EzEslqBV;EyE7lqBM;IAOI,6BAAA;EzEylqBV;EyEhmqBM;IAOI,6BAAA;EzE4lqBV;EyEnmqBM;IAOI,6BAAA;EzE+lqBV;EyEtmqBM;IAOI,6BAAA;EzEkmqBV;EyEzmqBM;IAOI,6BAAA;EzEqmqBV;EyE5mqBM;IAOI,6BAAA;EzEwmqBV;EyE/mqBM;IAOI,6BAAA;EzE2mqBV;EyElnqBM;IAOI,6BAAA;EzE8mqBV;EyErnqBM;IAOI,6BAAA;EzEinqBV;EyExnqBM;IAOI,8BAAA;EzEonqBV;EyE3nqBM;IAOI,8BAAA;EzEunqBV;EyE9nqBM;IAOI,8BAAA;EzE0nqBV;EyEjoqBM;IAOI,8BAAA;EzE6nqBV;EyEpoqBM;IAOI,8BAAA;EzEgoqBV;EyEvoqBM;IAOI,8BAAA;EzEmoqBV;EyE1oqBM;IAOI,8BAAA;EzEsoqBV;EyE7oqBM;IAOI,8BAAA;EzEyoqBV;EyEhpqBM;IAOI,8BAAA;EzE4oqBV;EyEnpqBM;IAOI,8BAAA;EzE+oqBV;EyEtpqBM;IAOI,qBAAA;EzEkpqBV;EyEzpqBM;IAOI,2BAAA;EzEqpqBV;EyE5pqBM;IAOI,0BAAA;EzEwpqBV;EyE/pqBM;IAOI,wBAAA;EzE2pqBV;EyElqqBM;IAOI,0BAAA;EzE8pqBV;EyErqqBM;IAOI,wBAAA;EzEiqqBV;EyExqqBM;IAOI,uBAAA;EzEoqqBV;EyE3qqBM;IAOI,wBAAA;EzEuqqBV;EyE9qqBM;IAOI,wBAAA;EzE0qqBV;EyEjrqBM;IAOI,wBAAA;EzE6qqBV;EyEprqBM;IAOI,wBAAA;EzEgrqBV;EyEvrqBM;IAOI,wBAAA;EzEmrqBV;EyE1rqBM;IAOI,wBAAA;EzEsrqBV;EyE7rqBM;IAOI,wBAAA;EzEyrqBV;EyEhsqBM;IAOI,wBAAA;EzE4rqBV;EyEnsqBM;IAOI,wBAAA;EzE+rqBV;EyEtsqBM;IAOI,wBAAA;EzEksqBV;EyEzsqBM;IAOI,wBAAA;EzEqsqBV;EyE5sqBM;IAOI,yBAAA;EzEwsqBV;EyE/sqBM;IAOI,yBAAA;EzE2sqBV;EyEltqBM;IAOI,yBAAA;EzE8sqBV;EyErtqBM;IAOI,yBAAA;EzEitqBV;EyExtqBM;IAOI,yBAAA;EzEotqBV;EyE3tqBM;IAOI,yBAAA;EzEutqBV;EyE9tqBM;IAOI,yBAAA;EzE0tqBV;EyEjuqBM;IAOI,yBAAA;EzE6tqBV;EyEpuqBM;IAOI,yBAAA;EzEguqBV;EyEvuqBM;IAOI,yBAAA;EzEmuqBV;EyE1uqBM;IAOI,2BAAA;IAAA,0BAAA;EzEuuqBV;EyE9uqBM;IAOI,iCAAA;IAAA,gCAAA;EzE2uqBV;EyElvqBM;IAOI,gCAAA;IAAA,+BAAA;EzE+uqBV;EyEtvqBM;IAOI,8BAAA;IAAA,6BAAA;EzEmvqBV;EyE1vqBM;IAOI,gCAAA;IAAA,+BAAA;EzEuvqBV;EyE9vqBM;IAOI,8BAAA;IAAA,6BAAA;EzE2vqBV;EyElwqBM;IAOI,6BAAA;IAAA,4BAAA;EzE+vqBV;EyEtwqBM;IAOI,8BAAA;IAAA,6BAAA;EzEmwqBV;EyE1wqBM;IAOI,8BAAA;IAAA,6BAAA;EzEuwqBV;EyE9wqBM;IAOI,8BAAA;IAAA,6BAAA;EzE2wqBV;EyElxqBM;IAOI,8BAAA;IAAA,6BAAA;EzE+wqBV;EyEtxqBM;IAOI,8BAAA;IAAA,6BAAA;EzEmxqBV;EyE1xqBM;IAOI,8BAAA;IAAA,6BAAA;EzEuxqBV;EyE9xqBM;IAOI,8BAAA;IAAA,6BAAA;EzE2xqBV;EyElyqBM;IAOI,8BAAA;IAAA,6BAAA;EzE+xqBV;EyEtyqBM;IAOI,8BAAA;IAAA,6BAAA;EzEmyqBV;EyE1yqBM;IAOI,8BAAA;IAAA,6BAAA;EzEuyqBV;EyE9yqBM;IAOI,8BAAA;IAAA,6BAAA;EzE2yqBV;EyElzqBM;IAOI,+BAAA;IAAA,8BAAA;EzE+yqBV;EyEtzqBM;IAOI,+BAAA;IAAA,8BAAA;EzEmzqBV;EyE1zqBM;IAOI,+BAAA;IAAA,8BAAA;EzEuzqBV;EyE9zqBM;IAOI,+BAAA;IAAA,8BAAA;EzE2zqBV;EyEl0qBM;IAOI,+BAAA;IAAA,8BAAA;EzE+zqBV;EyEt0qBM;IAOI,+BAAA;IAAA,8BAAA;EzEm0qBV;EyE10qBM;IAOI,+BAAA;IAAA,8BAAA;EzEu0qBV;EyE90qBM;IAOI,+BAAA;IAAA,8BAAA;EzE20qBV;EyEl1qBM;IAOI,+BAAA;IAAA,8BAAA;EzE+0qBV;EyEt1qBM;IAOI,+BAAA;IAAA,8BAAA;EzEm1qBV;EyE11qBM;IAOI,yBAAA;IAAA,4BAAA;EzEu1qBV;EyE91qBM;IAOI,+BAAA;IAAA,kCAAA;EzE21qBV;EyEl2qBM;IAOI,8BAAA;IAAA,iCAAA;EzE+1qBV;EyEt2qBM;IAOI,4BAAA;IAAA,+BAAA;EzEm2qBV;EyE12qBM;IAOI,8BAAA;IAAA,iCAAA;EzEu2qBV;EyE92qBM;IAOI,4BAAA;IAAA,+BAAA;EzE22qBV;EyEl3qBM;IAOI,2BAAA;IAAA,8BAAA;EzE+2qBV;EyEt3qBM;IAOI,4BAAA;IAAA,+BAAA;EzEm3qBV;EyE13qBM;IAOI,4BAAA;IAAA,+BAAA;EzEu3qBV;EyE93qBM;IAOI,4BAAA;IAAA,+BAAA;EzE23qBV;EyEl4qBM;IAOI,4BAAA;IAAA,+BAAA;EzE+3qBV;EyEt4qBM;IAOI,4BAAA;IAAA,+BAAA;EzEm4qBV;EyE14qBM;IAOI,4BAAA;IAAA,+BAAA;EzEu4qBV;EyE94qBM;IAOI,4BAAA;IAAA,+BAAA;EzE24qBV;EyEl5qBM;IAOI,4BAAA;IAAA,+BAAA;EzE+4qBV;EyEt5qBM;IAOI,4BAAA;IAAA,+BAAA;EzEm5qBV;EyE15qBM;IAOI,4BAAA;IAAA,+BAAA;EzEu5qBV;EyE95qBM;IAOI,4BAAA;IAAA,+BAAA;EzE25qBV;EyEl6qBM;IAOI,6BAAA;IAAA,gCAAA;EzE+5qBV;EyEt6qBM;IAOI,6BAAA;IAAA,gCAAA;EzEm6qBV;EyE16qBM;IAOI,6BAAA;IAAA,gCAAA;EzEu6qBV;EyE96qBM;IAOI,6BAAA;IAAA,gCAAA;EzE26qBV;EyEl7qBM;IAOI,6BAAA;IAAA,gCAAA;EzE+6qBV;EyEt7qBM;IAOI,6BAAA;IAAA,gCAAA;EzEm7qBV;EyE17qBM;IAOI,6BAAA;IAAA,gCAAA;EzEu7qBV;EyE97qBM;IAOI,6BAAA;IAAA,gCAAA;EzE27qBV;EyEl8qBM;IAOI,6BAAA;IAAA,gCAAA;EzE+7qBV;EyEt8qBM;IAOI,6BAAA;IAAA,gCAAA;EzEm8qBV;EyE18qBM;IAOI,yBAAA;EzEs8qBV;EyE78qBM;IAOI,+BAAA;EzEy8qBV;EyEh9qBM;IAOI,8BAAA;EzE48qBV;EyEn9qBM;IAOI,4BAAA;EzE+8qBV;EyEt9qBM;IAOI,8BAAA;EzEk9qBV;EyEz9qBM;IAOI,4BAAA;EzEq9qBV;EyE59qBM;IAOI,2BAAA;EzEw9qBV;EyE/9qBM;IAOI,4BAAA;EzE29qBV;EyEl+qBM;IAOI,4BAAA;EzE89qBV;EyEr+qBM;IAOI,4BAAA;EzEi+qBV;EyEx+qBM;IAOI,4BAAA;EzEo+qBV;EyE3+qBM;IAOI,4BAAA;EzEu+qBV;EyE9+qBM;IAOI,4BAAA;EzE0+qBV;EyEj/qBM;IAOI,4BAAA;EzE6+qBV;EyEp/qBM;IAOI,4BAAA;EzEg/qBV;EyEv/qBM;IAOI,4BAAA;EzEm/qBV;EyE1/qBM;IAOI,4BAAA;EzEs/qBV;EyE7/qBM;IAOI,4BAAA;EzEy/qBV;EyEhgrBM;IAOI,6BAAA;EzE4/qBV;EyEngrBM;IAOI,6BAAA;EzE+/qBV;EyEtgrBM;IAOI,6BAAA;EzEkgrBV;EyEzgrBM;IAOI,6BAAA;EzEqgrBV;EyE5grBM;IAOI,6BAAA;EzEwgrBV;EyE/grBM;IAOI,6BAAA;EzE2grBV;EyElhrBM;IAOI,6BAAA;EzE8grBV;EyErhrBM;IAOI,6BAAA;EzEihrBV;EyExhrBM;IAOI,6BAAA;EzEohrBV;EyE3hrBM;IAOI,6BAAA;EzEuhrBV;EyE9hrBM;IAOI,2BAAA;EzE0hrBV;EyEjirBM;IAOI,iCAAA;EzE6hrBV;EyEpirBM;IAOI,gCAAA;EzEgirBV;EyEvirBM;IAOI,8BAAA;EzEmirBV;EyE1irBM;IAOI,gCAAA;EzEsirBV;EyE7irBM;IAOI,8BAAA;EzEyirBV;EyEhjrBM;IAOI,6BAAA;EzE4irBV;EyEnjrBM;IAOI,8BAAA;EzE+irBV;EyEtjrBM;IAOI,8BAAA;EzEkjrBV;EyEzjrBM;IAOI,8BAAA;EzEqjrBV;EyE5jrBM;IAOI,8BAAA;EzEwjrBV;EyE/jrBM;IAOI,8BAAA;EzE2jrBV;EyElkrBM;IAOI,8BAAA;EzE8jrBV;EyErkrBM;IAOI,8BAAA;EzEikrBV;EyExkrBM;IAOI,8BAAA;EzEokrBV;EyE3krBM;IAOI,8BAAA;EzEukrBV;EyE9krBM;IAOI,8BAAA;EzE0krBV;EyEjlrBM;IAOI,8BAAA;EzE6krBV;EyEplrBM;IAOI,+BAAA;EzEglrBV;EyEvlrBM;IAOI,+BAAA;EzEmlrBV;EyE1lrBM;IAOI,+BAAA;EzEslrBV;EyE7lrBM;IAOI,+BAAA;EzEylrBV;EyEhmrBM;IAOI,+BAAA;EzE4lrBV;EyEnmrBM;IAOI,+BAAA;EzE+lrBV;EyEtmrBM;IAOI,+BAAA;EzEkmrBV;EyEzmrBM;IAOI,+BAAA;EzEqmrBV;EyE5mrBM;IAOI,+BAAA;EzEwmrBV;EyE/mrBM;IAOI,+BAAA;EzE2mrBV;EyElnrBM;IAOI,4BAAA;EzE8mrBV;EyErnrBM;IAOI,kCAAA;EzEinrBV;EyExnrBM;IAOI,iCAAA;EzEonrBV;EyE3nrBM;IAOI,+BAAA;EzEunrBV;EyE9nrBM;IAOI,iCAAA;EzE0nrBV;EyEjorBM;IAOI,+BAAA;EzE6nrBV;EyEporBM;IAOI,8BAAA;EzEgorBV;EyEvorBM;IAOI,+BAAA;EzEmorBV;EyE1orBM;IAOI,+BAAA;EzEsorBV;EyE7orBM;IAOI,+BAAA;EzEyorBV;EyEhprBM;IAOI,+BAAA;EzE4orBV;EyEnprBM;IAOI,+BAAA;EzE+orBV;EyEtprBM;IAOI,+BAAA;EzEkprBV;EyEzprBM;IAOI,+BAAA;EzEqprBV;EyE5prBM;IAOI,+BAAA;EzEwprBV;EyE/prBM;IAOI,+BAAA;EzE2prBV;EyElqrBM;IAOI,+BAAA;EzE8prBV;EyErqrBM;IAOI,+BAAA;EzEiqrBV;EyExqrBM;IAOI,gCAAA;EzEoqrBV;EyE3qrBM;IAOI,gCAAA;EzEuqrBV;EyE9qrBM;IAOI,gCAAA;EzE0qrBV;EyEjrrBM;IAOI,gCAAA;EzE6qrBV;EyEprrBM;IAOI,gCAAA;EzEgrrBV;EyEvrrBM;IAOI,gCAAA;EzEmrrBV;EyE1rrBM;IAOI,gCAAA;EzEsrrBV;EyE7rrBM;IAOI,gCAAA;EzEyrrBV;EyEhsrBM;IAOI,gCAAA;EzE4rrBV;EyEnsrBM;IAOI,gCAAA;EzE+rrBV;EyEtsrBM;IAOI,0BAAA;EzEksrBV;EyEzsrBM;IAOI,gCAAA;EzEqsrBV;EyE5srBM;IAOI,+BAAA;EzEwsrBV;EyE/srBM;IAOI,6BAAA;EzE2srBV;EyEltrBM;IAOI,+BAAA;EzE8srBV;EyErtrBM;IAOI,6BAAA;EzEitrBV;EyExtrBM;IAOI,4BAAA;EzEotrBV;EyE3trBM;IAOI,6BAAA;EzEutrBV;EyE9trBM;IAOI,6BAAA;EzE0trBV;EyEjurBM;IAOI,6BAAA;EzE6trBV;EyEpurBM;IAOI,6BAAA;EzEgurBV;EyEvurBM;IAOI,6BAAA;EzEmurBV;EyE1urBM;IAOI,6BAAA;EzEsurBV;EyE7urBM;IAOI,6BAAA;EzEyurBV;EyEhvrBM;IAOI,6BAAA;EzE4urBV;EyEnvrBM;IAOI,6BAAA;EzE+urBV;EyEtvrBM;IAOI,6BAAA;EzEkvrBV;EyEzvrBM;IAOI,6BAAA;EzEqvrBV;EyE5vrBM;IAOI,8BAAA;EzEwvrBV;EyE/vrBM;IAOI,8BAAA;EzE2vrBV;EyElwrBM;IAOI,8BAAA;EzE8vrBV;EyErwrBM;IAOI,8BAAA;EzEiwrBV;EyExwrBM;IAOI,8BAAA;EzEowrBV;EyE3wrBM;IAOI,8BAAA;EzEuwrBV;EyE9wrBM;IAOI,8BAAA;EzE0wrBV;EyEjxrBM;IAOI,8BAAA;EzE6wrBV;EyEpxrBM;IAOI,8BAAA;EzEgxrBV;EyEvxrBM;IAOI,8BAAA;EzEmxrBV;EyE1xrBM;IAOI,iBAAA;EzEsxrBV;EyE7xrBM;IAOI,uBAAA;EzEyxrBV;EyEhyrBM;IAOI,sBAAA;EzE4xrBV;EyEnyrBM;IAOI,oBAAA;EzE+xrBV;EyEtyrBM;IAOI,sBAAA;EzEkyrBV;EyEzyrBM;IAOI,oBAAA;EzEqyrBV;EyE5yrBM;IAOI,mBAAA;EzEwyrBV;EyE/yrBM;IAOI,oBAAA;EzE2yrBV;EyElzrBM;IAOI,oBAAA;EzE8yrBV;EyErzrBM;IAOI,oBAAA;EzEizrBV;EyExzrBM;IAOI,oBAAA;EzEozrBV;EyE3zrBM;IAOI,oBAAA;EzEuzrBV;EyE9zrBM;IAOI,oBAAA;EzE0zrBV;EyEj0rBM;IAOI,oBAAA;EzE6zrBV;EyEp0rBM;IAOI,oBAAA;EzEg0rBV;EyEv0rBM;IAOI,oBAAA;EzEm0rBV;EyE10rBM;IAOI,oBAAA;EzEs0rBV;EyE70rBM;IAOI,oBAAA;EzEy0rBV;EyEh1rBM;IAOI,qBAAA;EzE40rBV;EyEn1rBM;IAOI,qBAAA;EzE+0rBV;EyEt1rBM;IAOI,qBAAA;EzEk1rBV;EyEz1rBM;IAOI,qBAAA;EzEq1rBV;EyE51rBM;IAOI,qBAAA;EzEw1rBV;EyE/1rBM;IAOI,qBAAA;EzE21rBV;EyEl2rBM;IAOI,qBAAA;EzE81rBV;EyEr2rBM;IAOI,qBAAA;EzEi2rBV;EyEx2rBM;IAOI,qBAAA;EzEo2rBV;EyE32rBM;IAOI,qBAAA;EzEu2rBV;EyE92rBM;IAOI,qBAAA;EzE02rBV;EyEj3rBM;IAOI,2BAAA;EzE62rBV;EyEp3rBM;IAOI,0BAAA;EzEg3rBV;EyEv3rBM;IAOI,wBAAA;EzEm3rBV;EyE13rBM;IAOI,0BAAA;EzEs3rBV;EyE73rBM;IAOI,wBAAA;EzEy3rBV;EyEh4rBM;IAOI,uBAAA;EzE43rBV;EyEn4rBM;IAOI,wBAAA;EzE+3rBV;EyEt4rBM;IAOI,wBAAA;EzEk4rBV;EyEz4rBM;IAOI,wBAAA;EzEq4rBV;EyE54rBM;IAOI,wBAAA;EzEw4rBV;EyE/4rBM;IAOI,wBAAA;EzE24rBV;EyEl5rBM;IAOI,wBAAA;EzE84rBV;EyEr5rBM;IAOI,wBAAA;EzEi5rBV;EyEx5rBM;IAOI,wBAAA;EzEo5rBV;EyE35rBM;IAOI,wBAAA;EzEu5rBV;EyE95rBM;IAOI,wBAAA;EzE05rBV;EyEj6rBM;IAOI,wBAAA;EzE65rBV;EyEp6rBM;IAOI,yBAAA;EzEg6rBV;EyEv6rBM;IAOI,yBAAA;EzEm6rBV;EyE16rBM;IAOI,yBAAA;EzEs6rBV;EyE76rBM;IAOI,yBAAA;EzEy6rBV;EyEh7rBM;IAOI,yBAAA;EzE46rBV;EyEn7rBM;IAOI,yBAAA;EzE+6rBV;EyEt7rBM;IAOI,yBAAA;EzEk7rBV;EyEz7rBM;IAOI,yBAAA;EzEq7rBV;EyE57rBM;IAOI,yBAAA;EzEw7rBV;EyE/7rBM;IAOI,yBAAA;EzE27rBV;EyEl8rBM;IAOI,wBAAA;EzE87rBV;EyEr8rBM;IAOI,8BAAA;EzEi8rBV;EyEx8rBM;IAOI,6BAAA;EzEo8rBV;EyE38rBM;IAOI,2BAAA;EzEu8rBV;EyE98rBM;IAOI,6BAAA;EzE08rBV;EyEj9rBM;IAOI,2BAAA;EzE68rBV;EyEp9rBM;IAOI,0BAAA;EzEg9rBV;EyEv9rBM;IAOI,2BAAA;EzEm9rBV;EyE19rBM;IAOI,2BAAA;EzEs9rBV;EyE79rBM;IAOI,2BAAA;EzEy9rBV;EyEh+rBM;IAOI,2BAAA;EzE49rBV;EyEn+rBM;IAOI,2BAAA;EzE+9rBV;EyEt+rBM;IAOI,2BAAA;EzEk+rBV;EyEz+rBM;IAOI,2BAAA;EzEq+rBV;EyE5+rBM;IAOI,2BAAA;EzEw+rBV;EyE/+rBM;IAOI,2BAAA;EzE2+rBV;EyEl/rBM;IAOI,2BAAA;EzE8+rBV;EyEr/rBM;IAOI,2BAAA;EzEi/rBV;EyEx/rBM;IAOI,4BAAA;EzEo/rBV;EyE3/rBM;IAOI,4BAAA;EzEu/rBV;EyE9/rBM;IAOI,4BAAA;EzE0/rBV;EyEjgsBM;IAOI,4BAAA;EzE6/rBV;EyEpgsBM;IAOI,4BAAA;EzEggsBV;EyEvgsBM;IAOI,4BAAA;EzEmgsBV;EyE1gsBM;IAOI,4BAAA;EzEsgsBV;EyE7gsBM;IAOI,4BAAA;EzEygsBV;EyEhhsBM;IAOI,4BAAA;EzE4gsBV;EyEnhsBM;IAOI,4BAAA;EzE+gsBV;EyEthsBM;IAOI,2BAAA;EzEkhsBV;EyEzhsBM;IAOI,4BAAA;EzEqhsBV;EyE5hsBM;IAOI,6BAAA;EzEwhsBV;AACF;AcnisBI;E2DGI;IAOI,sBAAA;EzE6hsBV;EyEpisBM;IAOI,uBAAA;EzEgisBV;EyEvisBM;IAOI,sBAAA;EzEmisBV;EyE1isBM;IAOI,8BAAA;EzEsisBV;EyE7isBM;IAOI,4BAAA;EzEyisBV;EyEhjsBM;IAOI,2BAAA;EzE4isBV;EyEnjsBM;IAOI,iCAAA;EzE+isBV;EyEtjsBM;IAOI,2BAAA;EzEkjsBV;EyEzjsBM;IAOI,0BAAA;EzEqjsBV;EyE5jsBM;IAOI,gCAAA;EzEwjsBV;EyE/jsBM;IAOI,yBAAA;EzE2jsBV;EyElksBM;IAOI,wBAAA;EzE8jsBV;EyErksBM;IAOI,+BAAA;EzEiksBV;EyExksBM;IAOI,yBAAA;EzEoksBV;EyE3ksBM;IAOI,6BAAA;EzEuksBV;EyE9ksBM;IAOI,8BAAA;EzE0ksBV;EyEjlsBM;IAOI,wBAAA;EzE6ksBV;EyEplsBM;IAOI,+BAAA;EzEglsBV;EyEvlsBM;IAOI,wBAAA;EzEmlsBV;EyE1lsBM;IAOI,yBAAA;EzEslsBV;EyE7lsBM;IAOI,8BAAA;EzEylsBV;EyEhmsBM;IAOI,iCAAA;EzE4lsBV;EyEnmsBM;IAOI,sCAAA;EzE+lsBV;EyEtmsBM;IAOI,yCAAA;EzEkmsBV;EyEzmsBM;IAOI,uBAAA;EzEqmsBV;EyE5msBM;IAOI,uBAAA;EzEwmsBV;EyE/msBM;IAOI,yBAAA;EzE2msBV;EyElnsBM;IAOI,yBAAA;EzE8msBV;EyErnsBM;IAOI,0BAAA;EzEinsBV;EyExnsBM;IAOI,4BAAA;EzEonsBV;EyE3nsBM;IAOI,kCAAA;EzEunsBV;EyE9nsBM;IAOI,sCAAA;EzE0nsBV;EyEjosBM;IAOI,oCAAA;EzE6nsBV;EyEposBM;IAOI,kCAAA;EzEgosBV;EyEvosBM;IAOI,yCAAA;EzEmosBV;EyE1osBM;IAOI,wCAAA;EzEsosBV;EyE7osBM;IAOI,wCAAA;EzEyosBV;EyEhpsBM;IAOI,kCAAA;EzE4osBV;EyEnpsBM;IAOI,gCAAA;EzE+osBV;EyEtpsBM;IAOI,8BAAA;EzEkpsBV;EyEzpsBM;IAOI,gCAAA;EzEqpsBV;EyE5psBM;IAOI,+BAAA;EzEwpsBV;EyE/psBM;IAOI,oCAAA;EzE2psBV;EyElqsBM;IAOI,kCAAA;EzE8psBV;EyErqsBM;IAOI,gCAAA;EzEiqsBV;EyExqsBM;IAOI,uCAAA;EzEoqsBV;EyE3qsBM;IAOI,sCAAA;EzEuqsBV;EyE9qsBM;IAOI,iCAAA;EzE0qsBV;EyEjrsBM;IAOI,2BAAA;EzE6qsBV;EyEprsBM;IAOI,iCAAA;EzEgrsBV;EyEvrsBM;IAOI,+BAAA;EzEmrsBV;EyE1rsBM;IAOI,6BAAA;EzEsrsBV;EyE7rsBM;IAOI,+BAAA;EzEyrsBV;EyEhssBM;IAOI,8BAAA;EzE4rsBV;EyEnssBM;IAOI,oBAAA;EzE+rsBV;EyEtssBM;IAOI,mBAAA;EzEkssBV;EyEzssBM;IAOI,mBAAA;EzEqssBV;EyE5ssBM;IAOI,mBAAA;EzEwssBV;EyE/ssBM;IAOI,mBAAA;EzE2ssBV;EyEltsBM;IAOI,mBAAA;EzE8ssBV;EyErtsBM;IAOI,mBAAA;EzEitsBV;EyExtsBM;IAOI,mBAAA;EzEotsBV;EyE3tsBM;IAOI,oBAAA;EzEutsBV;EyE9tsBM;IAOI,0BAAA;EzE0tsBV;EyEjusBM;IAOI,yBAAA;EzE6tsBV;EyEpusBM;IAOI,uBAAA;EzEgusBV;EyEvusBM;IAOI,yBAAA;EzEmusBV;EyE1usBM;IAOI,uBAAA;EzEsusBV;EyE7usBM;IAOI,sBAAA;EzEyusBV;EyEhvsBM;IAOI,uBAAA;EzE4usBV;EyEnvsBM;IAOI,uBAAA;EzE+usBV;EyEtvsBM;IAOI,uBAAA;EzEkvsBV;EyEzvsBM;IAOI,uBAAA;EzEqvsBV;EyE5vsBM;IAOI,uBAAA;EzEwvsBV;EyE/vsBM;IAOI,uBAAA;EzE2vsBV;EyElwsBM;IAOI,uBAAA;EzE8vsBV;EyErwsBM;IAOI,uBAAA;EzEiwsBV;EyExwsBM;IAOI,uBAAA;EzEowsBV;EyE3wsBM;IAOI,uBAAA;EzEuwsBV;EyE9wsBM;IAOI,uBAAA;EzE0wsBV;EyEjxsBM;IAOI,wBAAA;EzE6wsBV;EyEpxsBM;IAOI,wBAAA;EzEgxsBV;EyEvxsBM;IAOI,wBAAA;EzEmxsBV;EyE1xsBM;IAOI,wBAAA;EzEsxsBV;EyE7xsBM;IAOI,wBAAA;EzEyxsBV;EyEhysBM;IAOI,wBAAA;EzE4xsBV;EyEnysBM;IAOI,wBAAA;EzE+xsBV;EyEtysBM;IAOI,wBAAA;EzEkysBV;EyEzysBM;IAOI,wBAAA;EzEqysBV;EyE5ysBM;IAOI,wBAAA;EzEwysBV;EyE/ysBM;IAOI,uBAAA;EzE2ysBV;EyElzsBM;IAOI,0BAAA;IAAA,yBAAA;EzE+ysBV;EyEtzsBM;IAOI,gCAAA;IAAA,+BAAA;EzEmzsBV;EyE1zsBM;IAOI,+BAAA;IAAA,8BAAA;EzEuzsBV;EyE9zsBM;IAOI,6BAAA;IAAA,4BAAA;EzE2zsBV;EyEl0sBM;IAOI,+BAAA;IAAA,8BAAA;EzE+zsBV;EyEt0sBM;IAOI,6BAAA;IAAA,4BAAA;EzEm0sBV;EyE10sBM;IAOI,4BAAA;IAAA,2BAAA;EzEu0sBV;EyE90sBM;IAOI,6BAAA;IAAA,4BAAA;EzE20sBV;EyEl1sBM;IAOI,6BAAA;IAAA,4BAAA;EzE+0sBV;EyEt1sBM;IAOI,6BAAA;IAAA,4BAAA;EzEm1sBV;EyE11sBM;IAOI,6BAAA;IAAA,4BAAA;EzEu1sBV;EyE91sBM;IAOI,6BAAA;IAAA,4BAAA;EzE21sBV;EyEl2sBM;IAOI,6BAAA;IAAA,4BAAA;EzE+1sBV;EyEt2sBM;IAOI,6BAAA;IAAA,4BAAA;EzEm2sBV;EyE12sBM;IAOI,6BAAA;IAAA,4BAAA;EzEu2sBV;EyE92sBM;IAOI,6BAAA;IAAA,4BAAA;EzE22sBV;EyEl3sBM;IAOI,6BAAA;IAAA,4BAAA;EzE+2sBV;EyEt3sBM;IAOI,6BAAA;IAAA,4BAAA;EzEm3sBV;EyE13sBM;IAOI,8BAAA;IAAA,6BAAA;EzEu3sBV;EyE93sBM;IAOI,8BAAA;IAAA,6BAAA;EzE23sBV;EyEl4sBM;IAOI,8BAAA;IAAA,6BAAA;EzE+3sBV;EyEt4sBM;IAOI,8BAAA;IAAA,6BAAA;EzEm4sBV;EyE14sBM;IAOI,8BAAA;IAAA,6BAAA;EzEu4sBV;EyE94sBM;IAOI,8BAAA;IAAA,6BAAA;EzE24sBV;EyEl5sBM;IAOI,8BAAA;IAAA,6BAAA;EzE+4sBV;EyEt5sBM;IAOI,8BAAA;IAAA,6BAAA;EzEm5sBV;EyE15sBM;IAOI,8BAAA;IAAA,6BAAA;EzEu5sBV;EyE95sBM;IAOI,8BAAA;IAAA,6BAAA;EzE25sBV;EyEl6sBM;IAOI,6BAAA;IAAA,4BAAA;EzE+5sBV;EyEt6sBM;IAOI,wBAAA;IAAA,2BAAA;EzEm6sBV;EyE16sBM;IAOI,8BAAA;IAAA,iCAAA;EzEu6sBV;EyE96sBM;IAOI,6BAAA;IAAA,gCAAA;EzE26sBV;EyEl7sBM;IAOI,2BAAA;IAAA,8BAAA;EzE+6sBV;EyEt7sBM;IAOI,6BAAA;IAAA,gCAAA;EzEm7sBV;EyE17sBM;IAOI,2BAAA;IAAA,8BAAA;EzEu7sBV;EyE97sBM;IAOI,0BAAA;IAAA,6BAAA;EzE27sBV;EyEl8sBM;IAOI,2BAAA;IAAA,8BAAA;EzE+7sBV;EyEt8sBM;IAOI,2BAAA;IAAA,8BAAA;EzEm8sBV;EyE18sBM;IAOI,2BAAA;IAAA,8BAAA;EzEu8sBV;EyE98sBM;IAOI,2BAAA;IAAA,8BAAA;EzE28sBV;EyEl9sBM;IAOI,2BAAA;IAAA,8BAAA;EzE+8sBV;EyEt9sBM;IAOI,2BAAA;IAAA,8BAAA;EzEm9sBV;EyE19sBM;IAOI,2BAAA;IAAA,8BAAA;EzEu9sBV;EyE99sBM;IAOI,2BAAA;IAAA,8BAAA;EzE29sBV;EyEl+sBM;IAOI,2BAAA;IAAA,8BAAA;EzE+9sBV;EyEt+sBM;IAOI,2BAAA;IAAA,8BAAA;EzEm+sBV;EyE1+sBM;IAOI,2BAAA;IAAA,8BAAA;EzEu+sBV;EyE9+sBM;IAOI,4BAAA;IAAA,+BAAA;EzE2+sBV;EyEl/sBM;IAOI,4BAAA;IAAA,+BAAA;EzE++sBV;EyEt/sBM;IAOI,4BAAA;IAAA,+BAAA;EzEm/sBV;EyE1/sBM;IAOI,4BAAA;IAAA,+BAAA;EzEu/sBV;EyE9/sBM;IAOI,4BAAA;IAAA,+BAAA;EzE2/sBV;EyElgtBM;IAOI,4BAAA;IAAA,+BAAA;EzE+/sBV;EyEtgtBM;IAOI,4BAAA;IAAA,+BAAA;EzEmgtBV;EyE1gtBM;IAOI,4BAAA;IAAA,+BAAA;EzEugtBV;EyE9gtBM;IAOI,4BAAA;IAAA,+BAAA;EzE2gtBV;EyElhtBM;IAOI,4BAAA;IAAA,+BAAA;EzE+gtBV;EyEthtBM;IAOI,2BAAA;IAAA,8BAAA;EzEmhtBV;EyE1htBM;IAOI,wBAAA;EzEshtBV;EyE7htBM;IAOI,8BAAA;EzEyhtBV;EyEhitBM;IAOI,6BAAA;EzE4htBV;EyEnitBM;IAOI,2BAAA;EzE+htBV;EyEtitBM;IAOI,6BAAA;EzEkitBV;EyEzitBM;IAOI,2BAAA;EzEqitBV;EyE5itBM;IAOI,0BAAA;EzEwitBV;EyE/itBM;IAOI,2BAAA;EzE2itBV;EyEljtBM;IAOI,2BAAA;EzE8itBV;EyErjtBM;IAOI,2BAAA;EzEijtBV;EyExjtBM;IAOI,2BAAA;EzEojtBV;EyE3jtBM;IAOI,2BAAA;EzEujtBV;EyE9jtBM;IAOI,2BAAA;EzE0jtBV;EyEjktBM;IAOI,2BAAA;EzE6jtBV;EyEpktBM;IAOI,2BAAA;EzEgktBV;EyEvktBM;IAOI,2BAAA;EzEmktBV;EyE1ktBM;IAOI,2BAAA;EzEsktBV;EyE7ktBM;IAOI,2BAAA;EzEyktBV;EyEhltBM;IAOI,4BAAA;EzE4ktBV;EyEnltBM;IAOI,4BAAA;EzE+ktBV;EyEtltBM;IAOI,4BAAA;EzEkltBV;EyEzltBM;IAOI,4BAAA;EzEqltBV;EyE5ltBM;IAOI,4BAAA;EzEwltBV;EyE/ltBM;IAOI,4BAAA;EzE2ltBV;EyElmtBM;IAOI,4BAAA;EzE8ltBV;EyErmtBM;IAOI,4BAAA;EzEimtBV;EyExmtBM;IAOI,4BAAA;EzEomtBV;EyE3mtBM;IAOI,4BAAA;EzEumtBV;EyE9mtBM;IAOI,2BAAA;EzE0mtBV;EyEjntBM;IAOI,0BAAA;EzE6mtBV;EyEpntBM;IAOI,gCAAA;EzEgntBV;EyEvntBM;IAOI,+BAAA;EzEmntBV;EyE1ntBM;IAOI,6BAAA;EzEsntBV;EyE7ntBM;IAOI,+BAAA;EzEyntBV;EyEhotBM;IAOI,6BAAA;EzE4ntBV;EyEnotBM;IAOI,4BAAA;EzE+ntBV;EyEtotBM;IAOI,6BAAA;EzEkotBV;EyEzotBM;IAOI,6BAAA;EzEqotBV;EyE5otBM;IAOI,6BAAA;EzEwotBV;EyE/otBM;IAOI,6BAAA;EzE2otBV;EyElptBM;IAOI,6BAAA;EzE8otBV;EyErptBM;IAOI,6BAAA;EzEiptBV;EyExptBM;IAOI,6BAAA;EzEoptBV;EyE3ptBM;IAOI,6BAAA;EzEuptBV;EyE9ptBM;IAOI,6BAAA;EzE0ptBV;EyEjqtBM;IAOI,6BAAA;EzE6ptBV;EyEpqtBM;IAOI,6BAAA;EzEgqtBV;EyEvqtBM;IAOI,8BAAA;EzEmqtBV;EyE1qtBM;IAOI,8BAAA;EzEsqtBV;EyE7qtBM;IAOI,8BAAA;EzEyqtBV;EyEhrtBM;IAOI,8BAAA;EzE4qtBV;EyEnrtBM;IAOI,8BAAA;EzE+qtBV;EyEtrtBM;IAOI,8BAAA;EzEkrtBV;EyEzrtBM;IAOI,8BAAA;EzEqrtBV;EyE5rtBM;IAOI,8BAAA;EzEwrtBV;EyE/rtBM;IAOI,8BAAA;EzE2rtBV;EyElstBM;IAOI,8BAAA;EzE8rtBV;EyErstBM;IAOI,6BAAA;EzEistBV;EyExstBM;IAOI,2BAAA;EzEostBV;EyE3stBM;IAOI,iCAAA;EzEustBV;EyE9stBM;IAOI,gCAAA;EzE0stBV;EyEjttBM;IAOI,8BAAA;EzE6stBV;EyEpttBM;IAOI,gCAAA;EzEgttBV;EyEvttBM;IAOI,8BAAA;EzEmttBV;EyE1ttBM;IAOI,6BAAA;EzEsttBV;EyE7ttBM;IAOI,8BAAA;EzEyttBV;EyEhutBM;IAOI,8BAAA;EzE4ttBV;EyEnutBM;IAOI,8BAAA;EzE+ttBV;EyEtutBM;IAOI,8BAAA;EzEkutBV;EyEzutBM;IAOI,8BAAA;EzEqutBV;EyE5utBM;IAOI,8BAAA;EzEwutBV;EyE/utBM;IAOI,8BAAA;EzE2utBV;EyElvtBM;IAOI,8BAAA;EzE8utBV;EyErvtBM;IAOI,8BAAA;EzEivtBV;EyExvtBM;IAOI,8BAAA;EzEovtBV;EyE3vtBM;IAOI,8BAAA;EzEuvtBV;EyE9vtBM;IAOI,+BAAA;EzE0vtBV;EyEjwtBM;IAOI,+BAAA;EzE6vtBV;EyEpwtBM;IAOI,+BAAA;EzEgwtBV;EyEvwtBM;IAOI,+BAAA;EzEmwtBV;EyE1wtBM;IAOI,+BAAA;EzEswtBV;EyE7wtBM;IAOI,+BAAA;EzEywtBV;EyEhxtBM;IAOI,+BAAA;EzE4wtBV;EyEnxtBM;IAOI,+BAAA;EzE+wtBV;EyEtxtBM;IAOI,+BAAA;EzEkxtBV;EyEzxtBM;IAOI,+BAAA;EzEqxtBV;EyE5xtBM;IAOI,8BAAA;EzEwxtBV;EyE/xtBM;IAOI,yBAAA;EzE2xtBV;EyElytBM;IAOI,+BAAA;EzE8xtBV;EyErytBM;IAOI,8BAAA;EzEiytBV;EyExytBM;IAOI,4BAAA;EzEoytBV;EyE3ytBM;IAOI,8BAAA;EzEuytBV;EyE9ytBM;IAOI,4BAAA;EzE0ytBV;EyEjztBM;IAOI,2BAAA;EzE6ytBV;EyEpztBM;IAOI,4BAAA;EzEgztBV;EyEvztBM;IAOI,4BAAA;EzEmztBV;EyE1ztBM;IAOI,4BAAA;EzEsztBV;EyE7ztBM;IAOI,4BAAA;EzEyztBV;EyEh0tBM;IAOI,4BAAA;EzE4ztBV;EyEn0tBM;IAOI,4BAAA;EzE+ztBV;EyEt0tBM;IAOI,4BAAA;EzEk0tBV;EyEz0tBM;IAOI,4BAAA;EzEq0tBV;EyE50tBM;IAOI,4BAAA;EzEw0tBV;EyE/0tBM;IAOI,4BAAA;EzE20tBV;EyEl1tBM;IAOI,4BAAA;EzE80tBV;EyEr1tBM;IAOI,6BAAA;EzEi1tBV;EyEx1tBM;IAOI,6BAAA;EzEo1tBV;EyE31tBM;IAOI,6BAAA;EzEu1tBV;EyE91tBM;IAOI,6BAAA;EzE01tBV;EyEj2tBM;IAOI,6BAAA;EzE61tBV;EyEp2tBM;IAOI,6BAAA;EzEg2tBV;EyEv2tBM;IAOI,6BAAA;EzEm2tBV;EyE12tBM;IAOI,6BAAA;EzEs2tBV;EyE72tBM;IAOI,6BAAA;EzEy2tBV;EyEh3tBM;IAOI,6BAAA;EzE42tBV;EyEn3tBM;IAOI,4BAAA;EzE+2tBV;EyEt3tBM;IAOI,2BAAA;EzEk3tBV;EyEz3tBM;IAOI,0BAAA;EzEq3tBV;EyE53tBM;IAOI,wBAAA;EzEw3tBV;EyE/3tBM;IAOI,0BAAA;EzE23tBV;EyEl4tBM;IAOI,wBAAA;EzE83tBV;EyEr4tBM;IAOI,uBAAA;EzEi4tBV;EyEx4tBM;IAOI,wBAAA;EzEo4tBV;EyE34tBM;IAOI,wBAAA;EzEu4tBV;EyE94tBM;IAOI,wBAAA;EzE04tBV;EyEj5tBM;IAOI,wBAAA;EzE64tBV;EyEp5tBM;IAOI,wBAAA;EzEg5tBV;EyEv5tBM;IAOI,wBAAA;EzEm5tBV;EyE15tBM;IAOI,wBAAA;EzEs5tBV;EyE75tBM;IAOI,wBAAA;EzEy5tBV;EyEh6tBM;IAOI,wBAAA;EzE45tBV;EyEn6tBM;IAOI,wBAAA;EzE+5tBV;EyEt6tBM;IAOI,wBAAA;EzEk6tBV;EyEz6tBM;IAOI,yBAAA;EzEq6tBV;EyE56tBM;IAOI,yBAAA;EzEw6tBV;EyE/6tBM;IAOI,yBAAA;EzE26tBV;EyEl7tBM;IAOI,yBAAA;EzE86tBV;EyEr7tBM;IAOI,yBAAA;EzEi7tBV;EyEx7tBM;IAOI,yBAAA;EzEo7tBV;EyE37tBM;IAOI,yBAAA;EzEu7tBV;EyE97tBM;IAOI,yBAAA;EzE07tBV;EyEj8tBM;IAOI,yBAAA;EzE67tBV;EyEp8tBM;IAOI,yBAAA;EzEg8tBV;EyEv8tBM;IAOI,iCAAA;IAAA,gCAAA;EzEo8tBV;EyE38tBM;IAOI,gCAAA;IAAA,+BAAA;EzEw8tBV;EyE/8tBM;IAOI,8BAAA;IAAA,6BAAA;EzE48tBV;EyEn9tBM;IAOI,gCAAA;IAAA,+BAAA;EzEg9tBV;EyEv9tBM;IAOI,8BAAA;IAAA,6BAAA;EzEo9tBV;EyE39tBM;IAOI,6BAAA;IAAA,4BAAA;EzEw9tBV;EyE/9tBM;IAOI,8BAAA;IAAA,6BAAA;EzE49tBV;EyEn+tBM;IAOI,8BAAA;IAAA,6BAAA;EzEg+tBV;EyEv+tBM;IAOI,8BAAA;IAAA,6BAAA;EzEo+tBV;EyE3+tBM;IAOI,8BAAA;IAAA,6BAAA;EzEw+tBV;EyE/+tBM;IAOI,8BAAA;IAAA,6BAAA;EzE4+tBV;EyEn/tBM;IAOI,8BAAA;IAAA,6BAAA;EzEg/tBV;EyEv/tBM;IAOI,8BAAA;IAAA,6BAAA;EzEo/tBV;EyE3/tBM;IAOI,8BAAA;IAAA,6BAAA;EzEw/tBV;EyE//tBM;IAOI,8BAAA;IAAA,6BAAA;EzE4/tBV;EyEnguBM;IAOI,8BAAA;IAAA,6BAAA;EzEgguBV;EyEvguBM;IAOI,8BAAA;IAAA,6BAAA;EzEoguBV;EyE3guBM;IAOI,+BAAA;IAAA,8BAAA;EzEwguBV;EyE/guBM;IAOI,+BAAA;IAAA,8BAAA;EzE4guBV;EyEnhuBM;IAOI,+BAAA;IAAA,8BAAA;EzEghuBV;EyEvhuBM;IAOI,+BAAA;IAAA,8BAAA;EzEohuBV;EyE3huBM;IAOI,+BAAA;IAAA,8BAAA;EzEwhuBV;EyE/huBM;IAOI,+BAAA;IAAA,8BAAA;EzE4huBV;EyEniuBM;IAOI,+BAAA;IAAA,8BAAA;EzEgiuBV;EyEviuBM;IAOI,+BAAA;IAAA,8BAAA;EzEoiuBV;EyE3iuBM;IAOI,+BAAA;IAAA,8BAAA;EzEwiuBV;EyE/iuBM;IAOI,+BAAA;IAAA,8BAAA;EzE4iuBV;EyEnjuBM;IAOI,+BAAA;IAAA,kCAAA;EzEgjuBV;EyEvjuBM;IAOI,8BAAA;IAAA,iCAAA;EzEojuBV;EyE3juBM;IAOI,4BAAA;IAAA,+BAAA;EzEwjuBV;EyE/juBM;IAOI,8BAAA;IAAA,iCAAA;EzE4juBV;EyEnkuBM;IAOI,4BAAA;IAAA,+BAAA;EzEgkuBV;EyEvkuBM;IAOI,2BAAA;IAAA,8BAAA;EzEokuBV;EyE3kuBM;IAOI,4BAAA;IAAA,+BAAA;EzEwkuBV;EyE/kuBM;IAOI,4BAAA;IAAA,+BAAA;EzE4kuBV;EyEnluBM;IAOI,4BAAA;IAAA,+BAAA;EzEgluBV;EyEvluBM;IAOI,4BAAA;IAAA,+BAAA;EzEoluBV;EyE3luBM;IAOI,4BAAA;IAAA,+BAAA;EzEwluBV;EyE/luBM;IAOI,4BAAA;IAAA,+BAAA;EzE4luBV;EyEnmuBM;IAOI,4BAAA;IAAA,+BAAA;EzEgmuBV;EyEvmuBM;IAOI,4BAAA;IAAA,+BAAA;EzEomuBV;EyE3muBM;IAOI,4BAAA;IAAA,+BAAA;EzEwmuBV;EyE/muBM;IAOI,4BAAA;IAAA,+BAAA;EzE4muBV;EyEnnuBM;IAOI,4BAAA;IAAA,+BAAA;EzEgnuBV;EyEvnuBM;IAOI,6BAAA;IAAA,gCAAA;EzEonuBV;EyE3nuBM;IAOI,6BAAA;IAAA,gCAAA;EzEwnuBV;EyE/nuBM;IAOI,6BAAA;IAAA,gCAAA;EzE4nuBV;EyEnouBM;IAOI,6BAAA;IAAA,gCAAA;EzEgouBV;EyEvouBM;IAOI,6BAAA;IAAA,gCAAA;EzEoouBV;EyE3ouBM;IAOI,6BAAA;IAAA,gCAAA;EzEwouBV;EyE/ouBM;IAOI,6BAAA;IAAA,gCAAA;EzE4ouBV;EyEnpuBM;IAOI,6BAAA;IAAA,gCAAA;EzEgpuBV;EyEvpuBM;IAOI,6BAAA;IAAA,gCAAA;EzEopuBV;EyE3puBM;IAOI,6BAAA;IAAA,gCAAA;EzEwpuBV;EyE/puBM;IAOI,+BAAA;EzE2puBV;EyElquBM;IAOI,8BAAA;EzE8puBV;EyErquBM;IAOI,4BAAA;EzEiquBV;EyExquBM;IAOI,8BAAA;EzEoquBV;EyE3quBM;IAOI,4BAAA;EzEuquBV;EyE9quBM;IAOI,2BAAA;EzE0quBV;EyEjruBM;IAOI,4BAAA;EzE6quBV;EyEpruBM;IAOI,4BAAA;EzEgruBV;EyEvruBM;IAOI,4BAAA;EzEmruBV;EyE1ruBM;IAOI,4BAAA;EzEsruBV;EyE7ruBM;IAOI,4BAAA;EzEyruBV;EyEhsuBM;IAOI,4BAAA;EzE4ruBV;EyEnsuBM;IAOI,4BAAA;EzE+ruBV;EyEtsuBM;IAOI,4BAAA;EzEksuBV;EyEzsuBM;IAOI,4BAAA;EzEqsuBV;EyE5suBM;IAOI,4BAAA;EzEwsuBV;EyE/suBM;IAOI,4BAAA;EzE2suBV;EyEltuBM;IAOI,6BAAA;EzE8suBV;EyErtuBM;IAOI,6BAAA;EzEituBV;EyExtuBM;IAOI,6BAAA;EzEotuBV;EyE3tuBM;IAOI,6BAAA;EzEutuBV;EyE9tuBM;IAOI,6BAAA;EzE0tuBV;EyEjuuBM;IAOI,6BAAA;EzE6tuBV;EyEpuuBM;IAOI,6BAAA;EzEguuBV;EyEvuuBM;IAOI,6BAAA;EzEmuuBV;EyE1uuBM;IAOI,6BAAA;EzEsuuBV;EyE7uuBM;IAOI,6BAAA;EzEyuuBV;EyEhvuBM;IAOI,iCAAA;EzE4uuBV;EyEnvuBM;IAOI,gCAAA;EzE+uuBV;EyEtvuBM;IAOI,8BAAA;EzEkvuBV;EyEzvuBM;IAOI,gCAAA;EzEqvuBV;EyE5vuBM;IAOI,8BAAA;EzEwvuBV;EyE/vuBM;IAOI,6BAAA;EzE2vuBV;EyElwuBM;IAOI,8BAAA;EzE8vuBV;EyErwuBM;IAOI,8BAAA;EzEiwuBV;EyExwuBM;IAOI,8BAAA;EzEowuBV;EyE3wuBM;IAOI,8BAAA;EzEuwuBV;EyE9wuBM;IAOI,8BAAA;EzE0wuBV;EyEjxuBM;IAOI,8BAAA;EzE6wuBV;EyEpxuBM;IAOI,8BAAA;EzEgxuBV;EyEvxuBM;IAOI,8BAAA;EzEmxuBV;EyE1xuBM;IAOI,8BAAA;EzEsxuBV;EyE7xuBM;IAOI,8BAAA;EzEyxuBV;EyEhyuBM;IAOI,8BAAA;EzE4xuBV;EyEnyuBM;IAOI,+BAAA;EzE+xuBV;EyEtyuBM;IAOI,+BAAA;EzEkyuBV;EyEzyuBM;IAOI,+BAAA;EzEqyuBV;EyE5yuBM;IAOI,+BAAA;EzEwyuBV;EyE/yuBM;IAOI,+BAAA;EzE2yuBV;EyElzuBM;IAOI,+BAAA;EzE8yuBV;EyErzuBM;IAOI,+BAAA;EzEizuBV;EyExzuBM;IAOI,+BAAA;EzEozuBV;EyE3zuBM;IAOI,+BAAA;EzEuzuBV;EyE9zuBM;IAOI,+BAAA;EzE0zuBV;EyEj0uBM;IAOI,kCAAA;EzE6zuBV;EyEp0uBM;IAOI,iCAAA;EzEg0uBV;EyEv0uBM;IAOI,+BAAA;EzEm0uBV;EyE10uBM;IAOI,iCAAA;EzEs0uBV;EyE70uBM;IAOI,+BAAA;EzEy0uBV;EyEh1uBM;IAOI,8BAAA;EzE40uBV;EyEn1uBM;IAOI,+BAAA;EzE+0uBV;EyEt1uBM;IAOI,+BAAA;EzEk1uBV;EyEz1uBM;IAOI,+BAAA;EzEq1uBV;EyE51uBM;IAOI,+BAAA;EzEw1uBV;EyE/1uBM;IAOI,+BAAA;EzE21uBV;EyEl2uBM;IAOI,+BAAA;EzE81uBV;EyEr2uBM;IAOI,+BAAA;EzEi2uBV;EyEx2uBM;IAOI,+BAAA;EzEo2uBV;EyE32uBM;IAOI,+BAAA;EzEu2uBV;EyE92uBM;IAOI,+BAAA;EzE02uBV;EyEj3uBM;IAOI,+BAAA;EzE62uBV;EyEp3uBM;IAOI,gCAAA;EzEg3uBV;EyEv3uBM;IAOI,gCAAA;EzEm3uBV;EyE13uBM;IAOI,gCAAA;EzEs3uBV;EyE73uBM;IAOI,gCAAA;EzEy3uBV;EyEh4uBM;IAOI,gCAAA;EzE43uBV;EyEn4uBM;IAOI,gCAAA;EzE+3uBV;EyEt4uBM;IAOI,gCAAA;EzEk4uBV;EyEz4uBM;IAOI,gCAAA;EzEq4uBV;EyE54uBM;IAOI,gCAAA;EzEw4uBV;EyE/4uBM;IAOI,gCAAA;EzE24uBV;EyEl5uBM;IAOI,gCAAA;EzE84uBV;EyEr5uBM;IAOI,+BAAA;EzEi5uBV;EyEx5uBM;IAOI,6BAAA;EzEo5uBV;EyE35uBM;IAOI,+BAAA;EzEu5uBV;EyE95uBM;IAOI,6BAAA;EzE05uBV;EyEj6uBM;IAOI,4BAAA;EzE65uBV;EyEp6uBM;IAOI,6BAAA;EzEg6uBV;EyEv6uBM;IAOI,6BAAA;EzEm6uBV;EyE16uBM;IAOI,6BAAA;EzEs6uBV;EyE76uBM;IAOI,6BAAA;EzEy6uBV;EyEh7uBM;IAOI,6BAAA;EzE46uBV;EyEn7uBM;IAOI,6BAAA;EzE+6uBV;EyEt7uBM;IAOI,6BAAA;EzEk7uBV;EyEz7uBM;IAOI,6BAAA;EzEq7uBV;EyE57uBM;IAOI,6BAAA;EzEw7uBV;EyE/7uBM;IAOI,6BAAA;EzE27uBV;EyEl8uBM;IAOI,6BAAA;EzE87uBV;EyEr8uBM;IAOI,8BAAA;EzEi8uBV;EyEx8uBM;IAOI,8BAAA;EzEo8uBV;EyE38uBM;IAOI,8BAAA;EzEu8uBV;EyE98uBM;IAOI,8BAAA;EzE08uBV;EyEj9uBM;IAOI,8BAAA;EzE68uBV;EyEp9uBM;IAOI,8BAAA;EzEg9uBV;EyEv9uBM;IAOI,8BAAA;EzEm9uBV;EyE19uBM;IAOI,8BAAA;EzEs9uBV;EyE79uBM;IAOI,8BAAA;EzEy9uBV;EyEh+uBM;IAOI,8BAAA;EzE49uBV;EyEn+uBM;IAOI,qBAAA;EzE+9uBV;EyEt+uBM;IAOI,2BAAA;EzEk+uBV;EyEz+uBM;IAOI,0BAAA;EzEq+uBV;EyE5+uBM;IAOI,wBAAA;EzEw+uBV;EyE/+uBM;IAOI,0BAAA;EzE2+uBV;EyEl/uBM;IAOI,wBAAA;EzE8+uBV;EyEr/uBM;IAOI,uBAAA;EzEi/uBV;EyEx/uBM;IAOI,wBAAA;EzEo/uBV;EyE3/uBM;IAOI,wBAAA;EzEu/uBV;EyE9/uBM;IAOI,wBAAA;EzE0/uBV;EyEjgvBM;IAOI,wBAAA;EzE6/uBV;EyEpgvBM;IAOI,wBAAA;EzEggvBV;EyEvgvBM;IAOI,wBAAA;EzEmgvBV;EyE1gvBM;IAOI,wBAAA;EzEsgvBV;EyE7gvBM;IAOI,wBAAA;EzEygvBV;EyEhhvBM;IAOI,wBAAA;EzE4gvBV;EyEnhvBM;IAOI,wBAAA;EzE+gvBV;EyEthvBM;IAOI,wBAAA;EzEkhvBV;EyEzhvBM;IAOI,yBAAA;EzEqhvBV;EyE5hvBM;IAOI,yBAAA;EzEwhvBV;EyE/hvBM;IAOI,yBAAA;EzE2hvBV;EyElivBM;IAOI,yBAAA;EzE8hvBV;EyErivBM;IAOI,yBAAA;EzEiivBV;EyExivBM;IAOI,yBAAA;EzEoivBV;EyE3ivBM;IAOI,yBAAA;EzEuivBV;EyE9ivBM;IAOI,yBAAA;EzE0ivBV;EyEjjvBM;IAOI,yBAAA;EzE6ivBV;EyEpjvBM;IAOI,yBAAA;EzEgjvBV;EyEvjvBM;IAOI,2BAAA;IAAA,0BAAA;EzEojvBV;EyE3jvBM;IAOI,iCAAA;IAAA,gCAAA;EzEwjvBV;EyE/jvBM;IAOI,gCAAA;IAAA,+BAAA;EzE4jvBV;EyEnkvBM;IAOI,8BAAA;IAAA,6BAAA;EzEgkvBV;EyEvkvBM;IAOI,gCAAA;IAAA,+BAAA;EzEokvBV;EyE3kvBM;IAOI,8BAAA;IAAA,6BAAA;EzEwkvBV;EyE/kvBM;IAOI,6BAAA;IAAA,4BAAA;EzE4kvBV;EyEnlvBM;IAOI,8BAAA;IAAA,6BAAA;EzEglvBV;EyEvlvBM;IAOI,8BAAA;IAAA,6BAAA;EzEolvBV;EyE3lvBM;IAOI,8BAAA;IAAA,6BAAA;EzEwlvBV;EyE/lvBM;IAOI,8BAAA;IAAA,6BAAA;EzE4lvBV;EyEnmvBM;IAOI,8BAAA;IAAA,6BAAA;EzEgmvBV;EyEvmvBM;IAOI,8BAAA;IAAA,6BAAA;EzEomvBV;EyE3mvBM;IAOI,8BAAA;IAAA,6BAAA;EzEwmvBV;EyE/mvBM;IAOI,8BAAA;IAAA,6BAAA;EzE4mvBV;EyEnnvBM;IAOI,8BAAA;IAAA,6BAAA;EzEgnvBV;EyEvnvBM;IAOI,8BAAA;IAAA,6BAAA;EzEonvBV;EyE3nvBM;IAOI,8BAAA;IAAA,6BAAA;EzEwnvBV;EyE/nvBM;IAOI,+BAAA;IAAA,8BAAA;EzE4nvBV;EyEnovBM;IAOI,+BAAA;IAAA,8BAAA;EzEgovBV;EyEvovBM;IAOI,+BAAA;IAAA,8BAAA;EzEoovBV;EyE3ovBM;IAOI,+BAAA;IAAA,8BAAA;EzEwovBV;EyE/ovBM;IAOI,+BAAA;IAAA,8BAAA;EzE4ovBV;EyEnpvBM;IAOI,+BAAA;IAAA,8BAAA;EzEgpvBV;EyEvpvBM;IAOI,+BAAA;IAAA,8BAAA;EzEopvBV;EyE3pvBM;IAOI,+BAAA;IAAA,8BAAA;EzEwpvBV;EyE/pvBM;IAOI,+BAAA;IAAA,8BAAA;EzE4pvBV;EyEnqvBM;IAOI,+BAAA;IAAA,8BAAA;EzEgqvBV;EyEvqvBM;IAOI,yBAAA;IAAA,4BAAA;EzEoqvBV;EyE3qvBM;IAOI,+BAAA;IAAA,kCAAA;EzEwqvBV;EyE/qvBM;IAOI,8BAAA;IAAA,iCAAA;EzE4qvBV;EyEnrvBM;IAOI,4BAAA;IAAA,+BAAA;EzEgrvBV;EyEvrvBM;IAOI,8BAAA;IAAA,iCAAA;EzEorvBV;EyE3rvBM;IAOI,4BAAA;IAAA,+BAAA;EzEwrvBV;EyE/rvBM;IAOI,2BAAA;IAAA,8BAAA;EzE4rvBV;EyEnsvBM;IAOI,4BAAA;IAAA,+BAAA;EzEgsvBV;EyEvsvBM;IAOI,4BAAA;IAAA,+BAAA;EzEosvBV;EyE3svBM;IAOI,4BAAA;IAAA,+BAAA;EzEwsvBV;EyE/svBM;IAOI,4BAAA;IAAA,+BAAA;EzE4svBV;EyEntvBM;IAOI,4BAAA;IAAA,+BAAA;EzEgtvBV;EyEvtvBM;IAOI,4BAAA;IAAA,+BAAA;EzEotvBV;EyE3tvBM;IAOI,4BAAA;IAAA,+BAAA;EzEwtvBV;EyE/tvBM;IAOI,4BAAA;IAAA,+BAAA;EzE4tvBV;EyEnuvBM;IAOI,4BAAA;IAAA,+BAAA;EzEguvBV;EyEvuvBM;IAOI,4BAAA;IAAA,+BAAA;EzEouvBV;EyE3uvBM;IAOI,4BAAA;IAAA,+BAAA;EzEwuvBV;EyE/uvBM;IAOI,6BAAA;IAAA,gCAAA;EzE4uvBV;EyEnvvBM;IAOI,6BAAA;IAAA,gCAAA;EzEgvvBV;EyEvvvBM;IAOI,6BAAA;IAAA,gCAAA;EzEovvBV;EyE3vvBM;IAOI,6BAAA;IAAA,gCAAA;EzEwvvBV;EyE/vvBM;IAOI,6BAAA;IAAA,gCAAA;EzE4vvBV;EyEnwvBM;IAOI,6BAAA;IAAA,gCAAA;EzEgwvBV;EyEvwvBM;IAOI,6BAAA;IAAA,gCAAA;EzEowvBV;EyE3wvBM;IAOI,6BAAA;IAAA,gCAAA;EzEwwvBV;EyE/wvBM;IAOI,6BAAA;IAAA,gCAAA;EzE4wvBV;EyEnxvBM;IAOI,6BAAA;IAAA,gCAAA;EzEgxvBV;EyEvxvBM;IAOI,yBAAA;EzEmxvBV;EyE1xvBM;IAOI,+BAAA;EzEsxvBV;EyE7xvBM;IAOI,8BAAA;EzEyxvBV;EyEhyvBM;IAOI,4BAAA;EzE4xvBV;EyEnyvBM;IAOI,8BAAA;EzE+xvBV;EyEtyvBM;IAOI,4BAAA;EzEkyvBV;EyEzyvBM;IAOI,2BAAA;EzEqyvBV;EyE5yvBM;IAOI,4BAAA;EzEwyvBV;EyE/yvBM;IAOI,4BAAA;EzE2yvBV;EyElzvBM;IAOI,4BAAA;EzE8yvBV;EyErzvBM;IAOI,4BAAA;EzEizvBV;EyExzvBM;IAOI,4BAAA;EzEozvBV;EyE3zvBM;IAOI,4BAAA;EzEuzvBV;EyE9zvBM;IAOI,4BAAA;EzE0zvBV;EyEj0vBM;IAOI,4BAAA;EzE6zvBV;EyEp0vBM;IAOI,4BAAA;EzEg0vBV;EyEv0vBM;IAOI,4BAAA;EzEm0vBV;EyE10vBM;IAOI,4BAAA;EzEs0vBV;EyE70vBM;IAOI,6BAAA;EzEy0vBV;EyEh1vBM;IAOI,6BAAA;EzE40vBV;EyEn1vBM;IAOI,6BAAA;EzE+0vBV;EyEt1vBM;IAOI,6BAAA;EzEk1vBV;EyEz1vBM;IAOI,6BAAA;EzEq1vBV;EyE51vBM;IAOI,6BAAA;EzEw1vBV;EyE/1vBM;IAOI,6BAAA;EzE21vBV;EyEl2vBM;IAOI,6BAAA;EzE81vBV;EyEr2vBM;IAOI,6BAAA;EzEi2vBV;EyEx2vBM;IAOI,6BAAA;EzEo2vBV;EyE32vBM;IAOI,2BAAA;EzEu2vBV;EyE92vBM;IAOI,iCAAA;EzE02vBV;EyEj3vBM;IAOI,gCAAA;EzE62vBV;EyEp3vBM;IAOI,8BAAA;EzEg3vBV;EyEv3vBM;IAOI,gCAAA;EzEm3vBV;EyE13vBM;IAOI,8BAAA;EzEs3vBV;EyE73vBM;IAOI,6BAAA;EzEy3vBV;EyEh4vBM;IAOI,8BAAA;EzE43vBV;EyEn4vBM;IAOI,8BAAA;EzE+3vBV;EyEt4vBM;IAOI,8BAAA;EzEk4vBV;EyEz4vBM;IAOI,8BAAA;EzEq4vBV;EyE54vBM;IAOI,8BAAA;EzEw4vBV;EyE/4vBM;IAOI,8BAAA;EzE24vBV;EyEl5vBM;IAOI,8BAAA;EzE84vBV;EyEr5vBM;IAOI,8BAAA;EzEi5vBV;EyEx5vBM;IAOI,8BAAA;EzEo5vBV;EyE35vBM;IAOI,8BAAA;EzEu5vBV;EyE95vBM;IAOI,8BAAA;EzE05vBV;EyEj6vBM;IAOI,+BAAA;EzE65vBV;EyEp6vBM;IAOI,+BAAA;EzEg6vBV;EyEv6vBM;IAOI,+BAAA;EzEm6vBV;EyE16vBM;IAOI,+BAAA;EzEs6vBV;EyE76vBM;IAOI,+BAAA;EzEy6vBV;EyEh7vBM;IAOI,+BAAA;EzE46vBV;EyEn7vBM;IAOI,+BAAA;EzE+6vBV;EyEt7vBM;IAOI,+BAAA;EzEk7vBV;EyEz7vBM;IAOI,+BAAA;EzEq7vBV;EyE57vBM;IAOI,+BAAA;EzEw7vBV;EyE/7vBM;IAOI,4BAAA;EzE27vBV;EyEl8vBM;IAOI,kCAAA;EzE87vBV;EyEr8vBM;IAOI,iCAAA;EzEi8vBV;EyEx8vBM;IAOI,+BAAA;EzEo8vBV;EyE38vBM;IAOI,iCAAA;EzEu8vBV;EyE98vBM;IAOI,+BAAA;EzE08vBV;EyEj9vBM;IAOI,8BAAA;EzE68vBV;EyEp9vBM;IAOI,+BAAA;EzEg9vBV;EyEv9vBM;IAOI,+BAAA;EzEm9vBV;EyE19vBM;IAOI,+BAAA;EzEs9vBV;EyE79vBM;IAOI,+BAAA;EzEy9vBV;EyEh+vBM;IAOI,+BAAA;EzE49vBV;EyEn+vBM;IAOI,+BAAA;EzE+9vBV;EyEt+vBM;IAOI,+BAAA;EzEk+vBV;EyEz+vBM;IAOI,+BAAA;EzEq+vBV;EyE5+vBM;IAOI,+BAAA;EzEw+vBV;EyE/+vBM;IAOI,+BAAA;EzE2+vBV;EyEl/vBM;IAOI,+BAAA;EzE8+vBV;EyEr/vBM;IAOI,gCAAA;EzEi/vBV;EyEx/vBM;IAOI,gCAAA;EzEo/vBV;EyE3/vBM;IAOI,gCAAA;EzEu/vBV;EyE9/vBM;IAOI,gCAAA;EzE0/vBV;EyEjgwBM;IAOI,gCAAA;EzE6/vBV;EyEpgwBM;IAOI,gCAAA;EzEggwBV;EyEvgwBM;IAOI,gCAAA;EzEmgwBV;EyE1gwBM;IAOI,gCAAA;EzEsgwBV;EyE7gwBM;IAOI,gCAAA;EzEygwBV;EyEhhwBM;IAOI,gCAAA;EzE4gwBV;EyEnhwBM;IAOI,0BAAA;EzE+gwBV;EyEthwBM;IAOI,gCAAA;EzEkhwBV;EyEzhwBM;IAOI,+BAAA;EzEqhwBV;EyE5hwBM;IAOI,6BAAA;EzEwhwBV;EyE/hwBM;IAOI,+BAAA;EzE2hwBV;EyEliwBM;IAOI,6BAAA;EzE8hwBV;EyEriwBM;IAOI,4BAAA;EzEiiwBV;EyExiwBM;IAOI,6BAAA;EzEoiwBV;EyE3iwBM;IAOI,6BAAA;EzEuiwBV;EyE9iwBM;IAOI,6BAAA;EzE0iwBV;EyEjjwBM;IAOI,6BAAA;EzE6iwBV;EyEpjwBM;IAOI,6BAAA;EzEgjwBV;EyEvjwBM;IAOI,6BAAA;EzEmjwBV;EyE1jwBM;IAOI,6BAAA;EzEsjwBV;EyE7jwBM;IAOI,6BAAA;EzEyjwBV;EyEhkwBM;IAOI,6BAAA;EzE4jwBV;EyEnkwBM;IAOI,6BAAA;EzE+jwBV;EyEtkwBM;IAOI,6BAAA;EzEkkwBV;EyEzkwBM;IAOI,8BAAA;EzEqkwBV;EyE5kwBM;IAOI,8BAAA;EzEwkwBV;EyE/kwBM;IAOI,8BAAA;EzE2kwBV;EyEllwBM;IAOI,8BAAA;EzE8kwBV;EyErlwBM;IAOI,8BAAA;EzEilwBV;EyExlwBM;IAOI,8BAAA;EzEolwBV;EyE3lwBM;IAOI,8BAAA;EzEulwBV;EyE9lwBM;IAOI,8BAAA;EzE0lwBV;EyEjmwBM;IAOI,8BAAA;EzE6lwBV;EyEpmwBM;IAOI,8BAAA;EzEgmwBV;EyEvmwBM;IAOI,iBAAA;EzEmmwBV;EyE1mwBM;IAOI,uBAAA;EzEsmwBV;EyE7mwBM;IAOI,sBAAA;EzEymwBV;EyEhnwBM;IAOI,oBAAA;EzE4mwBV;EyEnnwBM;IAOI,sBAAA;EzE+mwBV;EyEtnwBM;IAOI,oBAAA;EzEknwBV;EyEznwBM;IAOI,mBAAA;EzEqnwBV;EyE5nwBM;IAOI,oBAAA;EzEwnwBV;EyE/nwBM;IAOI,oBAAA;EzE2nwBV;EyElowBM;IAOI,oBAAA;EzE8nwBV;EyErowBM;IAOI,oBAAA;EzEiowBV;EyExowBM;IAOI,oBAAA;EzEoowBV;EyE3owBM;IAOI,oBAAA;EzEuowBV;EyE9owBM;IAOI,oBAAA;EzE0owBV;EyEjpwBM;IAOI,oBAAA;EzE6owBV;EyEppwBM;IAOI,oBAAA;EzEgpwBV;EyEvpwBM;IAOI,oBAAA;EzEmpwBV;EyE1pwBM;IAOI,oBAAA;EzEspwBV;EyE7pwBM;IAOI,qBAAA;EzEypwBV;EyEhqwBM;IAOI,qBAAA;EzE4pwBV;EyEnqwBM;IAOI,qBAAA;EzE+pwBV;EyEtqwBM;IAOI,qBAAA;EzEkqwBV;EyEzqwBM;IAOI,qBAAA;EzEqqwBV;EyE5qwBM;IAOI,qBAAA;EzEwqwBV;EyE/qwBM;IAOI,qBAAA;EzE2qwBV;EyElrwBM;IAOI,qBAAA;EzE8qwBV;EyErrwBM;IAOI,qBAAA;EzEirwBV;EyExrwBM;IAOI,qBAAA;EzEorwBV;EyE3rwBM;IAOI,qBAAA;EzEurwBV;EyE9rwBM;IAOI,2BAAA;EzE0rwBV;EyEjswBM;IAOI,0BAAA;EzE6rwBV;EyEpswBM;IAOI,wBAAA;EzEgswBV;EyEvswBM;IAOI,0BAAA;EzEmswBV;EyE1swBM;IAOI,wBAAA;EzEsswBV;EyE7swBM;IAOI,uBAAA;EzEyswBV;EyEhtwBM;IAOI,wBAAA;EzE4swBV;EyEntwBM;IAOI,wBAAA;EzE+swBV;EyEttwBM;IAOI,wBAAA;EzEktwBV;EyEztwBM;IAOI,wBAAA;EzEqtwBV;EyE5twBM;IAOI,wBAAA;EzEwtwBV;EyE/twBM;IAOI,wBAAA;EzE2twBV;EyEluwBM;IAOI,wBAAA;EzE8twBV;EyEruwBM;IAOI,wBAAA;EzEiuwBV;EyExuwBM;IAOI,wBAAA;EzEouwBV;EyE3uwBM;IAOI,wBAAA;EzEuuwBV;EyE9uwBM;IAOI,wBAAA;EzE0uwBV;EyEjvwBM;IAOI,yBAAA;EzE6uwBV;EyEpvwBM;IAOI,yBAAA;EzEgvwBV;EyEvvwBM;IAOI,yBAAA;EzEmvwBV;EyE1vwBM;IAOI,yBAAA;EzEsvwBV;EyE7vwBM;IAOI,yBAAA;EzEyvwBV;EyEhwwBM;IAOI,yBAAA;EzE4vwBV;EyEnwwBM;IAOI,yBAAA;EzE+vwBV;EyEtwwBM;IAOI,yBAAA;EzEkwwBV;EyEzwwBM;IAOI,yBAAA;EzEqwwBV;EyE5wwBM;IAOI,yBAAA;EzEwwwBV;EyE/wwBM;IAOI,wBAAA;EzE2wwBV;EyElxwBM;IAOI,8BAAA;EzE8wwBV;EyErxwBM;IAOI,6BAAA;EzEixwBV;EyExxwBM;IAOI,2BAAA;EzEoxwBV;EyE3xwBM;IAOI,6BAAA;EzEuxwBV;EyE9xwBM;IAOI,2BAAA;EzE0xwBV;EyEjywBM;IAOI,0BAAA;EzE6xwBV;EyEpywBM;IAOI,2BAAA;EzEgywBV;EyEvywBM;IAOI,2BAAA;EzEmywBV;EyE1ywBM;IAOI,2BAAA;EzEsywBV;EyE7ywBM;IAOI,2BAAA;EzEyywBV;EyEhzwBM;IAOI,2BAAA;EzE4ywBV;EyEnzwBM;IAOI,2BAAA;EzE+ywBV;EyEtzwBM;IAOI,2BAAA;EzEkzwBV;EyEzzwBM;IAOI,2BAAA;EzEqzwBV;EyE5zwBM;IAOI,2BAAA;EzEwzwBV;EyE/zwBM;IAOI,2BAAA;EzE2zwBV;EyEl0wBM;IAOI,2BAAA;EzE8zwBV;EyEr0wBM;IAOI,4BAAA;EzEi0wBV;EyEx0wBM;IAOI,4BAAA;EzEo0wBV;EyE30wBM;IAOI,4BAAA;EzEu0wBV;EyE90wBM;IAOI,4BAAA;EzE00wBV;EyEj1wBM;IAOI,4BAAA;EzE60wBV;EyEp1wBM;IAOI,4BAAA;EzEg1wBV;EyEv1wBM;IAOI,4BAAA;EzEm1wBV;EyE11wBM;IAOI,4BAAA;EzEs1wBV;EyE71wBM;IAOI,4BAAA;EzEy1wBV;EyEh2wBM;IAOI,4BAAA;EzE41wBV;EyEn2wBM;IAOI,2BAAA;EzE+1wBV;EyEt2wBM;IAOI,4BAAA;EzEk2wBV;EyEz2wBM;IAOI,6BAAA;EzEq2wBV;AACF;A0E55wBA;ED+CQ;IAOI,4BAAA;EzE02wBV;EyEj3wBM;IAOI,0BAAA;EzE62wBV;EyEp3wBM;IAOI,6BAAA;EzEg3wBV;EyEv3wBM;IAOI,4BAAA;EzEm3wBV;AACF;A0Ev5wBA;ED4BQ;IAOI,0BAAA;EzEw3wBV;EyE/3wBM;IAOI,gCAAA;EzE23wBV;EyEl4wBM;IAOI,yBAAA;EzE83wBV;EyEr4wBM;IAOI,wBAAA;EzEi4wBV;EyEx4wBM;IAOI,+BAAA;EzEo4wBV;EyE34wBM;IAOI,yBAAA;EzEu4wBV;EyE94wBM;IAOI,6BAAA;EzE04wBV;EyEj5wBM;IAOI,8BAAA;EzE64wBV;EyEp5wBM;IAOI,wBAAA;EzEg5wBV;EyEv5wBM;IAOI,+BAAA;EzEm5wBV;EyE15wBM;IAOI,wBAAA;EzEs5wBV;AACF;AA58wBA;EACE,SAAA;AA88wBF;;AA38wBA;EACE,UAAA;AA88wBF","sourcesContent":["//import bootstrap functions,mixins and variables\n@import \"../../../../node_modules/bootstrap/scss/functions\";\n@import \"../../../../node_modules/bootstrap/scss/mixins\";\n@import \"../../../../node_modules/bootstrap/scss/variables\";\n\n//Create custom colors\n@import \"color\";\n\n//Create custom spacer\n@import \"spacer\";\n\n//enable default negative margin\n$enable-negative-margins: true;\n\n//Create custom width and height\n@import \"width_height\";\n\n//import bootstrap\n@import \"../../../../node_modules/bootstrap/scss/bootstrap\";\n\np {\n  margin: 0;\n}\n\n.w-29 {\n  width: 29%;\n}\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.1 (https://getbootstrap.com/)\n   * Copyright 2011-2023 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}body-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(#{$pagination-border-width} * -1) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// Create own spacer map\n$spacer: 1rem;\n$custom-spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n  \"5-px\": 5px,\n  \"10-px\": 10px,\n  \"20-px\": 20px,\n  \"30-px\": 30px,\n  \"35-px\": 35px,\n  \"40-px\": 40px,\n  \"45-px\": 45px,\n  \"50-px\": 50px,\n  \"60-px\": 60px,\n  \"70-px\": 70px,\n  \"80-px\": 80px,\n  \"90-px\": 90px,\n  \"100-px\": 100px,\n  \"120-px\": 120px,\n  \"125-px\": 125px,\n  \"130-px\": 130px,\n  \"150-px\": 150px,\n  \"200-px\": 200px,\n  \"250-px\": 250px,\n  \"300-px\": 300px,\n  \"350-px\": 350px,\n  \"400-px\": 400px\n);\n\n// Merge the maps\n$spacers: map-merge($spacers, $custom-spacers);\n\n$position-values: map-merge(\n  $position-values,\n  (-8: -8%)\n);\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n\n      &::after {\n        position: absolute;\n        inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n        z-index: -1;\n        height: $form-floating-label-height;\n        content: \"\";\n        background-color: $input-bg;\n        @include border-radius($input-border-radius);\n      }\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n\n    &::after {\n      background-color: $input-disabled-bg;\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(#{$input-border-width} * -1); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($link-color), $link-color, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(#{$btn-border-width} * -1); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(#{$pagination-border-width} * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  --#{$prefix}btn-close-white-filter: #{$btn-close-white-filter};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  filter: var(--#{$prefix}btn-close-white-filter);\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .btn-close {\n      @include btn-close-white();\n    }\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    @if $color-mode-type == \"media-query\" {\n      .carousel {\n        @include carousel-dark();\n      }\n    } @else {\n      .carousel,\n      &.carousel {\n        @include carousel-dark();\n      }\n    }\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
